var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _path, _g12, _g13, _g14, _g15, _path2, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _path3, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _path4, _g65, _g66, _g67, _g68, _path5, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _path6, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnologbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1331,
    height: 1379,
    viewBox: "0 0 1331 1379",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M298.331 292.761L256.392 338.557C252.088 343.997 247.704 349.965 243.197 356.015C240.518 359.709 237.757 363.444 235.077 367.139C232.398 370.833 229.881 374.244 227.161 377.735C222.46 383.526 218.198 389.66 214.412 396.086L186.805 442.126L182.745 450.733H181.405C181.405 450.733 162.689 453.94 143.851 458.122C128.221 461.532 112.306 465.714 106.46 467.257L104.024 472.372C103.009 474.849 101.831 478.178 100.451 482.035C99.6931 484.281 98.8406 486.677 97.8933 489.221C96.2693 494.012 94.3205 499.33 92.25 505.055C88.1901 516.057 83.7242 528.562 80.0703 541.147L66.5914 594.698C65.4745 598.826 64.6738 603.034 64.1961 607.284C63.9525 609.232 63.7089 610.938 63.4247 612.44L62.5315 617.961L77.066 640.9L92.8996 664.366L92.6154 665.544C92.2725 667.392 92.0824 669.266 92.047 671.146L90.9508 687.833C90.9508 692.542 90.4636 697.901 90.0983 703.626C89.4081 714.019 88.6773 725.834 88.9209 737.486L90.9508 787.342C91.0108 791.223 91.391 795.093 92.0876 798.912C92.3718 800.618 92.5748 802.201 92.7372 803.581L93.7116 810.605L83.1558 826.033L73.818 840.202L74.7112 846.576C74.7112 847.672 75.036 848.931 75.239 850.311C75.8001 855.421 76.7364 860.482 78.0403 865.455C79.3395 870.854 80.7605 876.822 82.1002 883.156C85.0234 895.336 88.2713 909.424 91.844 923.227L111.25 979.295C112.996 984.167 114.945 988.267 116.65 991.921C117.543 993.83 118.355 995.535 118.964 997.037L122.456 1004.63L115.635 1027.85L109.667 1049.98C110.195 1051.24 111.453 1054.04 113.727 1058.1L145.841 1113.27C150.713 1120.7 156.193 1128.17 162.08 1136.05L170.809 1148.23C183.51 1166.37 197.528 1183.55 212.748 1199.63L221.964 1209.94C229.464 1218.98 237.605 1227.48 246.323 1235.35C249.937 1235.56 263.7 1236.29 276.894 1236.65C290.089 1237.02 302.553 1237.02 306.288 1237.02L307.344 1235.96L309.211 1237.83C314.07 1242.4 319.268 1246.59 324.76 1250.38L360.934 1277.33C366.317 1281.47 371.988 1285.21 377.905 1288.54L415.581 1311.11C419.64 1310.26 430.968 1307.82 442.254 1304.25L475.099 1294.02L473.556 1297.35C485.736 1303.64 561.534 1332.75 568.72 1332.47V1334.7L571.765 1335.68L569.451 1337.66C563.848 1338.64 482.447 1308.56 469.699 1301.13L443.756 1309.25C434.719 1312.06 425.546 1314.42 416.271 1316.31L415.378 1317.2L375.144 1292.84C369.039 1289.41 363.191 1285.55 357.646 1281.27L321.594 1254.4C316.186 1250.7 311.044 1246.63 306.207 1242.22C302.512 1242.22 289.724 1242.22 276.651 1241.85C261.304 1241.44 245.227 1240.51 245.065 1240.51H242.669V1239.13C233.766 1231.16 225.461 1222.54 217.823 1213.35C215.021 1210.14 211.936 1206.73 208.688 1203.16C193.342 1186.85 179.204 1169.44 166.384 1151.07C163.542 1147.01 160.619 1142.95 157.736 1139.09C151.89 1130.97 146.409 1123.63 141.497 1115.99L109.017 1060.45C104.186 1051.52 103.74 1049.9 104.551 1048.76L110.56 1026.39L116.894 1004.91L114.214 999.067C113.564 997.524 112.793 995.9 111.941 994.073C109.839 989.792 107.969 985.401 106.338 980.919L86.8909 924.73C83.237 910.682 79.9891 896.716 77.066 884.374C75.5638 878.04 74.1834 872.194 73.0061 866.794C71.6527 861.607 70.6758 856.329 70.0829 851.001C69.8799 849.661 69.7176 848.443 69.5552 847.347L68.4184 838.943L88.2713 809.346L87.5811 804.15C87.5811 802.769 87.2157 801.308 86.9315 799.724C86.2348 795.7 85.8412 791.628 85.7542 787.545L83.6836 737.77C83.44 725.834 84.2114 713.938 84.9016 703.423C85.2264 697.779 85.5512 692.461 85.7136 687.751L86.5661 671.228C86.6257 669.393 86.7883 667.563 87.0533 665.747L72.4783 644.026L56.8477 619.423L58.025 611.628C58.3092 610.126 58.5122 608.502 58.7558 606.715C59.2756 602.232 60.1305 597.794 61.3135 593.439L74.7112 539.97C78.5275 527.141 83.0746 514.555 87.1345 503.431C89.2051 497.787 91.1944 492.428 92.7778 487.638C93.7115 485.039 94.5641 482.684 95.3355 480.451C96.7565 476.391 97.9339 473.022 99.0706 470.423L102.562 462.994L103.74 462.669C108.733 461.329 125.785 456.823 142.512 453.169C158.751 449.596 174.382 446.795 179.051 445.983L182.055 439.609L209.744 393.447C213.642 386.765 218.039 380.386 222.898 374.365C225.537 370.915 228.216 367.464 230.733 363.891C233.25 360.318 236.295 356.421 238.853 352.767C243.359 346.636 247.825 340.587 252.291 334.984L294.474 289.107L298.331 292.761Z",
    fill: "url(#paint0_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.75 788.196L162.844 848.811L172.912 891.44C173.4 893.592 173.887 895.825 174.577 898.017L178.921 910.684C180.829 915.881 182.981 921.93 184.889 928.142C188.881 941.152 193.82 953.853 199.667 966.143L214.648 998.866C217.125 1004.18 220.657 1010.07 224.351 1016.28C226.706 1020.34 229.061 1024.2 231.334 1028.26C255.166 1071.9 290.812 1113.03 319.434 1144.13C350.208 1173.16 390.888 1209.33 433.964 1233.45C438.024 1235.88 442.084 1238.28 446.144 1240.67C452.355 1244.45 458.323 1248.06 463.764 1250.74L494.822 1265.4C507.401 1271.67 520.444 1276.97 533.838 1281.23C540.009 1283.34 546.017 1285.29 551.823 1287.65L564.815 1292.32C566.033 1292.68 568.266 1293.17 570.458 1293.74L620.313 1305.92L673.376 1314.04L664.485 1373.19L607.322 1364.46L556.37 1351.75C552.838 1350.9 549.225 1350.01 545.652 1348.87L531.077 1343.68C525.231 1341.44 519.831 1339.62 514.309 1337.67C498.462 1332.58 483.03 1326.28 468.148 1318.83L437.943 1304.62C429.457 1300.56 422.068 1295.97 414.923 1291.59C411.472 1289.48 408.021 1287.53 404.489 1285.33C355.77 1257.85 311.111 1218.18 277.698 1186.72L276.927 1185.99L276.237 1185.22C245.179 1151.48 206.082 1106.41 179.043 1056.96C177.175 1053.63 174.983 1050.14 173.075 1046.69C168.771 1039.46 164.346 1032.04 160.448 1023.79L145.914 991.964C138.859 977.384 132.915 962.292 128.132 946.817C126.305 941.255 124.518 935.815 122.57 930.578L117.657 916.287C116.277 911.739 115.424 908.167 114.612 904.716L101.174 844.588L94.5156 796.153L153.75 788.196Z",
    fill: "url(#paint1_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.994 244.907L268.836 262.867L273.346 267.93L293.504 249.969L288.994 244.907Z",
    fill: "url(#paint2_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.729 181.236L373.789 186.839C372.692 187.569 371.515 188.463 370.256 189.396L342.649 209.452L338.589 203.85L366.115 183.875L369.729 181.236ZM317.6 219.399L322.35 224.474L312.768 233.041L308.262 227.966L317.6 219.399Z",
    fill: "url(#paint3_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.001 104.584L935.931 111.08C919.691 105.721 903.086 101.011 886.765 97.0327L888.389 90.415C904.832 94.4343 921.559 99.225 938.001 104.584ZM869.511 86.1114L868.09 92.7697C855.626 90.0902 842.918 87.776 830.414 85.949L831.388 79.2096C844.055 81.0771 856.884 83.3913 869.511 86.1114ZM805.73 75.9616L805.08 82.7417L793.794 81.6861H792.494L792.738 74.8654H794.2L805.73 75.9616ZM767.201 73.4445L766.755 80.2245C749.847 78.8149 732.861 78.6114 715.925 79.6156L715.356 72.8355C732.63 71.7892 749.957 71.9928 767.201 73.4445ZM696.275 73.4445L696.559 80.2651L676.259 81.1177L658.68 83.5131L657.746 76.7736L679.629 74.3376L696.275 73.4445ZM632.209 80.2651L633.062 87.0046C629.002 87.5324 624.658 88.182 620.517 88.9128L619.34 82.0515C623.602 81.4425 627.865 80.7929 632.209 80.2651ZM594.006 87.4512L595.549 94.2313L582.638 97.3168L568.834 100.605L552.392 104.665C550.402 105.274 548.332 106.005 546.099 106.736L543.866 100.321C546.099 99.5092 548.372 98.819 550.646 98.1288L567.251 94.0689L581.055 90.7804L594.006 87.4512ZM525.637 106.411L527.87 112.826L507.57 119.728C502.374 121.27 497.137 123.097 491.331 125.412L489.098 118.956C494.985 116.561 500.425 114.653 505.744 113.069L525.637 106.411ZM465.551 129.553L468.392 135.724C464.82 137.388 461.328 139.012 457.918 140.474L456.659 141.042L453.899 134.831L455.117 134.222C458.608 132.76 462.018 131.177 465.551 129.553ZM430.473 145.792L433.518 151.882C428.484 154.44 424.343 156.754 420.932 158.947L389.224 177.46L385.773 171.37L417.359 152.978C421.602 150.33 425.979 147.904 430.473 145.711V145.792Z",
    fill: "url(#paint4_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.83 269.011L1223.77 289.148L1218.7 293.695L1200.71 273.517L1205.83 269.011Z",
    fill: "url(#paint5_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.74 308.149L1249.3 317.731L1244.23 322.278L1235.82 312.696L1240.74 308.149ZM1264.73 338.68L1284.75 366.247C1285.72 367.505 1286.65 368.764 1287.47 369.901L1281.86 373.961C1281.13 372.864 1280.28 371.687 1279.31 370.469L1259.25 342.821L1264.73 338.68Z",
    fill: "url(#paint6_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.817 1371.81L580.193 1378.43C563.953 1374.37 547.064 1369.62 530.54 1364.26L532.651 1357.8C549.013 1363.12 565.537 1367.83 581.817 1371.81ZM508.739 1349.4L506.384 1355.77C502.324 1354.27 498.264 1352.77 494.204 1351.23L496.681 1344.85C500.538 1346.4 504.516 1347.9 508.536 1349.4H508.739ZM473.174 1335.15L470.454 1341.4C458.518 1336.2 446.703 1330.68 435.376 1324.96L438.462 1318.91C449.464 1324.39 461.157 1330.03 472.971 1335.15H473.174ZM421.491 1309.98L418.243 1315.99C410.963 1312.01 403.993 1307.95 397.335 1303.81C389.499 1299.54 381.745 1294.92 373.706 1289.68L377.401 1283.95C385.521 1289.11 392.95 1293.66 400.705 1297.92C407.201 1302.1 414.102 1306.08 421.288 1309.98H421.491ZM356.533 1269.58L352.473 1275.1C348.9 1272.46 345.449 1269.91 342.161 1267.39L346.221 1261.99C349.266 1264.43 352.676 1266.98 356.289 1269.58H356.533ZM325.678 1246.48L321.618 1251.96L317.842 1249.28C312.489 1245.21 307.391 1240.82 302.577 1236.13C300.628 1234.26 298.882 1232.64 297.299 1231.3L292.184 1226.59L296.731 1221.59L301.806 1226.18C303.348 1227.48 305.175 1229.23 307.246 1231.17C311.851 1235.65 316.718 1239.86 321.821 1243.76L325.678 1246.48Z",
    fill: "url(#paint7_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.553 1213.27L282.965 1218.3L263.031 1200.08L267.619 1195.04L287.553 1213.27Z",
    fill: "url(#paint8_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.895 1175.19L267.881 1195.32L262.806 1199.83L244.82 1179.69L249.895 1175.19Z",
    fill: "url(#paint9_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.708 1095.04C187.439 1096.14 188.332 1097.32 189.266 1098.54L209.322 1126.18L203.8 1130.24L183.826 1102.72C182.851 1101.46 181.958 1100.2 181.105 1099.06L186.708 1095.04ZM224.384 1146.56L232.91 1156.15L227.835 1160.69L219.309 1151.11L224.384 1146.56Z",
    fill: "url(#paint10_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11 296.74L242.522 301.774C241.223 303.317 239.477 305.144 237.528 307.214C233.037 311.809 228.833 316.676 224.942 321.789L222.222 325.565L216.782 321.586C217.756 320.287 218.65 319.029 219.502 317.811C223.57 312.458 227.963 307.36 232.656 302.545C234.524 300.597 236.148 298.851 237.488 297.267L242.197 292.111L247.11 296.74ZM206.714 345.946L199.081 356.218L193.6 352.158C196.239 348.585 198.797 345.134 201.314 341.845L206.714 345.946ZM184.587 377.167C179.431 385.287 174.884 392.676 170.621 400.471C166.561 407.17 162.501 414.072 158.726 421.258L152.757 417.969C156.817 410.702 160.877 403.759 164.937 397.06C168.997 389.265 173.828 381.511 179.066 373.472L184.587 377.167ZM149.834 438.066C144.15 449.271 138.71 460.964 133.595 472.738L127.464 470.383C132.661 458.447 138.182 446.632 143.907 435.305L149.834 438.066ZM123.851 496.407C122.308 500.467 120.806 504.527 119.304 508.343L112.93 505.988C114.432 501.928 115.934 497.869 117.518 493.809L123.851 496.407ZM110.94 532.703C105.581 548.942 100.872 565.588 96.8932 581.868L90.2756 580.245C94.3355 564.005 99.045 547.075 104.445 530.592L110.94 532.703ZM92.5897 600.544C89.9508 613.049 87.6366 625.716 85.8097 638.22L79.0703 637.246C80.9378 624.579 83.1302 611.75 85.9721 599.123L92.5897 600.544ZM82.8054 663.635C82.44 667.411 82.0746 671.187 81.7904 674.963V676.262L74.6856 675.978V674.516C75.0104 670.456 75.3758 666.762 75.7412 662.945L82.8054 663.635ZM80.2882 701.961C78.8786 718.869 78.6751 735.855 79.6793 752.792L72.8992 753.319C71.853 736.059 72.0565 718.746 73.5082 701.515L80.2882 701.961ZM80.3288 772.239L81.1814 792.538L83.5768 810.158L76.8373 811.051L74.239 788.965L73.5488 772.401L80.3288 772.239ZM86.8653 835.655C87.3931 839.715 88.0426 844.059 88.7328 848.2L82.034 849.377C81.3032 845.114 80.6536 840.851 80.1258 836.507L86.8653 835.655ZM93.9295 873.168C94.9445 877.513 96.0001 881.816 97.015 886.079C98.03 890.342 99.248 895.336 100.344 899.883L104.404 916.325C105.013 918.315 105.744 920.385 106.475 922.659L100.06 924.851C99.2886 922.618 98.5578 920.345 97.8676 918.071L93.8077 901.426C92.7521 896.878 91.656 892.291 90.5598 887.662C89.4636 883.034 88.4486 879.055 87.4337 874.711L93.9295 873.168ZM112.564 940.847L119.426 960.944C120.968 966.181 122.836 971.419 125.11 977.184L118.817 979.742C116.421 973.855 114.513 968.414 112.93 963.096L106.109 943.202L112.564 940.847ZM135.584 1000.33C137.208 1003.9 138.832 1007.39 140.294 1010.8L140.862 1012.06L134.65 1014.82L134.082 1013.56C132.58 1010.11 131.037 1006.7 129.372 1003.17L135.584 1000.33ZM151.621 1035.24C153.742 1039.56 156.101 1043.76 158.685 1047.83L177.157 1079.49L171.271 1082.94L152.92 1051.36C150.221 1047.14 147.755 1042.77 145.531 1038.29L151.621 1035.24Z",
    fill: "url(#paint11_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.651 263.174L250.418 283.086L255.418 287.665L273.651 267.753L268.651 263.174Z",
    fill: "url(#paint12_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.438 572.857C122.358 569.257 123.454 565.643 124.726 562.017L140.073 513.703C145.188 500.752 149.086 492.267 149.126 492.145L149.573 491.171L150.628 490.846C150.628 490.846 168.695 485.568 185.868 481.468C194.597 479.356 203.204 477.408 209.578 476.108C209.578 476.108 215.993 474.769 219.484 474.281L232.679 450.693C234.222 448.054 235.724 445.294 237.307 442.573C240.149 437.336 243.316 431.449 247.132 425.684L275.552 384.557C277.703 381.553 280.058 378.832 282.372 376.194C283.631 374.732 284.889 373.311 286.067 371.849L304.864 349.804C309.143 344.333 313.839 339.202 318.911 334.457L324.433 329.139L327.762 332.59L322.362 337.827C317.461 342.445 312.914 347.426 308.762 352.727L289.883 374.732C288.706 376.194 287.447 377.655 286.148 379.157C283.915 381.715 281.601 384.354 279.611 387.277L251.192 428.323C247.579 433.885 244.534 439.447 241.611 444.847C240.027 447.811 238.485 450.612 236.942 453.251L222.286 479.478L220.946 479.113C219.687 479.113 215.749 479.844 210.715 480.98C204.3 482.32 195.734 484.188 187.086 486.299C172.43 489.831 157.246 494.135 153.146 495.352C151.968 497.91 148.72 505.381 144.701 515.652L129.395 563.884C126.522 572.365 124.296 581.051 122.737 589.868L113.399 634.527C114.536 636.582 115.783 638.574 117.134 640.495L127.325 655.395L142.712 676.872L140.397 698.593C139.87 706.347 139.87 715.969 139.87 726.16C139.87 732.087 139.87 738.339 139.87 744.348C139.563 756.554 140.146 768.766 141.615 780.887C141.94 784.054 142.265 787.058 142.509 789.86L144.539 811.581L140.235 817.589C138.53 819.944 136.419 822.867 134.754 825.709L126.634 838.823L131.222 862.33C131.79 864.806 132.278 867.567 132.805 870.449C133.669 876.027 134.931 881.536 136.581 886.933L144.945 915.028C146 918.316 147.015 921.767 147.949 925.137C149.546 931.08 151.457 936.935 153.673 942.676L172.917 990.136L170.644 997.444L167.112 1011.37L162.443 1031.43L177.749 1060.49L196.465 1089.36C198.413 1092.24 200.525 1095.25 202.27 1098.29C207.25 1106.45 212.799 1114.26 218.875 1121.64L224.275 1128.42C237.314 1145.95 251.515 1162.6 266.782 1178.23L289.761 1201.94C292.39 1202.23 295.033 1202.37 297.678 1202.35L317.978 1202.59C332.268 1202.59 346.397 1202.23 346.397 1202.23H347.331L362.433 1215.1C368.117 1219.16 375.385 1224.35 383.098 1229.71C387.402 1232.64 391.827 1235.72 396.252 1238.81C398.445 1240.27 400.678 1241.85 402.87 1243.39C406.93 1246.24 410.624 1248.92 414.441 1251.23L446.92 1269.3L471.279 1263.29L497.1 1254.52L511.96 1260.97C514.72 1262.03 517.806 1263.41 521.135 1265.03C528.104 1268.35 535.343 1271.07 542.774 1273.15L589.463 1287.93L588.002 1292.56L541.435 1277.78C533.774 1275.58 526.317 1272.73 519.146 1269.26C515.938 1267.75 512.934 1266.41 510.133 1265.2L496.938 1259.43L472.579 1267.55L446.108 1274.09L411.883 1255.01C407.823 1252.53 403.763 1249.73 399.947 1246.89C397.795 1245.38 395.603 1243.84 393.37 1242.34L380.256 1233.2C372.502 1227.85 365.194 1222.81 359.307 1218.43L345.504 1206.69C342.134 1206.69 330.117 1207.1 317.856 1207.02L297.556 1206.77C294.423 1206.77 291.292 1206.59 288.178 1206.25H287.366L263.291 1181.36C247.883 1165.67 233.546 1148.96 220.378 1131.34L215.1 1124.64C208.898 1117.1 203.227 1109.14 198.129 1100.81C196.221 1097.81 194.069 1094.84 192.364 1091.96L173.486 1062.85L157.246 1031.99L165.934 996.023L167.761 990.258L149.086 944.421C146.864 938.554 144.94 932.578 143.321 926.517C142.387 923.188 141.412 919.818 140.357 916.449L131.993 888.394C130.23 882.816 128.873 877.117 127.934 871.343C127.446 868.541 126.959 865.862 126.35 863.223L121.397 837.808L130.329 823.111C132.115 820.106 134.389 817.061 136.013 814.666L139.261 810.119L137.393 790.185C137.393 787.383 136.865 784.379 136.541 781.253C135.029 768.89 134.432 756.433 134.754 743.983C134.754 737.933 134.754 731.803 134.754 725.957C134.754 715.644 134.754 705.901 135.282 697.902L137.393 677.928L123.427 658.034L113.196 643.093C110.314 639.033 108.811 636.11 108.73 635.988L108.324 635.217L118.068 588.569C118.921 583.494 120.017 578.175 121.438 572.857Z",
    fill: "url(#paint13_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.203 594.455C214.667 542.411 235.963 492.513 263.538 446.065C267.923 438.635 272.957 431.53 277.788 424.669C280.508 420.893 283.188 417.077 285.908 413.261L297.154 397.021L310.186 381.837C313.272 378.345 316.235 374.813 319.159 371.322C324.427 364.764 330.023 358.476 335.926 352.483L363.208 326.094C406.771 288.174 446.152 261.135 483.828 243.068C497.968 235.316 512.665 228.625 527.797 223.053C533.684 220.698 539.571 218.343 545.336 215.907C551.934 213.161 558.717 210.882 565.635 209.087C569.167 208.072 572.699 207.097 576.11 206.001C579.52 204.905 583.499 203.809 587.031 202.713C593.445 200.764 599.82 198.653 606.234 197.354C697.623 176.364 767.737 181.763 801.394 186.838L817.633 188.544C821.409 189.152 824.657 189.843 827.783 190.492L874.106 200.155L871.305 213.674L824.819 203.849C821.937 203.24 818.932 202.591 815.766 202.063L799.526 200.399C766.519 195.405 698.353 190.167 609.198 210.63C603.108 212.051 597.018 213.918 590.928 215.786L580.048 219.034C576.678 220.13 572.984 221.185 569.248 222.241C562.886 223.857 556.646 225.919 550.573 228.412C544.645 230.929 538.677 233.325 532.588 235.72C517.953 241.147 503.732 247.633 490.04 255.126C452.973 272.868 414.607 299.258 372.303 336.325L345.386 362.187C339.864 367.627 334.87 373.636 329.552 379.969C326.548 383.583 323.543 387.196 320.417 390.728L307.872 405.425L297.113 420.893C294.556 424.71 291.795 428.607 288.993 432.464C284.284 439.122 279.412 445.984 275.271 453.007C248.343 498.317 227.55 547.001 213.439 597.784C200.917 648.897 195.224 701.443 196.509 754.051C196.509 762.171 197.524 770.656 198.377 778.735C198.864 783.486 199.351 788.236 199.716 792.945L201.584 812.23L205.238 830.621C206.172 835.128 207.065 839.756 207.917 844.385C209.419 852.504 210.8 860.178 212.952 867.688L223.791 903.984C242.467 956.52 262.929 998.337 286.192 1031.51C294.53 1044.94 303.853 1057.74 314.084 1069.79C318.144 1074.87 322.204 1079.86 326.263 1084.89C330.349 1090.06 334.784 1094.95 339.539 1099.51C342.246 1102.22 344.952 1104.92 347.659 1107.63C350.136 1110.15 352.734 1112.87 355.332 1115.75C359.758 1120.38 364.142 1124.97 368.73 1129.19C436.368 1190.78 498.363 1219.64 529.258 1231.38L544.808 1238.12C547.447 1239.09 550.411 1239.98 553.212 1240.88L598.114 1255.37L594.054 1268.53L548.949 1254.19C545.904 1253.26 542.737 1252.29 539.489 1251.07L523.899 1244.33C492.354 1232.35 428.573 1202.67 359.23 1139.54C354.399 1135.12 349.811 1130.28 345.183 1125.37C342.625 1122.73 340.067 1120.05 337.469 1117.25C334.87 1114.45 332.272 1111.81 329.674 1109.13C324.483 1104.14 319.64 1098.79 315.18 1093.14C311.364 1088.22 307.425 1083.31 303.406 1078.32C292.859 1065.88 283.251 1052.68 274.662 1038.81C250.952 1005.08 230.003 962.204 210.719 908.125L199.797 871.586C197.566 863.458 195.764 855.219 194.398 846.902C193.586 842.436 192.733 837.929 191.759 833.463L187.983 814.26L186.034 794.204C185.669 789.454 185.182 784.825 184.695 780.238C183.842 771.874 182.949 763.186 182.746 754.498C181.467 700.613 187.337 646.797 200.203 594.455Z",
    fill: "url(#paint14_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.044 584.021L161.329 583.087C173.508 542.488 190.844 490.44 217.355 445.74C219.101 442.735 220.928 439.406 222.674 436.158C226.368 429.378 230.185 422.355 234.853 415.412L253.326 388.941C261.585 376.494 270.787 364.699 280.852 353.661C284.384 349.601 287.835 345.541 291.083 341.481L300.137 330.884C303.06 327.636 305.455 325.322 307.85 323.008L349.221 284.114L384.461 256.06L418.808 299.176L375.123 334.985L346.054 363.039C344.552 364.46 343.009 365.881 341.588 367.424L333.468 376.883C330.261 380.943 326.404 385.287 322.466 389.834C314.001 399.095 306.238 408.975 299.243 419.391L280.365 446.674C277.32 451.139 274.275 456.661 271.108 462.548C269.078 466.283 267.049 469.978 264.897 473.713C241.471 513.094 225.638 560.676 214.392 598.028C205.866 636.029 196.325 685.316 197.381 730.869C197.381 735.416 197.381 739.638 197.381 743.86C197.381 750.6 197.381 756.893 197.665 762.577L200.669 794.122C201.623 807.038 203.551 819.863 206.434 832.489C207.652 838.376 208.83 844.1 209.804 849.743L212.24 862.248C212.524 863.344 213.174 865.415 213.783 867.363L227.343 912.753L245.978 958.59L194.823 979.296L174.848 929.846L160.963 883.481C159.989 880.274 159.015 877.026 158.243 873.656L155.482 859.609C154.508 854.006 153.452 848.81 152.356 843.369C148.947 828.421 146.694 813.233 145.617 797.939L142.694 767.286C142.114 759.18 141.952 751.049 142.207 742.927C142.207 739.191 142.207 735.497 142.207 731.762C141.029 680.038 151.504 626.204 160.801 584.792L161.044 584.021Z",
    fill: "url(#paint15_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6752 601.723L84.2742 610.167L82.8127 617.029C82.8127 618.206 82.2037 620.236 81.6759 622.591C80.9045 626.001 80.0113 630.183 79.2805 635.136C78.5498 640.089 78.1032 646.869 77.2506 654.461C75.6672 668.915 73.8809 685.276 72.5005 703.992C69.9377 773.138 77.7657 842.277 95.7232 909.1L105.386 941.579C107.184 948.39 109.464 955.065 112.206 961.554L133.44 1013.56L164.701 1072.51L180.94 1097.81C191.122 1114.28 202.45 1130.02 214.841 1144.9L233.8 1168.65C235.627 1171.05 236.683 1172.22 237.008 1172.71L207.33 1201.5C205.147 1199.19 203.1 1196.77 201.199 1194.23L182.646 1170.97C169.287 1154.8 157.078 1137.72 146.107 1119.85L125.036 1086.76L95.5201 1030.21L74.2057 978.038C70.7983 970.034 67.9628 961.799 65.7205 953.394L55.9767 920.914C36.808 849.609 28.4597 775.829 31.2113 702.044C32.6729 681.744 34.6217 664.408 36.1644 650.361C36.9764 643.012 37.7072 636.435 38.2349 630.711C39.2093 623.565 40.3461 618.531 41.2799 614.105C41.6453 612.36 42.0107 610.857 42.2543 609.518L43.6752 601.723Z",
    fill: "url(#paint16_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.094 1283.51L469.692 1277.78C470.788 1278.27 472.006 1278.8 473.387 1279.33L502.253 1291.83L499.776 1297.55L470.951 1285.13L467.094 1283.51ZM521.862 1306.89L523.77 1300.92L535.057 1304.5L533.148 1310.46L521.862 1306.89Z",
    fill: "url(#paint17_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.123 615.079L142.294 616.338L140.995 622.509C140.711 624.336 140.183 626.569 139.615 629.167C138.207 634.915 137.163 640.746 136.489 646.625C136.489 647.965 136.245 649.426 136.123 650.888L129.871 650.32L130.236 646.057C130.947 639.906 132.032 633.805 133.484 627.787C134.012 625.351 134.499 623.199 134.865 621.332L136.123 615.079ZM127.232 673.786L133.484 674.476C133.078 678.252 132.632 682.149 132.266 686.209L126.014 685.6C126.42 681.54 126.826 677.562 127.232 673.786ZM124.309 709.392L130.602 709.676C130.236 718.323 130.196 726.524 130.602 734.685C130.602 741.912 130.602 749.219 130.927 756.771L124.674 756.974C124.39 749.382 124.268 741.952 124.309 734.807C123.903 726.565 123.944 718.242 124.309 709.392ZM125.446 774.838L131.698 774.391C132.51 785.962 133.647 797.776 135.149 809.55L128.937 810.321C127.476 798.466 126.258 786.49 125.446 774.838ZM132.348 833.869L138.559 832.854C139.168 836.711 139.858 840.608 140.589 844.465L134.418 845.602C133.687 841.705 132.997 837.766 132.348 833.869ZM139.128 868.947L145.258 867.526C148.709 882.994 152.728 898.341 157.438 913.119L151.429 914.946C146.679 900.005 142.619 884.537 139.128 868.947ZM156.707 931.916L162.634 929.927C166.41 941.092 170.754 952.216 174.814 963.015L169.009 965.411C164.664 954.489 160.483 943.243 156.707 931.916ZM178.63 987.416L184.314 984.736C185.816 987.903 187.278 991.029 188.821 994.196L189.389 995.211L183.868 998.215L183.218 997.038L178.63 987.416ZM194.87 1019.16L200.432 1016.32C207.254 1030.39 215.069 1043.96 223.817 1056.92L218.702 1060.58C209.738 1047.33 201.746 1033.45 194.789 1019.04L194.87 1019.16ZM228.364 1075.27L233.602 1071.86L243.873 1087.66L254.063 1100.48L249.151 1104.54L236.687 1088.3L228.364 1075.27ZM263.726 1122.98L268.679 1118.92C271.074 1122.04 273.551 1125.05 276.068 1128.01L271.277 1132.07C268.638 1129.11 266.081 1126.02 263.645 1122.85L263.726 1122.98ZM287.355 1149.89L291.902 1145.55L300.387 1154.32L309.522 1163.74L320.321 1174.94C321.742 1176.24 323.366 1177.62 324.949 1179L320.889 1183.79C319.225 1182.41 317.56 1180.95 315.936 1179.45L305.015 1168.12L295.921 1158.74C292.998 1155.7 290.115 1152.78 287.273 1149.81L287.355 1149.89ZM334.531 1195.16L338.591 1190.33L353.49 1203.04C357.371 1206.62 361.437 1209.99 365.67 1213.15L361.854 1218.14C357.185 1214.61 353.125 1211.16 349.39 1207.71L334.531 1195.16ZM381.301 1231.7L384.833 1226.5C387.837 1228.58 390.72 1230.56 393.521 1232.59L394.536 1233.37L390.923 1238.44L389.867 1237.75C386.903 1235.84 384.021 1233.85 381.098 1231.86L381.301 1231.7ZM410.573 1252L413.983 1246.68C417.704 1249.12 421.553 1251.36 425.513 1253.38L455.069 1269.82L452.024 1275.31L422.59 1259.07C418.936 1257.28 414.957 1255.01 410.37 1252.08L410.573 1252Z",
    fill: "url(#paint18_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.548 579.595L149.678 580.854L144.603 605.254L138.473 603.995L143.548 579.595Z",
    fill: "url(#paint19_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.637 579.271L151.188 555.561L157.156 557.469L149.605 581.179L143.637 579.271Z",
    fill: "url(#paint20_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.25 533.191L161.823 521.905L167.791 523.772L164.218 535.099L158.25 533.191ZM171.16 499.778L183.584 470.993C184.112 469.653 184.68 468.313 185.208 466.933L190.932 469.491C190.445 470.628 189.917 471.846 189.389 473.185L176.926 502.051L171.16 499.778Z",
    fill: "url(#paint21_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.332 451.83L209.572 422.436C211.642 418.242 213.96 414.174 216.514 410.256L221.792 413.626C219.34 417.337 217.103 421.187 215.093 425.156L198.65 454.712L193.332 451.83ZM230.115 390.931L230.846 389.875C232.875 387.074 234.905 384.191 236.854 381.268L242.051 384.841C239.98 387.845 237.991 390.728 235.961 393.488L235.23 394.544L230.115 390.931ZM250.414 361.78C253.682 357.454 257.164 353.294 260.848 349.316L273.434 334.498L278.184 338.558L265.517 353.295C262.066 357.03 258.818 360.928 255.408 365.475L250.414 361.78ZM284.923 321.181C286.344 319.476 287.765 317.852 289.268 316.228L300.595 305.266C303.721 302.302 306.847 299.258 309.973 296.172L318.783 287.646L323.127 292.153L314.358 300.679L305.101 309.407L293.936 320.288C292.637 321.709 291.257 323.292 289.876 324.876L284.923 321.181ZM336.565 271.244C339.57 268.646 342.655 266.129 345.862 263.693L349.922 268.605C346.796 271.041 343.792 273.477 340.828 275.994L336.565 271.244ZM364.457 249.117L380.696 236.613L393.566 228.209L396.977 233.487L381.184 243.758L368.354 253.949L364.457 249.117ZM408.304 218.668C421.507 209.734 435.332 201.756 449.674 194.796L452.557 200.398C438.479 207.207 424.911 215.022 411.958 223.783L408.304 218.668ZM470.623 183.915L471.801 183.265C475.089 181.682 478.297 180.139 481.463 178.678L484.102 184.362L474.643 188.827L473.587 189.436L470.623 183.915ZM503.103 169.177C514.024 164.711 525.31 160.53 536.597 156.713L538.586 162.682C527.421 166.417 516.297 170.558 505.498 174.861L503.103 169.177ZM553.77 151.273C568.71 146.726 584.179 142.666 599.769 139.093L601.19 145.224C585.721 148.675 570.375 152.694 555.597 157.201L553.77 151.273ZM623.113 134.424C627.173 133.694 630.949 133.044 634.846 132.394L635.861 138.566L624.25 140.595L623.113 134.424ZM658.353 128.984C670.249 127.441 682.225 126.305 693.918 125.493L694.324 131.745C682.753 132.557 670.939 133.694 659.165 135.196L658.353 128.984ZM711.741 124.559C719.373 124.315 726.762 124.193 733.948 124.234C742.068 123.95 750.472 123.99 759.323 124.234L759.039 130.77C750.391 130.405 742.19 130.364 734.03 130.77C726.803 130.77 719.495 130.77 711.944 131.095L711.741 124.559ZM783.114 126.061C787.174 126.426 791.234 126.873 794.928 127.279L794.238 133.491C790.462 133.085 786.565 132.679 782.505 132.313L783.114 126.061ZM818.394 129.877L822.657 130.243C828.806 130.985 834.906 132.083 840.927 133.531C843.363 134.059 845.515 134.546 847.382 134.871L853.675 136.211L852.376 142.301L846.083 141.042C844.256 140.717 842.023 140.23 839.425 139.662C833.674 138.258 827.844 137.201 821.967 136.495L817.907 136.13L818.394 129.877Z",
    fill: "url(#paint22_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.639 138.492L863.363 144.612L887.727 149.689L889.003 143.568L864.639 138.492Z",
    fill: "url(#paint23_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.344 143.658L887.453 149.618L911.175 157.143L913.066 151.183L889.344 143.658Z",
    fill: "url(#paint24_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.652 164.265L935.398 158.297L946.685 161.869L944.817 167.837L933.652 164.265Z",
    fill: "url(#paint25_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.34 235.273L1077.95 230.117L1079 230.888C1081.81 232.918 1084.65 234.948 1087.61 236.897L1084.04 242.093C1081.08 240.023 1078.15 238.034 1075.39 236.004L1074.34 235.273ZM1103.28 255.572L1107.1 250.579C1111.77 254.111 1115.83 257.521 1119.56 260.972L1134.34 273.639L1130.28 278.389L1115.38 265.722C1111.73 262.312 1107.79 259.023 1103.28 255.613V255.572ZM1143.88 289.838L1147.94 285.088C1149.61 286.509 1151.23 287.89 1152.85 289.432L1163.82 300.759C1166.78 303.886 1169.82 307.012 1172.91 310.097L1181.44 318.948L1176.93 323.251L1168.4 314.482L1159.23 305.347L1148.43 294.142C1147.01 292.64 1145.42 291.219 1143.84 289.879L1143.88 289.838ZM1192.6 340.628L1197.35 336.568C1199.95 339.572 1202.47 342.658 1204.94 345.865L1199.95 349.682C1197.68 346.637 1195.24 343.632 1192.72 340.669L1192.6 340.628ZM1214.56 368.317L1219.48 364.257L1231.94 380.497L1240.3 393.326L1235.03 396.736L1224.76 380.943L1214.56 368.317ZM1244.81 411.92L1249.93 408.307C1258.86 421.509 1266.84 435.334 1273.8 449.678L1268.2 452.56C1261.43 438.482 1253.66 424.913 1244.93 411.961L1244.81 411.92ZM1279.16 473.591L1284.68 470.627L1285.33 471.804C1286.95 475.093 1288.46 478.26 1289.92 481.467L1284.56 483.984C1283.1 480.817 1281.59 477.691 1280.05 474.524L1279.16 473.591Z",
    fill: "url(#paint26_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.05 863.507L1330.22 864.765L1325.11 889.125L1318.98 887.866L1324.05 863.507Z",
    fill: "url(#paint27_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.57 911.252L1319.08 887.542L1325.05 889.45L1317.53 913.2L1311.57 911.252Z",
    fill: "url(#paint28_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.72 999.068L1279.27 995.374L1291.77 966.467L1297.49 968.984L1285.07 997.769C1284.54 999.109 1283.97 1000.45 1283.45 1001.63L1277.72 999.068ZM1300.86 944.95L1304.44 933.704L1310.4 935.571L1306.83 946.858L1300.86 944.95Z",
    fill: "url(#paint29_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.336 1326.46L622.466 1327.72C624.293 1328.04 626.526 1328.53 629.125 1329.14C634.882 1330.5 640.71 1331.54 646.582 1332.27L650.886 1332.59L650.317 1338.84L646.054 1338.48C639.89 1337.77 633.776 1336.69 627.744 1335.23C625.308 1334.66 623.197 1334.17 621.289 1333.89L614.996 1332.55L616.336 1326.46ZM674.474 1335.23C678.249 1335.64 682.147 1336.08 686.207 1336.45L685.598 1342.7L673.783 1341.48L674.474 1335.23ZM709.632 1338.11C718.321 1338.48 726.481 1338.52 734.641 1338.11C741.868 1338.11 749.216 1338.11 756.727 1337.79L756.93 1344.04C749.338 1344.32 741.909 1344.45 734.723 1344.41C726.603 1344.69 718.199 1344.65 709.348 1344.41L709.632 1338.11ZM774.388 1336.98C785.918 1336.2 797.773 1335.07 809.547 1333.57L810.318 1339.82C798.422 1341.28 786.486 1342.46 774.794 1343.27L774.388 1336.98ZM832.85 1330.16C836.707 1329.55 840.564 1328.86 844.462 1328.17L845.598 1334.3L833.906 1336.57L832.85 1330.16ZM1226.66 1084.08C1228.73 1081.12 1230.72 1078.2 1232.79 1075.39L1233.52 1074.38L1238.64 1077.99L1237.87 1079.05C1235.84 1081.81 1233.81 1084.69 1231.86 1087.66L1226.66 1084.08ZM1246.96 1054.93C1249.39 1051.22 1251.62 1047.37 1253.62 1043.4L1270.06 1013.89L1275.54 1016.93L1259.3 1046.33C1257.56 1049.78 1255.24 1053.76 1252.36 1058.51L1246.96 1054.93Z",
    fill: "url(#paint30_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4875 566.238L26.227 567.659L20.5837 594.617L13.8037 593.237L19.4875 566.238ZM8.24159 620.235L14.981 621.575L14.6156 623.28L11.9767 648.655L5.11548 647.924L8.24159 620.235ZM2.23296 675.369L9.09417 676.1L7.83561 688.28C7.23955 693.319 6.9413 698.389 6.94243 703.464H0.0812154C0.0607187 698.173 0.358959 692.885 0.974368 687.63L2.23296 675.369ZM0 730.746H6.90185V758.313H0V730.746ZM1.62397 786.124L8.48521 785.515L11.0429 812.757L4.18169 813.447L1.62397 786.124ZM277.372 1309.85L281.879 1304.66C285.208 1307.5 288.537 1310.34 291.988 1312.78L303.599 1320.9L299.54 1326.58L287.806 1318.46C284.234 1315.66 280.783 1312.78 277.332 1309.77L277.372 1309.85Z",
    fill: "url(#paint31_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3516 547.725L31.715 521.458L38.2514 523.528L30.1316 549.837L23.3516 547.725ZM40.0378 495.19L46.29 475.865L49.2943 468.8L55.6278 471.52L52.7047 478.26L46.696 497.22L40.0378 495.19ZM254.969 178.109C261.952 172.128 269.057 166.254 276.283 160.489L280.587 165.889C273.442 171.573 266.377 177.419 259.435 183.347L254.969 178.109ZM298.207 143.6C305.596 138.078 313.066 132.679 320.699 127.36L324.759 133.044C317.234 138.241 309.818 143.654 302.51 149.284L298.207 143.6ZM343.718 112.014C350.16 107.845 356.724 103.786 363.409 99.8339L367.266 97.6415L370.757 103.569L366.697 105.802C360.202 109.862 353.706 113.922 347.251 117.982L343.718 112.014ZM391.788 84.4467C399.907 80.3868 408.311 76.1239 416.634 72.2669L419.557 78.5192C411.438 82.5792 403.074 86.6391 394.914 90.699L391.788 84.4467ZM441.846 60.8179C450.372 57.164 458.911 53.6589 467.464 50.3027L469.981 56.7174C461.51 60.0466 453.038 63.5381 444.566 67.192L441.846 60.8179ZM493.407 40.5183C502.176 37.4327 510.905 34.469 519.634 31.7082L521.745 38.2853C513.057 41.0461 504.409 43.9692 495.721 47.0142L493.407 40.5183ZM546.186 23.7508C550.53 22.5328 554.833 21.3554 559.177 20.2186L573.265 17.4579L574.605 24.1974L560.68 26.9175L548.013 30.4091L546.186 23.7508ZM600.345 12.18L608.018 10.6778L616.422 9.05384C620.116 8.28245 623.811 7.55166 627.505 6.94267L628.602 13.7228C625.029 14.3317 621.416 15.0625 617.802 15.7933C614.96 16.3617 612.159 16.9301 609.317 17.4173L601.644 18.9601L600.345 12.18ZM655.235 4.06013L655.478 7.51106L655.275 4.06013L682.598 1.46177L683.248 8.32305L656.006 10.9214L655.235 4.06013ZM710.409 0.000195677H737.975V6.86147H710.368L710.409 0.000195677ZM765.583 0.000195677C770.888 -0.00895542 776.189 0.302874 781.457 0.933978L793.352 2.19255L792.662 8.97264L780.483 7.71406C775.456 7.13371 770.399 6.84902 765.339 6.86147L765.583 0.000195677ZM820.797 5.07511L848.486 8.20125L847.146 14.9407L845.441 14.5753L820.067 11.9364L820.797 5.07511ZM875.525 13.7634L902.483 19.4067L901.102 26.1461L874.104 20.5028L875.525 13.7634Z",
    fill: "url(#paint32_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.49 734.97C1206.49 737.771 1206.49 740.572 1206.12 743.414L1204.21 781.09C1203 791.402 1201.78 798.264 1201.78 798.345V799.157L1201.09 799.604C1201.09 799.604 1188.91 806.79 1177.46 813.001C1171.61 816.168 1165.77 819.172 1161.22 821.324C1161.22 821.324 1156.88 823.517 1154.44 824.491L1149.41 844.019C1148.8 846.171 1148.23 848.485 1147.66 850.88C1146.6 855.184 1145.39 860.015 1143.6 864.928L1130.77 899.924C1129.8 902.421 1128.69 904.861 1127.44 907.232C1126.79 908.531 1126.18 909.79 1125.61 911.089L1116.4 930.577C1114.34 935.314 1111.92 939.887 1109.17 944.259L1106.21 949.131L1103.12 947.263L1106.13 942.31C1108.82 938.08 1111.17 933.64 1113.15 929.034L1122.49 909.587L1124.4 905.527C1125.49 903.294 1126.67 900.939 1127.56 898.544L1140.39 863.629C1141.94 858.919 1143.07 854.331 1144.17 849.906C1144.78 847.47 1145.35 845.115 1145.91 842.964L1151.52 821.284H1152.57C1153.47 820.918 1156.19 819.781 1159.6 817.995C1163.98 815.843 1169.79 812.88 1175.63 809.875C1185.54 804.557 1195.65 798.589 1198.37 796.965C1198.73 794.894 1199.67 788.845 1200.64 780.725L1202.55 743.089C1203.06 736.441 1203.06 729.763 1202.55 723.114L1200.8 689.011C1199.6 687.753 1198.32 686.56 1196.99 685.438L1186.84 676.628L1171.69 664.083L1169.26 647.843C1168.2 642.159 1166.34 635.217 1164.43 627.869C1163.29 623.809 1162.11 619.18 1161.06 614.755C1158.99 605.879 1156.28 597.168 1152.94 588.69C1152.1 586.471 1151.33 584.36 1150.62 582.357L1145.02 567.132L1147.01 561.976C1147.78 559.946 1148.76 557.469 1149.41 555.115L1152.69 544.153L1144.94 527.913C1144.05 526.248 1143.19 524.34 1142.26 522.351C1140.57 518.5 1138.61 514.77 1136.41 511.186L1125.09 492.551C1123.71 490.359 1122.33 488.085 1121.03 485.812C1118.78 481.836 1116.31 477.987 1113.64 474.281L1090.78 443.71L1091.06 438.026V427.308L1090.66 412.002L1074.13 393.935L1055.22 376.681C1053.27 374.975 1051.16 373.148 1049.33 371.321C1044.24 366.391 1038.81 361.819 1033.09 357.64L1027.45 354.067C1014.74 343.941 1001.37 334.691 987.415 326.378L966.385 313.589C965.451 313.589 963.381 314.117 960.579 314.807L946.045 318.461C935.733 321.1 925.745 324.023 925.745 324.064H925.096L911.779 317.649C906.907 315.7 900.696 313.589 894.119 311.072C890.465 309.732 886.689 308.393 882.954 307.012L877.23 305.348C873.819 304.048 870.612 302.871 867.405 301.897L840.569 295.035L824.126 303.967L807.156 315.173L795.22 313.346C793.068 313.102 790.551 312.655 787.912 312.209C782.251 311.095 776.506 310.456 770.738 310.301L734.199 308.474L734.402 304.901L770.738 306.728C776.67 306.87 782.579 307.522 788.399 308.677C790.997 309.123 793.433 309.529 795.626 309.773L806.262 311.397L822.177 300.882L840.041 291.178L868.46 298.446C871.83 299.461 875.24 300.76 878.569 301.978C880.396 302.668 882.264 303.358 884.172 304.008C887.948 305.429 891.683 306.809 895.337 308.068C901.954 310.504 908.166 312.737 913.241 314.767L925.421 320.613C927.857 319.923 936.423 317.446 945.273 315.173L959.848 311.519C963.908 310.504 966.588 310.179 966.71 310.138H967.319L989.323 323.496C1003.4 331.884 1016.9 341.216 1029.72 351.428L1034.79 355.285C1040.69 359.529 1046.28 364.183 1051.52 369.21C1053.47 371.037 1055.58 372.783 1057.37 374.529L1076.41 391.905L1093.74 410.906L1094.31 438.473L1094.11 442.939L1116.2 472.495C1118.94 476.308 1121.47 480.265 1123.79 484.35C1125.13 486.583 1126.47 488.816 1127.85 491.049L1139.17 509.643C1141.47 513.351 1143.49 517.217 1145.22 521.214C1146.12 523.122 1146.97 524.99 1147.86 526.654L1156.23 544.031L1152.57 556.211C1151.87 558.647 1151.04 561.046 1150.1 563.397L1148.59 567.457L1153.71 581.463C1154.4 583.453 1155.21 585.523 1156.02 587.756C1159.46 596.371 1162.25 605.233 1164.35 614.268C1165.4 618.652 1166.58 623.037 1167.67 627.3C1169.62 634.689 1171.49 641.713 1172.59 647.6L1174.82 662.378L1188.95 674.111L1199.3 682.921C1200.87 684.182 1202.36 685.537 1203.77 686.981L1204.21 687.428L1206.04 722.871C1206.28 726.85 1206.49 730.869 1206.49 734.97Z",
    fill: "url(#paint33_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.19 949.09L1094.25 968.781C1092.02 972.723 1089.48 976.483 1086.66 980.027L1066.81 1006.58C1066.31 1007.3 1065.76 1007.99 1065.18 1008.65L1065.59 1027.04V1047.58L1062.54 1050.99C1061.89 1051.6 1061.28 1052.29 1060.59 1053.07C1058.98 1054.98 1057.24 1056.8 1055.4 1058.51L1032.5 1079.29C1026.83 1084.69 1020.76 1089.66 1014.35 1094.15C1012.16 1095.73 1010.09 1097.28 1008.26 1098.7L997.504 1106.82L996.205 1112.71C995.167 1117.49 993.88 1122.22 992.348 1126.87C989.343 1136.82 985.811 1147.17 985.771 1147.17C985.73 1147.17 985.771 1148.35 963.32 1161.02L940.016 1172.31C938.392 1173.04 936.727 1173.85 935.063 1174.66C927.85 1178.37 920.389 1181.57 912.733 1184.24L878.549 1196.75L835.067 1207.95L830.033 1205.35L820.208 1199.55L807.013 1191.43L789.353 1194.11C783.045 1195.17 776.666 1195.75 770.271 1195.85L748.551 1196.95C738.227 1197.75 727.857 1197.75 717.533 1196.95C714.042 1196.75 710.712 1196.54 707.668 1196.46L689.479 1195.53C688.627 1195.73 687.977 1195.28 685.419 1192.12L672.265 1176.65L657.528 1174.42C655.904 1174.09 654.239 1173.85 652.453 1173.6C648.818 1173.17 645.212 1172.52 641.653 1171.66L618.715 1165.73C609.056 1163.55 599.56 1160.7 590.296 1157.2L576.411 1152.09L559.075 1158.75C556.071 1159.89 553.008 1160.88 549.9 1161.71L546.489 1162.68L540.034 1164.55L523.795 1156.76L518.841 1154.4C515.391 1152.74 511.696 1150.99 507.92 1148.96L473.289 1127.93C469.847 1125.82 466.538 1123.5 463.383 1120.99C461.8 1119.77 460.298 1118.63 458.877 1117.62L444.342 1106.78V1097.44C444.342 1096.18 444.342 1094.68 444.342 1093.38C444.342 1089.12 444.342 1084.33 444.586 1079.09C445.195 1067.56 446.25 1056.43 446.575 1053.11L431.96 1039.38L428.346 1035.32C420.226 1026.63 410.28 1015.84 400.82 1004.67L379.14 975.683C377.719 973.693 376.542 971.623 375.405 969.837C374.837 968.822 374.268 967.847 373.659 966.913L362.738 948.928L365.824 947.06L376.745 965.046L378.531 967.969C379.606 969.899 380.785 971.77 382.063 973.572L403.622 1002.44C412.959 1013.48 422.947 1024.24 430.945 1032.85L434.477 1036.66L450.716 1051.2V1052.01C450.716 1053.59 449.295 1066.02 448.646 1078.93C448.28 1084.04 448.321 1088.79 448.362 1092.97C448.362 1094.48 448.362 1095.94 448.362 1097.28V1104.79L461.434 1114.53C462.855 1115.55 464.398 1116.72 465.982 1117.94C469.034 1120.38 472.234 1122.63 475.563 1124.68L510.153 1145.67C513.807 1147.62 517.421 1149.37 520.831 1150.95L525.825 1153.39L540.684 1160.53L545.799 1159.11C546.814 1158.75 547.992 1158.46 549.25 1158.1C552.248 1157.31 555.203 1156.36 558.101 1155.25L576.695 1148.11L591.96 1153.71C601.079 1157.15 610.426 1159.94 619.933 1162.07L642.384 1167.84C645.814 1168.64 649.283 1169.26 652.778 1169.71C654.605 1169.95 656.35 1170.19 657.974 1170.52L674.214 1172.91L688.18 1189.4C688.802 1190.16 689.466 1190.9 690.169 1191.59L708.033 1192.52C711.037 1192.52 714.407 1192.81 717.939 1193.01C728.1 1193.81 738.308 1193.81 748.469 1193.01L770.312 1191.91C776.557 1191.81 782.786 1191.24 788.947 1190.21L807.988 1187.33L831.982 1201.9L835.717 1203.77L877.656 1192.97L911.799 1180.51C919.327 1177.87 926.666 1174.72 933.763 1171.09L938.717 1168.73L961.899 1157.53C973.185 1151.11 980.899 1146.28 982.848 1145.06C983.781 1142.18 986.664 1133.65 989.181 1125.41C990.672 1120.86 991.932 1116.24 992.957 1111.57L994.54 1104.34L1006.35 1095.49C1008.18 1094.07 1010.41 1092.53 1012.48 1090.9C1018.76 1086.5 1024.71 1081.65 1030.27 1076.37L1053.25 1055.5C1054.98 1053.89 1056.62 1052.18 1058.16 1050.39C1058.89 1049.53 1059.58 1048.8 1060.19 1048.15L1062.26 1045.88V1026.76L1061.77 1005.81H1062.87C1063.15 1005.44 1063.6 1004.91 1064.13 1004.18L1084.06 977.51C1086.79 974.09 1089.24 970.451 1091.37 966.629L1103.35 946.898L1106.19 949.09Z",
    fill: "url(#paint34_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.472 308.312L691.802 310.463C687.093 311.032 682.059 311.844 676.943 312.615L667.565 314.077C664.601 314.604 661.556 315.051 658.552 315.457C653.466 316.001 648.431 316.937 643.49 318.258L607.762 327.434L601.632 329.667L600.861 329.098C600.861 329.098 590.305 321.587 579.059 314.604C569.762 308.717 559.977 303.074 556.364 301.044L552.71 302.343C551.046 303.034 548.65 304.13 546.296 305.348L541.586 307.621C538.5 309.205 534.968 310.829 531.193 312.615C523.925 316.066 515.684 319.963 507.767 324.308L475.491 343.917C472.953 345.387 470.537 347.057 468.264 348.911L465.382 351.063L462.215 353.417L458.155 371.606L454.664 390.606L453.973 391.053C452.9 391.787 451.895 392.616 450.969 393.529L442.565 401.162C440.21 403.395 437.49 405.831 434.445 408.47C429.086 413.22 423.077 418.62 417.556 424.466L394.496 449.8C392.667 451.73 390.984 453.792 389.462 455.971C388.771 456.946 388.162 457.839 387.553 458.57L384.63 462.629L372.045 465.065L360.636 467.461L357.997 470.993L356.455 473.104C354.354 475.874 352.454 478.791 350.771 481.833C348.822 485.121 346.711 488.694 344.315 492.511C339.768 499.94 334.653 508.344 329.74 516.87L312.12 553.409C310.81 556.267 309.658 559.195 308.67 562.179C308.182 563.559 307.736 564.777 307.33 565.792L305.381 571.192L290.806 579.312L277.205 587.432C276.88 588.284 276.15 590.233 275.297 593.197L264.335 635.826C263.158 641.754 262.224 648.006 261.209 654.705C260.722 658.075 260.194 661.444 259.666 664.814C257.096 679.817 255.617 694.987 255.241 710.204C255.241 713.533 254.957 716.7 254.795 719.704C254.107 727.806 253.999 735.947 254.47 744.064C256.134 745.891 262.59 752.874 268.801 759.41C275.013 765.947 280.981 771.996 282.97 773.783H284.026V775.61C284.184 780.176 284.7 784.724 285.569 789.21L290.238 819.863C290.853 824.476 291.817 829.036 293.12 833.504L300.631 862.695C305.875 866.155 311.296 869.339 316.87 872.236L337.86 883.076L335.505 883.969C338.429 892.901 361.408 943.691 365.021 947.02L364.006 948.157L365.062 950.105H362.95C359.743 947.913 334.531 893.957 331.852 884.172L315.247 875.565C309.469 872.613 303.858 869.347 298.439 865.781H297.545L289.426 834.6C288.111 829.965 287.12 825.244 286.462 820.472L281.752 789.454C280.901 785.005 280.372 780.5 280.169 775.975C278.383 774.189 272.049 767.855 265.919 761.562C258.611 753.929 251.181 745.728 251.1 745.647L250.004 744.429L250.613 743.78C250.128 735.582 250.223 727.361 250.897 719.176C251.1 716.294 251.222 713.127 251.384 709.798C251.755 694.431 253.247 679.111 255.85 663.961C256.378 660.632 256.865 657.263 257.393 653.933C258.367 647.235 259.301 640.901 260.56 634.771L271.562 592.019C273.47 585.321 274.079 584.306 274.972 584.143L288.735 576.023L302.174 568.594L303.676 564.534C304.122 563.478 304.528 562.301 304.975 561.002C306.025 557.898 307.231 554.849 308.588 551.867L326.289 515.327C331.283 506.68 336.439 498.276 340.946 490.968C343.3 487.151 345.452 483.619 347.401 480.371C349.25 477.191 351.312 474.139 353.572 471.237L355.115 469.207L358.566 464.538L382.56 459.666L384.711 456.783C385.32 456.052 385.929 455.24 386.579 454.347C388.175 451.894 389.982 449.585 391.979 447.445L414.998 422.111C420.642 416.184 426.731 410.703 432.172 405.872C435.054 403.273 437.774 400.878 440.291 398.604L448.695 390.972C449.591 390.085 450.555 389.271 451.578 388.536L454.907 370.875L458.967 351.306L463.311 348.058C464.251 347.428 465.159 346.75 466.031 346.028C468.458 344.098 471.022 342.347 473.704 340.791L505.981 321.181C514.1 316.756 522.22 312.818 529.65 309.326C533.385 307.581 536.917 305.876 540.043 304.333L544.753 302.059C547.351 300.801 549.625 299.704 551.411 298.974L556.689 297.025L557.42 297.431C560.546 299.177 571.02 305.226 580.967 311.519C590.914 317.812 599.602 323.699 602.241 325.607L606.788 323.942L642.596 314.726C647.715 313.384 652.926 312.421 658.186 311.844C661.109 311.438 664.114 311.032 667.037 310.504L676.456 309.042C681.612 308.23 686.687 307.459 691.599 306.85L734.269 304.698L734.472 308.312Z",
    fill: "url(#paint35_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.62 734.279C1145.05 774.521 1139.14 814.509 1128.04 853.194C1126.29 859.366 1123.98 865.374 1121.79 871.261C1120.57 874.509 1119.39 877.757 1118.25 881.005L1113.18 894.727L1106.68 908.206C1105.1 911.333 1103.68 914.418 1102.22 917.504C1099.66 923.22 1096.81 928.802 1093.69 934.231L1079 958.387C1054.64 993.952 1031.54 1020.91 1007.78 1041.01C999.072 1049.26 989.763 1056.86 979.934 1063.74C976.118 1066.54 972.301 1069.35 968.647 1072.23C964.368 1075.45 959.878 1078.38 955.209 1081C952.814 1082.38 950.5 1083.72 948.226 1085.06C945.953 1086.4 943.314 1088.02 941 1089.48C936.737 1092.12 932.514 1094.72 928.17 1096.99C866.379 1129.51 814.737 1138.85 789.525 1141.69L777.548 1143.56C774.706 1143.84 772.189 1143.93 769.834 1144.05L734.635 1145.83L734.107 1135.56L769.387 1133.82C771.58 1133.82 773.894 1133.61 776.289 1133.37L788.225 1131.54C812.95 1128.9 863.049 1119.77 923.42 1088.18C927.48 1086.03 931.54 1083.55 935.6 1081L942.826 1076.61C945.019 1075.19 947.495 1073.73 950.013 1072.27C954.242 1069.82 958.31 1067.11 962.192 1064.15C965.968 1061.18 969.825 1058.34 973.722 1055.46C983.249 1048.8 992.273 1041.44 1000.72 1033.46C1024.07 1013.68 1046.72 987.416 1070.27 952.866L1084.76 928.953C1087.73 923.83 1090.44 918.559 1092.88 913.16C1094.38 909.952 1095.88 906.785 1097.47 903.659L1103.72 890.749L1108.51 877.513C1109.65 874.306 1110.91 870.977 1112.17 867.648C1114.28 862.004 1116.51 856.118 1118.17 850.312C1128.99 812.561 1134.77 773.545 1135.35 734.279C1134.73 695.13 1128.93 656.236 1118.09 618.612C1116.43 612.684 1114.03 606.838 1112.08 601.154C1110.83 597.825 1109.57 594.536 1108.43 591.207L1103.44 577.647L1097.35 565.102C1095.8 562.016 1094.3 558.85 1092.8 555.683C1090.2 550.121 1087.72 544.843 1084.68 539.849L1070.02 515.733C1046.64 481.427 1023.98 455.159 1001 435.671C992.465 427.559 983.332 420.095 973.682 413.342C969.622 410.459 965.927 407.617 962.152 404.735C958.279 401.758 954.21 399.045 949.972 396.615C947.455 395.194 944.978 393.732 942.624 392.189C940.269 390.647 937.955 389.347 935.559 387.886C931.499 385.369 927.44 382.892 923.38 380.7C863.009 349.114 812.91 340.101 788.428 337.421L775.924 335.513C773.853 335.31 771.539 335.229 769.347 335.107L734.066 333.32L734.594 323.049L769.793 324.876C772.148 324.876 774.665 325.079 777.223 325.322L789.728 327.231C814.696 329.91 866.257 339.41 928.13 371.646C932.474 373.92 936.696 376.518 940.959 379.157L948.023 383.461C950.459 385.003 952.773 386.384 955.169 387.764C959.847 390.385 964.337 393.329 968.607 396.574C972.261 399.376 976.077 402.177 979.893 405.019C989.845 411.98 999.264 419.674 1008.07 428.039C1031.49 447.851 1054.76 474.768 1078.83 510.09L1093.61 534.449C1096.75 539.887 1099.61 545.483 1102.18 551.217C1103.64 554.262 1105.06 557.347 1106.6 560.392L1112.94 573.506L1118.17 587.594C1119.35 590.964 1120.53 594.171 1121.75 597.419C1123.98 603.265 1126.25 609.355 1128.04 615.607C1139.11 654.215 1145.03 694.119 1145.62 734.279Z",
    fill: "url(#paint36_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.77 734.401V735.132C1174.64 766.596 1172.04 807.479 1161.36 844.75C1160.67 847.267 1159.98 849.987 1159.33 852.666C1158.05 858.414 1156.48 864.092 1154.62 869.678L1146.5 892.251C1142.9 902.775 1138.51 913.009 1133.35 922.863C1131.56 926.476 1129.82 930.008 1128.23 933.5L1123.73 942.837C1122.22 945.72 1120.92 947.831 1119.67 949.983L1097.21 985.792L1077.16 1012.67L1044.27 988.065L1069.08 954.083L1084.71 928.384C1085.52 927.085 1086.37 925.786 1087.11 924.324L1091.17 916.204C1092.71 912.713 1094.66 908.815 1096.65 904.796C1100.98 896.515 1104.7 887.926 1107.77 879.097L1116.26 855.874C1117.6 852.098 1118.73 847.551 1119.91 842.679C1120.64 839.634 1121.41 836.549 1122.26 833.463C1131.68 800.659 1134.12 763.389 1135.13 734.36C1134.12 705.372 1131.68 668.061 1122.3 635.46C1121.41 632.172 1120.64 629.127 1119.91 626.082C1118.73 621.21 1117.6 616.663 1116.17 612.643L1108.05 590.517C1104.93 581.375 1101.12 572.485 1096.65 563.924C1094.66 559.864 1092.59 555.804 1090.96 552.151L1086.9 543.584L1084.83 540.174L1066.44 510.049L1044.4 480.574L1077.28 455.93L1100.5 488.044L1119.26 518.818C1120.56 520.97 1121.9 523.122 1123.08 525.396L1127.7 534.977C1129.49 539.037 1131.24 542.407 1133.02 546.02C1138.32 556.105 1142.82 566.584 1146.5 577.363L1154.38 598.88C1156.35 604.606 1158.02 610.434 1159.37 616.338C1160.02 619.018 1160.71 621.738 1161.44 624.458C1172.08 661.444 1174.68 702.368 1175.81 733.832L1175.77 734.401Z",
    fill: "url(#paint37_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.643 333.402L699.362 335.188C697.17 335.188 694.856 335.188 692.46 335.635L680.524 337.462C655.799 340.101 605.7 349.195 545.33 380.781C541.27 382.974 537.21 385.45 533.15 387.967C530.755 389.429 528.359 390.931 525.923 392.352C523.487 393.773 521.254 395.275 518.737 396.696C514.508 399.14 510.44 401.852 506.557 404.816C502.782 407.739 498.925 410.581 495.027 413.464C485.449 420.035 476.383 427.323 467.907 435.265C444.563 455.037 421.909 481.305 398.361 515.814L383.867 539.768C380.894 544.891 378.184 550.162 375.747 555.561C374.245 558.728 372.743 561.895 371.16 565.061L364.908 577.972L360.076 591.167C358.98 594.415 357.722 597.703 356.463 601.032C354.352 606.716 352.119 612.563 350.454 618.409C339.633 656.159 333.858 695.176 333.281 734.442C333.876 773.586 339.65 812.48 350.454 850.109C352.119 855.996 354.514 861.883 356.463 867.526C357.722 870.855 358.98 874.184 360.117 877.514L365.111 891.033L371.2 903.619C372.743 906.664 374.245 909.831 375.747 913.038C378.346 918.6 380.822 923.878 383.867 928.872L398.524 952.988C421.909 987.294 444.563 1013.56 467.542 1033.05C476.084 1041.15 485.217 1048.6 494.865 1055.34C498.925 1058.22 502.619 1061.06 506.395 1063.99C510.268 1066.96 514.337 1069.68 518.575 1072.11C521.092 1073.57 523.528 1075.03 525.923 1076.57L532.987 1080.63C537.047 1083.19 541.107 1085.67 545.167 1087.82C605.538 1119.4 655.637 1128.42 680.118 1131.14L692.582 1133.05C694.693 1133.25 697.008 1133.33 699.2 1133.45L734.48 1135.2L733.953 1145.47L698.753 1143.68C696.358 1143.68 693.881 1143.68 691.324 1143.2L678.819 1141.33C653.851 1138.65 602.29 1129.15 540.417 1096.91C536.073 1094.64 531.851 1092.04 527.588 1089.4C525.274 1087.94 522.919 1086.52 520.524 1085.1C518.128 1083.68 515.773 1082.17 513.378 1080.79C508.7 1078.17 504.209 1075.23 499.94 1071.98C496.286 1069.14 492.47 1066.34 488.653 1063.54C478.703 1056.58 469.285 1048.88 460.478 1040.52C437.011 1020.71 413.789 993.749 389.714 958.428L374.895 934.068C371.647 928.588 368.967 922.863 366.369 917.301C364.908 914.215 363.487 911.13 361.944 908.085L355.61 894.971L350.373 880.883C349.196 877.554 348.018 874.306 346.8 871.058C344.567 865.212 342.294 859.163 340.508 852.91C329.457 814.341 323.559 774.478 322.969 734.36C323.54 694.119 329.452 654.131 340.548 615.445C342.294 609.274 344.608 603.265 346.8 597.338C348.018 594.09 349.196 590.883 350.333 587.635L355.407 573.912L361.903 560.433C363.487 557.266 364.908 554.181 366.369 551.136C368.927 545.42 371.772 539.837 374.895 534.409L389.592 510.049C413.951 474.484 437.011 447.567 460.802 427.47C469.496 419.197 478.807 411.596 488.653 404.735C492.47 401.893 496.286 399.092 499.94 396.25C504.22 393.031 508.709 390.102 513.378 387.48C515.773 386.1 518.088 384.719 520.361 383.42C522.635 382.121 525.274 380.456 527.588 379.035C531.648 376.397 536.073 373.798 540.417 371.525C602.29 339.045 653.851 329.789 679.063 327.109L691.039 325.241C693.881 324.957 696.358 324.835 698.753 324.754L733.953 322.927L734.643 333.402Z",
    fill: "url(#paint38_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.831 480.615L400.025 514.596L384.395 540.255C383.583 541.595 382.73 542.894 381.999 544.315L377.939 552.435C376.356 555.886 374.448 559.824 372.458 563.843C368.09 572.109 364.371 580.701 361.334 589.543L352.849 612.725C351.509 616.541 350.373 621.088 349.195 625.919C348.464 629.005 347.693 632.05 346.84 635.136C337.421 667.94 334.986 705.251 333.971 734.238C334.986 763.267 337.421 800.578 346.8 833.179C347.693 836.427 348.464 839.512 349.195 842.557C350.373 847.429 351.509 851.976 352.93 855.996L361.05 878.122C364.161 887.254 367.976 896.132 372.458 904.674C374.448 908.734 376.518 912.794 378.142 916.489L382.202 925.055L384.273 928.465L402.664 958.55L424.709 988.065L391.824 1012.67L368.114 980.839L349.358 950.064C348.058 947.913 346.719 945.761 345.541 943.447L340.913 933.906C339.127 929.846 337.381 926.476 335.595 922.863C330.31 912.737 325.817 902.218 322.156 891.398L314.239 869.881C312.088 863.791 310.667 857.985 309.286 852.423C308.637 849.703 307.947 847.023 307.216 844.303C296.579 807.277 293.94 766.393 292.844 734.929V733.508C293.94 702.043 296.579 661.16 307.256 623.89C307.947 621.332 308.637 618.652 309.286 615.77C310.622 609.936 312.262 604.177 314.199 598.515L322.319 575.942C325.919 565.419 330.317 555.185 335.473 545.33C337.259 541.717 339.005 538.184 340.588 534.693L345.095 525.355C346.597 522.472 347.896 520.321 349.155 518.25L371.606 482.36L391.662 455.484L424.831 480.615Z",
    fill: "url(#paint39_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.52 735.7C1235.57 768.177 1232.54 800.585 1226.46 832.489C1216.56 877.148 1203.36 917.098 1189.31 945.355C1187 950.064 1184.89 954.49 1182.98 958.468C1179.73 965.289 1177.01 970.932 1174.86 975.195L1168.69 985.386L1162.11 981.326L1168.2 971.338C1170.31 967.278 1172.95 961.797 1176.32 955.099C1178.23 951.039 1180.38 946.654 1182.7 941.863C1196.5 914.134 1209.45 874.712 1219.24 830.865C1229.5 776.519 1230.93 720.876 1223.5 666.072C1214.84 603.131 1193.93 542.496 1161.95 487.598C1130.14 432.667 1088.09 384.347 1038.08 345.256C994.72 310.859 945.665 284.326 893.144 266.859C884.638 263.519 875.9 260.805 866.999 258.739L859.772 256.872C855.915 255.978 852.099 254.964 848.323 253.949C842.114 252.146 835.812 250.682 829.444 249.564L801.959 245.504C799.198 245.138 796.397 244.692 793.839 244.245C789.032 243.311 784.158 242.754 779.264 242.581L734.199 240.388L734.565 232.715L779.224 234.989C784.474 235.124 789.703 235.708 794.854 236.734C797.452 237.14 800.132 237.587 802.974 237.952L830.581 242.012C837.181 243.208 843.714 244.753 850.15 246.641C853.844 247.615 857.62 248.63 861.477 249.564L868.704 251.391C877.864 253.43 886.861 256.144 895.621 259.511C948.903 277.19 998.663 304.097 1042.63 339.004C1093.45 378.69 1136.18 427.771 1168.49 483.578C1200.84 539.34 1221.97 600.895 1230.68 664.773C1233.88 688.281 1235.49 711.976 1235.52 735.7Z",
    fill: "url(#paint40_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.01 699.526L1226.28 701.069L1226 695.832C1226 694.939 1226 693.396 1225.79 691.772C1225.79 689.133 1225.55 685.925 1225.14 682.272C1224.74 678.618 1223.76 673.583 1222.95 667.94C1221.37 657.222 1219.58 645.083 1217.02 631.401C1205.79 581.11 1187.08 532.788 1161.53 488.045L1148.45 466.527C1145.87 461.966 1142.97 457.597 1139.76 453.454L1114.63 420L1080.98 383.461L1064.33 368.358C1053.9 358.407 1042.77 349.209 1031.04 340.831L1012.89 327.271C1011.92 326.488 1010.9 325.756 1009.85 325.079L1025.76 298.73C1027.78 299.955 1029.72 301.311 1031.57 302.79L1049.31 316.025C1062.04 325.129 1074.11 335.113 1085.44 345.906L1106.88 365.8L1138.83 400.959L1164.04 434.535C1168.02 439.684 1171.63 445.111 1174.84 450.774L1188 472.454C1215.3 520.199 1235.25 571.784 1247.19 625.473C1249.95 640.211 1251.86 653.202 1253.4 663.636C1254.21 669.077 1254.94 673.949 1255.63 678.171C1256.24 683.49 1256.45 687.468 1256.57 690.716C1256.57 692.056 1256.57 693.193 1256.57 694.208L1257.01 699.526Z",
    fill: "url(#paint41_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.55 985.183L1150.57 1014.82L1122.15 1052.86C1120.04 1055.34 1118.09 1057.65 1115.81 1059.97L1091.01 1087.25C1085.81 1092.41 1080.37 1097.32 1074.77 1102.39C1071.56 1105.28 1068.31 1108.2 1065.02 1111.24C1022.7 1148.23 974.586 1178.01 922.603 1199.39C801.953 1248.47 666.9 1248.47 546.25 1199.39C494.391 1177.99 446.389 1148.25 404.154 1111.33C400.784 1108.2 397.536 1105.28 394.329 1102.39C388.686 1097.32 383.245 1092.41 378.089 1087.41L353.162 1059.97C351.01 1057.65 349.102 1055.34 346.991 1053.07L317.15 1012.83L300.383 985.183L306.96 981.124L324.986 1010.8L352.959 1048.19C354.745 1050.22 356.734 1052.46 358.805 1054.73L383.651 1082.05C388.483 1086.8 393.882 1091.63 399.404 1096.63C402.652 1099.55 405.94 1102.52 409.229 1105.56C450.854 1141.92 498.174 1171.19 549.295 1192.2C668.064 1240.56 801.034 1240.56 919.802 1192.2C970.982 1171.17 1018.36 1141.88 1060.03 1105.48C1063.2 1102.52 1066.49 1099.55 1069.73 1096.63C1075.26 1091.63 1080.66 1086.8 1085.61 1081.89L1110.29 1054.73C1112.4 1052.46 1114.35 1050.22 1116.3 1048.03L1145.37 1008.77L1162.18 981.124L1168.55 985.183Z",
    fill: "url(#paint42_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.198 1204.78L944.208 1214.77C941.813 1215.91 939.296 1217.17 936.535 1218.22L896.748 1232.8C844.161 1249.27 789.455 1258 734.352 1258.7C679.476 1258.02 624.99 1249.36 572.606 1233L532.413 1218.3C529.645 1217.26 526.935 1216.06 524.293 1214.73L503.344 1204.66L516.701 1176.89L534.686 1185.58C535.539 1185.95 536.757 1186.52 537.975 1187.16C539.193 1187.81 541.223 1188.75 543.09 1189.48L582.39 1203.85C631.587 1219.12 682.724 1227.23 734.23 1227.93C785.939 1227.17 837.27 1218.96 886.639 1203.57L925.492 1189.32C927.116 1188.71 928.781 1187.86 930.364 1187.08C931.948 1186.31 932.8 1185.87 933.977 1185.34L951.638 1176.81L965.198 1204.78Z",
    fill: "url(#paint43_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.554 240.388L689.895 242.662C684.933 242.822 679.991 243.378 675.117 244.327C672.438 244.773 669.637 245.22 666.795 245.585L639.39 249.645C633.022 250.759 626.719 252.223 620.512 254.03C616.736 255.045 612.92 256.06 608.982 257.034L601.836 258.821C593.026 260.883 584.382 263.597 575.975 266.94C523.345 284.394 474.19 310.957 430.752 345.419C380.741 384.509 338.692 432.829 306.884 487.76C275.033 542.646 254.235 603.236 245.661 666.113C238.159 720.932 239.53 776.602 249.721 830.986C259.465 874.752 272.416 914.174 286.26 941.863C288.615 946.694 290.726 951.079 292.634 955.139C295.841 961.797 298.48 967.319 300.754 971.379L306.722 981.204L300.145 985.264L293.933 975.236C291.578 970.77 288.858 965.126 285.813 958.306C283.905 954.246 281.754 949.902 279.48 945.152C265.433 916.732 252.238 876.904 242.332 832.448C231.92 777.217 230.454 720.672 237.988 664.976C246.701 601.098 267.83 539.543 300.185 483.781C332.492 427.974 375.218 378.893 426.042 339.207C470.071 304.24 519.898 277.279 573.254 259.551C581.924 256.205 590.825 253.491 599.887 251.431L607.033 249.604C611.093 248.671 614.747 247.656 618.441 246.681C624.918 244.812 631.491 243.294 638.132 242.134L665.617 238.074L673.737 236.816C678.968 235.773 684.279 235.189 689.611 235.07L734.27 232.796L734.554 240.388Z",
    fill: "url(#paint44_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.153 313.468L459.007 324.835C457.995 325.485 457.019 326.19 456.084 326.947L437.774 340.629C426.151 348.901 415.122 357.977 404.767 367.789L379.921 391.459L354.1 419.878L329.334 452.845C326.019 457.114 323.021 461.619 320.362 466.324L307.045 488.045C281.505 532.861 262.825 581.251 251.628 631.604C249.151 644.92 247.365 657.1 245.781 667.818C244.969 673.421 244.198 678.415 243.508 682.799C243.183 685.723 243.061 688.93 242.94 691.569C242.94 693.315 242.94 694.857 242.696 696.197V700.988L211.922 699.445L212.165 694.208C212.165 692.787 212.165 691.65 212.368 690.148C212.368 686.9 212.693 682.921 213.221 678.374C213.749 673.827 214.723 668.549 215.495 663.149C217.078 652.715 218.986 639.724 221.666 625.351C233.555 571.609 253.483 519.968 280.778 472.17L294.175 450.084C297.473 444.32 301.177 438.798 305.259 433.56L331.039 399.376L371.07 356.746L383.615 345.297C394.828 334.629 406.78 324.766 419.383 315.782L437.368 302.384C439.036 301.064 440.77 299.831 442.565 298.689L450.685 311.681L466.153 313.468Z",
    fill: "url(#paint45_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.545 279.539L734.305 284.202L752.834 285.157L753.074 280.494L734.545 279.539Z",
    fill: "url(#paint46_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.139 288.296L822.367 292.925L819.404 292.478L796.262 288.946L796.952 284.358L820.053 287.85L823.139 288.296ZM779.292 281.8L779.048 286.469L770.238 286.023L770.482 281.354L779.292 281.8Z",
    fill: "url(#paint47_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.89 707.28L1183.22 707.524L1182.98 702.814C1182.98 701.434 1182.98 699.688 1182.74 697.78C1182.65 693.364 1182.3 688.958 1181.68 684.585C1181.68 683.611 1181.32 682.555 1181.15 681.459L1185.74 680.688C1185.74 681.743 1186.11 682.799 1186.31 683.814C1186.95 688.389 1187.32 692.998 1187.41 697.617C1187.41 699.444 1187.41 701.109 1187.65 702.53L1187.89 707.28ZM1183.06 663.352L1178.43 664.042C1178.03 661.241 1177.58 658.358 1177.09 655.354L1181.68 654.623C1182.33 657.627 1182.78 660.55 1183.06 663.352ZM1178.43 637.165L1173.85 638.139C1172.47 631.847 1170.96 625.96 1169.22 620.113C1167.47 614.267 1166.42 609.639 1164.79 604.239L1169.3 602.899C1170.92 608.34 1172.38 613.658 1173.72 618.855C1175.63 624.701 1177.18 630.71 1178.6 637.165H1178.43ZM1165.24 590.232L1160.81 591.734C1158.05 583.615 1155.01 575.251 1151.72 567.05L1156.02 565.304C1159.51 573.587 1162.76 581.95 1165.4 590.232H1165.24ZM1149 548.983L1144.74 550.892C1143.56 548.212 1142.34 545.573 1141.08 542.772L1145.14 540.782C1146.85 543.584 1148.07 546.304 1149.28 548.943L1149 548.983ZM1137.47 525.03L1133.41 527.182C1128.01 516.707 1122.2 506.395 1116.2 496.61L1120.26 494.174C1126.47 504.04 1132.31 514.433 1137.75 525.03H1137.47ZM1113.11 482.928L1109.05 485.527C1104.26 478.178 1099.18 470.952 1093.95 464.009L1097.68 461.167C1103.2 468.191 1108.36 475.499 1113.23 482.928H1113.11ZM1086.84 447.201L1083.23 450.205L1078.24 444.237L1077.59 443.628L1081 440.421L1081.69 441.152L1086.84 447.201ZM1069.38 427.388L1065.89 430.474C1058.36 421.648 1050.22 413.359 1041.53 405.668L1044.54 402.095C1053.41 409.928 1061.71 418.38 1069.38 427.388ZM1034.63 393.285L1031.51 396.736L1021.11 387.317L1011.33 379.969L1014.13 376.274L1026.31 385.612L1034.63 393.285ZM1000.12 365.596L997.281 369.291C994.967 367.545 992.653 365.799 990.257 364.175L992.937 360.115C995.332 362.186 997.728 363.769 1000.08 365.596H1000.12ZM977.996 350.656L975.601 354.716L967.887 350.006C965.045 348.342 962.285 346.636 959.524 344.972L949.618 338.963C948.359 338.273 946.938 337.583 945.558 336.893L947.588 332.833L951.972 335.025L962 341.074C964.721 342.78 967.522 344.444 970.323 346.149L977.996 350.656ZM935.408 326.865L933.378 330.925L920.224 324.591C916.936 322.845 913.485 321.221 909.628 319.597L911.414 315.294C915.474 316.958 919.006 318.664 922.376 320.45L935.408 326.865ZM894.809 309.407L893.226 313.792L885.837 311.031L884.944 310.706L886.567 306.321L887.461 306.646C889.978 307.499 892.373 308.351 894.809 309.407ZM869.881 300.353L868.42 304.819C865.294 303.752 862.108 302.871 858.879 302.18L834.52 295.928L835.697 291.381L860.056 297.633C863.405 298.312 866.712 299.18 869.963 300.232L869.881 300.353Z",
    fill: "url(#paint48_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.22 734.28L1184.6 734.564L1183.62 716.01L1188.29 715.767L1189.22 734.28Z",
    fill: "url(#paint49_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.22 734.564L1188.29 753.077L1183.62 752.793L1184.6 734.28L1189.22 734.564Z",
    fill: "url(#paint50_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.44 770.534L1186.99 779.344L1182.32 779.101L1182.77 770.291L1187.44 770.534ZM1184.43 797.005L1180.9 820.106C1180.9 821.202 1180.62 822.258 1180.5 823.192L1175.87 822.42C1175.87 821.527 1176.15 820.553 1176.31 819.497L1179.85 796.315L1184.43 797.005Z",
    fill: "url(#paint51_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.52 835.737L1171.27 860.097C1170.55 863.461 1169.64 866.782 1168.55 870.044L1164.08 868.623C1165.14 865.481 1166.02 862.282 1166.72 859.041L1172.98 834.682L1177.52 835.737ZM1162.74 886.69L1162.42 887.583C1161.49 889.978 1160.63 892.455 1159.7 894.931L1155.31 893.348C1156.25 890.79 1157.14 888.354 1158.08 885.959L1158.4 885.066L1162.74 886.69ZM1153.53 911.577C1151.86 915.637 1150.16 919.169 1148.37 922.539L1142.08 935.571L1138.02 933.541L1144.35 920.428C1146.1 917.098 1147.72 913.648 1149.35 909.791L1153.53 911.577ZM1136.36 947.467C1135.65 948.928 1134.92 950.39 1134.16 951.851L1128.07 961.88L1123.04 969.999C1121.5 972.557 1119.91 975.196 1118.29 977.794L1114.23 975.358C1115.85 972.76 1117.4 970.162 1118.98 967.563C1120.56 964.965 1122.31 961.961 1124.01 959.444L1130.02 949.537C1130.71 948.279 1131.4 946.858 1132.09 945.477L1136.36 947.467ZM1108.67 992.938C1106.96 995.374 1105.22 997.769 1103.39 1000.12L1099.69 997.282C1101.44 994.968 1103.19 992.654 1104.81 990.258L1108.67 992.938ZM1092.71 1014.13L1083.37 1026.31L1075.7 1034.71L1072.25 1031.59L1081.55 1021.11L1088.85 1011.33L1092.71 1014.13ZM1066.69 1044.26C1058.88 1053.2 1050.43 1061.56 1041.39 1069.26L1038.27 1065.81C1047.12 1058.29 1055.42 1050.15 1063.11 1041.45L1066.69 1044.26ZM1028.36 1081.08L1027.63 1081.77C1025.56 1083.56 1023.57 1085.26 1021.54 1086.88L1018.58 1083.31L1024.5 1078.32L1025.15 1077.67L1028.36 1081.08ZM1007.62 1097.89C1000.55 1103.17 993.244 1108.32 985.814 1113.19L983.256 1109.13C990.605 1104.34 997.831 1099.23 1004.77 1094.03L1007.62 1097.89ZM974.609 1120.3C964.703 1126.43 954.309 1132.27 943.753 1137.72L941.602 1133.66C952.076 1128.26 962.388 1122.45 972.173 1116.4L974.609 1120.3ZM927.839 1145.75L919.719 1149.45L917.811 1145.39L925.931 1141.73L927.839 1145.75ZM903.479 1156.35C895.359 1159.68 886.793 1162.76 878.551 1165.57L877.049 1161.14C885.169 1158.38 893.532 1155.34 901.733 1152.01L903.479 1156.35ZM865.844 1169.59C860.444 1171.25 855.085 1172.71 849.929 1174.05C844.083 1175.8 838.034 1177.34 831.619 1178.76L830.645 1174.17C836.938 1172.79 842.824 1171.29 848.671 1169.54C853.867 1168.21 859.145 1166.74 864.504 1165.12L865.844 1169.59ZM814.161 1182.01L805.433 1183.35L804.742 1178.76C807.544 1178.31 810.426 1177.91 813.431 1177.38L814.161 1182.01ZM788.016 1186.07L784.889 1186.64C780.312 1187.26 775.704 1187.63 771.086 1187.73C769.259 1187.73 767.594 1187.73 766.214 1187.98L761.423 1188.22L761.18 1183.55L765.849 1183.31C767.27 1183.31 768.975 1183.11 770.923 1183.06C775.339 1182.98 779.745 1182.63 784.118 1182.01L787.244 1181.48L788.016 1186.07Z",
    fill: "url(#paint52_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.744 1183.71L734.215 1184.66L734.453 1189.32L752.982 1188.38L752.744 1183.71Z",
    fill: "url(#paint53_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.026 1183.79L715.789 1188.45L734.319 1189.39L734.556 1184.73L716.026 1183.79Z",
    fill: "url(#paint54_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.502 1182.78L698.258 1187.45L689.449 1187.04L689.692 1182.37L698.502 1182.78ZM672.478 1179.86L671.747 1184.48L648.687 1180.99L645.602 1180.51L646.373 1175.92L649.296 1176.32L672.478 1179.86Z",
    fill: "url(#paint55_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.185 1173.04L633.007 1177.58L608.648 1171.33C605.288 1170.59 601.968 1169.69 598.701 1168.61L600.122 1164.14C603.263 1165.21 606.462 1166.09 609.703 1166.78L634.185 1173.04ZM583.72 1158.26L582.096 1162.6L581.203 1162.28L574.058 1159.56L575.641 1155.17L583.03 1157.89L583.72 1158.26ZM558.995 1149.04L557.209 1153.39C553.149 1151.68 549.617 1150.02 546.247 1148.23L533.215 1141.94L535.245 1137.88L548.358 1144.17C551.818 1145.98 555.368 1147.6 558.995 1149.04ZM523.349 1132.03L521.319 1136.09L516.935 1133.9L506.907 1127.81L498.584 1122.77C495.986 1121.19 493.387 1119.65 490.789 1118.02L493.184 1113.96L500.979 1118.67L509.343 1123.75L519.249 1129.76C520.507 1130.65 521.928 1131.34 523.349 1132.03ZM478.69 1104.67L476.011 1108.48C473.575 1106.82 471.18 1105.07 468.825 1103.21L471.667 1099.51C473.819 1101.34 476.133 1103 478.528 1104.67H478.69ZM457.457 1088.91L454.615 1092.61L442.436 1083.23L433.991 1075.6L437.117 1072.15L447.51 1081.57L457.457 1088.91ZM427.414 1063.21L424.41 1066.79C415.484 1058.96 407.126 1050.51 399.401 1041.49L402.892 1038.37C410.467 1047.21 418.662 1055.5 427.414 1063.17V1063.21ZM390.875 1025.25L387.424 1028.46L386.774 1027.73C384.988 1025.66 383.283 1023.67 381.618 1021.64L385.232 1018.68C386.855 1020.67 388.561 1022.74 390.225 1024.6L390.875 1025.25ZM374.392 1004.95L370.656 1007.8C365.379 1000.73 360.223 993.425 355.351 985.995L359.411 983.437C364.242 990.664 369.317 997.891 374.554 1004.83L374.392 1004.95ZM352.184 972.475L348.124 974.911C342.034 965.005 336.188 954.612 330.707 944.056L334.767 941.904C340.532 952.135 346.338 962.447 352.346 972.232L352.184 972.475ZM327.216 926.192L323.156 928.141C321.897 925.461 320.679 922.782 319.461 920.021L323.724 918.113C324.901 920.589 326.119 923.269 327.378 925.949L327.216 926.192ZM316.7 901.833L312.397 903.578C309.068 895.459 305.942 886.892 303.181 878.61L307.606 877.148C310.529 885.268 313.574 893.591 316.863 901.792L316.7 901.833ZM303.627 864.603L299.121 865.983C297.497 860.502 296.035 855.184 294.696 850.028C292.95 844.182 291.407 838.173 289.986 831.718L294.574 830.703C295.954 837.036 297.456 842.882 299.202 848.769C300.704 853.925 302.044 859.203 303.79 864.562L303.627 864.603ZM291.448 813.529L286.86 814.26C286.373 811.256 285.926 808.332 285.48 805.531L290.108 804.841C290.555 807.561 291.001 810.484 291.488 813.489L291.448 813.529ZM287.388 787.343L282.8 788.114C282.597 787.018 282.435 786.003 282.232 784.988C281.589 780.413 281.223 775.803 281.136 771.184C281.136 769.357 281.136 767.693 280.892 766.272L280.648 761.521L285.317 761.278L285.561 765.947C285.561 767.368 285.561 769.073 285.805 771.022C285.891 775.437 286.243 779.843 286.86 784.216C287.225 785.11 287.428 786.206 287.591 787.302L287.388 787.343Z",
    fill: "url(#paint56_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.087 752.793L280.459 753.077L279.484 734.564L284.153 734.28L285.087 752.793Z",
    fill: "url(#paint57_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.087 716.01L284.153 734.564L279.484 734.28L280.459 715.767L285.087 716.01Z",
    fill: "url(#paint58_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.879 646.382C292.879 647.275 292.595 648.29 292.433 649.345L288.901 672.527L284.313 671.797L287.804 648.736C287.804 647.64 288.129 646.584 288.251 645.61L292.879 646.382ZM286.424 689.742L285.977 698.552L281.309 698.308L281.755 689.498L286.424 689.742Z",
    fill: "url(#paint59_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.556 285.534L702.887 285.819C701.466 285.819 699.761 285.819 697.812 286.062C693.399 286.152 688.993 286.49 684.618 287.077L681.492 287.645L680.72 283.017L683.846 282.489C688.421 281.846 693.031 281.48 697.65 281.393C699.477 281.393 701.142 281.393 702.562 281.15L707.313 280.906L707.556 285.534ZM663.993 290.203L655.265 291.543L654.534 286.915L663.263 285.575L663.993 290.203ZM638.091 294.791C631.798 296.171 625.912 297.674 620.065 299.419C614.219 301.165 609.591 302.221 604.232 303.804L602.892 299.338C608.292 297.714 613.651 296.253 618.807 294.913C624.653 293.167 630.662 291.624 637.117 290.203L638.091 294.791ZM591.687 307.823C583.567 310.544 575.203 313.629 567.002 316.918L565.257 312.573C573.376 309.285 581.943 306.159 590.184 303.398L591.687 307.823ZM550.844 323.779C548.164 324.956 545.526 326.174 542.724 327.433L540.775 323.373L548.895 319.678L550.844 323.779ZM527.134 335.187C516.66 340.587 506.348 346.393 496.563 352.401L494.127 348.341C504.033 342.252 514.427 336.405 524.982 330.924L527.134 335.187ZM485.48 359.547C478.131 364.378 470.905 369.453 463.962 374.69L461.12 370.955C468.144 365.677 475.492 360.521 482.881 355.649L485.48 359.547ZM450.158 385.53C448.169 387.154 446.099 388.86 444.19 390.565L443.581 391.174L440.374 387.723L441.105 387.073C443.175 385.246 445.165 383.582 447.195 381.917L450.158 385.53ZM430.468 402.785C421.61 410.296 413.306 418.437 405.621 427.145L402.049 424.14C409.865 415.205 418.318 406.846 427.342 399.131L430.468 402.785ZM396.69 437.173L387.311 447.729L379.963 457.472L376.268 454.671L385.647 442.491L393.279 434.047L396.69 437.173ZM369.245 471.357C367.458 473.712 365.753 476.026 364.129 478.422L360.272 475.742C361.977 473.306 363.723 470.911 365.55 468.515L369.245 471.357ZM354.588 493.078C353.005 495.717 351.462 498.315 349.879 500.873C348.296 503.431 346.509 506.476 344.845 509.236L338.836 519.143C338.146 520.401 337.456 521.822 336.765 523.203L332.706 521.173C333.382 519.711 334.113 518.25 334.898 516.788L340.988 506.76C342.652 503.999 344.357 501.238 346.022 498.64C347.687 496.042 349.148 493.443 350.772 490.804L354.588 493.078ZM331.041 535.139L324.708 548.252C322.962 551.582 321.338 555.033 319.714 558.889L315.41 557.103C317.075 553.043 318.78 549.511 320.566 546.141L326.819 533.109L331.041 535.139ZM313.624 575.332C312.69 577.849 311.797 580.326 310.863 582.721L310.538 583.614L306.154 581.95L306.519 581.057C307.453 578.661 308.346 576.225 309.239 573.749L313.624 575.332ZM304.652 600.098C303.597 603.292 302.729 606.546 302.053 609.842L295.76 634.201L291.254 633.024L297.506 608.664C298.224 605.3 299.132 601.979 300.226 598.717L304.652 600.098Z",
    fill: "url(#paint60_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.272 279.495L715.742 280.427L715.977 285.091L734.507 284.158L734.272 279.495Z",
    fill: "url(#paint61_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.26 598.272L1259.27 599.571L1254.11 579.677L1259.1 578.419L1264.26 598.272ZM1252.65 558.687L1247.82 560.433L1240.83 541.27L1245.62 539.484L1252.65 558.687ZM1238.32 519.996L1233.65 522.107C1232.51 519.631 1231.29 517.154 1230.12 514.718C1228.94 512.282 1228.21 510.861 1227.31 508.912L1224.76 503.675L1229.39 501.442L1231.94 506.72C1232.84 508.628 1233.77 510.78 1234.7 512.445C1235.84 514.962 1237.06 517.479 1238.2 519.996H1238.32ZM1220.49 482.929L1215.87 485.162L1211.16 475.865C1209.61 473.145 1207.95 470.262 1206.28 467.42L1210.71 464.822C1212.37 467.704 1214.08 470.587 1215.7 473.469L1220.49 482.929ZM1200.19 446.999L1195.85 449.719C1192.25 444.008 1188.52 438.31 1184.65 432.626L1188.91 429.744C1192.59 435.482 1196.27 441.233 1199.95 446.999H1200.19ZM1177.01 412.895L1172.95 415.9C1168.97 410.486 1164.91 405.073 1160.77 399.66L1164.83 396.493C1168.61 401.852 1172.75 407.374 1176.77 412.895H1177.01ZM1151.64 380.416L1147.58 383.704C1143.22 378.48 1138.77 373.324 1134.22 368.236L1138.04 364.785C1142.56 369.928 1147.01 375.138 1151.39 380.416H1151.64ZM1124.07 349.601L1120.42 353.255L1118.1 350.9C1114.04 346.84 1109.98 343.024 1105.72 339.167L1109.17 335.391C1113.43 339.451 1117.62 343.227 1121.76 347.246L1124.07 349.601ZM1093.5 321.587L1090.17 325.647C1084.97 321.208 1079.72 316.864 1074.42 312.615L1077.63 308.555C1082.99 312.858 1088.26 317.203 1093.5 321.587ZM1061.26 295.969L1058.18 300.029C1052.77 295.942 1047.24 291.882 1041.61 287.849L1044.54 283.789C1050.18 287.849 1055.78 291.869 1061.26 295.969ZM1027.41 272.422L1024.73 276.928C1019 273.193 1013.2 269.58 1007.39 266.088L1010.07 261.703C1015.83 265.032 1021.64 268.808 1027.45 272.422H1027.41ZM991.84 251.351L989.608 255.938L971.135 247.047L973.368 242.419L991.84 251.351ZM954.895 233.487L952.622 238.115C949.699 236.694 946.776 235.273 943.771 234.055L933.906 230.442L935.651 225.611L945.639 229.265C948.846 230.564 951.891 232.025 954.936 233.487H954.895ZM916.367 218.546L914.621 223.378L895.58 216.476L896.798 211.482L900.087 212.578L916.367 218.546ZM876.945 206.367L875.687 211.32L865.984 208.802C862.573 208.031 859.122 207.097 855.793 206.204L857.133 201.21C860.422 202.104 863.791 203.037 867.202 203.809L876.945 206.367ZM836.793 196.826L836.021 201.901L815.722 198.815L816.493 193.74L836.793 196.826ZM796.194 190.655L795.463 195.729L790.063 194.917L775.245 194.187L775.529 189.031L790.591 189.843L796.194 190.655ZM754.986 187.934L754.702 193.091L734.199 192.035L734.483 186.919L754.986 187.934Z",
    fill: "url(#paint62_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.87 734.564L1280.81 755.067L1275.69 754.783L1276.75 734.483L1281.87 734.564ZM1279.79 775.569L1278.98 790.632L1278.13 796.275L1273.06 795.504L1273.91 790.104L1274.64 775.326L1279.79 775.569ZM1275.04 816.575L1271.96 836.874L1266.88 836.103L1269.97 815.803L1275.04 816.575ZM1267.53 857.174C1266.64 860.463 1265.75 863.792 1264.94 867.243L1262.42 876.986L1257.47 875.728L1259.98 866.025C1260.75 862.574 1261.69 859.163 1262.58 855.834L1267.53 857.174ZM1257.3 896.84L1256.17 900.128L1250.24 916.368L1245.41 914.622L1252.31 895.581L1257.3 896.84ZM1243.17 935.693L1239.52 945.64C1238.22 948.847 1236.76 951.892 1235.26 954.897L1230.67 952.664C1232.09 949.7 1233.51 946.777 1234.73 943.813L1238.34 933.947L1243.17 935.693ZM1226.37 973.41L1217.43 991.882L1212.81 989.65L1221.74 971.177L1226.37 973.41ZM1207.24 1009.95C1203.71 1015.8 1200.1 1021.64 1196.32 1027.45L1192.02 1024.69C1195.75 1018.92 1199.37 1013.13 1202.86 1007.31L1207.24 1009.95ZM1184.83 1044.58C1180.94 1050.18 1176.88 1055.76 1172.65 1061.31L1168.59 1058.22C1172.71 1052.81 1176.69 1047.29 1180.53 1041.66L1184.83 1044.58ZM1160.19 1077.59C1155.93 1082.99 1151.54 1088.27 1147.08 1093.5L1143.02 1090.17C1147.43 1084.98 1151.77 1079.73 1156.05 1074.42L1160.19 1077.59ZM1133.39 1108.93C1129.5 1113.21 1125.55 1117.39 1121.54 1121.48L1119.14 1123.79L1115.49 1120.18L1117.89 1117.86C1121.95 1113.8 1125.76 1109.74 1129.62 1105.68L1133.39 1108.93ZM1103.96 1137.92C1098.84 1142.49 1093.65 1146.99 1088.37 1151.4L1085.08 1147.34C1090.33 1143.01 1095.49 1138.55 1100.55 1133.98L1103.96 1137.92ZM1072.33 1164.39C1066.93 1168.45 1061.41 1172.75 1055.89 1176.81L1052.85 1172.75C1058.26 1168.77 1063.67 1164.71 1069.09 1160.57L1072.33 1164.39ZM1039.04 1188.75C1033.33 1192.62 1027.58 1196.38 1021.79 1200.04L1019.03 1195.69C1024.74 1192.06 1030.45 1188.33 1036.16 1184.49L1039.04 1188.75ZM1004.17 1210.71C1001.29 1212.38 998.403 1214.08 995.48 1215.71L985.817 1220.33L983.625 1215.75L993.125 1211.16C995.845 1209.62 998.728 1207.95 1001.57 1206.25L1004.17 1210.71ZM967.345 1229.27L962.067 1231.82C960.118 1232.72 958.21 1233.65 956.342 1234.59C953.825 1235.8 951.308 1237.06 948.791 1238.2L946.68 1233.49C949.156 1232.39 951.592 1231.17 954.069 1229.96L959.875 1227.2L965.112 1224.64L967.345 1229.27ZM929.304 1245.51L910.1 1252.53L908.354 1247.7L927.477 1240.72L929.304 1245.51ZM890.369 1258.99L870.476 1264.1L869.217 1259.15L889.07 1253.99L890.369 1258.99ZM850.623 1269.3C846.806 1270.32 842.927 1271.09 839.011 1271.61L830.161 1272.99L829.389 1267.92L838.281 1266.54C842.019 1266.03 845.721 1265.28 849.364 1264.3L850.623 1269.3ZM810.024 1276.08L789.481 1279.08L789.196 1273.93H790.496L809.252 1271.04L810.024 1276.08ZM768.978 1280.14L748.476 1281.19L748.191 1276.08L768.491 1275.02L768.978 1280.14Z",
    fill: "url(#paint63_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.502 1276.77L734.218 1281.88L713.919 1280.87L714.162 1275.75L734.502 1276.77ZM693.457 1274.7L693.213 1279.81L678.151 1279.04L672.508 1278.19L673.279 1273.11L678.679 1273.93L693.457 1274.7ZM652.858 1270.03L652.086 1275.1L631.787 1271.98L632.558 1266.9L652.858 1270.03ZM612.786 1262.64L611.447 1267.59C608.158 1266.7 604.788 1265.81 601.378 1264.99L591.634 1262.48L592.893 1257.48L602.596 1260C606.128 1260.81 609.579 1261.7 612.908 1262.64H612.786ZM572.999 1252.37L571.781 1257.32L568.493 1256.22L552.253 1250.3L553.999 1245.42L572.999 1252.37ZM534.674 1238.4L533.05 1243.19L523.063 1239.54C519.896 1238.24 516.851 1236.78 513.806 1235.27L516.08 1230.69C519.003 1232.11 521.926 1233.53 524.93 1234.75L534.674 1238.4ZM497.445 1221.8L495.212 1226.42L476.739 1217.49L478.972 1212.86L497.445 1221.8ZM461.312 1202.92L458.632 1207.3C452.786 1203.77 446.98 1200.16 441.174 1196.38L443.935 1192.08C449.781 1195.81 455.614 1199.43 461.433 1202.92H461.312ZM426.965 1180.67L424.042 1184.73C418.439 1180.67 412.836 1176.81 407.315 1172.55L410.4 1168.49C415.976 1172.77 421.538 1176.83 427.087 1180.67H426.965ZM394.201 1156.31L390.994 1160.37C385.581 1156.12 380.289 1151.75 375.12 1147.26L378.449 1143.2C383.727 1147.61 389.018 1151.95 394.323 1156.23L394.201 1156.31ZM363.265 1129.51L359.814 1133.29C355.565 1129.39 351.369 1125.44 347.228 1121.43L344.955 1119.04L348.568 1115.38L350.882 1117.78C354.82 1121.88 359.083 1125.82 363.265 1129.51ZM334.521 1100.57L330.705 1104.02C326.13 1098.9 321.624 1093.7 317.185 1088.43L321.245 1085.14C325.63 1090.36 330.055 1095.5 334.521 1100.57ZM308.294 1069.26L304.234 1072.39C300.174 1066.99 295.871 1061.47 292.054 1055.95L296.114 1052.9C300.093 1058.38 304.193 1063.86 308.416 1069.26H308.294ZM284.34 1036.14L280.281 1039.02C276.221 1033.29 272.648 1027.57 268.994 1021.8L273.338 1019.04C276.748 1024.81 280.484 1030.53 284.34 1036.14ZM262.458 1001.59L258.032 1004.18C256.327 1001.3 254.663 998.378 253.039 995.495L248.37 985.833L252.998 983.64L257.586 993.1C259.129 995.901 260.793 998.784 262.458 1001.63V1001.59ZM244.107 965.046L239.438 967.279L236.921 962.001C236.028 960.052 235.094 957.941 234.16 956.276C232.902 953.719 231.684 951.242 230.547 948.684L235.216 946.614C236.352 949.09 237.57 951.526 238.748 954.003C239.925 956.479 240.656 957.86 241.549 959.808L244.107 965.046ZM227.867 927.41L223.077 929.237L216.215 910.277L221.006 908.491L227.867 927.41ZM214.591 889.003L209.598 890.302L204.442 870.409L209.435 869.11L214.591 889.003ZM204.604 849.378L199.651 850.637C198.636 846.803 197.85 842.912 197.296 838.985L195.956 830.175L201.031 829.404L202.412 838.295C202.924 842.029 203.656 845.73 204.604 849.378ZM197.946 809.104L192.871 809.875L189.867 789.332L194.982 789.048V790.306L197.946 809.104ZM193.886 768.505L188.77 768.789L187.715 748.246L192.83 748.002L193.886 768.505Z",
    fill: "url(#paint64_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.705 192.725L700.203 193.78L699.918 188.665L720.421 187.609L720.705 192.725ZM679.7 194.836H678.401L659.644 197.719L658.873 192.644L679.416 189.639L679.7 194.836ZM639.345 200.885L630.453 202.225C626.722 202.773 623.022 203.519 619.37 204.458L618.111 199.505C621.933 198.495 625.81 197.708 629.723 197.15L638.573 195.81L639.345 200.885ZM599.517 209.655L579.623 214.811L578.365 209.817L598.421 204.661L599.517 209.655ZM560.38 221.104L541.257 228.209L539.43 223.418L558.634 216.394L560.38 221.104ZM522.054 235.273C519.578 236.41 517.101 237.628 514.665 238.805C512.229 239.982 510.605 240.713 508.859 241.606L503.622 244.124L501.389 239.495L506.667 236.978C508.616 236.085 510.483 235.111 512.391 234.217C514.909 232.959 517.426 231.741 519.943 230.604L522.054 235.273ZM485.109 253.055L475.609 257.643L467.164 262.515L464.444 258.09C467.327 256.385 470.209 254.72 473.132 253.096L482.876 248.508L485.109 253.055ZM449.707 273.355C443.982 276.968 438.258 280.744 432.574 284.601L429.691 280.338C435.416 276.278 441.181 272.706 446.946 269.052L449.707 273.355ZM415.725 296.172C410.312 300.151 404.899 304.211 399.486 308.352L396.359 304.292C401.759 300.232 407.281 295.888 412.599 291.909L415.725 296.172ZM383.53 321.343C378.307 325.701 373.15 330.153 368.062 334.701L364.652 330.884C369.767 326.256 374.964 321.79 380.242 317.405L383.53 321.343ZM353.081 348.586L350.686 350.94C346.626 355 342.85 359.06 338.993 363.323L335.217 359.832C339.115 355.609 343.067 351.428 347.072 347.286L349.468 344.972L353.081 348.586ZM325.433 378.629C320.994 383.826 316.65 389.077 312.401 394.382L308.341 391.174C312.617 385.761 316.988 380.456 321.454 375.259L325.433 378.629ZM299.937 410.581C295.85 415.994 291.871 421.515 288.001 427.145L283.941 424.222C288.001 418.619 291.858 413.017 296.121 407.495L299.937 410.581ZM276.592 444.116C272.857 449.908 269.244 455.686 265.752 461.452L261.449 458.813C264.981 452.966 268.594 447.12 272.37 441.355L276.592 444.116ZM255.806 479.112L246.874 497.626L242.246 495.393L251.177 476.879L255.806 479.112ZM237.942 516.139C236.521 519.062 235.1 521.985 233.882 524.989L230.269 534.855L225.438 533.109L229.092 523.122C230.391 519.955 231.852 516.91 233.354 513.865L237.942 516.139ZM223.205 554.14L216.303 573.181L211.309 571.922L212.446 568.674L218.373 552.435L223.205 554.14ZM211.025 593.075L208.508 602.778C207.736 606.188 206.803 609.639 205.91 612.968L200.956 611.628C201.85 608.34 202.743 604.97 203.555 601.56L206.072 591.816L211.025 593.075ZM201.606 632.74L198.521 653.04L193.446 652.268L196.531 631.969L201.606 632.74ZM195.435 673.339L194.582 678.78L193.852 693.558L188.696 693.314L189.508 678.252L190.36 672.609L195.435 673.339ZM192.796 713.939L191.74 734.482L186.625 734.198L187.681 713.695L192.796 713.939Z",
    fill: "url(#paint65_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.23 293.898C1116.25 294.875 1115.92 295.826 1115.3 296.578C1114.58 297.29 1113.63 297.734 1112.62 297.836C1111.56 297.843 1110.54 297.468 1109.74 296.781L1106.65 293.898C1106.04 293.411 1105.56 292.883 1104.91 292.355C1104.26 291.828 1102.88 290.528 1101.66 289.392C1100.92 288.703 1100.47 287.764 1100.38 286.758C1100.3 285.752 1100.6 284.751 1101.21 283.951C1101.9 283.242 1102.83 282.809 1103.81 282.735C1104.8 282.66 1105.78 282.948 1106.57 283.545L1110.27 286.834C1110.75 287.315 1111.26 287.762 1111.81 288.174L1114.97 291.137C1115.37 291.479 1115.69 291.903 1115.91 292.379C1116.13 292.856 1116.24 293.374 1116.23 293.898ZM1042.18 240.104C1042.23 240.827 1042.06 241.548 1041.69 242.175C1041.13 243.012 1040.3 243.629 1039.34 243.92C1038.63 243.988 1037.91 243.866 1037.26 243.567C1036.61 243.268 1036.05 242.802 1035.64 242.216C1035.22 241.631 1034.97 240.947 1034.91 240.234C1034.85 239.521 1034.98 238.804 1035.28 238.155C1035.84 237.335 1036.69 236.749 1037.65 236.51C1038.62 236.27 1039.64 236.394 1040.52 236.856C1041.04 237.215 1041.47 237.701 1041.76 238.268C1042.05 238.836 1042.2 239.467 1042.18 240.104ZM954.731 195.729C954.723 196.183 954.654 196.633 954.527 197.069C954.145 198.016 953.421 198.784 952.497 199.221C951.594 199.64 950.568 199.712 949.615 199.424C948.6 199.018 947.544 198.733 946.326 198.287L912.345 185.904C907.193 183.935 901.918 182.308 896.552 181.032H895.902C890.584 179.692 885.347 178.271 880.231 176.972L879.176 176.769L867.28 173.684C860.5 171.938 854.045 170.192 847.874 168.974C840.891 167.959 834.111 166.904 827.574 165.889L817.14 164.346C808.818 163.006 800.901 161.869 794.324 160.854C789.817 160.448 785.514 160.245 781.819 160.123L775.648 159.839C765.092 159.19 759.003 158.906 759.003 158.906C758.03 158.853 757.115 158.427 756.449 157.716C755.783 157.004 755.418 156.063 755.43 155.089V154.602C755.444 154.095 755.563 153.596 755.778 153.137C755.994 152.677 756.301 152.267 756.682 151.932C757.063 151.597 757.509 151.344 757.992 151.188C758.475 151.033 758.985 150.979 759.49 151.029L776.095 151.841L781.941 152.125C786.001 152.125 790.386 152.45 795.298 152.856H795.501C800.535 153.587 805.895 154.399 811.741 155.333L849.214 160.976C855.994 162.316 862.652 164.143 869.757 165.97C873.451 166.904 877.227 167.959 881.124 168.852L890.056 171.207L898.501 173.399C904.163 174.68 909.715 176.404 915.106 178.556L939.465 187.487L948.803 190.857C949.859 191.263 950.955 191.588 952.091 191.994C952.883 192.236 953.572 192.734 954.049 193.41C954.527 194.086 954.767 194.902 954.731 195.729Z",
    fill: "url(#paint66_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.09 502.132C1270.08 502.875 1269.85 503.599 1269.43 504.213C1269.01 504.827 1268.42 505.303 1267.73 505.583C1267.28 505.797 1266.78 505.916 1266.28 505.934C1265.77 505.951 1265.27 505.866 1264.8 505.684C1264.33 505.502 1263.9 505.226 1263.54 504.874C1263.18 504.522 1262.89 504.1 1262.7 503.634C1261.48 500.751 1260.22 497.991 1259 495.23C1236.11 442.451 1206.75 403.435 1185.28 375.015L1181.22 369.697C1173.62 360.887 1166.72 353.457 1161.2 347.327C1159.13 345.175 1157.14 343.267 1155.64 341.277C1155.05 340.491 1154.77 339.52 1154.85 338.542C1154.92 337.565 1155.35 336.647 1156.04 335.959C1156.83 335.323 1157.81 335.001 1158.82 335.053C1159.82 335.106 1160.77 335.53 1161.48 336.243C1163.11 338.111 1164.98 340.059 1166.93 342.211C1172.57 348.342 1179.55 355.974 1187.22 365.109L1191.57 370.874C1213.13 399.497 1242.68 438.716 1265.78 492.226C1267.12 495.068 1268.34 497.869 1269.56 500.711C1269.82 501.151 1269.99 501.631 1270.09 502.132ZM1264.24 979.295C1264.21 979.857 1264.07 980.408 1263.84 980.919C1263.63 981.38 1263.33 981.795 1262.96 982.137C1262.59 982.479 1262.16 982.742 1261.68 982.909C1260.73 983.256 1259.68 983.256 1258.72 982.909C1257.83 982.439 1257.15 981.656 1256.8 980.711C1256.46 979.765 1256.47 978.726 1256.85 977.793C1257.32 976.894 1258.11 976.203 1259.07 975.857C1260.02 975.512 1261.07 975.536 1262.01 975.926C1262.64 976.243 1263.18 976.722 1263.57 977.313C1263.97 977.904 1264.2 978.588 1264.24 979.295ZM1225.23 1049.61C1225.26 1050.38 1225.05 1051.13 1224.62 1051.77C1224.03 1052.58 1223.16 1053.15 1222.18 1053.36C1221.19 1053.57 1220.17 1053.4 1219.3 1052.9C1218.48 1052.31 1217.92 1051.44 1217.71 1050.46C1217.5 1049.48 1217.66 1048.45 1218.16 1047.58C1218.75 1046.77 1219.62 1046.2 1220.6 1045.99C1221.58 1045.78 1222.61 1045.94 1223.48 1046.45C1224.06 1046.78 1224.54 1047.27 1224.86 1047.86C1225.18 1048.44 1225.34 1049.11 1225.31 1049.78L1225.23 1049.61ZM1150.56 325.322C1150.57 325.865 1150.47 326.403 1150.25 326.9C1150.03 327.398 1149.71 327.843 1149.31 328.204C1148.52 328.835 1147.53 329.151 1146.52 329.091C1145.52 329.031 1144.57 328.599 1143.87 327.88C1143.24 327.12 1142.93 326.152 1143 325.173C1143.07 324.193 1143.51 323.276 1144.23 322.609C1144.94 321.941 1145.89 321.573 1146.87 321.579C1147.86 321.585 1148.8 321.965 1149.51 322.642C1150.18 323.377 1150.55 324.33 1150.56 325.322ZM920.083 1285.9C920.038 1286.54 919.844 1287.15 919.517 1287.69C919.191 1288.24 918.741 1288.7 918.204 1289.04C917.667 1289.38 917.057 1289.59 916.425 1289.65C915.792 1289.71 915.154 1289.62 914.562 1289.39C914.1 1289.19 913.688 1288.88 913.352 1288.51C913.016 1288.13 912.764 1287.68 912.613 1287.2C912.327 1286.24 912.409 1285.2 912.844 1284.29C913.279 1283.38 914.036 1282.67 914.968 1282.29C915.896 1282.02 916.889 1282.09 917.769 1282.49C918.689 1282.97 919.408 1283.76 919.799 1284.72C919.891 1285.11 919.932 1285.51 919.921 1285.9H920.083ZM903.032 1291.22C903.033 1292.08 902.74 1292.92 902.201 1293.59C901.662 1294.26 900.909 1294.73 900.068 1294.91L883.138 1299.34L871.324 1302.43C869.781 1302.83 868.238 1303.12 866.696 1303.56C858.537 1305.87 850.238 1307.65 841.849 1308.88L800.682 1315.13C796.931 1315.84 793.13 1316.25 789.314 1316.35H787.649C786.431 1316.35 785.822 1316.35 785.498 1316.35C784.477 1316.36 783.492 1315.98 782.737 1315.3C782.358 1314.97 782.054 1314.56 781.844 1314.11C781.634 1313.65 781.523 1313.16 781.519 1312.66C781.48 1312.15 781.543 1311.65 781.703 1311.17C781.862 1310.69 782.116 1310.25 782.449 1309.87C782.782 1309.49 783.187 1309.19 783.641 1308.97C784.095 1308.75 784.588 1308.62 785.092 1308.6L789.152 1308.39C792.644 1308.35 796.125 1307.97 799.545 1307.26C807.34 1306.04 818.099 1304.37 831.659 1302.34L840.996 1300.88C849.313 1299.81 857.527 1298.06 865.559 1295.65L875.506 1293.09L898.282 1287.24C898.764 1287.12 899.266 1287.1 899.758 1287.17C900.25 1287.24 900.723 1287.41 901.149 1287.67C901.576 1287.92 901.947 1288.26 902.242 1288.66C902.537 1289.06 902.751 1289.52 902.869 1290C902.979 1290.4 902.993 1290.82 902.91 1291.22H903.032Z",
    fill: "url(#paint67_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.193 1314.04C713.173 1314.54 713.05 1315.04 712.833 1315.5C712.616 1315.96 712.309 1316.37 711.93 1316.71C711.551 1317.04 711.108 1317.3 710.628 1317.46C710.147 1317.63 709.639 1317.69 709.133 1317.65H707.59L692.487 1316.84L686.641 1316.51C682.581 1316.51 678.237 1316.19 673.325 1315.78H673.122L648.762 1312.09L633.659 1309.73L619.734 1307.66C612.954 1306.32 606.174 1304.5 599.069 1302.63C595.375 1301.7 591.599 1300.68 587.782 1299.79L571.056 1295.44L570.325 1295.24C564.687 1294.01 559.15 1292.35 553.761 1290.29L520.104 1278.11C518.967 1277.78 517.912 1277.38 516.775 1276.97C516.134 1276.95 515.506 1276.78 514.943 1276.48C514.38 1276.17 513.897 1275.73 513.535 1275.2C513.173 1274.68 512.941 1274.07 512.859 1273.43C512.777 1272.8 512.847 1272.15 513.063 1271.55C513.279 1270.94 513.635 1270.4 514.102 1269.96C514.568 1269.52 515.133 1269.19 515.748 1269.02C516.364 1268.84 517.013 1268.8 517.643 1268.92C518.274 1269.04 518.866 1269.31 519.373 1269.7L522.459 1270.84L524.286 1271.45C535.085 1275.51 545.844 1279.33 556.765 1283.26C562.045 1285.31 567.474 1286.95 573.004 1288.18H573.289L582.22 1290.53L589.934 1292.48C593.994 1293.49 598.054 1294.51 601.83 1295.57C608.732 1297.31 615.065 1299.06 621.317 1300.27L651.848 1304.9C659.968 1306.12 667.844 1307.34 674.705 1308.39C679.252 1308.8 683.556 1309 687.331 1309.08L693.421 1309.41C703.896 1310.02 709.661 1310.22 709.945 1310.22C710.835 1310.4 711.639 1310.88 712.228 1311.57C712.817 1312.26 713.157 1313.13 713.193 1314.04ZM434.156 1228.78C434.143 1229.46 433.977 1230.12 433.669 1230.73C433.412 1231.17 433.066 1231.55 432.654 1231.85C432.241 1232.15 431.771 1232.36 431.273 1232.47C430.779 1232.62 430.259 1232.66 429.748 1232.59C429.237 1232.52 428.747 1232.34 428.31 1232.07C427.482 1231.49 426.899 1230.63 426.674 1229.64C426.449 1228.66 426.598 1227.63 427.092 1226.75C427.632 1225.89 428.471 1225.27 429.446 1225C429.933 1224.87 430.444 1224.84 430.942 1224.93C431.44 1225.01 431.913 1225.2 432.329 1225.49C432.885 1225.82 433.346 1226.29 433.666 1226.85C433.986 1227.42 434.155 1228.05 434.156 1228.7V1228.78ZM368.467 1182.29C368.459 1183.23 368.129 1184.13 367.533 1184.85C366.844 1185.59 365.905 1186.04 364.899 1186.12C363.893 1186.21 362.893 1185.91 362.093 1185.3C360.753 1184.16 359.616 1183.11 358.601 1182.21C357.586 1181.32 357.464 1181.08 356.977 1180.67L353.77 1177.71C353.056 1177 352.632 1176.05 352.58 1175.04C352.527 1174.03 352.85 1173.05 353.486 1172.27C354.201 1171.56 355.154 1171.14 356.159 1171.1C357.164 1171.05 358.15 1171.38 358.926 1172.02L362.093 1174.9C362.646 1175.45 363.229 1175.96 363.838 1176.45C364.772 1177.38 365.909 1178.4 367.127 1179.45C367.541 1179.8 367.875 1180.24 368.106 1180.73C368.338 1181.22 368.46 1181.75 368.467 1182.29Z",
    fill: "url(#paint68_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.422 156.064C687.46 156.567 687.398 157.072 687.238 157.55C687.078 158.028 686.824 158.469 686.491 158.848C686.158 159.226 685.753 159.534 685.299 159.753C684.845 159.972 684.352 160.099 683.849 160.124L679.789 160.327C676.298 160.397 672.819 160.777 669.396 161.464C659.855 162.885 645.889 165.037 628.066 167.838C619.946 168.928 611.914 170.597 604.031 172.832L599.484 174.09C590.471 176.445 580.809 178.881 570.659 181.479C570.175 181.623 569.666 181.657 569.167 181.58C568.669 181.503 568.194 181.316 567.776 181.033C567.331 180.791 566.939 180.462 566.625 180.064C566.311 179.666 566.081 179.208 565.949 178.719C565.731 177.725 565.893 176.685 566.404 175.806C566.915 174.926 567.738 174.27 568.71 173.969L570.862 173.481C580.321 171.086 589.253 168.731 597.535 166.58L602.488 165.362C610.466 163.01 618.609 161.259 626.848 160.124L668.015 153.872C671.838 153.071 675.723 152.595 679.626 152.451H681.372C682.021 152.484 682.672 152.484 683.321 152.451C684.344 152.448 685.33 152.831 686.083 153.523C686.835 154.216 687.299 155.167 687.381 156.186L687.422 156.064ZM556.53 182.941C556.539 183.736 556.296 184.513 555.837 185.162C555.377 185.811 554.725 186.298 553.973 186.554C553.507 186.764 553.002 186.872 552.491 186.872C551.98 186.872 551.475 186.764 551.009 186.554C550.55 186.333 550.141 186.021 549.806 185.637C549.471 185.253 549.217 184.806 549.06 184.321C548.779 183.373 548.872 182.352 549.322 181.471C549.772 180.589 550.544 179.915 551.477 179.586C552.411 179.257 553.435 179.3 554.337 179.706C555.24 180.111 555.953 180.848 556.327 181.764C556.446 182.146 556.514 182.541 556.53 182.941ZM482.234 213.634C482.23 214.347 482.026 215.044 481.645 215.647C481.265 216.249 480.724 216.734 480.082 217.044C479.144 217.495 478.068 217.567 477.078 217.247C476.602 217.094 476.164 216.84 475.793 216.504C475.422 216.168 475.126 215.757 474.926 215.299C474.674 214.613 474.612 213.872 474.746 213.154C474.88 212.436 475.205 211.767 475.688 211.219C476.17 210.67 476.791 210.262 477.486 210.037C478.181 209.811 478.923 209.778 479.636 209.94C480.109 210.1 480.543 210.356 480.913 210.691C481.284 211.026 481.581 211.434 481.788 211.888C482.04 212.439 482.191 213.03 482.234 213.634ZM397.951 264.14C397.95 264.752 397.798 265.354 397.508 265.892C397.217 266.431 396.797 266.889 396.286 267.225C343.456 305.59 297.498 352.618 260.36 406.318C260.086 406.764 259.723 407.149 259.294 407.45C258.866 407.751 258.38 407.961 257.868 408.068C257.355 408.175 256.826 408.177 256.313 408.073C255.8 407.969 255.313 407.762 254.883 407.464C254.452 407.166 254.087 406.783 253.809 406.34C253.531 405.896 253.347 405.4 253.267 404.883C253.187 404.365 253.213 403.837 253.343 403.33C253.474 402.823 253.707 402.348 254.027 401.934C291.708 347.478 338.388 299.837 392.064 261.054C392.471 260.755 392.933 260.541 393.423 260.422C393.914 260.303 394.423 260.283 394.921 260.362C395.42 260.441 395.897 260.619 396.327 260.884C396.756 261.149 397.129 261.497 397.423 261.907C397.845 262.57 398.031 263.357 397.951 264.14ZM325.968 1143.52C325.983 1144.05 325.881 1144.58 325.671 1145.07C325.461 1145.57 325.147 1146 324.751 1146.36C323.964 1147.02 322.976 1147.4 321.949 1147.42C320.932 1147.32 319.99 1146.84 319.31 1146.08C318.724 1145.29 318.443 1144.32 318.517 1143.34C318.592 1142.37 319.018 1141.45 319.716 1140.76C320.261 1140.24 320.947 1139.9 321.687 1139.77C322.428 1139.65 323.189 1139.75 323.873 1140.06C324.557 1140.37 325.134 1140.87 325.529 1141.51C325.924 1142.15 326.119 1142.89 326.09 1143.64L325.968 1143.52ZM313.789 1130.24C313.787 1130.78 313.678 1131.31 313.469 1131.81C313.26 1132.3 312.954 1132.75 312.571 1133.13C312.197 1133.47 311.759 1133.74 311.282 1133.91C310.804 1134.08 310.298 1134.15 309.791 1134.13C309.285 1134.1 308.788 1133.97 308.332 1133.75C307.875 1133.53 307.466 1133.22 307.131 1132.84C305.385 1130.85 303.436 1128.78 301.284 1126.47C295.722 1120.42 288.861 1112.91 281.269 1103.98C279.848 1102.15 278.508 1100.32 277.209 1098.33C255.529 1069.91 225.973 1030.49 202.75 976.901C201.533 974.14 200.315 971.258 199.056 968.375C198.719 967.448 198.73 966.43 199.089 965.511C199.448 964.592 200.129 963.835 201.005 963.381C201.926 962.969 202.972 962.939 203.916 963.296C204.859 963.654 205.623 964.371 206.039 965.29C207.298 968.172 208.516 970.973 209.855 973.734C232.753 1026.51 261.984 1065.49 283.461 1093.83L287.521 1099.19C295.113 1108.08 302.096 1115.71 307.821 1121.76L313.261 1127.81C313.762 1128.52 314.005 1129.38 313.951 1130.24H313.789ZM251.023 419.026C251.022 419.748 250.811 420.453 250.414 421.056C249.872 421.902 249.018 422.501 248.037 422.721C247.057 422.941 246.029 422.766 245.176 422.233C244.339 421.655 243.748 420.784 243.523 419.791C243.297 418.799 243.453 417.758 243.958 416.874C244.553 416.067 245.426 415.508 246.407 415.306C247.389 415.104 248.412 415.272 249.277 415.778C249.819 416.128 250.263 416.609 250.568 417.177C250.873 417.745 251.03 418.381 251.023 419.026ZM212.129 489.344C212.127 489.914 212.017 490.479 211.804 491.009C211.323 491.928 210.532 492.647 209.571 493.038C208.648 493.42 207.612 493.42 206.689 493.038C205.789 492.568 205.098 491.778 204.753 490.823C204.407 489.869 204.431 488.82 204.821 487.882C205.299 487.013 206.079 486.348 207.013 486.015C207.93 485.672 208.939 485.672 209.855 486.015C210.516 486.301 211.081 486.77 211.484 487.368C211.887 487.965 212.111 488.664 212.129 489.385V489.344ZM178.35 581.626C178.35 581.951 178.35 582.357 178.35 582.641C161.547 644.225 155.126 708.179 159.35 771.874C159.35 773.295 159.35 774.798 159.634 776.259C159.648 777.238 159.288 778.186 158.629 778.91C157.969 779.634 157.059 780.08 156.083 780.157C155.107 780.235 154.138 779.938 153.372 779.327C152.607 778.716 152.102 777.837 151.961 776.868C151.961 776.056 151.961 775.325 151.961 774.595C151.961 773.864 151.961 773.092 151.961 772.362C147.731 707.823 154.22 643.029 171.164 580.611C171.296 580.125 171.522 579.67 171.831 579.271C172.139 578.873 172.523 578.54 172.961 578.291C173.399 578.041 173.882 577.881 174.382 577.82C174.882 577.758 175.389 577.796 175.874 577.932C176.635 578.203 177.288 578.713 177.735 579.386C178.181 580.06 178.397 580.86 178.35 581.667V581.626ZM174.859 873.738C174.844 874.597 174.557 875.43 174.039 876.116C173.521 876.802 172.799 877.305 171.976 877.554C170.985 877.734 169.962 877.539 169.106 877.006C168.251 876.473 167.624 875.641 167.348 874.672C167.215 874.184 167.183 873.674 167.253 873.173C167.324 872.672 167.495 872.19 167.757 871.757C168.019 871.324 168.366 870.949 168.777 870.655C169.189 870.36 169.655 870.152 170.149 870.044C171.125 869.858 172.135 870.037 172.988 870.545C173.841 871.054 174.477 871.858 174.778 872.804C174.844 873.111 174.871 873.425 174.859 873.738ZM161.096 794.488C161.062 795.452 160.668 796.368 159.993 797.056C159.317 797.743 158.408 798.153 157.445 798.204C156.482 798.255 155.535 797.944 154.791 797.331C154.046 796.718 153.558 795.849 153.423 794.894C153.355 793.895 153.684 792.909 154.337 792.149C154.99 791.39 155.916 790.917 156.914 790.834C157.899 790.825 158.854 791.173 159.601 791.816C160.348 792.458 160.836 793.35 160.974 794.326L161.096 794.488Z",
    fill: "url(#paint69_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.333 452.276C457.997 450.612 459.743 449.028 461.57 447.485L485.199 426.414C492.1 421.096 496.891 417.726 496.972 417.685L497.541 417.32H498.19C498.19 417.32 509.558 420.243 520.114 423.491C525.473 425.156 530.71 426.861 534.567 428.16C534.567 428.16 538.627 429.5 540.494 430.352L555.07 421.867C556.734 420.974 558.439 419.959 560.226 418.903C563.433 416.995 567.006 414.844 570.903 412.935L599.322 399.944C601.434 399.01 603.585 398.279 605.656 397.589L609.026 396.452L626.199 390.606C630.249 389.035 634.416 387.786 638.663 386.871L643.291 385.774L643.981 388.698L639.272 389.794C635.127 390.708 631.056 391.929 627.092 393.448L609.959 399.335L606.509 400.512C604.519 401.162 602.449 401.852 600.459 402.704L572.04 415.696C568.305 417.523 564.894 419.756 561.606 421.502C559.82 422.598 558.074 423.613 556.409 424.547L540.17 433.966L539.561 433.357C538.83 433.032 536.516 432.098 533.471 431.083C529.411 429.784 524.417 428.038 519.058 426.414C510.045 423.613 500.504 421.136 497.947 420.446C496.485 421.461 492.385 424.506 486.985 428.566L463.397 449.597C459.147 453.238 455.183 457.201 451.542 461.451L432.379 482.766C432.292 484.226 432.292 485.691 432.379 487.151L433.07 498.397L434.531 514.637L426.411 525.598C423.61 529.658 420.565 534.774 417.317 540.255C415.45 543.462 413.501 546.751 411.471 549.999C407.406 556.494 403.824 563.278 400.753 570.298L398.357 575.414L392.511 587.593L388.451 589.42C386.787 590.151 384.716 591.044 382.93 592.059L374.445 596.566L369.41 610.654C368.964 612.156 368.314 613.821 367.665 615.526C366.362 618.799 365.303 622.165 364.498 625.594L360.032 643.377C359.545 645.488 358.976 647.437 358.408 649.751C357.393 653.811 356.459 657.343 355.891 660.997L351.141 692.664L347.568 695.872L341.235 702.205L332.343 711.503L331.288 731.802L332.14 753.279C332.14 755.472 332.343 757.705 332.425 759.938C332.503 765.92 333.005 771.89 333.927 777.801L334.658 783.16C336.094 796.7 338.441 810.129 341.681 823.354L346.472 843.45C347.121 843.937 348.542 844.952 350.532 846.211L361.29 852.748C368.923 857.335 376.596 861.558 376.637 861.598L377.165 861.882L381.225 873.575C382.93 877.635 385.284 882.71 387.68 888.028C389.06 890.992 390.481 894.037 391.74 897.123L393.81 901.71C395.069 904.471 396.246 907.11 397.545 909.587L409.238 929.683L424.3 934.23L440.986 937.762L446.914 945.882C448.051 947.344 449.269 949.09 450.568 950.917C453.227 954.967 456.243 958.772 459.581 962.284L479.88 985.142L477.607 987.131L457.307 964.355C453.861 960.746 450.749 956.833 448.01 952.662C446.751 950.835 445.574 949.171 444.437 947.709L439.119 940.401L423.448 937.113L407.208 932.16L395.028 911.007C393.648 908.409 392.389 905.608 391.171 902.888C390.522 901.385 389.832 899.843 389.101 898.34C387.72 895.255 386.299 892.21 385.041 889.246C382.564 883.887 380.25 878.853 378.504 874.631L374.81 863.912C372.983 862.897 366.406 859.243 359.829 855.265L348.948 849.378C347.273 848.381 345.659 847.283 344.117 846.089L343.711 845.764L338.596 824.653C335.329 811.292 332.956 797.729 331.491 784.054L330.801 778.735C329.867 772.715 329.352 766.638 329.258 760.546C329.258 758.314 329.258 756.121 328.974 753.929L328.121 732.289L329.217 710.528L345.457 693.964L348.258 691.447L352.887 660.835C353.541 656.95 354.394 653.101 355.444 649.304C356.013 647.193 356.581 645.244 357.068 642.93L361.493 625.188C362.36 621.638 363.473 618.151 364.823 614.754C365.472 613.09 366.041 611.506 366.528 609.964L371.968 594.739L381.428 589.664C383.336 588.608 385.488 587.715 387.193 586.944L390.4 585.564L395.718 574.236C396.53 572.653 397.302 570.948 398.114 569.161C401.238 562.026 404.889 555.132 409.035 548.537C411.024 545.33 413.095 542.082 414.841 538.874C418.129 533.353 421.215 528.116 424.097 524.015L431.567 513.946L430.228 498.6L429.537 487.313C429.446 485.569 429.446 483.821 429.537 482.076V481.548L449.472 459.625C451.623 457.189 453.897 454.671 456.333 452.276Z",
    fill: "url(#paint70_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.293 385.896L662.09 381.39C665.749 380.398 669.483 379.705 673.255 379.319L700.822 375.503C701.555 375.344 702.304 375.262 703.055 375.259L713.773 364.135L725.953 351.955L729.769 351.752C730.5 351.752 731.271 351.752 732.164 351.752C734.26 351.646 736.361 351.646 738.457 351.752L764.359 353.173C770.924 353.39 777.464 354.082 783.928 355.244C786.161 355.609 788.313 355.934 790.261 356.178L801.385 357.883L805.689 355.203C809.146 352.989 812.724 350.969 816.407 349.154C824.121 345.094 832.363 341.034 832.647 341.034C832.931 341.034 833.378 340.425 854.124 346.272L874.423 353.579L878.727 355.122C885.21 357.22 891.533 359.784 897.646 362.795L925.294 375.868L957.773 395.194L959.194 399.741L961.508 409.038L964.431 421.705L976.611 430.677C980.913 433.847 984.984 437.32 988.79 441.071L1002.23 453.251C1008.77 458.976 1014.85 465.207 1020.42 471.886L1025.94 478.016L1036.13 489.465C1036.74 489.831 1036.86 490.521 1036.58 493.972L1035.07 510.942L1042.42 521.051C1043.23 522.229 1044.09 523.366 1044.98 524.584C1046.87 527.005 1048.6 529.541 1050.18 532.176L1059.96 548.943C1064.37 555.987 1068.27 563.341 1071.61 570.948L1076.81 582.235L1090.98 588.649C1093.44 589.781 1095.84 591.042 1098.16 592.425L1100.76 593.846L1105.68 596.607L1110.51 610.817C1110.99 612.238 1111.48 613.699 1112.05 615.201C1113.06 618.206 1114.2 621.454 1115.22 624.904L1123.09 657.993C1123.84 661.302 1124.41 664.65 1124.8 668.021C1125 669.645 1125.2 671.228 1125.45 672.649L1127.52 687.752L1122.16 693.477L1119.6 695.994C1117.08 698.552 1114.24 701.394 1110.91 704.114C1103.69 710.528 1096.42 716.496 1094.23 718.242L1094.96 735.132V739.598C1094.55 749.504 1093.98 761.846 1092.89 774.066L1088.38 804.11C1088.01 806.14 1087.53 808.17 1087.08 809.794L1086.35 812.554L1082.09 829.687L1079.16 828.957L1083.43 811.824C1083.67 810.93 1083.87 809.997 1084.16 809.022C1084.6 807.317 1085.05 805.531 1085.42 803.623L1089.68 773.863C1090.73 761.684 1091.3 749.504 1091.71 739.638V735.294L1090.94 717.105L1091.38 716.659C1092.44 715.806 1100.6 709.229 1108.68 702.003C1111.93 699.201 1114.77 696.4 1117.21 693.883C1118.15 692.99 1119.01 692.137 1119.76 691.325L1124.15 686.818L1122.28 673.258C1122.04 671.797 1121.83 670.173 1121.63 668.508C1121.27 665.246 1120.73 662.007 1120.01 658.805L1112.17 625.798C1111.16 622.469 1110.06 619.302 1109 616.297C1108.48 614.795 1107.95 613.293 1107.5 611.913L1103 598.799L1099.14 596.607C1098.33 596.201 1097.43 595.673 1096.5 595.145C1094.47 594.008 1092.16 592.669 1089.6 591.532L1074.37 584.671L1068.69 572.247C1065.37 564.774 1061.53 557.543 1057.2 550.608L1047.42 533.8C1045.89 531.263 1044.21 528.822 1042.38 526.492C1041.49 525.274 1040.59 524.056 1039.82 522.919L1031.7 511.917L1033.29 493.891C1033.33 493.052 1033.33 492.212 1033.29 491.373L1023.3 480.168L1017.74 473.997C1012.43 467.414 1006.62 461.252 1000.36 455.565L986.801 443.385C983.074 439.713 979.07 436.333 974.824 433.276L961.873 423.613L956.433 400.675L955.337 397.345L924.035 378.426L896.468 365.394C890.46 362.544 884.26 360.116 877.915 358.127L873.57 356.584L853.271 349.316C842.796 346.353 835.367 344.607 833.499 344.16C831.226 345.297 824.446 348.626 818.031 351.955C814.442 353.754 810.946 355.732 807.557 357.883L802.279 361.212L790.099 359.344L783.603 358.127C777.275 356.968 770.87 356.276 764.44 356.056L738.457 354.635C736.469 354.529 734.477 354.529 732.489 354.635H729.972H727.373L715.884 366.246L703.704 378.873L703.055 378.223L701.35 378.426L673.661 382.243C670.01 382.629 666.397 383.322 662.862 384.313L644.024 388.779L643.293 385.896Z",
    fill: "url(#paint71_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.924 985.589L506.314 1009.75C509.44 1012.22 512.891 1014.78 516.382 1017.34L522.756 1022.09C524.827 1023.55 526.816 1025.09 528.887 1026.68C532.223 1029.38 535.751 1031.83 539.443 1034.02L565.954 1049.94L570.907 1052.25V1053.07C570.907 1053.07 572.734 1063.82 575.17 1074.66C577.119 1083.68 579.514 1092.85 580.407 1096.22L583.371 1097.6C584.751 1098.21 586.7 1098.9 588.933 1099.67L592.993 1101.18C595.753 1102.07 598.798 1103.21 602.087 1104.42C608.461 1106.74 615.647 1109.34 622.874 1111.49L653.607 1119.2C655.987 1119.86 658.418 1120.32 660.874 1120.58C662.011 1120.58 662.985 1120.87 663.838 1121.07L667.127 1121.56L680.321 1113.19L693.841 1104.06H694.531C695.6 1104.27 696.688 1104.38 697.779 1104.38L707.279 1104.87L716.373 1105.36C722.382 1105.76 729.162 1106.17 735.901 1106.05L764.889 1105.15C767.122 1105.11 769.348 1104.89 771.547 1104.5C772.562 1104.5 773.455 1104.18 774.227 1104.14L778.287 1103.57L787.178 1109.62L795.298 1115.02L798.952 1114.49L801.144 1114.21C804.086 1113.86 807.002 1113.32 809.873 1112.58L820.063 1110.15C827.127 1108.48 835.166 1106.62 843.123 1104.55L875.602 1093.5C878.404 1092.49 880.758 1091.35 882.87 1090.38L885.833 1089.04L890.177 1087.05L903.575 1091.11L916.323 1094.52C917.013 1094.23 918.637 1093.5 920.911 1092.28L952.822 1073.69C956.882 1070.89 961.388 1067.72 965.935 1064.39C968.209 1062.73 970.523 1061.02 972.878 1059.36C983.347 1052.04 993.279 1043.98 1002.6 1035.24C1004.67 1033.37 1006.66 1031.59 1008.52 1029.92C1013.72 1025.57 1018.62 1020.86 1023.18 1015.84C1023.18 1013.76 1023.71 1005.81 1023.91 998.215C1024.11 990.623 1024.11 983.437 1024.11 981.286L1023.5 980.677L1024.56 979.58C1027.19 976.79 1029.61 973.804 1031.79 970.648L1047.34 949.78C1049.73 946.699 1051.89 943.442 1053.79 940.037L1066.78 918.316C1065.7 913.133 1064.35 908.01 1062.72 902.969L1056.8 884.05L1058.74 884.943C1062.36 877.92 1079.04 834.235 1079.04 830.094H1080.3L1080.87 828.307L1082.01 829.688C1082.58 832.895 1065.24 879.787 1060.98 887.136L1065.65 902.076C1067.27 907.281 1068.62 912.566 1069.71 917.91L1070.19 918.397L1056.31 941.62C1054.34 945.146 1052.1 948.512 1049.61 951.689L1034.14 972.435C1032 975.571 1029.62 978.543 1027.04 981.326C1027.04 983.437 1027.04 990.826 1026.83 998.337C1026.59 1007.19 1026.06 1016.44 1026.06 1016.57V1017.91H1025.33C1020.71 1023.02 1015.75 1027.8 1010.47 1032.24L1004.42 1037.23C995.028 1046.07 985.001 1054.21 974.42 1061.59L967.519 1066.58C962.971 1069.95 958.627 1073.12 954.243 1076L922.21 1094.64C917.095 1097.44 916.12 1097.68 915.511 1097.24L902.601 1093.75L890.421 1090.13L887.011 1091.67L884.128 1092.97C881.671 1094.19 879.151 1095.28 876.577 1096.22L844.098 1107.31C835.978 1109.42 827.858 1111.37 820.875 1112.99C817.221 1113.84 813.811 1114.61 810.725 1115.39C807.737 1116.15 804.698 1116.71 801.631 1117.05L799.52 1117.37L794.689 1118.02L777.637 1106.57L774.673 1106.98L772.116 1107.35C769.768 1107.76 767.393 1107.99 765.011 1108.04L736.348 1109.21C729.487 1109.21 722.625 1108.93 716.535 1108.52C713.288 1108.32 710.243 1108.16 707.523 1108.08L698.022 1107.55C696.961 1107.53 695.903 1107.44 694.856 1107.27L682.351 1115.71L668.141 1124.68L663.676 1124.03C662.738 1123.83 661.789 1123.68 660.834 1123.59C658.257 1123.28 655.707 1122.8 653.201 1122.12L622.468 1114.41C615.079 1112.18 607.811 1109.58 601.437 1107.27C598.189 1106.05 595.104 1104.95 592.343 1103.98L588.283 1102.52C585.969 1101.7 584.223 1101.01 582.518 1100.36L578.215 1098.33V1097.68C577.403 1094.8 574.845 1084.98 572.734 1075.31C570.623 1065.65 569.039 1056.96 568.674 1054.32L564.979 1052.58L538.387 1036.62C534.56 1034.37 530.909 1031.83 527.466 1029.03C525.517 1027.53 523.406 1025.99 521.457 1024.52L514.596 1019.9C511.064 1017.3 507.613 1014.74 504.365 1012.14L477.895 987.781L479.924 985.589Z",
    fill: "url(#paint72_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.815 488.978C516.136 465.619 543.439 445.579 573.013 429.378C577.763 426.78 582.716 424.547 587.507 422.435C590.186 421.258 592.825 420.081 595.424 418.822L606.548 413.747L618.443 409.687C621.245 408.794 623.924 407.82 626.563 406.886C631.483 405.028 636.497 403.429 641.585 402.095L664.686 396.614C700.169 390.118 729.969 388.088 755.993 390.443C766.059 390.767 776.088 391.839 785.995 393.651C790.055 394.3 793.831 394.909 797.688 395.396C802.136 396.042 806.532 397.006 810.842 398.279C813.075 398.847 815.267 399.456 817.46 399.943C819.652 400.431 822.129 401.121 824.361 401.649C828.421 402.664 832.481 403.638 836.541 404.897C875.825 416.879 912.541 436.056 944.819 461.451L952.939 467.541C954.765 469.084 956.308 470.464 957.77 471.845L979.612 491.779L973.806 498.153L951.924 478.138C950.543 476.879 949.163 475.58 947.62 474.078L939.5 468.028C908.026 443.281 872.235 424.587 833.943 412.895C830.208 411.717 826.351 410.783 822.453 409.85L815.552 408.104C813.4 407.617 811.086 407.008 808.731 406.399C804.806 405.238 800.804 404.356 796.754 403.76C792.694 403.232 788.634 402.582 784.574 401.973C774.975 400.211 765.259 399.153 755.506 398.807C725.679 396.812 695.72 398.833 666.431 404.815L643.574 410.256C638.865 411.433 634.277 413.057 629.405 414.762C626.644 415.777 623.843 416.752 621.042 417.645L609.633 421.705L598.915 426.617L590.795 430.271C586.126 432.342 581.336 434.331 576.87 436.929C547.957 452.712 521.267 472.262 497.499 495.068C474.472 518.496 454.65 544.871 438.549 573.505C435.991 578.012 433.799 582.762 431.688 587.39C430.429 590.111 429.171 592.79 427.872 595.51L422.715 606.513L418.656 617.556C417.762 620.276 416.747 623.037 415.732 625.676C414.143 630.341 412.788 635.084 411.673 639.885L405.907 662.864C399.605 691.891 397.216 721.63 398.803 751.29C399.015 761.17 399.951 771.022 401.604 780.765C402.213 784.825 402.781 788.885 403.228 792.945C403.797 797.056 404.637 801.125 405.745 805.124C406.354 807.479 406.922 809.793 407.41 812.148C407.897 814.503 408.465 816.573 408.993 818.888C409.886 822.948 410.779 826.642 411.916 830.377C423.102 868.771 441.314 904.755 465.629 936.504L471.84 945.07C472.977 946.41 474.276 947.872 475.494 949.13L495.225 971.257L488.811 976.738L469.12 954.652C467.78 953.19 466.359 951.647 465.06 949.983L458.808 941.376C433.813 908.84 415.077 871.946 403.553 832.57C402.375 828.51 401.442 824.45 400.508 820.39C399.98 818.157 399.452 815.924 398.884 813.65C398.315 811.377 397.828 809.063 397.26 806.83C396.055 802.5 395.16 798.091 394.58 793.635C394.093 789.778 393.525 785.88 392.956 781.942C391.252 771.891 390.302 761.726 390.114 751.533C388.125 725.834 390.48 696.075 397.382 660.916L403.187 637.693C404.568 632.496 406.395 627.503 408.181 622.671C409.155 620.032 410.13 617.312 411.064 614.551L415.123 603.021L420.482 591.613C421.782 588.933 423 586.294 424.218 583.493C426.41 578.743 428.684 573.79 431.363 569.04C447.903 539.808 468.229 512.889 491.815 488.978Z",
    fill: "url(#paint73_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.081 470.912L474.568 470.466C493.975 452.602 519.958 429.866 548.458 414.52C550.367 413.464 552.518 412.246 554.345 411.028C558.405 408.592 562.79 406.034 567.54 403.802L585.891 395.438C594.285 391.365 602.987 387.958 611.915 385.248C615.122 384.151 618.248 383.136 621.293 382.04L629.413 379.198C632.011 378.386 634.082 377.899 636.112 377.453L670.743 369.698L698.593 365.638L703.303 399.782L668.388 405.02L643.907 410.906C642.648 411.191 641.39 411.434 640.131 411.84L632.823 414.357C629.819 415.494 626.327 416.631 622.755 417.808C615.252 420.084 607.936 422.934 600.872 426.334L582.196 435.266C579.111 436.728 575.741 438.717 572.128 440.869C569.854 442.208 567.581 443.589 565.226 444.929C540.095 458.651 516.507 479.194 498.481 495.678C481.795 513.379 460.967 536.805 447.001 561.652C445.58 564.128 444.2 566.361 442.942 568.635C440.749 572.207 438.882 575.577 437.136 578.785L428.691 596.689C425.083 603.931 422.03 611.436 419.557 619.14C418.339 622.713 417.121 626.164 415.862 629.493L413.182 637.004C412.979 637.694 412.695 638.993 412.37 640.252L405.225 668.956L400.353 699.161L366.25 694.046L371.284 661.12L378.592 631.767C379.12 629.696 379.607 627.707 380.297 625.596L383.261 617.191C384.52 613.822 385.616 610.736 386.712 607.529C389.63 598.391 393.268 589.499 397.592 580.936L405.712 563.519C408.108 558.647 410.706 554.384 413.223 550.243C414.441 548.294 415.659 546.183 416.836 544.275C432.67 516.099 455.527 490.44 473.675 471.196L474.081 470.912Z",
    fill: "url(#paint74_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.821 970.689L516.663 990.704C518.044 991.963 519.465 993.262 521.007 994.561L529.127 1000.61C560.594 1025.38 596.387 1044.09 634.685 1055.78C638.379 1056.96 642.236 1057.9 646.134 1058.83L653.035 1060.54C655.187 1061.02 657.501 1061.63 659.856 1062.28C663.852 1063.43 667.921 1064.32 672.036 1064.92C676.096 1065.45 680.156 1066.06 684.216 1066.71C693.813 1068.47 703.53 1069.52 713.284 1069.83C743.111 1071.85 773.073 1069.83 802.359 1063.82L825.216 1058.38C829.925 1057.25 834.513 1055.58 839.385 1053.88L847.748 1050.99L859.157 1046.93L869.875 1042.06C872.473 1040.8 875.153 1039.63 877.995 1038.41C882.623 1036.34 887.414 1034.35 891.879 1031.75C920.793 1015.95 947.483 996.389 971.251 973.571C994.299 950.151 1014.14 923.775 1030.24 895.134C1032.76 890.668 1034.95 885.877 1037.06 881.249C1038.32 878.569 1039.58 875.889 1040.88 873.129L1045.99 862.167L1050.05 851.124C1050.95 848.404 1051.96 845.643 1053.02 843.004C1054.76 838.132 1056.47 833.585 1057.69 828.835L1063.45 805.896C1069.77 776.859 1072.16 747.104 1070.56 717.43C1070.35 707.563 1069.41 697.725 1067.75 687.996C1067.15 683.936 1066.58 679.876 1066.13 676.019C1065.56 671.908 1064.72 667.839 1063.61 663.839C1063.04 661.525 1062.44 659.17 1061.95 656.856C1061.46 654.542 1060.89 652.39 1060.37 650.117C1059.47 646.057 1058.58 642.322 1057.44 638.587C1046.07 600.241 1027.67 564.34 1003.2 532.704L996.99 524.137C995.894 522.757 994.554 521.336 993.336 520.077L973.605 497.951L980.061 492.104L999.751 514.19C1001.09 515.652 1002.51 517.195 1003.81 518.9L1010.06 527.466C1035.04 560.011 1053.78 596.902 1065.32 636.272C1066.5 640.332 1067.43 644.392 1068.4 648.452C1068.89 650.685 1069.42 652.959 1069.99 655.192C1070.56 657.425 1071.04 659.779 1071.61 662.012C1072.84 666.351 1073.73 670.775 1074.29 675.248C1074.78 679.105 1075.35 683.002 1075.91 686.94C1077.61 696.979 1078.58 707.129 1078.8 717.309C1080.79 743.008 1078.39 772.767 1071.49 807.967L1065.68 831.19C1064.34 836.346 1062.48 841.339 1060.69 846.171C1059.72 848.85 1058.74 851.53 1057.81 854.291L1053.75 865.78L1048.39 877.229C1047.09 879.909 1045.87 882.507 1044.65 885.146C1042.46 889.937 1040.19 894.849 1037.51 899.599C1021.02 928.95 1000.7 955.982 977.097 979.986C952.793 1003.36 925.487 1023.41 895.899 1039.59C891.149 1042.18 886.196 1044.42 881.405 1046.57C878.766 1047.75 876.086 1048.92 873.488 1050.14L862.323 1055.22L850.468 1059.28C847.627 1060.17 844.947 1061.1 842.349 1062.08C837.517 1063.78 832.483 1065.57 827.327 1066.83L804.226 1072.35C768.743 1078.85 738.943 1080.83 712.96 1078.52C702.878 1078.19 692.836 1077.1 682.916 1075.27C678.856 1074.66 675.081 1074.05 671.224 1073.53C666.781 1072.87 662.387 1071.92 658.07 1070.68C655.837 1070.08 653.644 1069.51 651.452 1069.02L644.55 1067.27C640.49 1066.3 636.431 1065.29 632.371 1064.07C576.547 1046.2 540.576 1020.95 524.134 1007.47L516.014 1001.42C514.146 999.88 512.644 998.459 511.183 997.119L488.812 977.063L494.821 970.689Z",
    fill: "url(#paint75_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.324 1068.86L800.239 1063.66L824.802 1057.86C826.06 1057.57 827.319 1057.29 828.618 1056.88L835.885 1054.36C838.89 1053.27 842.381 1052.13 845.954 1050.95C853.444 1048.64 860.757 1045.79 867.837 1042.43L886.715 1033.78C889.76 1032.36 893.13 1030.33 896.743 1028.22C899.017 1026.84 901.29 1025.5 903.645 1024.16C928.776 1010.44 952.364 989.892 970.39 973.409C987.117 955.667 1007.94 932.241 1021.91 907.394C1023.29 904.958 1024.67 902.685 1025.97 900.452C1028.16 896.879 1030.23 893.51 1031.78 890.302L1040.22 872.398C1043.85 865.15 1046.9 857.629 1049.35 849.906C1050.57 846.374 1051.79 842.923 1053.05 839.553L1055.73 832.083C1055.73 831.393 1056.26 830.093 1056.54 828.835L1063.69 800.091L1068.31 769.519L1102.38 774.635L1097.34 807.601L1090.04 836.955C1089.55 838.985 1089.02 841.015 1088.37 843.126L1085.37 851.53C1084.11 854.859 1083.01 857.985 1081.92 861.192C1078.99 870.308 1075.36 879.184 1071.08 887.744L1062.96 905.162C1060.56 910.033 1057.96 914.296 1055.44 918.437C1054.23 920.427 1053.01 922.497 1051.83 924.446C1036 952.582 1013.18 978.281 994.993 997.525L994.587 997.972L994.14 998.377C974.693 1016.24 948.751 1038.98 920.25 1054.36C918.301 1055.42 916.19 1056.6 914.323 1057.81C910.263 1060.29 905.878 1062.81 901.128 1065.08L882.777 1073.45C874.371 1077.49 865.671 1080.9 856.753 1083.64C853.546 1084.69 850.42 1085.75 847.415 1086.84L839.296 1089.69C836.697 1090.46 834.627 1090.94 832.637 1091.43L797.966 1099.14L770.115 1103L765.324 1068.86Z",
    fill: "url(#paint76_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.504 434.616C458.871 415.436 480.009 398.131 502.635 382.933C535.114 362.633 566.782 346.84 591.953 338.599L603.524 334.539C609.492 332.468 614.485 330.763 618.342 329.586L628.086 327.312L629.588 333.564L620.007 335.838C616.394 336.934 611.522 338.639 605.635 340.669L593.983 344.729C569.299 352.849 538.119 368.317 506.208 388.373C467.714 414.28 433.648 446.222 405.319 482.97C372.841 525.174 348.926 573.321 334.921 624.702C320.903 676.074 316.851 729.656 322.985 782.552C328.012 828.723 341.094 873.656 361.635 915.312C364.678 922.337 368.248 929.123 372.312 935.611L375.438 941.011C377.184 943.853 378.808 946.735 380.432 949.577C383.032 954.337 385.878 958.958 388.958 963.422L402.64 982.301C404.101 984.168 405.441 986.076 406.7 987.984C408.998 991.392 411.549 994.622 414.332 997.647L439.504 1025.82L434.672 1030.13L409.623 1002.07C406.62 998.85 403.903 995.373 401.503 991.679C400.204 989.893 398.905 988.025 397.443 986.157L383.68 967.116C380.473 962.61 377.712 957.779 374.789 952.663C373.205 949.862 371.582 947.02 369.836 944.178L366.669 938.737C362.506 932.054 358.855 925.064 355.748 917.829C334.894 875.581 321.62 830 316.529 783.161C310.293 729.432 314.428 675.005 328.709 622.834C342.93 570.645 367.217 521.739 400.204 478.869C412.306 463.262 425.436 448.478 439.504 434.616Z",
    fill: "url(#paint77_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.386 442.979L424.427 460.437L421.463 463.685L419.068 466.283C417.566 467.866 415.739 469.856 413.79 472.251C411.841 474.646 409.405 478.219 406.523 482.036C401.083 489.262 394.912 497.504 388.213 507.126C364.832 543.512 347.042 583.2 335.434 624.864L330.278 645.163C329.103 649.404 328.208 653.717 327.598 658.074L322.361 692.908L320.372 734.563L321.143 753.401C321.39 765.505 322.462 777.577 324.35 789.535L326.989 808.332C327.081 809.384 327.243 810.428 327.477 811.458L302.346 817.507C301.899 815.567 301.573 813.601 301.371 811.621L298.773 793.189C296.735 780.236 295.582 767.16 295.322 754.051L294.551 729.691L296.703 689.863L301.899 655.029C302.608 649.638 303.707 644.306 305.188 639.074L310.344 618.409C322.771 573.958 341.808 531.627 366.817 492.835C374.003 482.523 380.621 473.713 385.939 466.648C388.7 462.954 391.176 459.665 393.288 456.742C396.13 453.21 398.403 450.774 400.23 448.622L402.219 446.471L405.386 442.979Z",
    fill: "url(#paint78_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.066 327.393L656.486 320.653L695.867 315.172C698.587 314.969 701.185 314.888 703.987 314.766L734.923 313.508C741.053 313.508 747.103 313.914 753.558 314.32L764.56 314.888C811.608 318.336 857.765 329.516 901.176 347.976C1001.62 391.045 1081.24 471.676 1123.05 572.653C1140.93 616.246 1151.52 662.483 1154.39 709.513C1154.39 713.37 1154.68 717.024 1154.84 720.637C1155.16 726.971 1155.45 733.142 1155.45 739.11L1153.74 770.209C1153.74 772.848 1153.5 775.446 1153.3 777.964L1146.52 819.456L1139.9 845.805L1133.61 844.222L1140.71 816.005L1146.56 777.192C1146.56 774.959 1146.84 772.442 1146.96 769.884L1148.67 738.948C1148.67 733.264 1148.38 727.174 1148.06 720.922C1148.06 717.268 1147.73 713.573 1147.61 709.838C1144.77 663.536 1134.35 618.014 1116.76 575.089C1075.61 475.755 997.272 396.437 898.456 354.066C855.733 335.94 810.319 324.967 764.033 321.587L753.03 320.978C746.778 320.612 740.85 320.247 734.842 320.206L704.068 321.465C701.51 321.465 698.952 321.668 696.516 321.83L655.917 327.636L629.569 333.767L628.066 327.393Z",
    fill: "url(#paint79_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.077 319.314L897.469 325.891C899.58 326.622 901.813 327.393 904.086 328.408L936.2 343.593C977.04 365.239 1014.5 392.73 1047.4 425.197C1079.32 458.317 1106.26 495.899 1127.38 536.764L1142.36 569.243C1143.46 571.761 1144.19 573.994 1144.92 576.105L1151.21 594.577L1126.85 602.981L1121.45 587.107C1121.17 586.376 1120.8 585.321 1120.44 584.225C1119.98 582.721 1119.44 581.244 1118.81 579.799L1104.24 547.848C1084.29 509.606 1058.96 474.427 1029.01 443.386C998.096 412.922 962.939 387.091 924.629 366.694L893.246 351.875C891.907 351.306 890.445 350.819 889.186 350.291L886.02 349.195L870.43 343.674L879.077 319.314Z",
    fill: "url(#paint80_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.272 1025.62L467.001 1050.99C469.993 1053.87 473.211 1056.51 476.623 1058.87C478.491 1060.21 480.399 1061.59 482.307 1062.93L500.942 1076.82C505.366 1079.94 509.946 1082.84 514.664 1085.5C517.506 1087.17 520.389 1088.83 523.271 1090.62L528.549 1093.83C534.928 1097.91 541.605 1101.51 548.524 1104.59C589.966 1125.77 634.804 1139.51 680.999 1145.18C733.823 1152 787.464 1148.61 839.01 1135.2C890.561 1121.85 939.001 1098.55 981.594 1066.58C1018.73 1038.72 1051.11 1005.03 1077.49 966.832C1097.79 935.246 1113.78 904.269 1122.15 879.706C1123.61 875.443 1125.03 871.586 1126.21 868.054C1128.32 862.248 1130.06 857.376 1131.24 853.601L1133.56 844.222L1139.85 845.806L1137.45 855.306C1136.19 859.366 1134.41 864.319 1132.3 870.246C1131 873.738 1129.64 877.595 1128.24 881.817C1119.67 906.826 1103.55 938.291 1082.85 970.405C1056.04 1009.26 1023.14 1043.54 985.41 1071.9C942.166 1104.4 892.963 1128.08 840.593 1141.61C788.241 1155.25 733.758 1158.69 680.105 1151.76C633.255 1146.07 587.77 1132.19 545.723 1110.76C538.606 1107.58 531.739 1103.88 525.18 1099.67L519.861 1096.47C516.979 1094.68 514.137 1093.01 511.376 1091.39C506.445 1088.62 501.662 1085.6 497.044 1082.34L478.328 1068.37L472.807 1064.31C469.099 1061.82 465.621 1059.01 462.414 1055.91L434.766 1030.65L439.272 1025.62Z",
    fill: "url(#paint81_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.133 1142.79L652.135 1140.35C653.126 1140.59 654.129 1140.76 655.139 1140.88L674.099 1143.72C685.878 1145.8 697.79 1147.04 709.745 1147.42L738.53 1148.27L770.725 1146.97L805.031 1142.3C809.524 1141.76 813.973 1140.91 818.347 1139.74L839.256 1134.75C881.073 1123.58 920.979 1106.2 957.643 1083.19C967.062 1076.82 975.384 1070.73 982.733 1065.33C986.549 1062.52 989.959 1060.01 993.004 1057.86C994.953 1056.31 997.064 1054.53 998.566 1053.02C1000.07 1051.52 1000.6 1051.16 1001.45 1050.47L1004.45 1047.79L1021.67 1067.03L1018.42 1069.95C1017.49 1070.73 1016.75 1071.38 1015.94 1072.15C1013.95 1073.97 1011.48 1076.21 1008.43 1078.6C1005.39 1081 1001.69 1083.47 997.998 1086.19C990.853 1091.43 981.961 1097.93 971.812 1104.79C932.705 1129.39 890.111 1147.95 845.468 1159.84L824.397 1164.83C819.065 1166.26 813.638 1167.31 808.157 1167.96L772.592 1172.75L723.224 1173.97L708.974 1173.2C695.996 1172.77 683.066 1171.41 670.283 1169.14L651.689 1166.34C648.725 1165.93 646.817 1165.48 646.411 1165.4L649.293 1152.82L641.133 1142.79Z",
    fill: "url(#paint82_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.266 988.383L452.355 990.975L462.697 1002.59L465.608 999.994L455.266 988.383Z",
    fill: "url(#paint83_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.727 944.462L418.934 942.189C419.34 942.798 419.868 943.488 420.395 944.219L431.966 960.134L428.799 962.407L417.269 946.573L415.727 944.462ZM437.691 974.465L440.614 971.867L445.567 977.388L442.644 979.987L437.691 974.465Z",
    fill: "url(#paint84_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.803 479.641L453.685 482.28L451.046 485.203C450.275 486.096 449.301 487.152 448.164 488.329C445.575 490.971 443.161 493.778 440.937 496.733C440.45 497.383 439.922 498.154 439.354 498.885L436.187 496.612L437.73 494.419C440.08 491.332 442.615 488.39 445.322 485.609C446.378 484.513 447.352 483.498 448.123 482.605L450.803 479.641ZM427.296 508.345L430.422 510.7C429.001 512.567 427.54 514.76 426.037 516.627L422.871 514.272L427.296 508.345ZM414.386 526.533L417.674 528.685C414.71 533.232 412.071 537.617 409.554 542.083C407.037 546.549 404.926 549.918 402.693 554.263L399.242 552.395C401.516 548.335 403.83 544.275 406.144 540.215C408.702 535.668 411.381 531.202 414.386 526.574V526.533ZM394.086 562.058L397.618 563.844C394.33 570.299 391.203 577.039 388.24 583.819L384.667 582.276C387.671 575.455 390.838 568.635 394.127 562.098L394.086 562.058ZM379.186 596.08L382.84 597.501C381.947 599.774 381.094 602.048 380.242 604.362L376.547 603.022C377.237 600.668 378.131 598.353 379.186 596.08ZM371.675 617.07L375.411 618.288C372.325 627.666 369.605 637.207 367.291 646.707L363.474 645.773C365.667 636.192 368.427 626.57 371.513 617.07H371.675ZM361.038 656.532L364.855 657.344C363.312 664.53 362.013 671.838 360.795 679.065L356.735 678.496C357.953 671.189 359.293 663.8 360.876 656.532H361.038ZM355.192 693.275L359.252 693.64L358.643 700.177V700.907H354.583V700.095C354.827 697.619 354.827 695.467 355.03 693.275H355.192ZM353.731 715.482L357.79 715.726C356.978 725.463 356.869 735.246 357.466 744.998L353.406 745.323C352.752 735.358 352.806 725.359 353.568 715.401L353.731 715.482ZM353.731 756.325H357.79L358.318 768.099L359.699 778.249L355.639 778.777L354.137 766.029L353.731 756.325ZM357.547 793.23L361.607 792.743C361.891 795.179 362.256 797.615 362.662 800.01L358.805 800.66C358.264 798.224 357.831 795.747 357.506 793.23H357.547ZM361.607 815.276L365.423 814.342C365.992 816.859 366.6 819.335 367.169 821.812C367.737 824.289 368.468 827.131 369.077 829.932L371.351 839.391C371.675 840.528 372.122 841.787 372.528 843.045L368.833 844.304C368.387 843.005 367.94 841.706 367.575 840.244L365.261 830.663C364.652 828.024 364.043 825.385 363.393 822.543C362.744 819.701 362.216 817.752 361.647 815.276H361.607ZM372.406 854.616L376.141 853.358L380.201 864.928C381.094 867.933 382.191 870.937 383.49 874.226L379.876 875.687C378.496 872.277 377.4 869.151 376.466 866.106L372.406 854.616ZM385.844 889.288L389.417 887.623C390.392 889.653 391.285 891.683 392.137 893.673L392.462 894.404L388.889 895.987L388.565 895.256C387.753 893.267 386.819 891.277 385.885 889.288H385.844ZM395.182 909.588L398.674 907.842C400.135 910.724 401.475 913.12 402.734 915.109L413.411 933.379L410.001 935.328L399.486 917.017C397.986 914.582 396.631 912.06 395.426 909.466L395.182 909.588Z",
    fill: "url(#paint85_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.121 462.954L469.003 465.593L458.488 477.042L455.605 474.403L466.121 462.954Z",
    fill: "url(#paint86_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.242 462.791L477.854 452.438L480.452 455.362L468.841 465.714L466.242 462.791Z",
    fill: "url(#paint87_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.812 442.656L494.334 437.743L496.932 440.666L491.411 445.579L488.812 442.656ZM506.392 428.852L522.225 417.322L524.337 415.738L526.61 418.986C525.909 419.439 525.232 419.927 524.58 420.448L508.665 431.978L506.392 428.852Z",
    fill: "url(#paint88_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.465 410.134L551.653 399.538C554.088 398.037 556.61 396.681 559.205 395.478L560.95 398.969C558.486 400.106 556.087 401.38 553.764 402.786L535.495 413.423L533.465 410.134ZM572.683 389.023L573.414 388.698L579.382 385.978L581.047 389.55C578.976 390.484 576.987 391.418 574.998 392.27L574.267 392.595L572.683 389.023ZM592.983 379.888C596.113 378.58 599.312 377.442 602.564 376.477L614.054 372.417L615.312 376.112L603.742 380.172C600.586 381.101 597.482 382.198 594.445 383.46L592.983 379.888ZM624.528 368.926L628.588 367.667L638.17 365.394L646.289 363.486L653.719 361.699L654.612 365.516L647.183 367.302L639.063 369.21L629.603 371.443L625.949 372.62L624.528 368.926ZM668.01 358.695C670.446 358.248 672.922 357.883 675.399 357.599L675.886 361.659C673.45 361.983 671.055 362.308 668.66 362.755L668.01 358.695ZM690.055 355.69L702.803 354.148L712.344 353.782V357.842L700.57 358.329L690.421 359.71L690.055 355.69ZM723.346 353.295C733.289 352.692 743.262 352.814 753.187 353.661L752.943 357.72C743.207 356.894 733.425 356.772 723.671 357.355L723.346 353.295ZM768.005 354.472H768.939L775.597 355.122L775.191 359.182C773.04 358.938 770.888 358.735 768.696 358.573H767.965L768.005 354.472ZM790.294 356.949C797.602 358.045 804.991 359.385 812.258 361.009L811.446 365.069C804.22 363.526 796.912 362.186 789.726 361.009L790.294 356.949ZM823.139 363.404C832.598 365.759 842.22 368.479 851.558 371.524L850.34 375.259C840.921 372.214 831.421 369.494 821.921 367.139L823.139 363.404ZM865.768 376.477C868.122 377.33 870.437 378.223 872.71 379.116L871.289 382.77C869.016 381.877 866.702 380.984 864.387 380.172L865.768 376.477ZM886.473 384.597C893.334 387.561 900.115 390.768 906.773 394.057L904.986 397.548C898.531 394.3 891.792 391.134 884.971 388.211L886.473 384.597ZM916.557 399.254C920.617 401.527 924.677 403.841 928.737 406.155C933.203 408.591 937.709 411.271 942.337 414.275L940.186 417.564C935.639 414.6 931.254 411.961 926.788 409.444C922.322 406.927 918.952 404.816 914.608 402.583L916.557 399.254ZM954.436 422.801C956.507 424.303 958.496 425.765 960.404 427.226L958.049 430.353L952.122 425.968L954.436 422.801ZM972.178 436.118L974.37 437.66C977.446 440.01 980.374 442.545 983.139 445.253L986.184 448.013L989.148 450.733L986.509 453.616L983.586 450.977C982.693 450.206 981.637 449.231 980.46 448.094C977.757 445.564 974.91 443.192 971.934 440.99C971.285 440.502 970.513 440.015 969.782 439.447L972.178 436.118Z",
    fill: "url(#paint89_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.404 455.737L991.773 458.614L1003.25 469.107L1005.88 466.231L994.404 455.737Z",
    fill: "url(#paint90_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.02 466.392L1003.11 468.986L1013.46 480.591L1016.37 477.997L1006.02 466.392Z",
    fill: "url(#paint91_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.17 491.496L1026.09 488.857L1031.04 494.378L1028.12 496.977L1023.17 491.496ZM1036.89 508.75L1040.1 506.436L1051.59 522.311C1052.14 522.985 1052.66 523.689 1053.13 524.422L1049.92 526.655C1049.52 526.046 1048.99 525.355 1048.46 524.665L1036.89 508.75Z",
    fill: "url(#paint92_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.29 535.626L1058.65 533.637L1069.25 551.825C1070.55 553.855 1071.97 556.332 1073.31 559.377L1069.78 561.163C1068.56 558.669 1067.2 556.243 1065.72 553.896L1055.29 535.626ZM1076.19 574.48L1079.77 572.896L1080.09 573.627C1080.94 575.616 1081.88 577.687 1082.81 579.595L1079.24 581.26C1078.3 579.189 1077.37 577.2 1076.52 575.21L1076.19 574.48ZM1085.29 594.779L1088.9 593.318C1090.28 596.687 1091.38 599.814 1092.31 602.858L1096.37 614.348L1092.68 615.607L1088.62 604.076C1087.68 600.95 1086.63 597.946 1085.29 594.657V594.779ZM1096.13 626.122L1099.86 624.863C1100.27 626.122 1100.72 627.421 1101.12 628.923L1103.4 638.505C1104 641.103 1104.61 643.783 1105.3 646.625C1105.99 649.466 1106.48 651.578 1107.05 654.095L1103.27 654.988C1102.66 652.471 1102.06 649.994 1101.49 647.558C1100.92 645.122 1100.19 642.199 1099.58 639.438L1097.35 629.979C1096.98 628.477 1096.57 627.218 1096.13 626.081V626.122ZM1106.24 668.995L1110.09 668.345C1110.5 670.781 1110.91 673.258 1111.19 675.734L1107.13 676.221C1107.01 673.664 1106.64 671.268 1106.24 668.873V668.995ZM1109.24 690.918L1113.1 690.391L1114.6 703.098L1115.01 712.639H1110.95L1110.46 700.906L1109.24 690.918ZM1111.6 723.966L1115.66 723.641C1116.24 733.584 1116.12 743.556 1115.29 753.482L1111.23 753.238C1112.06 743.462 1112.18 733.638 1111.6 723.844V723.966ZM1110.38 768.057H1114.44V768.91C1114.44 771.183 1114.07 773.376 1113.83 775.568L1109.77 775.162C1110.01 773.01 1110.18 770.818 1110.38 768.666V768.057ZM1107.94 789.94L1112 790.468C1110.91 797.776 1109.57 805.165 1107.94 812.473L1103.88 811.62C1105.55 804.312 1106.89 797.004 1107.94 789.818V789.94ZM1101.53 822.419L1105.34 823.353C1103.03 832.853 1100.31 842.476 1097.22 851.773L1093.49 850.555C1096.53 841.258 1099.25 831.636 1101.53 822.257V822.419ZM1088.66 864.643L1092.31 866.023C1091.46 868.337 1090.57 870.651 1089.67 872.966L1086.02 871.545C1086.91 869.109 1087.76 866.795 1088.66 864.48V864.643ZM1080.54 885.145L1084.15 886.688C1081.15 893.59 1077.98 900.37 1074.69 906.988L1071.2 905.201C1074.33 898.503 1077.49 891.804 1080.42 884.983L1080.54 885.145ZM1066.04 914.905L1069.49 916.772C1067.22 920.832 1064.91 924.892 1062.59 928.952C1060.12 933.459 1057.44 937.924 1054.47 942.553L1051.18 940.442C1054.15 935.854 1056.79 931.469 1059.3 927.003C1061.82 922.537 1063.69 918.883 1065.92 914.742L1066.04 914.905ZM1042.78 952.378L1045.95 954.692C1044.45 956.763 1042.94 958.752 1041.52 960.66L1038.4 958.305L1042.78 952.378ZM1029.46 970.12L1032.63 972.434L1031.09 974.586C1028.74 977.673 1026.2 980.615 1023.5 983.396C1022.44 984.532 1021.51 985.507 1020.74 986.441L1018.02 989.404L1015.13 986.765L1017.77 983.842C1018.54 982.949 1019.52 981.893 1020.65 980.676C1023.25 978.04 1025.67 975.247 1027.92 972.312C1028.25 971.459 1028.77 970.729 1029.34 969.957L1029.46 970.12Z",
    fill: "url(#paint93_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.22 991.8L1013.1 994.439L1002.63 1005.93L999.703 1003.29L1010.22 991.8Z",
    fill: "url(#paint94_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.258 1013.48L999.869 1003.13L1002.47 1006.05L990.856 1016.44L988.258 1013.48Z",
    fill: "url(#paint95_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.105 1049.9C942.755 1049.45 943.445 1048.96 944.135 1048.4L960.05 1036.87L962.324 1040.03L946.49 1051.56L944.379 1053.11L942.105 1049.9ZM971.946 1028.02L977.467 1023.1L980.106 1026.03L974.585 1030.94L971.946 1028.02Z",
    fill: "url(#paint96_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.201 1015.11L485.125 1017.74C486.018 1018.47 487.073 1019.49 488.251 1020.63C490.901 1023.21 493.708 1025.62 496.655 1027.85L498.847 1029.44L496.533 1032.6L494.341 1031.02C491.257 1028.7 488.328 1026.17 485.571 1023.47C484.434 1022.39 483.419 1021.45 482.526 1020.67L479.562 1017.99L482.201 1015.11ZM510.621 1038.37L516.548 1042.75L514.234 1045.92L508.266 1041.49L510.621 1038.37ZM528.606 1051.12C533.153 1054.08 537.538 1056.72 542.044 1059.24C545.901 1061.55 549.88 1063.82 553.98 1066.1L552.113 1069.55C548.053 1067.23 543.993 1064.96 539.933 1062.65C535.427 1060.17 530.961 1057.49 526.333 1054.53L528.606 1051.12ZM563.765 1071.13C570.22 1074.42 576.96 1077.55 583.78 1080.51L582.197 1084.08C575.336 1081.12 568.556 1077.95 561.897 1074.62L563.765 1071.13ZM597.381 1086.11L604.283 1088.71L602.902 1092.37L595.96 1089.77L597.381 1086.11ZM618.168 1093.54C627.586 1096.63 637.087 1099.35 646.587 1101.66L645.653 1105.48C636.194 1103.17 626.572 1100.4 617.234 1097.36L618.168 1093.54ZM657.224 1104.1C664.45 1105.64 671.758 1106.94 678.944 1108.16L678.376 1112.02C671.109 1110.96 663.679 1109.62 656.412 1107.96L657.224 1104.1ZM693.56 1109.86L700.056 1110.43H700.827V1114.49H699.934L693.276 1113.88L693.56 1109.86ZM715.605 1111.28C725.355 1112.11 735.151 1112.23 744.918 1111.65L745.202 1115.71C735.259 1116.29 725.287 1116.17 715.362 1115.34L715.605 1111.28ZM756.204 1111.28L767.978 1110.8L778.128 1109.42L778.655 1113.48L765.948 1114.98L756.407 1115.39L756.204 1111.28ZM792.743 1107.51C795.179 1107.23 797.575 1106.86 799.97 1106.45L800.619 1110.51C798.183 1110.92 795.707 1111.28 793.231 1111.61L792.743 1107.51ZM814.342 1103.45L821.772 1101.66L829.891 1099.75L839.351 1097.52C840.528 1097.2 841.746 1096.79 843.005 1096.34L844.263 1100.04C843.005 1100.49 841.706 1100.93 840.203 1101.3L830.622 1103.61L822.705 1105.48L815.235 1107.27L814.342 1103.45ZM853.317 1092.73L864.888 1088.67C868.043 1087.76 871.147 1086.67 874.185 1085.42L875.646 1089.04C872.277 1090.42 869.151 1091.51 866.065 1092.45L854.616 1096.51L853.317 1092.73ZM887.583 1079.46C889.653 1078.48 891.642 1077.59 893.632 1076.73L894.363 1076.41L895.946 1079.98L895.215 1080.31C893.226 1081.16 891.155 1082.05 889.247 1083.03L887.583 1079.46ZM907.882 1070.2C910.371 1068.97 912.797 1067.61 915.149 1066.14L933.419 1055.5L935.368 1058.87L917.179 1069.47C914.753 1070.96 912.245 1072.31 909.668 1073.53L907.882 1070.2Z",
    fill: "url(#paint97_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.499 999.842L462.867 1002.72L474.335 1013.22L476.967 1010.34L465.499 999.842Z",
    fill: "url(#paint98_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.544 416.224L406.752 419.107L395.1 431.815L391.933 428.932L403.544 416.224ZM380.322 441.64L383.529 444.522L382.758 445.334L373.258 458.123L369.807 455.565L380.322 441.64ZM359.535 469.369L362.945 471.805L358.479 477.814C356.551 480.33 354.775 482.96 353.161 485.69L349.507 483.457C351.189 480.645 353.032 477.934 355.029 475.337L359.535 469.369ZM340.657 498.438L344.351 500.63L335.541 515.449L331.847 513.216L340.657 498.438ZM323.93 528.644L327.99 530.471L320.682 545.939L316.622 544.153L323.93 528.644ZM309.314 559.986L313.374 561.529C312.521 563.681 311.791 565.833 311.019 568.025C310.248 570.218 309.842 571.395 309.192 573.1L307.568 577.728L303.508 576.267L305.173 571.638C305.782 569.933 306.391 568.269 306.959 566.604C307.528 564.94 308.461 562.219 309.314 560.068V559.986ZM297.703 592.466L301.763 593.928L298.799 602.25L296.647 610.167L292.587 609.071C293.318 606.351 294.049 603.631 294.82 600.951L297.703 592.466ZM288.243 626.082L292.303 627.057C291.004 632.619 289.827 638.221 288.69 643.865L284.63 643.012C285.807 637.166 286.985 631.522 288.243 626.082ZM281.747 659.901L286.01 660.592C285.077 666.194 284.265 671.878 283.534 677.562L279.23 676.994C279.799 671.269 280.651 665.545 281.747 659.901ZM277.322 694.167L281.626 694.614C281.057 700.298 280.611 705.982 280.286 711.706L275.982 711.462C276.145 705.657 276.591 699.932 277.119 694.167H277.322ZM275.211 728.798H279.555V731.559C279.555 736.309 279.555 741.1 279.88 745.891H275.576C275.576 741.059 275.292 736.228 275.252 731.397L275.211 728.798ZM276.429 763.348L280.732 763.064C281.138 768.748 281.626 774.473 282.235 780.116L277.931 780.603C277.16 774.879 276.632 769.113 276.226 763.348H276.429ZM280.042 797.777L284.346 797.168C285.117 802.851 286.01 808.495 286.985 814.097L282.722 814.828C281.612 809.171 280.651 803.488 279.839 797.777H280.042ZM285.97 831.839L290.03 830.946C291.166 836.59 292.466 842.192 293.765 847.714L289.705 848.729C288.203 843.167 286.944 837.523 285.807 831.839H285.97ZM294.333 865.496L298.393 864.116L303.955 880.356L299.895 881.777L294.333 865.496ZM305.498 897.976L309.558 896.595C310.451 899.194 311.344 901.792 312.359 904.269L316.013 912.388L311.953 914.175L308.259 906.055C307.122 903.457 306.107 900.777 305.295 898.097L305.498 897.976ZM319.261 929.765L323.321 927.979L330.426 943.447L326.731 945.639L325.473 943.041L319.261 929.765ZM335.216 960.499L338.951 958.347L343.011 965.614C344.554 968.131 346.016 970.73 347.437 973.247L343.701 975.358C342.28 972.881 340.86 970.324 339.276 967.806L335.216 960.499ZM353.202 990.095L356.693 987.578L366.802 1001.54L363.311 1004.06L353.202 990.095ZM373.501 1017.99L376.952 1015.47L379.672 1019.16L387.792 1028.46L384.544 1031.3L376.14 1021.84L373.501 1017.99ZM396.196 1044.17L399.403 1041.33L410.852 1054.16L407.645 1057.04L396.196 1044.17Z",
    fill: "url(#paint99_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.668 407.495L424.538 396.005L427.38 399.253L414.51 410.905L411.668 407.495ZM437.367 384.556L446.827 376.152L450.887 373.31L453.404 376.802L449.709 379.481L440.412 387.601L437.367 384.556ZM464.447 363.201L478.372 353.092L480.93 356.583L466.964 366.693L464.447 363.201ZM493.15 343.713C495.627 342.333 498.144 340.872 500.661 339.329L508.009 335.269L510.161 339.004L502.894 343.064C500.377 344.607 497.778 346.068 495.261 347.53L493.15 343.713ZM522.869 326.459L525.467 325.2L538.702 319.151L540.529 323.211L525.345 330.153L522.869 326.459ZM554.414 311.965L562.534 308.27C565.213 307.174 567.893 306.281 570.654 305.347L572.034 309.407C569.395 310.3 566.837 311.153 564.32 312.208L556.2 315.862L554.414 311.965ZM586.893 299.785L603.133 294.223L604.554 298.283L588.314 303.845L586.893 299.785ZM619.981 289.635C625.544 288.295 631.187 287.037 636.871 285.859L637.723 289.919C632.121 291.097 626.518 292.355 620.996 293.695L619.981 289.635ZM653.841 282.612C659.525 281.637 665.209 280.744 670.933 279.932L671.542 283.992C665.858 284.804 660.215 285.697 654.612 286.631L653.841 282.612ZM688.107 277.821C693.831 277.212 699.556 276.725 705.361 276.278L705.645 280.582C699.921 280.988 694.237 281.515 688.553 282.124L688.107 277.821ZM722.616 275.385C727.447 275.385 732.278 275.06 737.11 275.06H739.87V279.364H737.069C732.36 279.364 727.528 279.364 722.778 279.648L722.616 275.385ZM757.247 275.872C763.012 276.197 768.777 276.643 774.501 277.212L774.095 281.272C768.411 280.744 762.728 280.297 757.003 279.973L757.247 275.872ZM791.715 279.12C797.44 279.851 803.164 280.703 808.807 281.637L808.117 285.9C802.515 284.966 796.831 284.154 791.147 283.424L791.715 279.12ZM825.778 284.723C831.462 285.819 837.105 287.037 842.667 288.336L841.693 292.396C836.171 291.097 830.569 289.879 824.925 288.783L825.778 284.723ZM859.475 292.518L867.595 294.751L876.039 297.755L874.618 301.815L866.377 298.851L858.257 296.659L859.475 292.518ZM892.279 303.561L896.907 305.185L901.942 307.012L908.559 309.366L906.976 313.467C904.865 312.655 902.713 311.884 900.521 311.153L895.608 309.407L890.98 307.783L892.279 303.561ZM924.393 316.674L939.902 324.023L938.075 328.083L922.607 320.775L924.393 316.674ZM955.695 331.98L970.473 340.831L968.28 344.525L953.462 335.715L955.695 331.98ZM985.291 349.641C988.104 351.335 990.816 353.192 993.411 355.203L999.42 359.669L996.862 363.12L990.772 358.613C988.266 356.703 985.649 354.94 982.937 353.336L985.291 349.641ZM1013.35 369.941L1027.23 380.415L1024.35 383.623L1023.58 382.892L1010.79 373.392L1013.35 369.941ZM1039.98 392.067L1052.69 403.679L1049.8 406.845L1036.89 395.275L1039.98 392.067Z",
    fill: "url(#paint100_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.1 414.56L1061.31 411.718L1072.75 424.548L1069.55 427.43L1058.1 414.56ZM1081.04 440.3L1084.24 437.418L1092.65 446.877L1095.45 450.937L1092 453.495L1089.28 449.76L1081.04 440.3ZM1102.11 467.218L1105.6 464.7L1115.71 478.626L1112.22 481.143L1102.11 467.218ZM1121.31 495.637L1125.05 493.526C1126.47 496.043 1127.93 498.56 1129.47 501.077L1133.53 508.385L1129.84 510.578L1125.57 503.31C1124.23 500.631 1122.73 498.032 1121.31 495.475V495.637ZM1138.65 525.478L1142.34 523.285L1143.6 525.883L1149.65 539.119L1145.59 540.905L1138.65 525.478ZM1152.9 556.577L1156.96 554.79L1160.69 562.91C1161.79 565.549 1162.68 568.229 1163.61 571.03L1159.55 572.41C1158.66 569.812 1157.81 567.254 1156.75 564.737L1152.9 556.577ZM1165.08 588.609L1169.14 587.229L1174.7 603.469L1170.64 604.849L1165.08 588.609ZM1175.14 621.332L1179.2 620.317C1180.54 625.88 1181.8 631.482 1182.98 637.166L1178.92 638.059C1177.58 632.254 1176.32 626.692 1174.94 621.17L1175.14 621.332ZM1182.09 654.908L1186.15 654.177C1187.12 659.821 1188.01 665.545 1188.83 671.27L1184.56 671.879C1183.79 666.032 1183.06 660.348 1181.92 654.746L1182.09 654.908ZM1186.84 688.89L1191.14 688.443C1191.75 694.168 1192.24 699.892 1192.64 705.657L1188.34 705.982C1187.77 700.095 1187.12 694.411 1186.67 688.727L1186.84 688.89ZM1189.31 723.115H1193.58C1193.78 727.906 1193.86 732.737 1193.9 737.609V740.37H1189.56V737.568C1189.39 732.493 1189.31 727.581 1189.15 722.952L1189.31 723.115ZM1188.79 757.34L1193.09 757.584C1192.76 763.349 1192.28 769.114 1191.75 774.838L1187.45 774.432C1187.85 768.586 1188.3 762.862 1188.62 757.178L1188.79 757.34ZM1185.58 791.484L1189.64 792.012C1188.91 797.777 1188.06 803.461 1187.16 809.145L1182.9 808.455C1183.83 802.649 1184.64 797.006 1185.42 791.322L1185.58 791.484ZM1179.85 825.019L1183.91 825.831C1182.78 831.556 1181.6 837.158 1180.3 842.761L1176.24 841.787C1177.54 836.428 1178.76 830.825 1179.85 825.019ZM1172.1 858.432L1176.16 859.569C1175.43 862.289 1174.7 864.969 1173.93 867.689L1170.92 876.174L1166.86 874.713L1169.83 866.39C1170.88 863.994 1171.41 861.274 1172.1 858.595V858.432ZM1161.18 890.912L1165.24 892.373L1163.61 896.961C1162.96 898.666 1162.4 900.371 1161.79 902.036C1161.18 903.701 1160.24 906.461 1159.39 908.613L1155.33 907.07C1156.14 904.959 1156.87 902.767 1157.65 900.615C1158.42 898.463 1158.82 897.205 1159.47 895.499L1161.18 890.912ZM1148.19 922.701L1152.25 924.487L1144.94 939.996L1140.88 938.169L1148.19 922.701ZM1133.08 953.272L1136.82 955.465L1127.97 970.283L1124.27 968.05L1133.08 953.272ZM1115.46 982.829L1119.16 985.061C1117.46 987.872 1115.6 990.583 1113.6 993.181L1109.13 999.19L1105.64 996.632L1110.19 990.583C1112.09 988.154 1113.85 985.619 1115.46 982.991V982.829ZM1095.16 1010.56L1098.62 1013.16L1088.1 1027.04L1084.93 1024.16L1085.66 1023.39L1095.16 1010.56ZM1073.44 1037.03L1076.61 1039.95L1065 1052.66L1061.83 1049.74L1073.44 1037.03Z",
    fill: "url(#paint101_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.023 1061.96L431.731 1073.61L428.848 1076.78L416.141 1065.12L419.023 1061.96ZM444.479 1085.18L445.25 1085.91L458.079 1095.45L455.481 1098.9L441.556 1088.39L444.479 1085.18ZM471.883 1105.72L477.932 1110.23C480.447 1112.14 483.063 1113.92 485.768 1115.55L483.576 1119.2C480.755 1117.52 478.043 1115.66 475.456 1113.64L469.447 1109.17L471.883 1105.72ZM500.587 1124.32L515.365 1133.17L513.172 1136.86L498.354 1128.01L500.587 1124.32ZM530.467 1140.96L545.936 1148.27L544.149 1152.33L528.64 1145.02L530.467 1140.96ZM561.566 1155.46C563.677 1156.27 565.87 1157.04 568.021 1157.81L573.137 1159.64L577.725 1161.26L576.263 1165.32L571.635 1163.66L566.601 1161.87C564.408 1161.1 562.175 1160.33 559.983 1159.48L561.566 1155.46ZM594.045 1167.03L602.165 1169.99L610.285 1172.18L609.148 1176.24C606.428 1175.55 603.749 1174.78 601.028 1174.05L592.584 1171.01L594.045 1167.03ZM626.931 1176.32C632.452 1177.62 638.055 1178.8 643.698 1179.94L642.886 1184C637.148 1182.86 631.505 1181.64 625.956 1180.34L626.931 1176.32ZM660.587 1182.98C666.19 1183.88 671.874 1184.73 677.558 1185.46L676.989 1189.72C671.265 1188.99 665.54 1188.14 659.897 1187.21L660.587 1182.98ZM694.609 1187.37C700.293 1187.94 705.977 1188.38 711.701 1188.71L711.458 1193.01C705.693 1192.65 699.928 1192.2 694.203 1191.67L694.609 1187.37ZM728.834 1189.44H731.635C736.386 1189.44 741.136 1189.44 745.926 1189.11V1193.42C741.095 1193.42 736.304 1193.7 731.432 1193.74H728.672L728.834 1189.44ZM763.059 1188.26C768.783 1187.85 774.467 1187.37 780.151 1186.76L780.598 1190.82C774.873 1191.43 769.149 1191.96 763.343 1192.36L763.059 1188.26ZM797.162 1184.65C802.846 1183.88 808.53 1182.98 814.133 1182.01L814.863 1186.07C809.18 1187.08 803.496 1187.98 797.771 1188.75L797.162 1184.65ZM830.981 1178.8C836.624 1177.62 842.187 1176.37 847.708 1175.07L848.723 1179.13C843.161 1180.47 837.518 1181.72 831.834 1182.9L830.981 1178.8ZM864.11 1170.68L880.35 1165.08L881.73 1169.14L865.49 1174.7L864.11 1170.68ZM896.589 1159.52C899.188 1158.62 901.745 1157.73 904.262 1156.72L912.382 1153.06L914.209 1157.12L906.089 1160.82C903.41 1161.91 900.771 1162.85 897.97 1163.74L896.589 1159.52ZM927.932 1145.88L943.4 1138.77L945.592 1142.51L942.994 1143.76L929.84 1149.81L927.932 1145.88ZM958.3 1130.12L965.567 1126.06C968.084 1124.52 970.682 1123.06 973.2 1121.64L975.351 1125.37C972.834 1126.79 970.317 1128.21 967.8 1129.76L960.492 1134.02L958.3 1130.12ZM987.531 1112.38L1001.5 1102.23L1004.01 1105.72L990.089 1115.83L987.531 1112.38ZM1015.42 1092.08L1019.12 1089.36L1028.41 1081.24L1031.3 1084.45L1021.84 1092.89L1017.98 1095.69L1015.42 1092.08ZM1041.28 1069.63L1054.15 1058.14L1057 1061.35L1044.21 1072.67L1041.28 1069.63Z",
    fill: "url(#paint102_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.227 766.19C246.802 765.607 247.564 765.248 248.379 765.175C249.248 765.153 250.092 765.472 250.729 766.064C251.367 766.655 251.747 767.473 251.789 768.342V771.874V773.823C251.789 774.919 251.789 776.137 251.789 777.558C251.815 778.406 251.52 779.232 250.963 779.872C250.406 780.511 249.628 780.917 248.785 781.009C247.943 781.054 247.116 780.77 246.48 780.217C245.844 779.664 245.447 778.885 245.375 778.045C245.375 776.462 245.375 775.081 245.375 773.985C245.375 772.889 245.375 772.848 245.375 772.28V768.626C245.324 768.182 245.374 767.732 245.522 767.31C245.67 766.889 245.911 766.506 246.227 766.19ZM257.757 842.111C258.166 841.651 258.703 841.325 259.3 841.177C260.13 841.02 260.989 841.149 261.736 841.542C262.48 842.029 263.004 842.786 263.198 843.654C263.297 844.45 263.097 845.255 262.638 845.913C262.178 846.572 261.491 847.036 260.709 847.218C259.927 847.399 259.106 847.285 258.403 846.897C257.701 846.509 257.167 845.874 256.905 845.115C256.762 844.584 256.766 844.024 256.917 843.495C257.067 842.966 257.357 842.488 257.757 842.111ZM282.726 920.589C283.009 920.324 283.323 920.092 283.66 919.899C284.457 919.596 285.338 919.596 286.136 919.899C286.92 920.183 287.571 920.747 287.963 921.482C288.328 922.335 288.775 923.147 289.222 924.121L301.848 951.729C303.723 955.93 305.88 959.999 308.303 963.909L308.587 964.315C310.942 968.375 313.175 972.435 315.408 976.129L315.895 976.86C317.641 979.864 319.387 982.828 321.051 985.792C324.015 990.867 326.776 995.739 329.699 1000.16C332.622 1004.59 336.56 1009.58 339.727 1013.97L344.964 1021.15C349.024 1026.88 353.084 1032.16 356.332 1036.78C358.727 1039.75 361.163 1042.43 363.274 1044.7L366.725 1048.76C372.571 1055.42 375.982 1059.24 375.982 1059.24C376.557 1059.82 376.879 1060.61 376.879 1061.43C376.879 1062.25 376.557 1063.04 375.982 1063.62C375.671 1063.91 375.306 1064.13 374.909 1064.27C374.511 1064.41 374.089 1064.47 373.668 1064.44C373.247 1064.41 372.835 1064.3 372.459 1064.11C372.082 1063.92 371.747 1063.66 371.475 1063.34L362.178 1052.94L358.889 1049.25C356.657 1046.85 354.139 1044.05 351.46 1040.84C348.902 1037.39 346.263 1033.74 343.34 1029.76L324.624 1004.06C321.417 999.23 318.575 994.155 315.489 988.837C313.865 986.117 312.241 983.234 310.495 980.351C309.237 978.078 307.938 975.886 306.436 973.612L302.782 967.319C300.195 963.203 297.915 958.901 295.961 954.449L286.867 934.637L283.375 927.045C283.01 926.192 282.523 925.339 282.117 924.446C281.765 923.83 281.634 923.112 281.745 922.411C281.856 921.71 282.202 921.068 282.726 920.589Z",
    fill: "url(#paint103_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.95 385.774C420.951 355.121 455.904 328.742 493.884 307.337C494.235 307.111 494.634 306.968 495.049 306.919C495.464 306.87 495.884 306.915 496.279 307.052C496.696 307.153 497.088 307.338 497.43 307.597C497.772 307.855 498.058 308.181 498.268 308.555C498.67 309.301 498.767 310.175 498.54 310.992C498.313 311.809 497.78 312.506 497.05 312.939C459.653 334.039 425.199 359.975 394.579 390.078L394.091 390.606C386.865 397.751 379.76 405.221 372.899 412.976L372.533 413.463C371.843 414.275 371.112 415.006 370.422 415.777C370.146 416.101 369.808 416.366 369.428 416.556C369.048 416.746 368.633 416.858 368.209 416.884C367.785 416.911 367.359 416.852 366.958 416.71C366.557 416.569 366.189 416.348 365.875 416.061C365.542 415.799 365.272 415.467 365.082 415.088C364.893 414.709 364.789 414.293 364.779 413.869C364.748 412.998 365.037 412.147 365.591 411.474C366.322 410.662 367.174 409.809 367.986 408.875C375.132 401.04 382.318 393.285 389.95 385.774ZM355.969 423.085C356.572 422.546 357.352 422.248 358.161 422.248C358.97 422.248 359.751 422.546 360.354 423.085C360.68 423.362 360.948 423.7 361.142 424.081C361.337 424.462 361.455 424.877 361.489 425.303C361.523 425.729 361.472 426.158 361.34 426.565C361.208 426.971 360.997 427.348 360.719 427.673C360.17 428.302 359.399 428.695 358.567 428.77C357.736 428.846 356.907 428.598 356.253 428.079C355.632 427.537 355.237 426.781 355.147 425.961C355.057 425.142 355.278 424.318 355.766 423.654C355.76 423.55 355.775 423.446 355.81 423.349C355.844 423.251 355.899 423.161 355.969 423.085ZM316.872 478.057C317.286 477.664 317.795 477.386 318.349 477.25C318.903 477.114 319.482 477.124 320.031 477.28C320.58 477.435 321.079 477.731 321.479 478.138C321.879 478.544 322.166 479.048 322.312 479.599C322.482 480.434 322.338 481.301 321.906 482.035C321.439 482.761 320.707 483.277 319.867 483.474C319.026 483.671 318.141 483.534 317.4 483.091C317.042 482.867 316.732 482.575 316.488 482.232C316.243 481.888 316.069 481.5 315.975 481.089C315.88 480.678 315.868 480.252 315.938 479.836C316.009 479.421 316.161 479.023 316.385 478.666C316.457 478.373 316.63 478.114 316.872 477.935V478.057ZM279.805 551.704C280.249 551.249 280.823 550.943 281.448 550.826C282.073 550.71 282.719 550.79 283.297 551.054C284.063 551.355 284.687 551.935 285.042 552.678C285.348 553.489 285.348 554.384 285.042 555.195L282.201 562.381C264.134 607.041 258.206 647.64 253.781 677.237L252.929 682.799C252.117 692.543 251.711 701.069 251.345 707.93C251.345 710.447 251.345 712.761 251.02 714.832C250.91 715.649 250.5 716.397 249.87 716.93C249.24 717.462 248.435 717.742 247.61 717.714C247.185 717.694 246.769 717.589 246.385 717.405C246.001 717.222 245.657 716.964 245.373 716.647C245.09 716.329 244.873 715.959 244.734 715.557C244.595 715.154 244.538 714.729 244.565 714.304C244.565 712.233 244.565 709.96 244.931 707.564C245.255 700.541 245.661 691.893 246.514 681.865C246.839 679.835 247.082 677.805 247.407 675.897C251.792 646.138 257.8 605.376 276.111 560.027C277.044 557.55 277.978 555.155 278.953 552.759C279.119 552.294 279.415 551.885 279.805 551.582V551.704ZM568.058 273.68C568.422 273.372 568.833 273.125 569.276 272.949C569.66 272.779 570.075 272.691 570.494 272.691C570.914 272.691 571.329 272.779 571.712 272.949C572.482 273.333 573.087 273.982 573.417 274.776C573.639 275.579 573.558 276.435 573.192 277.183C572.826 277.931 572.198 278.519 571.428 278.836C571.042 278.997 570.628 279.079 570.21 279.079C569.792 279.079 569.378 278.997 568.992 278.836C568.511 278.623 568.091 278.296 567.766 277.883C567.442 277.469 567.224 276.983 567.132 276.466C567.04 275.948 567.076 275.416 567.237 274.917C567.399 274.417 567.681 273.964 568.058 273.599V273.68ZM633.017 255.491C633.454 255.034 634.02 254.722 634.641 254.598C635.479 254.441 636.346 254.615 637.058 255.085C637.77 255.555 638.271 256.283 638.457 257.115C638.594 257.951 638.411 258.808 637.944 259.516C637.478 260.223 636.762 260.728 635.94 260.932C635.101 261.089 634.235 260.914 633.523 260.445C632.811 259.975 632.309 259.247 632.123 258.414C632.006 257.859 632.043 257.282 632.229 256.745C632.415 256.209 632.743 255.733 633.179 255.369L633.017 255.491ZM647.754 252.69C648.216 252.207 648.808 251.868 649.459 251.716C675.51 247.136 701.894 244.705 728.343 244.448C757.419 243.973 786.476 246.188 815.144 251.066C815.573 251.119 815.987 251.263 816.358 251.487C816.729 251.71 817.048 252.01 817.295 252.365C817.76 253.056 817.948 253.897 817.823 254.72C817.656 255.559 817.178 256.305 816.487 256.809C815.795 257.313 814.938 257.538 814.088 257.44C760.051 248.417 704.87 248.678 650.921 258.211C650.079 258.335 649.222 258.132 648.525 257.643C648.166 257.419 647.863 257.116 647.638 256.757C647.413 256.398 647.272 255.993 647.226 255.572C647.068 255.055 647.048 254.505 647.169 253.978C647.29 253.451 647.548 252.964 647.916 252.568L647.754 252.69ZM244.849 727.255C245.17 726.938 245.55 726.688 245.969 726.521C246.387 726.354 246.835 726.272 247.285 726.281C248.143 726.343 248.943 726.74 249.512 727.385C250.081 728.03 250.375 728.872 250.33 729.732C250.239 730.575 249.833 731.352 249.193 731.909C248.553 732.466 247.727 732.761 246.879 732.736C246.057 732.665 245.292 732.287 244.736 731.678C244.179 731.069 243.872 730.273 243.875 729.447C243.881 729.035 243.97 728.628 244.137 728.251C244.305 727.874 244.547 727.535 244.849 727.255ZM892.079 272.178C892.503 271.759 893.036 271.468 893.618 271.339C894.2 271.209 894.806 271.247 895.367 271.447C896.175 271.721 896.84 272.306 897.217 273.071C897.594 273.836 897.652 274.719 897.377 275.527C897.102 276.335 896.518 277 895.753 277.377C894.988 277.754 894.104 277.811 893.297 277.537C892.502 277.251 891.847 276.669 891.469 275.913C891.091 275.157 891.019 274.285 891.267 273.477C891.429 272.984 891.707 272.539 892.079 272.178ZM954.155 298.486C954.555 298.119 955.038 297.855 955.563 297.718C956.088 297.58 956.639 297.573 957.167 297.697C957.696 297.821 958.186 298.073 958.595 298.43C959.004 298.786 959.319 299.238 959.514 299.745C959.684 300.128 959.772 300.543 959.772 300.962C959.772 301.382 959.684 301.797 959.514 302.18C959.129 302.949 958.46 303.536 957.648 303.817C956.836 304.097 955.947 304.049 955.17 303.683C954.483 303.272 953.954 302.643 953.668 301.896C953.363 301.071 953.363 300.164 953.668 299.339C953.749 299.054 953.952 298.73 954.155 298.486ZM967.39 305.55C967.91 305.015 968.603 304.68 969.346 304.606C970.089 304.532 970.834 304.722 971.45 305.144L984.117 312.655L992.927 317.892C994.064 318.542 995.16 319.273 996.297 319.963C1002.51 323.454 1008.48 327.361 1014.16 331.656L1042.17 352.524C1044.8 354.359 1047.29 356.395 1049.6 358.613L1050.62 359.547C1051.35 360.278 1051.8 360.562 1051.96 360.725C1052.57 361.33 1052.93 362.14 1052.97 362.998C1053.01 363.423 1052.95 363.849 1052.8 364.248C1052.65 364.648 1052.42 365.01 1052.12 365.312C1051.55 365.938 1050.76 366.315 1049.92 366.361C1049.07 366.407 1048.25 366.117 1047.61 365.556L1045.18 363.364C1043.11 361.29 1040.84 359.426 1038.4 357.802C1033.08 353.742 1025.73 348.423 1016.51 341.562L1010.14 336.852C1004.6 332.538 998.717 328.669 992.561 325.281L985.172 320.856C979.813 317.649 974.17 314.279 968.243 310.666C967.883 310.449 967.57 310.163 967.322 309.825C967.074 309.487 966.896 309.102 966.798 308.694C966.699 308.286 966.683 307.863 966.75 307.449C966.817 307.034 966.965 306.637 967.187 306.281C967.217 306.029 967.286 305.782 967.39 305.55Z",
    fill: "url(#paint104_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.88 405.344C1093.19 405.057 1093.56 404.836 1093.96 404.695C1094.36 404.553 1094.79 404.494 1095.21 404.521C1095.64 404.547 1096.05 404.659 1096.43 404.849C1096.81 405.039 1097.15 405.304 1097.42 405.628L1098.32 406.521L1106.72 416.021L1109.97 419.716C1112.28 422.152 1114.76 424.913 1117.4 428.12C1121.01 433.154 1125.15 438.757 1129.58 444.969C1132.02 448.257 1134.45 451.749 1137.05 455.362L1144.07 464.903C1147.28 469.734 1150.16 474.85 1153.25 480.168C1154.87 482.929 1156.5 485.812 1158.2 488.613C1160.6 492.673 1162.99 496.733 1165.47 501.158L1165.79 501.686C1168.36 505.822 1170.62 510.137 1172.57 514.597L1185.08 541.96C1185.55 542.816 1185.97 543.697 1186.34 544.599C1186.61 545.359 1186.59 546.193 1186.28 546.938C1185.97 547.684 1185.4 548.288 1184.67 548.632C1183.94 548.977 1183.1 549.038 1182.33 548.802C1181.56 548.567 1180.9 548.053 1180.49 547.36C1180.12 546.508 1179.76 545.736 1179.35 544.843L1178.62 543.381C1174.56 534.653 1170.5 525.843 1166.44 517.114C1164.56 512.775 1162.37 508.581 1159.87 504.568C1158.57 502.295 1157.27 500.103 1155.81 497.829L1152.84 492.104L1147.69 483.173C1144.68 478.017 1141.96 473.226 1139 468.719L1123.77 447.811C1119.71 442.127 1115.65 436.808 1112.37 432.099C1109.93 429.176 1107.53 426.455 1105.34 423.979C1104.16 422.599 1103.07 421.381 1101.97 420.163C1096.17 413.545 1092.76 409.891 1092.72 409.81C1092.18 409.178 1091.91 408.371 1091.94 407.545C1091.97 406.72 1092.3 405.935 1092.88 405.344ZM1206.55 622.225C1206.98 621.851 1207.48 621.561 1208.02 621.373C1208.43 621.265 1208.85 621.243 1209.27 621.305C1209.69 621.368 1210.09 621.515 1210.45 621.738C1210.83 621.949 1211.16 622.24 1211.42 622.59C1211.68 622.94 1211.86 623.342 1211.95 623.768C1212.07 624.195 1212.1 624.64 1212.04 625.078C1211.98 625.516 1211.83 625.937 1211.6 626.316C1211.37 626.695 1211.07 627.024 1210.71 627.284C1210.36 627.543 1209.95 627.729 1209.52 627.828C1208.69 627.992 1207.83 627.863 1207.08 627.463C1206.72 627.244 1206.41 626.95 1206.17 626.599C1205.93 626.249 1205.77 625.851 1205.7 625.433C1205.5 624.885 1205.46 624.29 1205.59 623.72C1205.72 623.15 1206.01 622.631 1206.43 622.225H1206.55ZM1217.6 688.808C1218.16 688.255 1218.89 687.91 1219.67 687.834C1220.52 687.799 1221.35 688.09 1221.99 688.649C1222.63 689.208 1223.04 689.991 1223.12 690.838C1223.12 692.3 1223.12 693.599 1223.32 694.898C1223.28 695.533 1223.28 696.171 1223.32 696.806V700.46C1223.35 701.306 1223.04 702.128 1222.47 702.755C1221.91 703.383 1221.12 703.767 1220.28 703.83C1219.85 703.846 1219.43 703.778 1219.03 703.629C1218.63 703.48 1218.27 703.254 1217.96 702.963C1217.65 702.672 1217.4 702.323 1217.23 701.935C1217.05 701.547 1216.96 701.128 1216.95 700.704V697.131C1216.95 696.522 1216.95 695.832 1216.95 695.182C1216.95 694.533 1216.95 692.787 1216.95 691.447C1216.84 690.995 1216.83 690.525 1216.92 690.069C1217.01 689.613 1217.2 689.182 1217.48 688.808H1217.6Z",
    fill: "url(#paint105_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.749 1103.45C417.353 1102.88 418.152 1102.56 418.982 1102.56C419.813 1102.56 420.612 1102.88 421.215 1103.45C421.215 1103.45 422.108 1104.26 423.692 1105.72C425.768 1107.78 428.038 1109.63 430.472 1111.24C436.968 1116.12 446.468 1123.18 458.891 1132.19C464.336 1136.38 470.06 1140.19 476.024 1143.6L479.434 1145.55L500.87 1158.42C501.234 1158.62 501.549 1158.9 501.795 1159.24C502.04 1159.57 502.209 1159.96 502.291 1160.37C502.523 1161.21 502.422 1162.11 502.007 1162.89C501.522 1163.58 500.802 1164.07 499.98 1164.27C499.159 1164.47 498.292 1164.37 497.541 1163.98L495.958 1163.01C488.975 1158.95 482.317 1154.89 476.105 1151.15L472.492 1148.92C466.341 1145.5 460.451 1141.64 454.872 1137.35L426.859 1116.48C424.22 1114.66 421.735 1112.62 419.429 1110.39L418.333 1109.42C417.643 1108.73 417.237 1108.44 417.115 1108.32C416.81 1108.02 416.568 1107.67 416.403 1107.28C416.238 1106.89 416.152 1106.47 416.152 1106.05C416.152 1105.62 416.238 1105.2 416.403 1104.81C416.568 1104.42 416.81 1104.07 417.115 1103.77L416.749 1103.45ZM510.127 1165.73C510.612 1165.27 511.226 1164.97 511.886 1164.87C512.546 1164.77 513.221 1164.87 513.822 1165.16C514.214 1165.33 514.566 1165.58 514.853 1165.89C515.141 1166.21 515.357 1166.58 515.486 1166.99C515.715 1167.59 515.755 1168.26 515.603 1168.89C515.45 1169.52 515.111 1170.09 514.63 1170.53C514.149 1170.97 513.548 1171.25 512.904 1171.34C512.261 1171.43 511.604 1171.33 511.02 1171.05C510.258 1170.68 509.67 1170.02 509.382 1169.23C509.094 1168.43 509.128 1167.55 509.477 1166.78C509.602 1166.41 509.765 1166.06 509.965 1165.73H510.127ZM572.284 1192C572.712 1191.58 573.248 1191.3 573.829 1191.18C574.411 1191.06 575.015 1191.1 575.573 1191.31C575.986 1191.44 576.368 1191.66 576.696 1191.94C577.023 1192.23 577.29 1192.58 577.481 1192.97C577.661 1193.35 577.755 1193.77 577.755 1194.19C577.755 1194.61 577.661 1195.03 577.481 1195.41C577.204 1196.21 576.622 1196.86 575.861 1197.24C575.1 1197.61 574.223 1197.67 573.421 1197.4C573.018 1197.27 572.645 1197.06 572.325 1196.78C572.005 1196.51 571.744 1196.17 571.558 1195.79C571.372 1195.41 571.265 1195 571.243 1194.58C571.222 1194.15 571.286 1193.73 571.432 1193.34C571.564 1192.84 571.799 1192.39 572.122 1192H572.284ZM652.142 1212.54C652.504 1212.18 652.95 1211.92 653.44 1211.78C653.929 1211.63 654.446 1211.62 654.944 1211.73C708.99 1220.68 764.166 1220.38 818.111 1210.83C818.532 1210.76 818.964 1210.77 819.382 1210.86C819.799 1210.95 820.195 1211.13 820.546 1211.37C820.896 1211.62 821.195 1211.93 821.425 1212.29C821.655 1212.65 821.812 1213.05 821.887 1213.47C821.962 1213.89 821.952 1214.33 821.86 1214.74C821.768 1215.16 821.594 1215.56 821.349 1215.91C821.104 1216.26 820.793 1216.56 820.432 1216.79C820.071 1217.02 819.669 1217.17 819.248 1217.25C793.255 1221.87 766.925 1224.34 740.526 1224.64C711.437 1225.08 682.368 1222.85 653.685 1217.98C653.105 1217.88 652.564 1217.62 652.121 1217.23C651.678 1216.84 651.351 1216.34 651.175 1215.78C650.999 1215.22 650.981 1214.62 651.123 1214.05C651.265 1213.47 651.561 1212.95 651.98 1212.54H652.142ZM1219.59 737.04C1219.91 736.713 1220.29 736.46 1220.71 736.299C1221.13 736.137 1221.58 736.071 1222.03 736.106C1222.88 736.166 1223.68 736.543 1224.26 737.161C1224.82 737.814 1225.1 738.66 1225.03 739.516C1224.93 740.341 1224.53 741.099 1223.9 741.64C1223.27 742.18 1222.46 742.466 1221.62 742.439C1221.2 742.414 1220.78 742.304 1220.4 742.116C1220.01 741.928 1219.67 741.667 1219.39 741.346C1219.1 741.026 1218.89 740.652 1218.75 740.248C1218.61 739.843 1218.55 739.415 1218.58 738.988C1218.7 738.246 1219.05 737.561 1219.59 737.04ZM1218.74 752.021C1219.06 751.698 1219.45 751.448 1219.88 751.286C1220.31 751.125 1220.76 751.057 1221.22 751.087C1221.64 751.107 1222.06 751.213 1222.44 751.396C1222.82 751.58 1223.16 751.839 1223.44 752.157C1223.72 752.475 1223.94 752.846 1224.07 753.248C1224.2 753.65 1224.26 754.075 1224.22 754.497C1224.22 756.69 1224.22 759.085 1223.86 761.765C1223.53 768.626 1223.09 777.152 1222.23 786.936C1221.99 788.844 1221.67 790.753 1221.34 792.742C1217.04 822.582 1211.03 863.344 1192.72 908.775C1191.83 911.17 1190.81 913.565 1189.84 916.001C1189.5 916.753 1188.91 917.356 1188.16 917.693C1187.41 918.031 1186.56 918.079 1185.78 917.828C1185.01 917.512 1184.4 916.915 1184.06 916.161C1183.72 915.406 1183.68 914.55 1183.95 913.768C1184.96 911.373 1185.9 908.978 1186.75 906.542C1204.82 861.882 1210.78 821.283 1215.17 791.808L1215.98 786.246C1216.83 776.462 1217.28 767.814 1217.61 760.953C1217.61 758.517 1217.89 756.202 1218.01 754.132C1217.95 753.364 1218.14 752.596 1218.54 751.94L1218.74 752.021ZM831.062 1208.93C831.503 1208.5 832.05 1208.21 832.646 1208.07C833.474 1207.9 834.336 1208.07 835.043 1208.53C835.75 1209 836.246 1209.72 836.421 1210.55C836.629 1211.42 836.486 1212.33 836.021 1213.09C835.557 1213.85 834.811 1214.4 833.945 1214.61C833.106 1214.77 832.24 1214.59 831.528 1214.12C830.816 1213.65 830.314 1212.92 830.128 1212.09C829.973 1211.53 829.978 1210.93 830.143 1210.38C830.308 1209.82 830.627 1209.31 831.062 1208.93ZM896.021 1190.7C896.358 1190.35 896.758 1190.08 897.198 1189.88C898.024 1189.58 898.93 1189.58 899.756 1189.88C900.127 1190.06 900.457 1190.32 900.723 1190.63C900.988 1190.95 901.185 1191.32 901.299 1191.71C901.561 1192.51 901.505 1193.38 901.142 1194.13C900.779 1194.89 900.136 1195.48 899.35 1195.77C898.568 1196.01 897.724 1195.94 896.995 1195.57C896.252 1195.21 895.672 1194.59 895.371 1193.82C895.187 1193.29 895.147 1192.73 895.254 1192.18C895.361 1191.63 895.611 1191.12 895.98 1190.7H896.021ZM971.048 1156.43L971.697 1155.9C1018.37 1129.62 1060.32 1095.74 1095.85 1055.66L1098.28 1052.9C1098.87 1052.43 1099.6 1052.17 1100.35 1052.17C1101.1 1052.17 1101.83 1052.43 1102.41 1052.91C1102.99 1053.39 1103.39 1054.06 1103.53 1054.8C1103.67 1055.53 1103.56 1056.3 1103.2 1056.96C1102.71 1057.45 1102.34 1057.94 1101.9 1058.38C1101.45 1058.83 1101.05 1059.32 1100.72 1059.8C1064.65 1100.34 1022.12 1134.64 974.864 1161.3C974.494 1161.51 974.087 1161.64 973.665 1161.69C973.244 1161.74 972.817 1161.71 972.409 1161.59C972.001 1161.47 971.62 1161.27 971.289 1161.01C970.958 1160.74 970.683 1160.42 970.479 1160.04C970.177 1159.46 970.066 1158.8 970.161 1158.15C970.255 1157.5 970.551 1156.9 971.007 1156.43H971.048ZM1147.37 986.4C1147.87 985.846 1148.56 985.489 1149.3 985.392C1150.05 985.296 1150.8 985.466 1151.43 985.873C1152.15 986.332 1152.67 987.06 1152.86 987.896C1153.05 988.733 1152.9 989.611 1152.44 990.339C1152.23 990.702 1151.95 991.019 1151.61 991.271C1151.27 991.522 1150.89 991.702 1150.48 991.801C1150.07 991.899 1149.64 991.914 1149.23 991.844C1148.81 991.774 1148.41 991.621 1148.06 991.394C1147.33 990.956 1146.81 990.249 1146.61 989.428C1146.4 988.606 1146.53 987.737 1146.96 987.009C1147.05 986.79 1147.18 986.585 1147.33 986.4H1147.37ZM1108.19 1041.33C1108.79 1040.79 1109.57 1040.48 1110.38 1040.48C1111.18 1040.48 1111.96 1040.78 1112.56 1041.32C1113.16 1041.87 1113.54 1042.61 1113.61 1043.42C1113.69 1044.22 1113.47 1045.03 1112.98 1045.68C1112.71 1046.01 1112.38 1046.28 1112 1046.49C1111.62 1046.69 1111.2 1046.81 1110.77 1046.85C1110.35 1046.89 1109.91 1046.84 1109.51 1046.71C1109.1 1046.58 1108.72 1046.36 1108.39 1046.08C1107.74 1045.52 1107.33 1044.73 1107.25 1043.87C1107.18 1043.01 1107.44 1042.16 1107.99 1041.49L1108.19 1041.33Z",
    fill: "url(#paint106_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.257 1207.55C654.551 1207.09 651.749 1206.52 648.853 1205.84L611.38 1197.72C601.271 1194.8 594.572 1192.48 594.491 1192.48L593.72 1192.2L593.395 1191.43C593.395 1191.43 588.117 1178.23 583.773 1165.57C581.54 1159.19 579.713 1152.86 578.008 1148.11C578.008 1148.11 576.547 1143.4 575.938 1140.8L557.221 1132.68C555.11 1131.71 552.918 1130.77 550.604 1129.8C546.544 1128.05 541.794 1126.06 537.166 1123.63L504.158 1105.15C501.723 1103.73 499.49 1102.15 497.338 1100.61C496.161 1099.75 494.983 1098.9 493.806 1098.13L475.861 1085.59C471.419 1082.77 467.21 1079.61 463.275 1076.13L458.891 1072.35L461.245 1069.59L465.711 1073.41C469.533 1076.77 473.604 1079.84 477.891 1082.58L495.876 1095.13C497.054 1095.9 498.231 1096.75 499.49 1097.64C501.56 1099.1 503.55 1100.65 505.945 1101.99L538.911 1120.46C543.337 1122.77 547.762 1124.52 552.025 1126.47C554.38 1127.48 556.612 1128.42 558.724 1129.39L579.51 1138.49V1139.54C579.51 1140.48 580.444 1143.4 581.662 1147.13C583.124 1151.84 585.154 1158.14 587.386 1164.51C591.081 1175.31 595.506 1186.43 596.643 1189.44C598.673 1190.09 604.519 1192.04 612.436 1194.31L649.828 1202.43C656.428 1203.95 663.131 1204.98 669.884 1205.52L704.352 1209.29C705.768 1208.29 707.124 1207.2 708.412 1206.04L718.927 1197.31L733.949 1184.16H750.473C756.36 1184.16 763.627 1183.31 771.3 1182.54C775.725 1182.09 780.354 1181.64 784.982 1181.28C794.221 1180.63 803.396 1179.27 812.427 1177.22L819.126 1175.92L835.365 1172.79L840.237 1175.63C842.105 1176.73 844.297 1178.11 846.733 1179.17L857.167 1184.2L874.543 1179.04C876.37 1178.44 878.4 1177.87 880.552 1177.26C884.703 1176.2 888.773 1174.84 892.732 1173.2L913.275 1164.88C915.711 1163.82 918.187 1162.85 920.704 1161.87C925.048 1160.24 929.304 1158.39 933.452 1156.31L967.799 1138.36L973.483 1139.54L984.201 1141.17L999.629 1143.24L1020.42 1129.64L1040.71 1113.4C1042.74 1111.73 1044.77 1110.07 1047.01 1108.36C1052.75 1104.01 1058.17 1099.26 1063.25 1094.15L1067.96 1089.65C1080.16 1078.55 1091.61 1066.66 1102.22 1054.04L1118.46 1035C1118.47 1032.99 1118.37 1030.99 1118.18 1028.99L1116.88 1013.81C1115.9 1003.05 1114.61 992.572 1114.56 992.491V991.801L1123.13 979.621C1125.93 975.033 1129.18 969.187 1132.63 962.975L1138.52 952.42L1141.52 947.101C1143.35 943.894 1145.1 940.889 1146.56 937.844L1157.8 912.064L1151.43 894.038L1142.94 875.2L1146.72 863.548C1147.29 861.396 1148.14 858.96 1149.03 856.402C1151.08 850.905 1152.64 845.241 1153.7 839.472L1161.46 803.258L1165.03 804.029L1157.27 840.163C1156.17 846.093 1154.57 851.92 1152.48 857.58C1151.59 860.097 1150.82 862.452 1150.21 864.603L1146.84 874.997L1154.96 892.698L1161.78 912.105L1149.89 939.265C1148.34 942.513 1146.52 945.721 1144.73 948.847C1143.71 950.593 1142.74 952.338 1141.77 954.125C1139.74 957.698 1137.71 961.23 1135.84 964.681C1132.39 970.892 1129.1 976.86 1126.22 981.529L1118.42 992.775C1118.71 995.293 1119.84 1004.31 1120.65 1013.52L1121.95 1028.71C1122.17 1031.18 1122.24 1033.66 1122.16 1036.14V1036.74L1105.1 1056.44C1094.41 1069.19 1082.85 1081.2 1070.51 1092.37L1065.89 1097.03C1060.66 1102.24 1055.08 1107.08 1049.2 1111.53C1047.05 1113.19 1045.14 1114.86 1042.95 1116.52L1022.4 1132.76L1000.36 1147.17L972.631 1143.11L968.165 1142.18L934.995 1159.56C930.723 1161.67 926.347 1163.57 921.882 1165.24C919.446 1166.22 916.969 1167.19 914.493 1168.25L893.99 1176.57C889.915 1178.23 885.721 1179.59 881.445 1180.63C879.374 1181.24 877.385 1181.77 875.558 1182.41L856.761 1187.98L845.068 1182.33C842.673 1181.2 840.237 1179.82 838.288 1178.68L834.634 1176.53L819.775 1179.41L813.117 1180.67C803.922 1182.73 794.585 1184.08 785.185 1184.73C780.638 1185.09 776.05 1185.54 771.584 1185.99C763.87 1186.72 756.522 1187.45 750.473 1187.61H735.289L721.241 1199.79L710.726 1208.56C707.763 1211.04 705.773 1212.38 705.692 1212.62L705.164 1212.99L669.356 1208.93C665.458 1208.68 661.358 1208.2 657.257 1207.55Z",
    fill: "url(#paint107_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.889 1072.31L441.067 1057.16C437.476 1054.3 434.123 1051.15 431.039 1047.75L407.653 1023.39C406.992 1022.77 406.381 1022.11 405.827 1021.4L387.313 1018.84L366.73 1015.39L363.847 1011.77C363.319 1011.04 362.71 1010.31 362.061 1009.5C360.415 1007.56 358.883 1005.53 357.473 1003.41L340.34 977.103C335.851 970.537 331.861 963.643 328.404 956.478C327.146 954.043 325.928 951.728 324.791 949.658L318.498 937.478L312.814 935.204C308.168 933.405 303.627 931.345 299.214 929.033C289.754 924.405 279.97 919.208 279.848 919.168C279.726 919.127 278.711 918.843 269.617 894.443L262.106 869.677L260.523 864.359C257.967 856.512 255.973 848.494 254.555 840.365L247.572 804.028L243.512 758.679L246.922 754.01L254.352 745.119L264.623 733.223L264.826 715.075C264.774 708.581 265.222 702.093 266.166 695.669L268.602 673.704C269.481 663.131 271.164 652.639 273.636 642.321C274.448 638.83 275.138 635.541 275.707 632.537L279.767 614.429C279.767 613.536 280.294 612.927 283.827 610.735L301.487 600.098L306.115 585.685C306.684 584.102 307.212 582.437 307.739 580.691C308.755 577.114 309.989 573.603 311.434 570.176L320.731 548.943C324.452 539.608 328.848 530.558 333.885 521.863L341.233 508.75L337.174 490.317C336.504 487.111 336.002 483.873 335.671 480.614C335.671 479.315 335.387 478.138 335.225 477.041L334.535 470.058L344.928 455.158C345.943 453.738 347.039 452.195 348.135 450.571C350.328 447.404 352.682 443.994 355.321 440.502L381.995 409.2C384.689 406.098 387.563 403.156 390.602 400.39C392.063 399.01 393.444 397.71 394.662 396.33L407.938 383.541L417.275 384.881L421.579 385.531C425.842 386.18 430.673 386.911 435.87 388.129C447.319 390.606 458.321 393.448 461.61 394.341L477.565 381.552L482.071 378.548C492.059 371.889 504.482 363.607 517.23 355.974L549.709 338.923C551.983 337.827 554.135 336.974 556.205 336.121C557.301 335.715 558.357 335.309 559.372 334.863L579.225 326.743L580.565 330.113L560.793 338.233L557.545 339.532C555.515 340.344 553.485 341.156 551.374 342.171L518.895 359.141C506.309 366.693 493.926 374.975 483.98 381.593L479.595 384.516L462.422 398.238H461.61C460.067 397.832 447.806 394.584 434.936 391.824C429.902 390.606 425.152 389.915 420.929 389.266L416.626 388.616L409.034 387.52L397.138 399.05C395.88 400.349 394.459 401.689 393.078 403.11C390.133 405.78 387.354 408.628 384.756 411.636L358.123 442.897C355.606 446.227 353.251 449.596 351.099 452.723C349.962 454.346 348.907 455.889 347.851 457.351L338.595 471.033L339.163 476.351C339.163 477.447 339.488 478.665 339.61 480.005C339.975 482.807 340.3 486.014 341.031 489.343L345.09 509.115L336.971 523.528C332.016 532.089 327.701 541.004 324.06 550.201L314.641 571.76C313.218 575.057 312.024 578.448 311.068 581.909C310.5 583.655 309.972 585.401 309.404 586.984L304.37 602.656L285.816 613.902L283.299 615.607L279.523 633.349C278.914 636.353 278.183 639.682 277.412 643.174C274.915 653.23 273.205 663.464 272.296 673.786L269.86 695.831C268.961 702.111 268.513 708.447 268.521 714.791V734.36L249.642 755.999L247.166 759.41L251.226 803.257L258.168 839.471C259.588 847.446 261.555 855.314 264.055 863.019C264.623 864.805 265.151 866.592 265.638 868.337L273.108 893.428C277.696 905.608 281.228 914.296 282.203 916.448C284.923 917.828 293.002 922.091 300.878 925.948C306.115 928.587 310.703 930.657 314.154 931.997L321.137 934.758L328.079 947.993C329.216 950.064 330.394 952.419 331.693 954.895C335.07 961.948 338.979 968.734 343.385 975.195L360.559 1001.58C361.901 1003.58 363.351 1005.51 364.903 1007.35C365.634 1008.24 366.283 1009.01 366.811 1009.74L368.76 1012.18L387.922 1015.39L408.993 1018.31V1019.41C409.426 1019.96 409.901 1020.47 410.414 1020.95L433.921 1045.31C436.897 1048.61 440.143 1051.65 443.624 1054.4L461.447 1069.59L458.889 1072.31Z",
    fill: "url(#paint108_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.45 803.582L1166.16 760.547C1166.36 755.715 1166.36 750.519 1166.4 745.282C1166.4 742.074 1166.4 738.867 1166.4 735.619C1166.4 732.371 1166.4 729.488 1166.4 726.403C1166.67 721.204 1166.55 715.993 1166.04 710.813L1162.63 673.543L1161.41 667.047L1162.06 666.356C1162.06 666.356 1171.27 656.856 1180.16 646.747C1187.55 638.384 1194.78 629.492 1197.42 626.447L1196.69 622.387C1196.28 620.56 1195.55 618.328 1194.74 615.486C1194.25 613.902 1193.76 612.197 1193.24 610.37C1192.14 607 1191.09 603.225 1189.91 599.124C1187.59 591.288 1185.04 582.397 1181.79 573.79L1167.38 538.266C1166.31 535.465 1165.04 532.751 1163.56 530.146C1162.91 528.928 1162.3 527.872 1161.89 526.898L1160.03 523.325L1142.73 516.464L1124.18 509.765L1123.85 508.994C1123.27 507.81 1122.61 506.67 1121.86 505.583L1115.53 495.961C1113.7 493.241 1111.67 490.074 1109.52 486.705C1105.46 480.574 1101.2 473.632 1096.25 467.176L1074.57 439.975C1072.99 437.815 1071.25 435.78 1069.37 433.885C1068.48 433.032 1067.7 432.261 1067.06 431.53L1063.6 427.957L1063.2 414.966L1062.63 403.111L1059.5 399.903C1058.94 399.376 1058.33 398.685 1057.68 397.995C1055.19 395.343 1052.52 392.874 1049.68 390.606L1040.06 382.486C1033.36 376.762 1025.77 370.306 1018.09 363.973L984.111 340.263C981.494 338.494 978.784 336.868 975.992 335.391C974.733 334.66 973.556 334.051 972.581 333.442L967.506 330.641L961.782 314.726L956.057 299.826C955.245 299.339 953.378 298.283 950.536 296.944L909.612 279.039C903.847 276.887 897.676 274.979 891.18 272.868L881.315 269.701C866.737 264.677 851.811 260.728 836.656 257.887L827.196 255.898C819.186 253.955 811.044 252.598 802.837 251.838C800.726 253.177 792.687 258.455 785.095 263.693C777.503 268.93 770.52 274.046 768.409 275.548V276.603L766.582 276.319C761.975 275.767 757.335 275.55 752.697 275.669L721.233 275.385C716.5 275.252 711.764 275.469 707.064 276.035L676.574 278.836C674.544 281.069 669.266 286.956 664.394 293.655L650.144 312.98L649.616 310.422C640.157 311.925 585.551 326.662 581.613 329.829L580.638 328.611L578.527 329.342L579.015 327.271C581.735 324.389 639.913 307.824 650.185 306.972L661.471 291.706C665.392 286.409 669.579 281.314 674.016 276.441V275.588L706.495 272.584C711.345 272.016 716.23 271.799 721.111 271.934L752.413 272.219C757.009 272.097 761.608 272.3 766.176 272.828C768.247 271.325 775.433 266.047 782.943 260.891C791.753 254.801 801.213 248.712 801.294 248.712L802.674 247.818L803.243 248.509C811.531 249.264 819.754 250.621 827.846 252.568L837.184 254.558C852.59 257.35 867.774 261.257 882.614 266.25L892.398 269.417C898.975 271.488 905.146 273.477 911.114 275.669L952.201 293.614C958.575 296.659 959.508 297.39 959.508 298.324L965.233 313.467L970.47 328.124L974.53 330.357L977.859 332.224C980.295 333.523 983.259 335.188 986.426 337.299L1020.41 361.009C1028.24 367.424 1035.83 373.92 1042.53 379.685C1045.98 382.649 1049.19 385.409 1052.11 387.805C1054.99 390.175 1057.71 392.739 1060.23 395.478L1062.02 397.346L1066.08 401.405L1067.1 426.252L1069.61 428.891C1070.26 429.622 1070.99 430.353 1071.81 431.124C1073.87 433.167 1075.77 435.366 1077.49 437.701L1099.13 464.862C1104.16 471.48 1108.63 478.504 1112.61 484.715C1114.72 488.044 1116.67 491.13 1118.58 493.891L1124.87 503.513C1125.61 504.56 1126.27 505.659 1126.86 506.801L1144.03 513.013L1162.95 520.524L1165.47 525.396C1165.91 526.37 1166.48 527.344 1167.09 528.441C1168.65 531.196 1170 534.059 1171.15 537.007L1185.56 572.531C1188.69 581.342 1191.33 590.273 1193.68 598.15C1194.82 602.21 1195.96 605.985 1197.01 609.355C1197.54 611.223 1198.03 612.887 1198.51 614.471C1199.37 617.313 1200.1 619.748 1200.54 621.657L1201.64 627.3L1201.11 627.95C1198.84 630.751 1191.09 640.332 1183.17 649.264C1175.25 658.196 1167.86 665.95 1165.63 668.305L1166.56 673.137L1169.93 710.529C1170.49 715.923 1170.62 721.353 1170.34 726.768C1170.34 729.773 1170.34 732.817 1170.34 735.862C1170.34 738.907 1170.34 742.358 1170.34 745.525C1170.34 750.844 1170.34 756.04 1170.1 761.075L1165.35 804.191L1161.45 803.582Z",
    fill: "url(#paint109_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.81 1146.69C627.563 1139.58 588.436 1127.17 551.453 1109.78C545.566 1107.02 539.842 1103.73 534.361 1100.61C531.316 1098.82 528.23 1097.12 525.185 1095.45L512.234 1088.14L499.77 1079.45C496.888 1077.38 494.046 1075.39 491.163 1073.49C486.048 1069.95 480.729 1066.34 475.817 1062.2L453.934 1043.56C422.226 1013.52 398.963 985.873 382.683 958.794C375.815 948.72 369.708 938.149 364.413 927.167C362.221 923.107 360.029 918.641 357.755 914.5C355.213 909.69 353.002 904.711 351.137 899.6C350.122 897.002 349.148 894.444 348.052 891.927C346.956 889.409 345.859 886.527 344.804 883.807C342.855 879.097 340.744 874.428 339.364 869.719C316.912 802.446 315.897 749.261 317.278 723.561V711.382C317.278 708.499 317.765 705.982 318.049 703.586L322.109 668.021L332.502 669.158L328.443 704.804C328.199 707.037 327.915 709.352 327.752 711.788V723.967C326.372 749.179 327.387 800.862 349.27 866.511C350.772 870.977 352.599 875.403 354.507 879.869C355.563 882.508 356.659 885.187 357.714 887.988C358.77 890.79 359.866 893.145 360.922 895.865C362.587 900.54 364.595 905.086 366.93 909.466C369.244 913.769 371.477 918.073 373.751 922.457C378.876 933.095 384.778 943.341 391.412 953.11C407.448 979.702 430.102 1006.66 460.958 1035.85L482.556 1054.28C487.218 1058.06 492.069 1061.6 497.091 1064.88C500.054 1066.91 502.978 1068.94 505.86 1071.01L517.796 1079.37L530.26 1086.36C533.305 1088.02 536.431 1089.81 539.557 1091.59C544.916 1094.64 550.438 1097.81 555.797 1100.4C591.927 1117.39 630.154 1129.5 669.474 1136.42C708.815 1142.19 748.746 1142.72 788.226 1138C794.438 1137.27 800.69 1136.01 806.699 1134.79C810.231 1134.06 813.763 1133.33 817.295 1132.72L831.667 1129.92L845.268 1125.86C848.556 1124.8 852.007 1123.83 855.418 1122.81C861.426 1121.11 867.11 1119.49 872.591 1117.33L899.143 1106.53C937.306 1088.67 967.308 1070.24 990.612 1050.3C1000.1 1043.04 1009.05 1035.1 1017.41 1026.55C1020.9 1023.1 1024.39 1019.69 1027.92 1016.4C1031.5 1012.93 1034.85 1009.23 1037.95 1005.32C1039.78 1003.05 1041.65 1000.81 1043.59 998.703C1045.54 996.592 1047.17 994.643 1049.03 992.329C1052.2 988.634 1055.37 985.021 1058.21 981.245C1099.62 925.868 1116.88 877.108 1123.45 852.992L1127.51 840.812C1128.04 838.742 1128.53 836.468 1128.97 834.276L1136.48 799.157L1146.72 801.35L1139.16 836.387C1138.72 838.742 1138.19 841.177 1137.54 843.735L1133.48 855.915C1126.74 880.518 1109.12 930.699 1066.53 987.457C1063.53 991.517 1060.24 995.252 1056.91 999.109C1055.08 1001.18 1053.26 1003.17 1051.47 1005.48C1049.68 1007.8 1047.74 1009.79 1045.95 1011.94C1042.59 1016.25 1038.92 1020.32 1034.99 1024.12C1031.54 1027.33 1028.13 1030.65 1024.67 1034.06C1016.09 1042.88 1006.85 1051.02 997.027 1058.42C973.358 1078.72 942.624 1097.68 903.324 1116.08L876.488 1126.96C870.514 1129.21 864.43 1131.16 858.26 1132.8C854.971 1133.78 851.642 1134.71 848.353 1135.77L834.184 1139.83L819.203 1142.79C815.631 1143.4 812.22 1144.09 808.769 1144.78C802.558 1146.04 796.102 1147.34 789.525 1148.15C749.067 1153.03 708.139 1152.54 667.81 1146.69Z",
    fill: "url(#paint110_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.768 1176.89H662.037C630.695 1170.68 590.137 1161.39 554.572 1144.66C552.177 1143.56 549.578 1142.47 546.98 1141.37C541.621 1139.06 536.059 1136.7 530.497 1133.66L509.101 1121.6C499.174 1116.29 489.673 1110.22 480.682 1103.45C477.353 1101.1 474.105 1098.74 470.857 1096.59L462.209 1090.58C459.57 1088.63 457.662 1086.97 455.754 1085.3L423.275 1056.88L399.605 1032.52L429.608 1003.54L459.651 1033.94L482.874 1053.8C484.051 1054.81 485.229 1055.83 486.487 1056.8L494.201 1062.16C497.409 1064.27 501.022 1066.87 504.716 1069.51C512.321 1075.18 520.326 1080.3 528.67 1084.81L550.593 1096.99C554.166 1098.94 558.713 1100.81 563.22 1102.8C566.143 1104.06 569.106 1105.32 572.07 1106.66C603.412 1121.44 640.398 1129.88 669.508 1135.65C698.739 1139.3 736.537 1142.91 770.762 1138.81C774.172 1138.41 777.379 1138.16 780.546 1137.92C785.621 1137.51 790.371 1137.11 794.634 1136.34L818.141 1131.79C827.781 1130.13 837.282 1127.74 846.56 1124.64C850.904 1123.3 855.126 1122 859.308 1120.87L868.565 1118.15L872.3 1116.6L905.469 1103.08L938.639 1085.75L957.964 1122.69L922.196 1141.29L888.296 1155.13C885.941 1156.11 883.546 1157.08 881.069 1157.89L870.716 1160.98C866.657 1162.12 862.597 1163.29 858.821 1164.51C847.809 1168.17 836.529 1170.97 825.083 1172.87L802.226 1177.3C796.165 1178.34 790.053 1179.06 783.916 1179.45L775.512 1180.22C736.658 1184.89 695.247 1180.91 663.54 1176.89H662.768Z",
    fill: "url(#paint111_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.24 799.645L1140.3 763.998C1140.54 761.765 1140.83 759.451 1140.99 757.015V744.836C1142.33 719.623 1141.36 667.94 1119.47 602.291C1117.97 597.825 1116.1 593.4 1114.28 588.934C1113.18 586.295 1112.09 583.656 1111.03 580.814C1109.97 577.972 1108.88 575.658 1107.82 572.695C1106.13 568.029 1104.12 563.485 1101.81 559.094C1099.5 555.034 1097.27 550.487 1095.03 546.102C1089.87 535.471 1083.94 525.227 1077.29 515.45C1061.26 488.857 1038.6 461.899 1007.83 432.708L986.147 414.56C981.64 410.785 976.769 407.496 971.612 403.964C968.649 401.934 965.726 399.904 962.843 397.833L950.866 389.47L938.443 382.487C935.398 380.863 932.272 379.076 929.146 377.29C923.787 374.205 918.306 371.038 912.906 368.439C876.777 351.45 838.55 339.34 799.229 332.428C759.887 326.67 719.955 326.152 680.477 330.885C674.306 331.616 668.054 332.874 662.045 334.092C658.513 334.783 654.981 335.513 651.449 336.122L637.077 338.924L623.476 342.984C620.187 344.039 616.736 345.014 613.326 345.988C607.317 347.693 601.634 349.317 596.153 351.469L569.56 362.187C531.357 380.051 501.395 398.483 478.091 418.417C468.598 425.676 459.655 433.628 451.336 442.208C447.804 445.659 444.312 449.07 440.78 452.358C437.191 455.908 433.841 459.692 430.752 463.685C428.925 465.959 427.058 468.192 425.109 470.344L419.791 476.555C416.624 480.209 413.457 483.823 410.615 487.598C369.164 542.976 351.909 591.736 345.332 615.852L341.272 628.031C340.744 630.102 340.298 632.416 339.811 634.608L332.34 669.686L322.109 667.494L329.62 632.497C330.107 630.143 330.635 627.666 331.285 625.149L335.345 612.969C342.084 588.366 359.704 538.226 402.292 481.427C405.256 477.367 408.585 473.673 411.914 469.816C413.741 467.705 415.568 465.756 417.355 463.442C419.141 461.128 421.09 459.098 422.836 456.987C426.214 452.674 429.89 448.604 433.838 444.807C437.289 441.599 440.699 438.27 444.109 434.901C452.712 426.11 461.954 417.968 471.757 410.541C495.427 390.241 526.201 371.322 565.5 352.931L592.215 341.888C598.223 339.533 604.394 337.828 610.444 336.041C613.732 335.107 617.061 334.133 620.35 333.077L634.519 329.018L649.5 326.094L659.934 324.064C666.145 322.806 672.601 321.507 679.137 320.735C719.629 315.882 760.586 316.428 800.934 322.359C841.168 329.442 880.282 341.839 917.25 359.223C923.178 361.984 928.902 365.273 934.424 368.439C937.469 370.185 940.473 371.931 943.559 373.596L956.51 380.863L968.973 389.551C971.856 391.662 974.698 393.611 977.54 395.56C982.696 399.051 988.014 402.705 992.927 406.806L1014.81 425.441C1046.52 455.484 1069.74 483.132 1086.06 510.212C1092.93 520.285 1099.04 530.857 1104.33 541.839C1106.52 546.143 1108.72 550.405 1110.95 554.547C1113.52 559.349 1115.74 564.328 1117.61 569.447C1118.58 572.004 1119.6 574.562 1120.69 577.079C1121.79 579.596 1122.88 582.479 1123.94 585.199C1125.89 589.909 1127.8 594.578 1129.38 599.287C1151.83 666.56 1152.85 719.745 1151.43 745.445V757.624C1151.43 760.507 1150.98 763.024 1150.69 765.419L1146.51 800.66L1136.24 799.645Z",
    fill: "url(#paint112_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.94 465.268L1008.89 434.899L985.669 414.965C984.492 413.95 983.315 412.894 982.016 411.92L974.383 406.845C971.135 404.693 967.522 402.136 963.827 399.497C956.233 393.796 948.227 388.666 939.874 384.15L917.95 371.97C913.859 369.818 909.658 367.881 905.365 366.165C902.401 364.906 899.437 363.648 896.473 362.105C865.131 347.367 828.145 338.882 799.036 333.157C769.764 329.463 732.007 325.85 697.741 329.95C694.372 330.356 691.164 330.6 687.997 330.884C682.923 331.29 678.173 331.655 673.91 332.427L650.403 336.974C640.762 338.632 631.262 341.021 621.984 344.119C617.639 345.459 613.377 346.758 609.235 347.895L599.979 350.656C599.167 350.94 597.665 351.549 596.244 352.158L563.074 365.678L529.905 383.013L510.742 345.946L546.51 327.352L580.41 313.548C582.765 312.574 585.16 311.599 587.637 310.747L597.989 307.661C602.049 306.524 606.109 305.347 609.885 304.129C620.89 300.494 632.155 297.699 643.582 295.766L666.439 291.34C672.935 290.163 678.944 289.676 684.79 289.188C687.592 288.945 690.393 288.742 693.194 288.417C732.047 283.789 773.418 287.767 805.166 291.746H805.897H806.587C837.93 297.958 878.488 307.215 914.053 323.941C916.489 325.038 919.087 326.174 921.645 327.23C927.044 329.544 932.606 331.899 938.169 334.944L959.442 346.88C969.362 352.2 978.862 358.267 987.862 365.028C991.232 367.423 994.479 369.737 997.687 371.889L1006.46 378.426C1009.1 380.415 1011.04 382.039 1012.95 383.704L1045.23 412.123L1068.94 436.483L1038.94 465.268Z",
    fill: "url(#paint113_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.031 1236.57C619.463 1231.36 587.462 1223.07 556.461 1211.81C513.385 1194.68 475.263 1174.94 449.361 1156.27C445.017 1153.18 440.916 1150.38 437.181 1147.78C430.929 1143.44 425.692 1139.66 421.794 1136.86L412.578 1128.99L417.653 1123.06L426.707 1130.77C430.36 1133.53 435.476 1137.11 441.647 1141.37C445.382 1143.97 449.483 1146.77 453.827 1149.89C479.364 1168.25 516.796 1187.61 559.181 1204.5C611.988 1223.58 667.519 1234.03 723.648 1235.48C788.067 1237.08 852.176 1226.05 912.352 1203C972.572 1180.02 1027.82 1145.7 1075.11 1101.91C1116.62 1064.03 1151.17 1019.16 1177.18 969.35C1181.85 961.355 1185.93 953.023 1189.36 944.422L1192.4 937.438C1193.95 933.744 1195.57 930.09 1197.19 926.477C1199.99 920.532 1202.49 914.448 1204.66 908.248L1213.31 881.371C1214.12 878.651 1215.02 875.971 1215.91 873.251C1217.62 868.581 1218.97 863.791 1219.97 858.919L1229.51 814.26L1237.18 815.884L1227.64 860.543C1226.64 865.784 1225.2 870.931 1223.34 875.931C1222.49 878.488 1221.64 881.087 1220.82 883.807L1212.14 910.765C1209.89 917.245 1207.3 923.601 1204.38 929.806C1202.8 933.338 1201.17 936.951 1199.63 940.646L1196.59 947.629C1193.02 956.484 1188.8 965.061 1183.96 973.288C1160.25 1020.3 1124.4 1066.91 1080.43 1107.75C1032.39 1152.19 976.267 1187 915.113 1210.31C854.005 1233.65 788.921 1244.83 723.526 1243.19C699.572 1242.6 675.686 1240.39 652.031 1236.57Z",
    fill: "url(#paint114_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.613 1263.98L688.024 1232.88L693.301 1233.49L697.361 1233.94C700 1234.26 703.208 1234.67 706.983 1234.83C710.759 1234.99 715.915 1234.83 721.68 1234.83C732.683 1234.83 745.146 1235.15 759.315 1234.83C811.561 1231.68 863.041 1220.73 912.049 1202.35L935.718 1192.73C940.715 1190.89 945.573 1188.69 950.253 1186.15L987.888 1166.38L1029.99 1138.57L1047.85 1124.36C1059.5 1115.49 1070.52 1105.82 1080.82 1095.41L1097.34 1079.41C1099.01 1077.87 1099.82 1076.98 1100.06 1076.73L1123.89 1097.03C1122.31 1098.84 1120.63 1100.56 1118.86 1102.19L1102.62 1117.86C1091.42 1129.12 1079.45 1139.59 1066.81 1149.2L1043.43 1167.51L1002.83 1193.82L965.112 1213.64C959.316 1216.74 953.322 1219.45 947.167 1221.76L923.254 1231.46C870.967 1251.06 816.033 1262.69 760.29 1265.97C745.065 1266.33 731.871 1265.97 721.031 1265.97H706.09C700.65 1265.72 696.631 1265.28 693.383 1264.87L689.851 1264.47L684.613 1263.98Z",
    fill: "url(#paint115_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.618 1128.99L385.823 1106.13L352.288 1071.5C350.137 1068.94 348.228 1066.5 346.199 1063.99L322.854 1034.67C318.551 1028.62 314.491 1022.49 310.35 1015.92C307.954 1012.22 305.559 1008.49 303.042 1004.71C272.831 956.291 250.777 903.239 237.759 847.673C208.052 718.794 229.907 583.408 298.657 470.424C328.522 421.768 366.17 378.345 410.101 341.886C413.755 339.044 417.247 336.243 420.657 333.523C426.625 328.692 432.431 324.023 438.277 319.76L469.823 299.176C472.502 297.43 475.141 295.725 477.942 294.101L523.129 270.756L553.578 258.577L556.501 265.803L524.022 279.079L481.962 301.084C479.647 302.505 477.09 304.17 474.491 305.875L443.068 326.174C437.506 330.234 431.781 334.863 425.894 339.613L415.379 347.976C372.166 383.818 335.133 426.515 305.762 474.362C237.845 585.548 216.119 718.891 245.229 845.886C258.014 900.594 279.713 952.825 309.456 1000.49C311.892 1004.18 314.328 1007.96 316.724 1011.65C320.784 1018.03 324.843 1024.2 328.903 1029.96L352.126 1059.11C354.075 1061.59 356.186 1063.99 357.85 1066.26L392.522 1101.74L417.49 1123.06L412.618 1128.99Z",
    fill: "url(#paint116_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.44 889.531L218.701 866.877C217.929 864.278 217.077 861.558 216.468 858.757L208.348 816.533C200.362 761.176 200.485 704.951 208.713 649.63C218.273 594.728 235.779 541.512 260.68 491.658L281.751 453.576C283.238 451.025 284.865 448.559 286.623 446.187L300.142 426.821L325.801 444.684L314.23 461.33L312.119 464.335C311.104 465.796 309.967 467.339 308.952 469.085L288.166 506.152C264.9 552.997 248.492 602.945 239.447 654.461C231.79 706.409 231.667 759.191 239.082 811.174L247.201 852.423C247.567 854.128 248.135 855.955 248.663 857.66C249.191 859.366 249.475 860.299 249.84 861.72L255.524 880.802L225.44 889.531Z",
    fill: "url(#paint117_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.59 814.666L1234.54 769.438C1235.2 764.446 1235.46 759.409 1235.31 754.376C1235.31 751.615 1235.31 748.733 1235.31 745.81L1235.55 717.674C1235.45 711.119 1235 704.573 1234.21 698.065C1233.81 694.005 1233.4 689.945 1233.08 685.885L1232.43 678.415C1231.86 669.281 1230.61 660.202 1228.69 651.254C1219.73 595.652 1201.07 542.058 1173.56 492.917C1142.49 436.553 1100.91 386.663 1051.07 345.947C1001.19 305.136 943.821 274.463 882.18 255.654C828.414 239.27 772.36 231.648 716.171 233.081C670.74 235.761 629.126 242.338 599.124 251.716C593.927 253.3 589.136 254.68 584.792 255.776C577.606 257.887 571.598 259.836 567.091 261.216L556.251 265.601L553.328 258.374L564.33 253.909C569.162 252.244 575.252 250.458 582.6 248.265C586.904 247.047 591.694 245.626 596.85 244.205C627.381 234.664 669.644 227.966 715.805 225.245C772.854 223.722 829.774 231.413 884.372 248.022C947.02 267.104 1005.32 298.276 1055.98 339.776C1106.68 381.187 1148.95 431.949 1180.5 489.303C1208.42 539.133 1227.36 593.484 1236.45 649.873C1238.48 659.1 1239.84 668.463 1240.51 677.887L1241.16 685.317C1241.48 689.377 1241.89 693.436 1242.29 697.253C1243.09 704.06 1243.54 710.903 1243.63 717.755L1243.39 745.972C1243.39 748.895 1243.39 751.656 1243.39 754.335C1243.58 759.762 1243.31 765.195 1242.58 770.575L1237.62 815.559L1229.59 814.666Z",
    fill: "url(#paint118_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 533.799L1189.6 524.583C1189.12 523.473 1188.57 522.388 1187.97 521.335L1177.22 500.751C1170.8 487.767 1163.49 475.245 1155.33 463.278L1135.64 434.575L1111.28 404.044L1082.26 373.879C1078.46 369.861 1074.39 366.116 1070.08 362.673L1050.47 345.946C1009.69 313.07 964.213 286.494 915.556 267.102C902.604 262.474 890.709 258.698 880.194 255.369C874.713 253.664 869.8 252.081 865.578 250.66C862.655 249.848 859.488 249.239 856.849 248.711L852.262 247.696L847.512 246.681L854.211 216.029L859.367 217.125L863.426 217.977C866.634 218.627 870.613 219.439 875.119 220.697C879.625 221.956 884.7 223.824 889.978 225.488C900.169 228.736 912.917 232.755 926.883 237.668C978.715 258.424 1027.14 286.85 1070.52 321.993L1090.5 339.004C1095.73 343.245 1100.66 347.859 1105.23 352.808L1135.32 384.15L1171.86 431.489L1181.24 445.942C1190.12 458.898 1198.09 472.465 1205.07 486.542L1215.58 506.841C1217.33 510.008 1218.22 512.16 1218.42 512.606L1204.09 518.818L1199.83 533.799Z",
    fill: "url(#paint119_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.61 807.223L1181.65 825.641L1186.29 826.639L1190.25 808.221L1185.61 807.223Z",
    fill: "url(#paint120_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.1 895.703L1162.76 894.039L1163.65 891.115L1170.96 868.502L1175.47 869.963L1168.2 892.536C1167.75 893.754 1167.43 894.769 1167.1 895.703ZM1180.74 852.79L1176.11 851.815L1177.98 843.046L1182.61 844.02L1180.74 852.79Z",
    fill: "url(#paint121_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.941 1193.38L688.429 1188.67L693.179 1189.2C694.6 1189.2 696.345 1189.52 698.294 1189.76C702.736 1190.38 707.209 1190.74 711.692 1190.86H714.94V1195.61H711.692C707.018 1195.51 702.354 1195.13 697.726 1194.47C695.858 1194.23 694.194 1194.03 692.773 1193.9L687.941 1193.38ZM732.803 1195.81V1191.06H741.776V1195.81H732.803ZM759.842 1195.45L759.558 1190.7C766.135 1190.33 772.265 1189.76 778.396 1188.99C783.836 1188.5 789.358 1187.9 795.001 1187.12L795.61 1191.83C789.926 1192.61 784.323 1193.21 778.924 1193.7C772.996 1194.47 766.501 1195.08 759.842 1195.45ZM809.008 1189.84L808.236 1185.18C816.884 1183.71 825.653 1182.01 834.423 1180.02L835.478 1184.65C826.628 1186.64 817.655 1188.38 809.008 1189.84ZM852.936 1180.34L851.758 1175.76C854.6 1175.03 857.442 1174.21 860.325 1173.4L861.624 1177.95C858.741 1178.8 855.818 1179.57 852.936 1180.34ZM878.838 1172.71L877.336 1168.21C888.744 1164.47 899.99 1160.33 910.789 1156.03L912.616 1160.41C901.695 1164.75 890.327 1168.94 878.838 1172.71ZM924.999 1154.93L923.05 1150.59C931.17 1146.93 939.29 1143.03 947.085 1138.93L949.277 1142.99C941.401 1147.26 933.241 1151.23 924.999 1154.93ZM965.07 1134.39L962.634 1130.33L969.455 1126.27L970.186 1125.74L972.825 1129.8L971.972 1130.37L965.07 1134.39ZM987.806 1119.93L985.248 1115.87C995.35 1109.73 1005 1102.86 1014.11 1095.33L1017.2 1098.9C1007.91 1106.6 998.092 1113.63 987.806 1119.93ZM1027.59 1090.62L1024.67 1086.93L1035.79 1078.03L1044.73 1069.43L1047.97 1072.84L1036.65 1083.43L1027.59 1090.62ZM1060.97 1060.54L1057.72 1057.09C1059.87 1055.06 1061.78 1053.03 1064.01 1050.87L1067.42 1054.16C1065.31 1056.44 1063.16 1058.47 1060.97 1060.5V1060.54ZM1079.52 1040.76L1075.91 1037.68C1077.94 1035.32 1079.97 1032.97 1081.91 1030.65C1083.86 1028.34 1086.18 1025.58 1088.33 1023.1L1095.96 1014.17C1096.85 1012.99 1097.75 1011.7 1098.68 1010.4L1102.54 1013.12C1101.59 1014.44 1100.62 1015.8 1099.62 1017.18L1091.9 1026.23L1085.61 1033.7C1083.58 1036.05 1081.55 1038.41 1079.52 1040.76ZM1110.25 1002.07L1106.19 999.353L1114.68 987.173C1117.1 984.024 1119.35 980.744 1121.42 977.348L1125.48 979.865C1123.34 983.353 1121.02 986.727 1118.53 989.974L1110.25 1002.07ZM1134.61 964.194L1130.55 961.92C1131.89 959.525 1133.19 957.17 1134.61 954.937L1135.1 954.125L1139.16 956.48L1138.67 957.292C1137.05 959.566 1135.79 961.839 1134.33 964.194H1134.61ZM1147.73 940.687L1143.67 938.535C1145.45 935.003 1146.83 931.999 1147.73 929.36L1157.96 905.893L1162.3 907.801L1152.11 931.146C1150.78 934.41 1149.26 937.595 1147.56 940.687H1147.73Z",
    fill: "url(#paint122_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.703 1190.37L661.231 1185.66L679.947 1187.73L679.46 1192.44L660.703 1190.37Z",
    fill: "url(#paint123_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.458 1190.33L642.066 1186.39L643.081 1181.77L661.473 1185.7L660.458 1190.33Z",
    fill: "url(#paint124_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.702 1182.7L615.973 1180.83L616.948 1176.2L625.717 1178.07L624.702 1182.7ZM598.637 1175.39L576.064 1168.12L573.02 1167.19L574.562 1162.68L577.445 1163.62L600.099 1170.88L598.637 1175.39Z",
    fill: "url(#paint125_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.913 1162.2L537.528 1152.01C534.263 1150.72 531.065 1149.27 527.947 1147.66L530.139 1143.6C533.122 1145.12 536.185 1146.48 539.315 1147.66L562.74 1157.89L560.913 1162.2ZM512.194 1138.93L511.342 1138.49C509.109 1137.15 506.795 1135.89 504.44 1134.43L506.754 1130.37L513.697 1134.43L514.549 1134.91L512.194 1138.93ZM488.809 1125.66C485.074 1123.34 481.745 1121.07 478.66 1118.71L466.48 1110.31L469.2 1106.25L481.38 1114.74C484.425 1117.05 487.591 1119.24 491.205 1121.47L488.809 1125.66ZM455.599 1102.64C454.219 1101.72 452.866 1100.74 451.54 1099.71L442.486 1092L434.935 1085.59L427.911 1079.58L430.996 1076L438.061 1081.97L445.612 1088.39L454.544 1096.02C455.721 1096.91 457.02 1097.85 458.32 1098.74L455.599 1102.64ZM414.513 1067.48C412.375 1065.42 410.264 1063.27 408.18 1061.02L411.59 1057.77C413.661 1059.97 415.65 1061.83 417.802 1064.07L414.513 1067.48ZM395.838 1048.07L385.282 1036.74L378.055 1027.69L381.79 1024.73L390.682 1035.89L399.248 1044.78L395.838 1048.07ZM369.733 1017.3C362.05 1008 355.048 998.166 348.783 987.863L352.843 985.305C358.994 995.404 365.86 1005.05 373.386 1014.17L369.733 1017.3ZM339.08 972.922L338.471 972.069C337.05 969.715 335.67 967.441 334.411 965.127L338.471 962.732C339.811 965.005 341.151 967.279 342.531 969.512L343.018 970.283L339.08 972.922ZM325.601 949.374C321.542 941.458 317.482 933.135 313.787 925.015L318.131 923.066C321.745 931.186 325.683 939.306 329.783 947.101L325.601 949.374ZM308.428 912.835C303.922 901.914 299.74 890.587 296.005 879.097L300.511 877.595C304.246 889.003 308.387 900.249 312.691 911.049L308.428 912.835ZM290.767 861.558C289.955 858.635 289.144 855.752 288.372 852.87L292.96 851.652C293.731 854.534 294.503 857.376 295.355 860.259L290.767 861.558ZM284.109 835.412C282.079 826.562 280.334 817.63 278.913 808.901L283.581 808.129C285.043 816.777 286.748 825.587 288.738 834.357L284.109 835.412ZM276.923 795.544C276.152 789.819 275.543 784.257 275.056 778.857C274.244 772.686 273.675 766.434 273.31 759.735L278.019 759.491C278.385 766.028 278.953 772.199 279.765 778.33C280.252 783.77 280.861 789.291 281.592 794.935L276.923 795.544ZM272.863 741.709C272.863 738.623 272.863 735.619 272.863 732.737H277.613C277.613 735.579 277.613 738.542 277.613 741.628L272.863 741.709ZM273.188 714.873C273.188 713.777 273.188 712.681 273.188 711.625C273.289 706.951 273.668 702.287 274.325 697.659C274.528 695.791 274.771 694.127 274.853 692.706L275.38 687.834L280.09 688.402L279.562 693.112C279.562 694.533 279.278 696.278 279.034 698.227C278.384 702.666 278.004 707.14 277.898 711.625C277.898 712.599 277.898 713.736 277.898 714.873H273.188Z",
    fill: "url(#paint126_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.3 660.75L276.246 679.476L280.968 679.994L283.022 661.268L278.3 660.75Z",
    fill: "url(#paint127_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.332 642.128L278.387 660.549L283.031 661.543L286.977 643.123L282.332 642.128Z",
    fill: "url(#paint128_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.695 625.757L286.066 624.783L287.934 616.014L292.562 617.029L290.695 625.757ZM297.84 600.18L293.334 598.718L300.601 576.145C300.885 575.089 301.25 574.034 301.575 573.1L306.041 574.643C305.757 575.495 305.432 576.47 305.148 577.525L297.84 600.18Z",
    fill: "url(#paint129_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.85 562.909L306.547 561.001L316.737 537.657C318.005 534.397 319.456 531.212 321.081 528.116L325.141 530.308C323.631 533.281 322.276 536.33 321.081 539.443L310.85 562.909ZM333.911 514.718L329.851 512.363L330.338 511.511C331.678 509.278 332.936 506.963 334.398 504.609L338.458 506.882C337.118 509.318 335.778 511.632 334.398 513.865L333.911 514.718ZM347.105 491.414L343.045 488.937C345.174 485.441 347.478 482.053 349.947 478.788L358.392 466.608L362.452 469.328L354.007 481.508C351.531 484.593 349.379 487.801 347.105 491.414ZM369.962 458.447L365.903 455.727C366.877 454.347 367.811 453.007 368.826 451.667L376.58 442.573C378.691 440.096 380.64 437.62 382.954 435.062L388.963 427.998L392.576 431.083L386.568 438.107C384.416 440.665 382.305 443.182 380.153 445.659L372.52 454.631C371.789 455.849 371.059 457.148 369.962 458.447ZM404.634 417.848L401.264 414.559C403.335 412.408 405.324 410.5 407.679 408.185L410.927 411.636C408.775 413.747 406.705 415.818 404.634 417.929V417.848ZM423.837 399.375L420.549 395.965L431.917 385.409L440.93 378.182L443.893 381.877L432.85 390.606L423.837 399.375ZM454.449 373.432L451.364 369.86C460.61 362.171 470.407 355.169 480.676 348.91L483.234 352.97C473.2 359.112 463.608 365.949 454.53 373.432H454.449ZM498.377 343.105L495.738 339.045L496.55 338.476L503.493 334.416L505.888 338.476L499.149 342.536L498.377 343.105ZM521.478 329.91L519.245 325.85C527.162 321.79 535.485 317.73 543.604 314.076L545.513 318.38C537.515 321.871 529.395 325.647 521.559 329.91H521.478ZM557.814 312.939L555.987 308.555C566.908 304.048 578.276 299.866 589.765 296.091L591.227 300.638C579.9 304.332 568.654 308.474 557.814 312.939ZM608.238 295.401L606.979 290.853C609.862 290.001 612.745 289.229 615.627 288.458L616.845 293.046L608.238 295.401ZM634.181 288.783L633.125 284.155C641.976 282.165 650.867 280.419 659.636 278.958L660.367 283.667C651.801 285.048 643.072 286.834 634.221 288.783H634.181ZM673.602 281.678L672.993 276.928C678.718 276.197 684.28 275.547 689.72 275.101C695.851 274.289 702.144 273.68 708.802 273.315L709.086 278.065C702.509 278.43 696.338 278.998 690.207 279.81C684.821 280.325 679.3 280.947 673.643 281.678H673.602ZM726.787 277.618V272.868H735.759V277.618H726.787ZM753.664 277.943V273.233H756.749C761.435 273.354 766.111 273.734 770.756 274.37C772.623 274.614 774.288 274.817 775.709 274.938L780.54 275.466L780.012 280.176L775.262 279.648C773.882 279.648 772.136 279.323 770.147 279.08C765.718 278.465 761.259 278.099 756.79 277.983L753.664 277.943Z",
    fill: "url(#paint130_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.711 281.069L789.198 276.36L807.914 278.43L807.427 283.14L788.711 281.069Z",
    fill: "url(#paint131_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.577 287.037L807.145 283.099L808.16 278.471L826.591 282.409L825.577 287.037Z",
    fill: "url(#paint132_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.104 306.118L891.221 305.225L868.567 297.917L870.029 293.411L892.602 300.678L895.647 301.612L894.104 306.118ZM851.719 292.64L842.949 290.772L843.924 286.103L852.693 287.971L851.719 292.64Z",
    fill: "url(#paint133_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.62 780.359L1189.1 775.609C1189.1 774.229 1189.43 772.483 1189.67 770.494C1190.3 766.067 1190.67 761.607 1190.77 757.136C1190.77 756.121 1190.77 755.025 1190.77 753.889H1195.52C1195.52 755.025 1195.52 756.081 1195.52 757.136C1195.44 761.825 1195.06 766.503 1194.38 771.143C1194.14 773.011 1193.93 774.675 1193.85 776.096L1193.33 780.928L1188.62 780.359ZM1191.17 735.7C1191.17 732.818 1191.17 729.854 1191.17 726.768H1195.88C1195.88 729.894 1195.88 732.858 1195.88 735.741L1191.17 735.7ZM1190.77 708.986C1190.44 702.449 1189.87 696.278 1189.06 690.148C1188.58 684.707 1187.97 679.226 1187.2 673.583L1191.9 672.934C1192.68 678.658 1193.28 684.22 1193.77 689.62C1194.58 695.791 1195.15 702.084 1195.52 708.742L1190.77 708.986ZM1185.25 660.267C1183.83 651.619 1182.08 642.809 1180.09 634.039L1184.72 632.984C1186.71 641.834 1188.49 650.766 1189.92 659.495L1185.25 660.267ZM1175.83 616.744C1175.1 613.902 1174.28 611.02 1173.47 608.178L1178.02 606.838C1178.87 609.761 1179.68 612.644 1180.46 615.526L1175.83 616.744ZM1168.28 591.126C1164.58 579.758 1160.4 568.512 1156.1 557.672L1160.44 555.886C1164.95 566.807 1169.17 578.175 1172.9 589.664L1168.28 591.126ZM1150.57 545.655C1146.92 537.535 1142.98 529.415 1138.88 521.661L1142.94 519.428C1147 527.547 1151.06 535.667 1154.76 543.787L1150.57 545.655ZM1130.28 506.07L1126.22 499.29L1125.69 498.56L1129.75 495.88L1130.28 496.733C1131.74 499.087 1133.12 501.401 1134.34 503.675L1130.28 506.07ZM1115.94 483.497C1109.79 473.388 1102.91 463.74 1095.36 454.631L1098.97 451.546C1106.67 460.818 1113.67 470.642 1119.92 480.939L1115.94 483.497ZM1086.92 444.075L1078.06 432.951L1069.38 424.019L1072.79 420.731L1083.34 432.058L1090.53 441.112L1086.92 444.075ZM1057.2 410.906C1055.17 408.754 1053.14 406.846 1050.99 404.613L1054.31 401.202C1056.47 403.273 1058.58 405.262 1060.69 407.658L1057.2 410.906ZM1037.83 392.717L1030.77 386.708L1023.22 380.294L1014.28 372.661C1013.11 371.768 1011.81 370.834 1010.51 369.941L1013.23 365.881L1017.29 368.804L1026.34 376.518L1033.85 382.933L1040.96 388.941L1037.83 392.717ZM999.465 362.268L987.286 353.782C984.241 351.509 981.033 349.316 977.42 347.084L979.896 343.024C983.672 345.378 987.001 347.611 990.087 349.966L1002.27 358.37L999.465 362.268ZM962.033 338.273C959.638 336.974 957.283 335.635 955.05 334.214L954.238 333.726L956.593 329.666L957.445 330.154C959.678 331.453 961.952 332.752 964.347 334.214L962.033 338.273ZM938.648 325.241C935.666 323.72 932.603 322.365 929.473 321.181L906.047 310.91L907.955 306.565L931.259 316.796C934.525 318.047 937.711 319.498 940.8 321.141L938.648 325.241Z",
    fill: "url(#paint134_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.76 788.811L1185.69 807.535L1190.41 808.057L1192.48 789.333L1187.76 788.811Z",
    fill: "url(#paint135_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.684 1284.76L660.252 1279.61L680.957 1281.88L680.389 1287.08L659.684 1284.76ZM701.135 1289.31L701.663 1284.12H702.962H722.247V1289.31H701.135ZM743.074 1289.84V1284.6H752.209C756.03 1284.69 759.852 1284.55 763.658 1284.2L764.104 1289.35C760.058 1289.76 755.991 1289.92 751.925 1289.84H743.074ZM784.932 1287.48L784.444 1282.29L805.19 1280.34L805.678 1285.54L784.932 1287.48ZM826.505 1282.29L825.531 1277.17L845.83 1273.11L846.845 1278.23L826.505 1282.29ZM867.591 1274.17L866.251 1269.13C868.89 1268.44 871.57 1267.63 874.371 1266.82C876.442 1266.17 878.431 1265.52 880.623 1264.95L886.307 1263.25L887.769 1268.24L882.085 1269.95L875.873 1271.77C873.031 1272.63 870.433 1273.44 867.591 1274.17ZM907.622 1262.31L906.16 1257.32L916.432 1254.27L925.688 1250.74L927.596 1255.57L918.056 1259.23L907.622 1262.31ZM946.962 1247.7L944.932 1242.91C951.266 1240.19 957.558 1237.39 963.892 1234.42L966.084 1239.13C959.751 1242.09 953.336 1244.98 946.962 1247.7ZM984.922 1230L982.567 1225.33C988.698 1222.2 994.747 1218.99 1000.92 1215.62L1003.44 1220.21C997.264 1223.6 991.093 1226.86 984.922 1230ZM1021.46 1209.7L1018.82 1205.19C1024.75 1201.7 1030.64 1198.04 1036.48 1194.31L1039.28 1198.69C1033.49 1202.56 1027.59 1206.27 1021.58 1209.82L1021.46 1209.7ZM1056.78 1187L1053.74 1182.94L1056.5 1181.03C1061.13 1177.58 1065.71 1174.09 1070.26 1170.48L1073.47 1174.54C1068.89 1178.16 1064.25 1181.72 1059.54 1185.22L1056.78 1187ZM1089.71 1161.18L1086.3 1157.12C1091.71 1152.63 1096.92 1148.07 1101.93 1143.44L1105.46 1147.5C1100.35 1152.18 1095.08 1156.78 1089.67 1161.3L1089.71 1161.18ZM1120.69 1133.05L1117.07 1129.31C1122.08 1124.49 1126.96 1119.59 1131.73 1114.61L1135.46 1118.23C1130.73 1123.29 1125.84 1128.27 1120.81 1133.17L1120.69 1133.05ZM1149.79 1102.92L1145.73 1099.43C1150.39 1094.26 1154.95 1089.05 1159.42 1083.8L1163.48 1087.17C1159.21 1092.61 1154.63 1097.85 1149.92 1103.04L1149.79 1102.92ZM1176.67 1070.73L1172.61 1067.72L1184.55 1050.63L1188.61 1053.63L1176.67 1070.73ZM1200.54 1036.54L1196.48 1033.54C1198.39 1030.82 1200.26 1028.1 1201.96 1025.42L1207.2 1016.08L1211.75 1018.64L1206.47 1028.06C1204.6 1031.06 1202.65 1033.86 1200.67 1036.66L1200.54 1036.54ZM1221.78 1000.37L1217.23 997.809L1227.26 979.864L1232.05 981.894L1230.38 984.98L1221.78 1000.37ZM1240.41 962.853L1235.62 960.742L1239.68 951.445C1241.02 948.115 1242.52 944.827 1243.94 941.62L1248.73 943.771C1247.27 946.938 1245.81 950.145 1244.47 953.474L1240.41 962.853ZM1256.45 924.121L1251.5 922.497L1257.91 902.644L1262.86 904.268L1256.45 924.121ZM1269.24 884.415L1264.28 882.832L1265.99 877.554L1269.16 862.816L1274.23 863.953L1271.02 878.894L1269.24 884.415ZM1278.62 843.532L1273.54 842.435L1277.88 822.136L1283 823.232L1278.62 843.532Z",
    fill: "url(#paint136_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.485 1283.18L625.186 1278.84L626.282 1273.72L646.581 1278.11L645.485 1283.18ZM604.683 1274.45L589.702 1271.25L584.181 1269.46L585.805 1264.51L591.083 1266.21L605.779 1269.38L604.683 1274.45ZM564.368 1263.09L544.516 1256.67L546.099 1251.72L565.952 1258.13L564.368 1263.09ZM524.825 1248.96C521.699 1247.54 518.451 1246.07 515.162 1244.9L505.784 1240.84L507.895 1236.05L517.192 1240.11C520.522 1241.45 523.769 1242.95 526.977 1244.37L524.825 1248.96ZM486.703 1232.23L483.617 1230.61L468.271 1222L470.788 1217.45L488.773 1227.44L486.703 1232.23ZM450.163 1211.93L440.744 1206.65C437.781 1204.83 434.979 1202.88 432.178 1200.89L435.182 1196.62C437.903 1198.57 440.582 1200.44 443.302 1202.15L452.64 1207.38L450.163 1211.93ZM415.086 1188.95L397.994 1177.01L400.998 1172.75L418.09 1184.69L415.086 1188.95ZM381.511 1163.86C376.097 1159.39 370.847 1154.81 365.758 1150.1L369.25 1146.24C374.446 1150.9 379.656 1155.44 384.88 1159.88L381.511 1163.86ZM350.493 1135.81C345.513 1130.99 340.573 1126.06 335.674 1121.03L339.409 1117.42C344.241 1122.37 349.153 1127.28 354.066 1132.07L350.493 1135.81ZM321.343 1105.76C316.633 1100.59 312.032 1095.34 307.539 1090.01L311.599 1086.64C316.065 1091.96 320.653 1097.16 325.281 1102.27L321.343 1105.76ZM294.304 1073.81C290.65 1069.22 287.118 1064.6 283.626 1059.89L281.678 1057.13L285.737 1054.04L287.686 1056.84C291.097 1061.43 294.629 1066.06 298.201 1070.56L294.304 1073.81ZM269.944 1039.63C266.169 1033.74 262.474 1027.77 258.942 1021.8L263.408 1019.16C266.954 1025.09 270.594 1030.97 274.329 1036.78L269.944 1039.63ZM248.549 1003.66C245.138 997.512 241.877 991.341 238.764 985.143L243.393 982.788C246.519 988.959 249.767 994.968 253.096 1001.18L248.549 1003.66ZM229.589 966.345C226.612 959.957 223.77 953.583 221.063 947.223L225.854 945.152C228.561 951.486 231.375 957.806 234.299 964.112L229.589 966.345ZM213.146 927.816C211.928 924.65 210.711 921.483 209.533 918.316L206.448 907.882L211.401 906.421L214.486 916.652C215.582 919.656 216.76 922.782 218.018 925.949L213.146 927.816ZM200.561 887.745L198.896 882.061C198.287 879.95 197.638 878.001 197.029 875.849C196.217 873.129 195.364 870.409 194.633 867.729L199.708 866.349C200.398 869.029 201.21 871.708 202.022 874.469C202.834 877.23 203.281 878.529 203.89 880.762L205.595 886.405L200.561 887.745ZM190.492 847.146L193.05 846.74L190.452 847.146L186.392 826.846L191.507 825.831L195.567 846.131L190.492 847.146ZM183.266 805.897L181.357 785.15L186.513 784.663L188.503 805.45L183.266 805.897ZM179.206 764.404C178.811 760.357 178.662 756.29 178.759 752.224V743.13H184.321V752.265C184.251 756.1 184.4 759.936 184.768 763.755L179.206 764.404ZM179.003 722.465L179.368 701.394L184.524 701.922V703.221V722.506L179.003 722.465ZM181.601 680.648L183.875 659.902L189.071 660.47L186.757 681.216L181.601 680.648Z",
    fill: "url(#paint137_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.649 646.625L185.574 645.529L189.918 625.229L194.993 626.325L190.649 646.625ZM199.378 606.026L194.262 604.93L197.51 589.948L199.256 584.427L204.25 586.01L202.545 591.288L199.378 606.026ZM210.624 566.198L205.671 564.614L212.085 544.761L217.038 546.345L210.624 566.198ZM224.509 527.223L219.799 525.071C221.22 521.904 222.641 518.697 223.859 515.408L227.919 506.03L232.71 508.1L228.65 517.438C227.472 520.524 225.97 523.853 224.509 527.06V527.223ZM241.154 488.856L236.364 486.786L238.028 483.7L246.635 468.313L251.182 470.871L241.154 488.856ZM261.454 452.682L256.907 450.124L262.185 440.746C263.971 437.742 265.96 434.94 267.909 432.139L272.172 435.143C270.264 437.863 268.396 440.584 266.691 443.263L261.454 452.682ZM284.149 418.051L279.886 414.965L291.822 397.873L296.085 400.837L284.149 418.051ZM308.914 384.881L304.854 381.512C309.361 376.234 313.908 370.956 318.617 365.759L322.677 369.251C317.968 374.366 313.38 379.644 308.955 384.881H308.914ZM336.806 354.067L333.07 350.453C337.861 345.459 342.814 340.506 347.808 335.634L351.462 339.41C346.468 344.201 341.596 349.113 336.806 354.067ZM366.605 325.2L363.114 321.14C368.229 316.431 373.507 311.843 378.826 307.337L382.195 311.397C376.917 315.944 371.721 320.545 366.605 325.2ZM398.272 298.364L395.024 294.304C399.599 290.677 404.254 287.132 408.991 283.667L411.751 281.719L414.796 285.778L412.035 287.727C407.61 291.259 402.82 294.792 398.272 298.364ZM432.051 274.411L429.249 269.985C435.123 266.196 441.064 262.529 447.072 258.983L449.711 263.489C443.784 267.022 437.856 270.635 431.97 274.411H432.051ZM467.737 253.177L465.22 248.508C471.337 245.125 477.508 241.877 483.733 238.765L486.088 243.393C479.958 246.6 473.827 249.808 467.737 253.177ZM504.764 234.38L502.571 229.67C508.945 226.707 515.279 223.865 521.693 221.144L523.723 225.935C517.228 228.615 511.056 231.457 504.764 234.38ZM542.967 218.14L541.1 213.268C544.226 212.01 547.433 210.832 550.6 209.655L561.034 206.529L562.495 211.522L552.224 214.567C549.26 215.663 546.093 216.841 542.967 218.099V218.14ZM582.47 205.595L581.009 200.601L586.692 198.896C588.804 198.328 590.752 197.678 592.904 197.069C595.624 196.216 598.344 195.404 601.024 194.674L602.485 199.789C599.847 200.52 597.167 201.332 594.366 202.144L588.113 204.012L582.47 205.595ZM622.785 195.729L621.729 190.614L642.029 186.554L643.084 191.669L622.785 195.729ZM663.384 188.624L662.897 183.428L683.683 181.519L684.13 186.676L663.384 188.624ZM704.876 184.564L704.511 179.49C708.558 179.094 712.625 178.945 716.69 179.043H725.744V184.24H716.609C712.722 184.121 708.832 184.23 704.957 184.564H704.876ZM746.287 184.564V179.327L767.358 179.652L766.83 184.849H765.531L746.287 184.564ZM787.617 187.082L788.185 181.925L808.891 184.199L808.322 189.396L787.617 187.082Z",
    fill: "url(#paint138_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.52 808.494L1281.8 787.789L1286.99 788.316L1284.72 809.063L1279.52 808.494ZM1284.07 767.083V765.743V746.459H1289.27L1288.98 767.57L1284.07 767.083ZM1257.23 562.584L1254.19 552.313C1253.09 549.349 1251.87 546.182 1250.66 543.015L1255.53 541.148C1256.75 544.315 1257.96 547.481 1259.14 550.648L1262.23 561.082L1257.23 562.584ZM1242.82 523.812C1240.11 517.478 1237.29 511.159 1234.34 504.852L1239.09 502.66C1242.04 508.993 1244.88 515.354 1247.61 521.741L1242.82 523.812ZM1225.24 486.176C1222.16 480.046 1218.91 473.997 1215.58 467.826L1220.13 465.308C1223.5 471.439 1226.78 477.488 1229.91 483.822L1225.24 486.176ZM1205.27 449.637C1201.73 443.71 1198.12 437.823 1194.35 431.976L1198.73 429.175C1202.49 435.048 1206.16 440.976 1209.73 446.957L1205.27 449.637ZM1183.06 414.965L1181.11 412.164C1177.7 407.576 1174.17 402.988 1170.59 398.441L1174.65 395.193C1178.27 399.781 1181.8 404.409 1185.29 409.16L1187.24 411.88L1183.06 414.965ZM1157.44 382.486C1152.98 377.208 1148.39 372.011 1143.76 366.896L1147.82 363.364C1152.49 368.52 1157.12 373.757 1161.62 379.116L1157.44 382.486ZM1129.55 351.752C1124.72 346.758 1119.81 341.846 1114.85 337.096L1118.47 333.32C1123.45 338.138 1128.39 343.064 1133.28 348.098L1129.55 351.752ZM1099.71 322.886C1094.51 318.204 1089.3 313.656 1084.08 309.245L1087.45 305.185C1092.86 309.651 1098.11 314.238 1103.2 318.948L1099.71 322.886ZM1068 296.375L1050.71 284.235L1053.67 280.176L1070.76 292.112L1068 296.375ZM1033.78 272.502C1031.06 270.594 1028.38 268.727 1025.66 266.981L1016.36 261.784L1018.88 257.237L1028.25 262.515C1031.26 264.301 1034.06 266.25 1036.86 268.239L1033.78 272.502ZM998.09 251.553L980.064 241.363L982.134 236.572L985.22 238.196L1000.36 246.803L998.09 251.553ZM960.982 233.162L951.685 229.102C948.397 227.721 945.108 226.26 941.901 224.798L944.012 220.048C947.179 221.469 950.386 222.931 953.715 224.108L963.094 228.168L960.982 233.162ZM922.738 217.287L902.926 210.71L904.509 205.757L924.159 211.969L922.738 217.287ZM883.073 204.498L877.795 202.834L863.098 199.667L864.194 194.552L879.135 197.8L884.656 199.545L883.073 204.498ZM842.717 195.282L822.418 190.898L823.514 185.823L843.814 190.167L842.717 195.282Z",
    fill: "url(#paint139_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.93 1123.1C1179.2 1123.01 1178.51 1122.72 1177.94 1122.25C1177.18 1121.54 1176.69 1120.6 1176.56 1119.57C1176.46 1118.88 1176.53 1118.19 1176.77 1117.54C1177.01 1116.89 1177.41 1116.32 1177.93 1115.87C1178.46 1115.42 1179.09 1115.11 1179.76 1114.97C1180.44 1114.83 1181.14 1114.87 1181.8 1115.08C1182.46 1115.29 1183.05 1115.66 1183.53 1116.16C1184 1116.66 1184.34 1117.27 1184.51 1117.94C1184.68 1118.61 1184.68 1119.31 1184.5 1119.98C1184.33 1120.65 1183.98 1121.26 1183.51 1121.76C1183.07 1122.26 1182.51 1122.64 1181.89 1122.87C1181.26 1123.11 1180.59 1123.19 1179.93 1123.1ZM1238.76 1042.63C1238.31 1042.54 1237.88 1042.41 1237.46 1042.23C1236.56 1041.68 1235.9 1040.81 1235.63 1039.79C1235.36 1038.83 1235.45 1037.8 1235.88 1036.91C1236.45 1035.93 1236.93 1034.92 1237.54 1033.78L1255.49 1001.71C1258.3 996.874 1260.78 991.855 1262.92 986.685V986.076C1265.15 980.92 1267.42 975.926 1269.58 970.973L1269.98 969.999C1271.65 965.939 1273.31 962.285 1275.02 958.55C1277.86 952.054 1280.66 945.842 1282.85 939.874C1285 933.054 1287.15 926.395 1289.23 920.184L1292.47 909.953C1295.15 901.833 1297.51 894.281 1299.66 887.664C1300.8 883.238 1301.69 878.935 1302.38 875.24C1302.83 873.088 1303.27 871.18 1303.68 869.11C1306.03 858.594 1307.33 852.586 1307.33 852.586C1307.42 852.103 1307.61 851.643 1307.88 851.232C1308.15 850.822 1308.5 850.469 1308.91 850.193C1309.32 849.918 1309.77 849.726 1310.26 849.628C1310.74 849.53 1311.23 849.528 1311.72 849.622C1312.22 849.712 1312.7 849.905 1313.12 850.189C1313.55 850.473 1313.91 850.843 1314.19 851.274C1314.46 851.705 1314.64 852.189 1314.72 852.694C1314.8 853.2 1314.77 853.716 1314.64 854.21C1314.64 854.21 1313.34 860.543 1311.15 870.734C1310.74 872.561 1310.34 874.509 1309.89 876.539C1309.16 880.599 1308.23 884.943 1307.01 889.815V890.018C1305.46 894.931 1303.76 900.128 1301.93 905.771L1290.16 942.31C1287.72 948.887 1284.8 955.302 1281.84 962.082C1280.29 965.614 1278.63 969.268 1277.09 973.044C1275.79 975.886 1274.57 978.768 1273.27 981.61L1269.74 989.73C1267.56 995.21 1264.97 1000.52 1261.98 1005.6L1249.07 1028.62L1244.2 1037.43C1243.59 1038.41 1243.1 1039.5 1242.54 1040.56C1242.19 1041.25 1241.64 1041.81 1240.97 1042.18C1240.29 1042.55 1239.53 1042.71 1238.76 1042.63Z",
    fill: "url(#paint140_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.754 1319.88C587.636 1311.5 536.871 1296.2 488.807 1274.37C488.344 1274.18 487.928 1273.89 487.585 1273.53C487.242 1273.17 486.98 1272.73 486.817 1272.26C486.606 1271.78 486.497 1271.26 486.497 1270.74C486.497 1270.21 486.606 1269.7 486.817 1269.22C487.281 1268.31 488.068 1267.61 489.023 1267.26C489.978 1266.9 491.031 1266.92 491.973 1267.31C539.357 1288.69 589.363 1303.71 640.687 1311.97H641.499C653.679 1313.92 666.062 1315.5 678.526 1316.68H679.622C680.88 1316.68 682.098 1317 683.357 1317.08C683.874 1317.12 684.378 1317.26 684.839 1317.49C685.3 1317.73 685.708 1318.06 686.039 1318.46C686.369 1318.85 686.615 1319.32 686.761 1319.81C686.907 1320.31 686.951 1320.83 686.889 1321.35C686.855 1321.86 686.714 1322.36 686.477 1322.81C686.239 1323.26 685.909 1323.66 685.509 1323.98C684.678 1324.63 683.637 1324.95 682.586 1324.88C681.246 1324.88 679.825 1324.51 678.526 1324.39C665.372 1323.62 652.542 1321.95 639.754 1319.88ZM700.368 1326.54C699.415 1326.38 698.551 1325.88 697.934 1325.13C697.316 1324.39 696.984 1323.45 696.998 1322.48C697.099 1321.48 697.571 1320.55 698.322 1319.87C699.073 1319.2 700.048 1318.82 701.058 1318.83C702.048 1318.95 702.96 1319.43 703.619 1320.18C704.278 1320.93 704.638 1321.89 704.631 1322.89C704.539 1323.9 704.072 1324.84 703.32 1325.53C702.568 1326.21 701.587 1326.59 700.571 1326.58C700.502 1326.58 700.434 1326.56 700.368 1326.54ZM781.931 1325.49C781.267 1325.34 780.651 1325.03 780.139 1324.58C779.627 1324.13 779.236 1323.56 779.002 1322.92C778.767 1322.28 778.697 1321.6 778.797 1320.92C778.898 1320.25 779.166 1319.61 779.577 1319.07C780.268 1318.32 781.202 1317.83 782.216 1317.69C783.267 1317.62 784.303 1317.97 785.106 1318.65C785.909 1319.33 786.416 1320.3 786.519 1321.35C786.524 1322.36 786.153 1323.33 785.477 1324.08C784.801 1324.83 783.87 1325.3 782.865 1325.41C782.564 1325.51 782.245 1325.53 781.931 1325.49ZM402.818 1225.94C402.254 1225.8 401.718 1225.57 401.234 1225.25C400.808 1224.97 400.443 1224.61 400.163 1224.18C399.884 1223.75 399.696 1223.27 399.61 1222.77C399.455 1221.74 399.671 1220.69 400.219 1219.81C400.83 1218.98 401.73 1218.42 402.74 1218.23C403.749 1218.04 404.793 1218.24 405.66 1218.79C406.486 1219.4 407.049 1220.3 407.238 1221.31C407.426 1222.32 407.225 1223.37 406.675 1224.23C406.25 1224.84 405.665 1225.32 404.985 1225.62C404.305 1225.93 403.555 1226.03 402.818 1225.94ZM338.59 1175.43C337.825 1175.34 337.112 1175 336.56 1174.46C335.824 1173.74 335.386 1172.78 335.333 1171.75C335.28 1170.73 335.617 1169.72 336.276 1168.94C336.99 1168.2 337.957 1167.76 338.981 1167.71C340.005 1167.66 341.011 1167.99 341.797 1168.65C342.545 1169.37 342.991 1170.34 343.044 1171.38C343.096 1172.41 342.752 1173.43 342.082 1174.21C341.651 1174.7 341.104 1175.06 340.493 1175.27C339.883 1175.49 339.228 1175.54 338.59 1175.43ZM325.274 1163.05C324.471 1162.93 323.722 1162.58 323.122 1162.03C300.106 1139.99 278.937 1116.09 259.828 1090.58C238.598 1062.5 220.006 1032.52 204.289 1001.02C204.052 1000.57 203.909 1000.07 203.867 999.563C203.825 999.055 203.885 998.544 204.044 998.059C204.203 997.575 204.458 997.127 204.793 996.743C205.127 996.358 205.536 996.045 205.994 995.821C206.93 995.37 208.003 995.296 208.993 995.613C209.982 995.931 210.812 996.615 211.312 997.526C241.05 1056.79 280.721 1110.52 328.603 1156.39C329.309 1157.12 329.715 1158.09 329.74 1159.11C329.769 1159.63 329.686 1160.15 329.497 1160.63C329.308 1161.11 329.017 1161.55 328.643 1161.91C328.209 1162.34 327.685 1162.66 327.108 1162.86C326.532 1163.06 325.919 1163.12 325.314 1163.05H325.274ZM170.104 910.481C169.387 910.377 168.715 910.07 168.168 909.595C167.621 909.12 167.222 908.497 167.019 907.801C166.744 907.032 166.708 906.197 166.915 905.407C167.123 904.617 167.564 903.907 168.181 903.371C168.798 902.836 169.562 902.498 170.373 902.404C171.185 902.31 172.006 902.462 172.73 902.842C173.453 903.222 174.045 903.811 174.428 904.533C174.812 905.255 174.968 906.075 174.877 906.887C174.787 907.699 174.453 908.465 173.92 909.085C173.387 909.704 172.68 910.148 171.891 910.359C171.322 910.583 170.698 910.625 170.104 910.481ZM151.469 831.028C150.83 830.893 150.232 830.605 149.728 830.189C149.223 829.774 148.827 829.242 148.572 828.64C148.317 828.039 148.211 827.384 148.263 826.732C148.315 826.081 148.523 825.451 148.871 824.898C149.155 824.48 149.521 824.124 149.947 823.852C150.373 823.58 150.849 823.397 151.348 823.314C152.366 823.168 153.401 823.413 154.245 824.001C155.089 824.589 155.679 825.475 155.895 826.481C156.007 827.436 155.777 828.4 155.245 829.201C154.614 830.065 153.691 830.671 152.647 830.906C152.262 831 151.866 831.041 151.469 831.028ZM148.871 813.083C148.026 812.906 147.259 812.464 146.683 811.822C146.106 811.179 145.749 810.37 145.664 809.51C145.055 803.38 144.527 797.331 143.959 791.809L142.822 779.629C142.822 778.046 142.578 776.422 142.416 774.839C141.409 766.283 140.962 757.672 141.076 749.058L141.482 706.794C141.4 702.901 141.604 699.006 142.091 695.142V693.478C142.091 692.26 142.091 691.61 142.335 691.326C142.485 690.3 143.023 689.37 143.837 688.728C144.231 688.394 144.693 688.149 145.19 688.009C145.687 687.869 146.209 687.837 146.719 687.916C147.703 688.018 148.608 688.499 149.245 689.257C149.881 690.014 150.198 690.989 150.13 691.976C150.13 691.976 150.13 693.356 149.724 696.035C149.188 699.54 148.997 703.09 149.155 706.632C149.155 714.752 149.155 725.714 148.871 739.639V749.221C148.621 757.726 149.041 766.237 150.13 774.676L151.063 785.07L153.256 808.861C153.265 809.846 152.917 810.801 152.274 811.548C151.632 812.295 150.74 812.783 149.764 812.921C149.473 813.008 149.174 813.063 148.871 813.083Z",
    fill: "url(#paint141_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.787 619.221C155.802 618.961 154.952 618.342 154.403 617.484C153.854 616.627 153.647 615.595 153.823 614.593L154.067 613.05L157.355 598.069C157.72 596.242 158.167 594.293 158.573 592.263C159.344 588.203 160.278 583.859 161.496 578.987V578.784C163.81 571.679 166.368 563.64 169.169 554.79C170.672 550.08 172.336 545.168 174.001 540.052L178.304 526.411C180.74 519.834 183.704 513.338 186.708 506.517C188.21 502.985 189.875 499.331 191.418 495.677C193.732 490.359 196.087 485.04 198.441 479.437L198.766 478.747C200.946 473.281 203.538 467.987 206.521 462.914L224.222 431.206C224.72 430.134 225.276 429.091 225.886 428.079C226.406 427.19 227.245 426.531 228.233 426.237C229.22 425.943 230.283 426.036 231.205 426.496C232.094 427.016 232.753 427.855 233.047 428.843C233.341 429.83 233.248 430.893 232.788 431.815C232.179 432.789 231.732 433.682 231.123 434.738L230.23 436.483C224.587 446.674 218.822 456.783 213.138 466.974C210.235 471.904 207.71 477.048 205.587 482.361V482.645C204.288 485.527 203.07 488.369 201.77 491.211L198.604 498.641L193.569 510.049C190.687 516.667 187.926 522.757 185.45 528.847L176.193 558.768C173.595 566.888 171.118 574.44 168.966 581.179C167.83 585.645 166.936 589.908 166.206 593.724C165.759 595.836 165.313 597.784 164.907 599.733C162.592 610.127 161.415 615.973 161.415 615.973C161.217 617.01 160.623 617.929 159.759 618.535C158.895 619.141 157.829 619.387 156.787 619.221ZM287.516 353.377C286.837 353.259 286.197 352.981 285.648 352.565C285.242 352.24 284.91 351.834 284.672 351.372C284.434 350.91 284.296 350.404 284.268 349.885C284.173 348.832 284.494 347.783 285.161 346.962C285.866 346.203 286.835 345.742 287.869 345.674C288.903 345.606 289.924 345.936 290.723 346.597C291.477 347.288 291.965 348.222 292.103 349.236C292.154 349.749 292.089 350.267 291.914 350.751C291.738 351.236 291.456 351.675 291.088 352.037C290.671 352.564 290.118 352.968 289.488 353.204C288.859 353.44 288.177 353.5 287.516 353.377ZM344.679 295.035C343.735 294.889 342.872 294.415 342.243 293.696C341.609 292.885 341.307 291.864 341.398 290.839C341.488 289.814 341.964 288.861 342.73 288.174L346.384 285.17C347.074 284.642 347.683 284.236 348.17 283.789L351.662 281.069C352.483 280.445 353.51 280.157 354.535 280.263C355.56 280.368 356.507 280.86 357.183 281.638C357.781 282.47 358.042 283.497 357.914 284.514C357.786 285.53 357.279 286.461 356.493 287.119L353.124 289.839C352.515 290.285 351.906 290.813 351.297 291.341C350.065 292.218 348.885 293.167 347.764 294.183C347.335 294.527 346.84 294.78 346.309 294.926C345.779 295.073 345.224 295.11 344.679 295.035Z",
    fill: "url(#paint142_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.19 473.388C1259.59 473.269 1259.01 473.013 1258.52 472.64C1258.03 472.268 1257.63 471.787 1257.35 471.236C1227.48 412.064 1187.81 358.377 1140.02 312.452C1139.49 312.141 1139.04 311.714 1138.7 311.203C1138.36 310.692 1138.14 310.111 1138.06 309.503C1137.97 308.895 1138.03 308.276 1138.22 307.693C1138.41 307.109 1138.73 306.577 1139.16 306.135C1139.58 305.693 1140.1 305.354 1140.68 305.142C1141.25 304.93 1141.87 304.852 1142.48 304.913C1143.09 304.974 1143.68 305.173 1144.2 305.494C1144.73 305.815 1145.17 306.251 1145.5 306.768C1193.9 353.324 1234.06 407.755 1264.25 467.744C1264.68 468.672 1264.74 469.726 1264.42 470.696C1264.11 471.667 1263.44 472.483 1262.55 472.982C1261.83 473.371 1261 473.514 1260.19 473.388ZM390.439 258.739C389.901 258.65 389.386 258.453 388.926 258.16C388.466 257.867 388.069 257.484 387.76 257.034C387.245 256.137 387.045 255.094 387.192 254.07C387.451 253.059 388.091 252.186 388.978 251.634C389.867 251.148 390.905 251.012 391.889 251.253C392.873 251.493 393.732 252.093 394.296 252.934C394.818 253.816 394.987 254.863 394.768 255.865C394.55 256.866 393.961 257.748 393.119 258.333C392.29 258.745 391.353 258.887 390.439 258.739ZM405.664 248.833C405.126 248.743 404.611 248.546 404.151 248.253C403.69 247.96 403.294 247.578 402.985 247.128C402.697 246.697 402.499 246.213 402.405 245.704C402.31 245.195 402.32 244.672 402.434 244.166C402.548 243.661 402.763 243.185 403.067 242.765C403.372 242.346 403.758 241.993 404.203 241.728C406.435 240.307 408.79 238.683 411.51 236.897C418.493 232.309 427.1 226.625 437.291 220.454C439.361 219.317 441.351 218.262 443.665 217.166C475.86 200.073 519.95 176.81 577.642 162.235L586.776 159.921C587.764 159.713 588.794 159.881 589.664 160.391C590.535 160.902 591.184 161.718 591.486 162.681C591.704 163.675 591.542 164.715 591.031 165.594C590.52 166.474 589.697 167.13 588.725 167.431C585.639 168.203 582.676 168.974 579.671 169.867C522.833 184.24 479.229 207.259 447.359 224.189L441.351 227.315C431.16 233.486 422.431 239.252 415.448 243.839L408.506 248.305C408.09 248.576 407.625 248.761 407.138 248.852C406.65 248.942 406.149 248.936 405.664 248.833ZM1128.77 301.003C1128.04 300.895 1127.36 300.57 1126.82 300.069C1126.11 299.359 1125.69 298.409 1125.63 297.404C1125.58 296.399 1125.9 295.41 1126.54 294.629C1127.25 293.87 1128.21 293.409 1129.25 293.341C1130.28 293.273 1131.3 293.603 1132.1 294.264C1132.84 294.985 1133.28 295.963 1133.33 296.996C1133.37 298.03 1133.02 299.042 1132.35 299.826C1131.89 300.296 1131.33 300.648 1130.7 300.853C1130.08 301.058 1129.42 301.11 1128.77 301.003ZM1064.59 250.619C1064.02 250.543 1063.48 250.349 1063 250.051C1062.14 249.42 1061.53 248.496 1061.3 247.453C1061.2 246.957 1061.21 246.447 1061.33 245.956C1061.45 245.465 1061.67 245.006 1061.99 244.611C1062.6 243.785 1063.5 243.221 1064.51 243.033C1065.52 242.844 1066.56 243.046 1067.43 243.596C1068.2 244.215 1068.72 245.096 1068.89 246.072C1069.06 247.057 1068.85 248.069 1068.32 248.914C1067.93 249.528 1067.37 250.016 1066.71 250.319C1066.04 250.621 1065.31 250.726 1064.59 250.619ZM977.542 201.9C977.223 201.787 976.897 201.692 976.567 201.616C917.506 174.799 854.391 158.005 789.812 151.922L785.346 151.517C784.514 151.208 783.807 150.636 783.331 149.888C782.855 149.14 782.637 148.256 782.711 147.372C782.784 146.488 783.145 145.653 783.738 144.994C784.332 144.335 785.125 143.888 785.996 143.721C786.808 143.721 787.538 143.721 788.269 143.965C789 144.209 789.812 143.965 790.543 143.965C855.922 150.19 919.821 167.187 979.653 194.268C980.569 194.732 981.276 195.526 981.63 196.49C981.984 197.455 981.959 198.517 981.561 199.464C981.245 200.245 980.679 200.9 979.952 201.326C979.225 201.752 978.378 201.925 977.542 201.819V201.9ZM685.472 151.07C684.6 150.96 683.793 150.553 683.186 149.917C682.58 149.281 682.211 148.455 682.143 147.578C682.137 146.575 682.503 145.604 683.17 144.855C683.838 144.105 684.759 143.629 685.757 143.518C686.598 143.709 687.357 144.162 687.923 144.813C688.489 145.464 688.834 146.278 688.906 147.138C688.978 147.997 688.775 148.857 688.326 149.594C687.876 150.33 687.204 150.904 686.406 151.232C686.087 151.241 685.77 151.186 685.472 151.07ZM767.158 150.136C766.326 149.815 765.623 149.229 765.157 148.468C764.691 147.708 764.489 146.815 764.582 145.928C764.674 145.041 765.056 144.209 765.668 143.561C766.281 142.913 767.089 142.484 767.97 142.341C768.975 142.442 769.906 142.914 770.581 143.665C771.257 144.415 771.629 145.391 771.624 146.401C771.523 147.406 771.051 148.337 770.3 149.013C769.549 149.688 768.574 150.06 767.564 150.055L767.158 150.136Z",
    fill: "url(#paint143_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.308 1087.49C639.19 1086.97 637.102 1086.34 635.056 1085.59L607.205 1076.73C599.775 1073.77 595.025 1071.54 594.781 1071.5L594.213 1071.25V1070.64C594.213 1070.64 591.168 1060.25 588.813 1050.35C587.595 1045.31 586.499 1040.36 585.728 1036.66C585.728 1036.66 584.916 1032.97 584.672 1030.98L571.071 1023.39C569.569 1022.49 567.945 1021.64 566.281 1020.71C563.276 1019.08 559.866 1017.22 556.537 1015.06L532.868 998.581C531.177 997.326 529.564 995.971 528.037 994.521L525.519 992.41L512.812 981.57C509.671 979.093 506.726 976.379 504.002 973.45L500.957 970.283L502.906 968.334L506.032 971.542C508.684 974.381 511.547 977.014 514.598 979.418L527.306 990.217C528.145 990.894 528.997 991.625 529.864 992.41C531.325 993.668 532.868 995.008 534.451 996.145L558.08 1012.59C561.287 1014.7 564.494 1016.4 567.621 1018.11L572.452 1020.79L587.555 1029.23L587.352 1030C587.352 1030.74 587.798 1033.01 588.448 1035.93C589.219 1039.63 590.275 1044.54 591.493 1049.53C593.523 1057.98 595.999 1066.75 596.689 1069.1C598.192 1069.75 602.495 1071.62 608.301 1073.97L636.111 1082.78C640.991 1084.42 645.985 1085.7 651.052 1086.6L676.913 1092C677.563 1091.63 678.74 1090.9 680.323 1089.81L688.93 1083.96L701.313 1075.07L713.818 1076.41C718.283 1076.73 723.846 1076.73 729.692 1076.73C733.102 1076.73 736.634 1076.73 740.166 1076.73C747.233 1076.93 754.303 1076.59 761.318 1075.72L766.475 1075.23L778.979 1074.06L782.43 1076.53C783.81 1077.51 785.475 1078.72 787.099 1079.66L794.691 1084.29L808.21 1081.65C809.631 1081.28 811.255 1081 812.92 1080.71C816.122 1080.21 819.283 1079.48 822.379 1078.52L838.619 1073.73C840.527 1073.08 842.476 1072.55 844.465 1071.98C847.879 1071.07 851.24 1069.97 854.534 1068.7L881.898 1057.57L885.957 1058.91L894.077 1060.94L905.648 1063.62L922.375 1054.81L939.02 1044.05C940.644 1042.92 942.39 1041.82 944.136 1040.68C948.85 1037.81 953.354 1034.61 957.615 1031.1L961.675 1028.02C971.678 1020.54 981.172 1012.4 990.094 1003.66L1003.74 990.421C1003.92 988.899 1004 987.366 1003.98 985.833V974.221C1003.98 966.102 1003.98 957.982 1003.78 957.982V957.454L1011.16 948.725C1013.6 945.477 1016.52 941.255 1019.57 936.829L1024.85 929.278C1025.7 927.979 1026.59 926.72 1027.49 925.462C1029.11 923.147 1030.65 920.996 1031.99 918.803L1042.39 900.046L1038.93 885.999L1033.9 871.099L1037.59 862.533C1038.2 860.949 1039.02 859.163 1039.87 857.295C1041.81 853.267 1043.41 849.084 1044.66 844.791L1053.18 817.914L1055.82 818.726L1047.34 845.562C1046.06 849.982 1044.42 854.287 1042.43 858.432C1041.57 860.259 1040.8 862.005 1040.15 863.588L1036.86 871.221L1041.61 885.228L1045.35 900.452L1034.39 920.184C1032.97 922.498 1031.34 924.812 1029.76 927.045L1027.12 930.821L1021.88 938.413C1018.8 942.879 1015.87 947.101 1013.36 950.593L1006.62 958.712C1006.62 960.661 1006.82 967.563 1006.62 974.627V986.239C1006.6 988.043 1006.5 989.845 1006.29 991.638V992.085L991.961 1005.97C982.931 1014.86 973.3 1023.12 963.136 1030.7L959.279 1033.74C954.938 1037.32 950.353 1040.59 945.557 1043.52C943.852 1044.62 942.106 1045.72 940.482 1046.85L923.714 1057.69L905.932 1067.07L885.227 1062.08L881.898 1061.02L855.468 1071.74C852.063 1073.05 848.594 1074.19 845.074 1075.15C843.166 1075.68 841.014 1076.25 839.309 1076.86L823.069 1081.65C819.856 1082.65 816.572 1083.41 813.245 1083.92C811.621 1084.2 810.078 1084.49 808.616 1084.85L794.001 1087.7L785.515 1082.54C783.81 1081.53 782.065 1080.27 780.644 1079.29L778.045 1077.38L766.556 1078.48L761.44 1078.97C754.303 1079.84 747.111 1080.18 739.923 1079.98H729.529C723.643 1079.98 717.999 1079.98 713.29 1079.66L701.76 1078.44L690.23 1086.56L681.623 1092.45C680.313 1093.37 678.958 1094.22 677.563 1095L677.116 1095.25L650.28 1089.65C647.438 1088.91 644.353 1088.31 641.308 1087.49Z",
    fill: "url(#paint144_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.988 970.486L488.565 957.697C486.047 955.182 483.739 952.467 481.663 949.577L465.667 929.521C465.225 929.008 464.818 928.465 464.449 927.897L450.605 924.609L435.258 920.549L433.309 917.585C432.985 916.976 432.579 916.407 432.132 915.717C431.017 914.13 430 912.476 429.087 910.764L418.044 889.571C415.112 884.263 412.588 878.739 410.493 873.047C409.721 871.099 408.991 869.272 408.26 867.607L404.2 857.985L400.14 855.833C396.754 854.128 393.461 852.244 390.274 850.19C383.454 846.13 376.39 841.299 376.308 841.258C376.227 841.218 375.496 840.933 370.381 821.771L366.321 802.08C366.077 800.74 365.793 799.319 365.509 798.02C364.163 791.893 363.241 785.68 362.748 779.425L360.109 751.371V716.659L363.033 713.37L369.325 707.159L378.014 699.039L379.475 685.276C379.901 680.347 380.715 675.46 381.911 670.66L385.362 654.177C386.806 646.308 388.884 638.569 391.574 631.035C392.386 628.437 393.198 626.001 393.847 623.727L398.11 610.289C398.11 609.639 398.597 609.233 401.52 607.812L415.649 601.032L420.237 590.436L421.82 586.782C422.855 584.141 424.048 581.565 425.393 579.068L434.081 563.397C437.681 556.599 441.751 550.06 446.26 543.828L452.797 534.449L451.214 520.158C450.95 517.691 450.814 515.211 450.808 512.729C450.808 511.754 450.808 510.821 450.808 509.968V504.771L459.78 494.256L462.541 491.008C464.449 488.775 466.601 486.339 468.752 483.903L491.285 462.101C493.55 459.951 495.935 457.931 498.43 456.052C499.648 455.118 500.785 454.225 501.8 453.332L512.802 444.603L519.785 446.308L522.993 447.12C526.2 447.932 529.813 448.825 533.63 450.125C542.155 452.845 550.275 455.809 552.711 456.702L565.743 448.216L569.357 446.268C577.476 441.924 587.464 436.564 597.776 431.693L623.719 421.137C625.505 420.487 627.21 420 628.834 419.513L631.351 418.782L646.941 414.113L647.753 416.793L632.163 421.421L629.606 422.192C628.022 422.639 626.398 423.126 624.734 423.735L598.913 434.25C588.804 439.041 578.613 444.4 570.778 448.704L567.246 450.612L552.914 459.625H552.305C551.168 459.219 542.115 455.849 532.574 452.804C528.839 451.546 525.266 450.652 522.14 449.881L518.892 449.028L513.168 447.445L503.383 455.565C502.328 456.458 501.15 457.392 499.932 458.326C497.515 460.133 495.21 462.085 493.031 464.172L470.539 485.933C468.387 488.288 466.479 490.643 464.489 492.876L461.688 496.164L453.568 505.867V509.927C453.568 510.739 453.568 511.714 453.568 512.688C453.573 515.089 453.709 517.488 453.974 519.874L455.679 535.18L448.493 545.533C444.118 551.667 440.197 558.113 436.76 564.818L427.91 580.408C426.609 582.798 425.457 585.266 424.459 587.797L422.835 591.532L417.882 603.062L402.82 610.248L400.749 611.344L396.689 624.499C395.999 626.772 395.228 629.208 394.375 631.847C391.736 639.28 389.686 646.909 388.244 654.664L384.794 671.188C383.638 675.885 382.837 680.662 382.398 685.479L380.815 700.297L365.265 715.4L363.114 717.836V751.371L365.753 779.344C366.257 785.487 367.166 791.59 368.473 797.614C368.757 798.994 369.041 800.415 369.285 801.674L373.142 821.202C375.699 830.905 377.811 837.442 378.338 839.309C380.287 840.609 386.133 844.425 391.817 847.916C394.912 849.946 398.125 851.79 401.439 853.438L406.514 856.077L410.818 866.633C411.508 868.257 412.238 870.124 413.05 872.114C415.101 877.699 417.557 883.126 420.399 888.353L431.523 909.587C432.395 911.21 433.357 912.782 434.406 914.296C434.852 914.987 435.299 915.636 435.664 916.245L436.963 918.234L451.254 922.091L467.007 925.827L466.804 926.639C467.007 926.923 467.331 927.369 467.778 927.897L483.815 948.197C485.823 950.917 488.064 953.457 490.513 955.789L502.896 968.618L500.988 970.486Z",
    fill: "url(#paint145_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.14 818.076L1059.88 785.799C1060.37 782.145 1060.77 778.248 1061.18 774.269C1061.42 771.833 1061.67 769.397 1061.95 766.961C1062.23 764.525 1062.4 762.292 1062.68 759.978C1063.29 756.056 1063.59 752.092 1063.57 748.123V719.704L1063.13 714.669L1063.65 714.182C1063.65 714.182 1071.37 707.686 1078.84 700.622C1085.05 694.857 1091.02 688.442 1093.41 686.331L1093.17 683.367C1092.97 681.946 1092.6 680.119 1092.16 677.968C1091.91 676.75 1091.67 675.41 1091.38 673.908C1090.82 671.269 1090.29 668.305 1089.68 665.138C1088.54 659.048 1087.24 652.106 1085.62 645.326L1077.5 617.353C1076.89 615.158 1076.12 613.014 1075.18 610.938C1074.74 610.004 1074.41 609.152 1074.13 608.38L1072.99 605.538L1060.12 599.002L1046.56 592.547L1046.36 591.938C1046.03 590.993 1045.61 590.082 1045.1 589.218L1040.96 581.423C1039.74 579.23 1038.44 576.672 1036.9 573.952C1034.38 569.04 1031.54 563.437 1028.25 558.2L1013.8 535.951C1012.74 534.2 1011.53 532.543 1010.19 530.998L1008.6 529.049L1006.25 526.086L1006.9 516.179L1007.34 507.166L1005.19 504.527L1003.93 502.944C1002.3 500.755 1000.51 498.692 998.574 496.773L991.835 489.83C987.166 484.999 981.929 479.518 976.529 474.2L952.616 453.9C950.505 452.154 948.556 450.815 946.729 449.597C945.796 448.988 944.943 448.419 944.253 447.891L940.64 445.374L937.473 432.91L934.184 421.177C933.616 420.771 932.276 419.837 930.124 418.619L900.406 402.055C896.346 399.984 891.637 397.995 886.846 396.006L879.619 392.879C868.88 388.037 857.809 383.966 846.49 380.7L839.67 378.426C833.813 376.331 827.817 374.649 821.725 373.392C820.02 374.285 813.605 377.655 807.394 381.106C801.182 384.557 795.579 387.886 793.874 388.86L793.671 389.631L792.331 389.307C788.868 388.54 785.354 388.024 781.816 387.764L757.985 385.247C754.416 384.811 750.82 384.634 747.226 384.719H723.881C720.258 387.98 716.816 391.436 713.569 395.072L701.39 408.632V406.683C694.082 407.13 651.575 414.356 648.408 416.427L647.758 415.412L646.094 415.818L646.621 414.275C648.895 412.326 694.244 404.004 702.08 403.963L711.742 393.204C714.974 389.452 718.402 385.874 722.014 382.486V381.836H746.942C750.659 381.746 754.377 381.936 758.066 382.405L781.776 384.881C785.272 385.132 788.745 385.634 792.169 386.383C793.874 385.368 799.68 381.918 805.77 378.548C812.875 374.488 820.507 370.428 820.588 370.428L821.725 370.306L822.09 370.875C828.321 372.125 834.453 373.821 840.441 375.949L847.384 378.142C858.806 381.375 869.974 385.446 880.797 390.322L887.983 393.407C892.814 395.478 897.361 397.467 901.705 399.538L931.545 416.183C936.174 418.944 936.823 419.553 936.742 420.243L940.071 432.098L942.994 443.628L945.796 445.577L948.191 447.242C949.937 448.419 952.251 449.881 954.321 451.708L978.356 472.007C983.796 477.448 989.074 482.929 993.743 487.801L1000.44 494.702C1002.48 496.682 1004.36 498.828 1006.04 501.117L1007.26 502.619L1010.06 506.151L1009.01 525.071L1010.75 527.222C1011.16 527.831 1011.69 528.44 1012.22 529.09C1013.65 530.748 1014.94 532.527 1016.07 534.409L1030.53 556.576C1033.85 561.935 1036.74 567.578 1039.3 572.572C1040.63 575.251 1041.93 577.769 1043.15 579.961L1047.21 587.756C1047.7 588.599 1048.13 589.482 1048.47 590.395L1061.06 596.363L1074.86 603.346L1076.4 607.406C1076.69 608.177 1077.01 608.949 1077.42 609.842C1078.4 612.031 1079.21 614.299 1079.81 616.622L1088.18 644.595C1089.88 651.497 1091.22 658.48 1092.24 664.651C1092.85 667.777 1093.41 670.741 1093.94 673.38C1094.23 674.801 1094.47 676.1 1094.71 677.44C1095.16 679.632 1095.52 681.5 1095.73 683.043L1096.17 687.387L1095.69 687.833C1093.78 689.823 1087.2 696.481 1080.54 702.693C1073.89 708.904 1067.76 714.223 1065.85 715.847L1066.21 719.582V748.001C1066.23 752.078 1065.93 756.151 1065.32 760.181C1065.03 762.455 1064.75 764.769 1064.59 767.083C1064.43 769.397 1064.06 771.996 1063.82 774.391C1063.45 778.451 1063 782.511 1062.52 786.165L1055.74 818.644L1053.14 818.076Z",
    fill: "url(#paint146_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.728 1042.1C623.734 1033.77 594.981 1021.48 568.226 1005.56C563.963 1003.05 559.863 1000.12 556.046 997.445C553.854 995.902 551.662 994.359 549.469 992.897L540.172 986.401L531.362 978.891C529.332 977.104 527.302 975.44 525.313 973.735C521.537 970.701 517.919 967.475 514.473 964.072L499.248 948.36C480.26 927.443 464.173 904.064 451.423 878.854C446.952 870.723 443.098 862.268 439.893 853.561C438.512 850.15 437.172 846.74 435.833 843.451C434.199 839.629 432.842 835.694 431.773 831.678C431.204 829.607 430.636 827.618 429.986 825.628C429.337 823.639 428.728 821.568 428.119 819.335C426.982 815.641 425.845 811.946 424.993 808.292C416.042 771.502 413.991 733.371 418.943 695.832L419.918 686.494C420.283 684.302 420.689 682.435 421.055 680.648L426.617 653.934L434.412 655.558L428.809 682.313C428.484 683.977 428.078 685.723 427.794 687.55L426.82 696.847C421.985 733.436 423.981 770.605 432.707 806.465C433.519 809.957 434.615 813.448 435.711 816.981C436.32 819.051 436.97 821.041 437.578 823.274C438.187 825.507 438.796 827.333 439.405 829.485C440.339 833.152 441.533 836.747 442.978 840.244C444.44 843.654 445.779 847.105 447.038 850.597C450.137 858.988 453.869 867.131 458.203 874.956C470.678 899.574 486.439 922.382 505.054 942.757L520.116 958.347C523.242 961.514 526.693 964.397 530.347 967.442C532.418 969.187 534.407 970.933 536.559 972.72L545.003 979.946L553.935 986.117L560.593 990.786C564.41 993.506 568.348 996.267 572.408 998.662C624.436 1030.61 684.757 1046.43 745.766 1044.13C750.516 1044.13 755.306 1043.57 759.975 1043.08C762.736 1042.79 765.416 1042.51 768.095 1042.31L779.219 1041.21L789.816 1039.1L797.732 1037.56C802.401 1036.7 806.867 1035.89 811.171 1034.67L832.079 1028.42C858.068 1019.78 882.783 1007.7 905.563 992.491C913.29 987.612 920.658 982.185 927.608 976.252C930.532 973.897 933.414 971.542 936.297 969.309C939.284 966.963 942.106 964.412 944.741 961.677C946.284 960.093 947.867 958.51 949.491 957.048L954.079 952.623C956.759 950.065 959.438 947.548 961.874 944.909C986.967 918.063 1006.9 886.821 1020.66 852.749L1024.52 843.776C1025.09 842.274 1025.61 840.569 1026.1 838.945L1034.22 812.88L1041.81 815.316L1033.69 841.3C1033.13 843.045 1032.6 844.872 1031.91 846.74L1027.85 855.712C1013.89 890.758 993.558 922.915 967.883 950.552C965.325 953.354 962.524 955.993 959.763 958.672L955.175 963.138C953.511 964.64 952.049 966.102 950.547 967.604C947.678 970.608 944.598 973.403 941.331 975.967C938.489 978.16 935.647 980.433 932.805 982.748C925.631 988.823 918.019 994.359 910.029 999.312C886.626 1014.92 861.226 1027.31 834.515 1036.14L813.363 1042.43C808.682 1043.71 803.939 1044.75 799.153 1045.55C796.555 1046 793.957 1046.49 791.399 1047.06L780.356 1049.21L768.785 1050.39C766.024 1050.59 763.385 1050.83 760.665 1051.12C755.875 1051.64 750.881 1052.13 745.847 1052.25C714.827 1052.96 683.85 1049.55 653.728 1042.1Z",
    fill: "url(#paint147_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.704 1064.55H647.176C623.832 1057.53 593.789 1047.54 568.049 1032.08L562.527 1028.99C558.429 1026.86 554.445 1024.51 550.591 1021.97L535.326 1011.37C528.169 1006.6 521.383 1001.29 515.027 995.496C512.672 993.466 510.398 991.436 508.084 989.568L501.954 984.371C500.127 982.707 498.787 981.326 497.447 979.946L475.036 956.114L458.797 935.815L483.643 916.043L504.187 941.255L520.426 958.022C521.238 958.875 522.05 959.768 522.984 960.58L528.424 965.168C530.698 967.035 533.255 969.228 535.854 971.542C541.202 976.407 546.901 980.872 552.905 984.899L568.617 995.78C571.57 997.707 574.619 999.482 577.752 1001.1C579.904 1002.28 582.055 1003.45 584.207 1004.71C606.902 1018.19 634.306 1027.28 655.824 1033.78C677.707 1038.69 706.085 1044.17 732.353 1043.57C734.951 1043.57 737.387 1043.57 739.823 1043.57C743.42 1043.75 747.025 1043.75 750.622 1043.57L768.77 1041.86C776.219 1041.31 783.616 1040.2 790.897 1038.53C794.266 1037.8 797.596 1037.15 800.843 1036.58L808.03 1035.2L810.993 1034.31L837.098 1026.47L863.528 1015.75L875.505 1045.19L847.086 1056.68L820.372 1064.8C818.504 1065.37 816.636 1065.94 814.688 1066.38L806.568 1067.97C803.32 1068.53 800.356 1069.14 797.271 1069.75C788.673 1071.77 779.932 1073.13 771.125 1073.81L753.464 1075.48C748.791 1075.82 744.102 1075.93 739.417 1075.8C737.266 1075.8 735.114 1075.8 732.962 1075.8C703.203 1076.49 672.063 1070.44 648.313 1065.08L647.704 1064.55Z",
    fill: "url(#paint148_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.28 813.285L1039.89 786.53C1040.21 784.866 1040.62 783.12 1040.9 781.293L1041.88 771.996C1046.69 735.406 1044.69 698.241 1035.99 662.377C1035.18 658.886 1034.08 655.394 1032.99 651.862C1032.38 649.792 1031.73 647.802 1031.12 645.569C1030.51 643.336 1029.9 641.509 1029.29 639.358C1028.33 635.7 1027.13 632.107 1025.72 628.599C1024.26 625.189 1022.92 621.738 1021.66 618.287C1018.55 609.9 1014.82 601.757 1010.49 593.927C998.073 569.242 982.367 546.353 963.805 525.883L948.742 510.333C945.492 507.114 942.077 504.065 938.511 501.198C936.441 499.452 934.452 497.747 932.3 495.92L923.855 488.734L914.923 482.523L908.265 477.854C904.449 475.174 900.511 472.373 896.451 469.977C844.423 438.034 784.101 422.211 723.093 424.506C718.343 424.506 713.552 425.115 708.884 425.562C706.163 425.846 703.443 426.13 700.764 426.333L689.68 427.429L679.084 429.54L670.964 431.083C666.451 431.825 661.979 432.801 657.566 434.006L636.658 440.218C610.656 448.848 585.939 460.948 563.174 476.189C555.437 481.054 548.068 486.482 541.128 492.429C538.205 494.784 535.323 497.138 532.4 499.371C529.434 501.729 526.627 504.278 523.996 507.004C522.412 508.587 520.87 510.171 519.246 511.632L514.658 516.058C511.938 518.615 509.299 521.133 506.863 523.812C481.711 550.736 461.752 582.077 447.994 616.257L444.137 625.229C443.569 626.731 443.041 628.436 442.554 630.06L434.434 656.125L426.883 653.73L435.003 627.746C435.53 625.96 436.099 624.133 436.789 622.265L440.849 613.293C454.843 578.167 475.23 545.941 500.976 518.25C503.534 515.449 506.294 512.81 509.096 510.13C510.598 508.669 512.181 507.207 513.684 505.664C515.186 504.121 516.81 502.7 518.312 501.198C521.191 498.205 524.27 495.411 527.528 492.835C530.37 490.683 533.212 488.369 536.054 486.055C543.227 479.98 550.84 474.443 558.83 469.49C582.157 453.9 607.474 441.514 634.1 432.667L655.252 426.374C659.962 424.993 664.793 424.141 669.462 423.248C672.06 422.801 674.659 422.314 677.216 421.745L688.259 419.594L699.83 418.457L707.95 417.686C712.74 417.198 717.734 416.671 722.768 416.549C785.275 414.239 847.07 430.454 900.389 463.157C904.692 465.674 908.793 468.597 912.569 471.277C914.761 472.819 916.953 474.362 919.146 475.824L928.443 482.32L937.253 489.83C939.283 491.617 941.313 493.322 943.302 494.987C947.078 498.021 950.696 501.246 954.142 504.649L969.529 520.524C988.525 541.42 1004.61 564.786 1017.35 589.989C1021.81 598.128 1025.66 606.582 1028.88 615.282C1030.27 618.693 1031.6 622.103 1032.94 625.392C1034.58 629.226 1035.94 633.174 1037 637.206C1037.57 639.236 1038.14 641.266 1038.79 643.215C1039.44 645.163 1040.05 647.478 1040.66 649.507C1041.8 653.202 1042.93 656.897 1043.78 660.551C1052.75 697.339 1054.79 735.476 1049.79 773.011L1048.86 782.348C1048.49 784.541 1048.09 786.408 1047.68 788.195L1042.16 814.909L1034.28 813.285Z",
    fill: "url(#paint149_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.957 552.598L964.373 527.386L948.134 510.618C947.322 509.752 946.469 508.899 945.576 508.06L940.176 503.473C937.862 501.605 935.304 499.413 932.706 497.139C927.369 492.248 921.669 487.77 915.654 483.741L899.943 472.861C897.385 471.115 894.178 469.369 890.808 467.542L884.353 463.97C861.658 450.491 834.253 441.356 812.736 434.86C790.813 429.947 762.474 424.466 736.207 425.075C733.608 425.075 731.173 425.075 728.737 425.075C725.139 424.888 721.535 424.888 717.937 425.075L699.79 426.781C692.339 427.342 684.943 428.469 677.663 430.15C674.293 430.841 670.964 431.49 667.716 432.058L660.53 433.439L657.567 434.332L631.421 442.168L605.031 452.886L593.055 423.451L621.474 411.962L648.188 403.842C650.015 403.274 651.923 402.705 653.872 402.259L661.992 400.675C665.28 400.147 668.244 399.498 671.289 398.889C679.901 396.869 688.656 395.512 697.475 394.829L715.136 393.164C719.81 392.831 724.499 392.736 729.183 392.88H735.638C765.397 392.19 796.537 398.239 820.247 403.558H820.815H821.343C844.647 410.581 874.731 420.569 900.47 435.834C902.216 436.849 904.084 437.905 905.992 438.92C910.091 441.051 914.075 443.395 917.928 445.943L933.193 456.58C940.349 461.339 947.135 466.632 953.493 472.414C955.847 474.444 958.121 476.474 960.435 478.342L966.525 483.538C968.393 485.203 969.732 486.583 971.072 488.004L993.645 512.405L1009.88 532.704L984.957 552.598Z",
    fill: "url(#paint150_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.173 1109.21C580.847 1095.41 530.334 1069.52 487.393 1033.5C484.348 1030.86 481.425 1028.42 478.826 1026.19C474.361 1022.41 470.707 1019.29 467.946 1016.77L461.531 1010.15L465.835 1006.09L472.128 1012.59C474.685 1014.98 478.299 1018.03 482.683 1021.72L491.331 1029.07C514.645 1048.32 540.108 1064.8 567.21 1078.2C605.848 1096.54 647.197 1108.52 689.657 1113.68C738.386 1119.61 787.804 1115.94 835.123 1102.88C882.478 1089.82 926.876 1067.77 965.893 1037.92C1000.19 1012.27 1029.72 980.807 1053.14 944.949C1057.28 939.221 1061 933.196 1064.26 926.923L1067.07 921.888C1068.49 919.168 1070.03 916.529 1071.53 913.769C1074.09 909.467 1076.42 905.035 1078.51 900.493L1087.04 880.761C1087.85 878.772 1088.7 876.701 1089.6 874.874C1091.2 871.442 1092.56 867.901 1093.66 864.278L1104.17 831.068L1109.86 832.895L1099.34 865.902C1098.21 869.812 1096.75 873.615 1094.96 877.27C1094.14 879.137 1093.29 881.086 1092.48 883.076L1083.91 902.888C1081.88 907.516 1079.33 911.982 1076.65 916.732C1075.19 919.29 1073.68 921.929 1072.26 924.609L1069.46 929.684C1066.09 936.13 1062.25 942.319 1057.97 948.197C1034.28 984.582 1004.39 1016.53 969.668 1042.59C929.982 1072.8 884.875 1095.13 836.788 1108.36C788.728 1121.62 738.538 1125.34 689.048 1119.32C670.885 1117.15 652.887 1113.78 635.173 1109.21Z",
    fill: "url(#paint151_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.906 1132.27L662.778 1108.97L666.838 1109.82L670.045 1110.47C672.035 1110.92 674.43 1111.45 677.272 1111.85C680.114 1112.26 684.052 1112.54 688.437 1113.03C696.76 1113.92 706.178 1114.98 716.856 1115.75C756.696 1117.21 796.53 1112.71 835.04 1102.39L853.715 1096.83C857.632 1095.74 861.471 1094.38 865.205 1092.77L895.167 1080.59L929.108 1062.57L943.683 1053.07C953.188 1047.21 962.264 1040.68 970.844 1033.54L984.525 1022.66C985.906 1021.6 986.555 1020.95 986.758 1020.79L1003.36 1037.88C1002.08 1039.13 1000.72 1040.31 999.303 1041.41L985.743 1052.38C976.435 1060.11 966.6 1067.19 956.309 1073.57L937.228 1085.75L904.748 1102.76L874.705 1114.94C870.085 1116.9 865.338 1118.54 860.495 1119.85L841.536 1125.45C800.538 1136.51 758.11 1141.32 715.679 1139.75C704.067 1138.89 693.999 1137.8 685.92 1136.9L674.592 1135.69C670.533 1135.12 667.447 1134.47 665.011 1133.94L662.372 1133.37L657.906 1132.27Z",
    fill: "url(#paint152_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.529 1010.07L442.894 990.745L419.996 962.041C418.535 959.971 417.236 957.981 415.936 955.911L400.387 931.998C397.545 927.085 394.947 922.01 392.267 916.814C390.724 913.85 389.182 910.845 387.558 907.801C368.172 868.879 355.333 827.029 349.557 783.932C336.47 684.044 362.959 582.998 423.366 502.376C449.54 467.667 481.237 437.493 517.19 413.057L525.797 407.455C530.669 404.247 535.419 401.121 540.169 398.32L565.625 385.044C567.777 383.907 569.888 382.77 571.958 381.755L607.929 367.383L631.923 360.238L633.628 365.922L607.889 373.595L574.394 387.196L568.386 390.606L543.052 403.801C538.545 406.48 533.877 409.566 529.045 412.733C526.244 414.56 523.402 416.468 520.479 418.295C485.106 442.316 453.917 471.983 428.157 506.111C368.665 585.482 342.569 684.97 355.444 783.323C361.154 825.696 373.786 866.843 392.836 905.121C394.419 908.085 396.002 911.13 397.545 914.134C400.184 919.25 402.742 924.203 405.462 928.912L420.93 952.703C422.229 954.693 423.488 956.763 424.787 958.509L448.416 987.984L465.833 1005.97L461.529 1010.07Z",
    fill: "url(#paint153_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.135 814.789L333.684 797.128C333.278 795.098 332.872 793.068 332.588 790.713L329.502 758.234C327.497 715.683 331.696 673.067 341.966 631.726C353.262 590.805 370.424 551.736 392.918 515.734L411.796 488.533C413.258 486.503 414.72 484.838 416.059 483.295L427.914 469.451L446.062 484.879L436.034 496.612C435.587 497.18 434.938 497.952 434.207 498.764C433.476 499.576 432.38 500.875 431.487 502.133L412.811 528.645C391.741 562.445 375.648 599.104 365.026 637.491C355.405 676.33 351.44 716.354 353.253 756.326L356.298 788.196C356.298 789.495 356.744 790.916 357.028 792.256C357.313 793.596 357.434 794.327 357.637 795.301L360.52 810.16L337.135 814.789Z",
    fill: "url(#paint154_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.97 831.473L1111.03 797.573C1111.9 793.823 1112.46 790.007 1112.7 786.165C1112.9 784.094 1113.1 781.902 1113.39 779.709L1115.66 758.395C1116.05 753.411 1116.18 748.411 1116.07 743.413C1116.07 740.369 1116.07 737.324 1116.07 734.198V728.473C1116.3 721.505 1116.02 714.53 1115.22 707.605C1112.48 664.8 1102.25 622.808 1085.01 583.533C1065.57 538.454 1037.66 497.521 1002.8 462.954C967.999 428.332 926.741 400.882 881.365 382.161C841.807 365.814 799.871 355.957 757.173 352.97C727.029 351.351 696.799 353.218 667.084 358.532L655.919 360.684C650.276 361.78 645.607 362.673 642.075 363.526L633.549 366.043L631.844 360.359L640.491 357.761C644.308 356.868 649.058 355.934 654.782 354.838C658.152 354.229 661.846 353.498 665.866 352.686C696.077 347.282 726.811 345.388 757.457 347.043C800.84 350.026 843.453 360.022 883.639 376.639C929.727 395.693 971.641 423.581 1007.02 458.731C1042.42 493.833 1070.75 535.4 1090.49 581.179C1107.99 621.016 1118.37 663.614 1121.14 707.037C1121.96 714.178 1122.26 721.369 1122.04 728.554V734.238C1122.04 737.405 1122.04 740.409 1122.04 743.373C1122.14 748.588 1121.98 753.805 1121.55 759.004L1119.32 780.359C1119.03 782.551 1118.83 784.662 1118.63 786.692C1118.38 790.796 1117.78 794.871 1116.84 798.872L1109.98 832.691L1103.97 831.473Z",
    fill: "url(#paint155_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.86 616.338L1094.8 608.746C1094.8 608.746 1094.43 607.65 1093.78 606.148L1087.12 589.908C1083.21 579.598 1078.58 569.573 1073.28 559.905L1060.45 536.682L1044.21 511.795L1024.72 486.623C1022.24 483.313 1019.52 480.179 1016.6 477.245L1002.8 463.035C974.286 435.11 941.742 411.625 906.254 393.367C896.794 388.941 888.025 385.247 880.311 381.918L869.593 377.249C867.441 376.437 865.046 375.706 863.138 375.138L859.727 374.041L856.195 372.905L863.381 350.21L867.198 351.428L870.08 352.361C872.476 353.092 875.439 353.985 878.728 355.285C882.016 356.584 885.792 358.33 889.649 359.994C897.2 363.201 906.538 367.18 916.728 372.174C954.617 391.615 989.355 416.663 1019.77 446.471L1033.65 460.802C1037.32 464.402 1040.72 468.255 1043.84 472.332L1064.35 498.316L1088.71 536.885L1094.8 548.537C1100.58 558.992 1105.62 569.846 1109.86 581.017L1116.39 597.256C1117.45 599.814 1117.98 601.316 1118.1 601.885L1106.77 605.539L1101.86 616.338Z",
    fill: "url(#paint156_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.16 822.637L1066.81 836.294L1070.26 837.389L1074.6 823.732L1071.16 822.637Z",
    fill: "url(#paint157_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.66 888.354L1047.37 886.893C1047.65 886.243 1047.98 885.512 1048.26 884.741L1055.45 868.095L1058.78 869.557L1051.63 886.121C1051.31 886.893 1050.98 887.664 1050.66 888.354ZM1064.13 856.809L1060.68 855.712L1062.75 849.217L1066.21 850.313L1064.13 856.809Z",
    fill: "url(#paint158_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.621 1079.01L666.311 1075.48L669.884 1076.21L673.7 1077.02C677.021 1077.81 680.382 1078.42 683.769 1078.85H686.245L685.921 1082.46L683.444 1082.22C679.903 1081.82 676.391 1081.19 672.929 1080.35C671.549 1080.02 670.29 1079.74 669.194 1079.58L665.621 1079.01ZM699.44 1084.16L699.805 1080.55L706.585 1081.24L706.22 1084.85L699.44 1084.16ZM719.943 1085.83V1082.22C724.936 1082.42 729.646 1082.46 734.355 1082.22C739.065 1081.97 742.719 1082.22 747.063 1082.01V1085.63C742.678 1085.63 738.415 1085.63 734.274 1085.63C730.133 1085.63 725.017 1086.03 719.943 1085.83ZM757.618 1085.18L757.375 1081.57C764.074 1081.12 770.854 1080.47 777.674 1079.58L778.121 1083.19C771.26 1084.04 764.358 1084.85 757.618 1085.18ZM791.64 1081.12L791.072 1077.55C793.305 1077.18 795.538 1076.82 797.771 1076.37L798.42 1079.94L791.64 1081.12ZM811.94 1077.06L811.128 1073.53C820.019 1071.54 828.87 1069.22 837.395 1066.62L838.451 1070.08C829.844 1072.96 820.831 1075.27 811.859 1077.3L811.94 1077.06ZM848.235 1066.95L847.058 1063.5C853.513 1061.35 859.928 1058.95 866.14 1056.43L867.52 1059.76C861.146 1062.61 854.65 1065 848.154 1067.19L848.235 1066.95ZM880.106 1054.28L878.563 1051.03L884.003 1048.44L884.612 1048.11L886.358 1051.28L885.668 1051.64L880.106 1054.28ZM898.416 1044.99L896.751 1041.78C904.869 1037.87 912.685 1033.36 920.136 1028.3L922.247 1031.26C914.627 1036.49 906.635 1041.16 898.335 1045.23L898.416 1044.99ZM930.895 1025.7L928.906 1022.7L938 1016.77L945.429 1010.88L947.662 1013.72L938.284 1020.91L930.895 1025.7ZM958.381 1005.4L956.147 1002.56C957.934 1001.18 959.68 999.758 961.385 998.296L963.74 1001.06C961.75 1002.68 959.964 1004.14 958.137 1005.56L958.381 1005.4ZM973.889 991.8L971.372 989.202L976.447 984.29L981.847 979.012L988.302 972.8C989.073 971.988 989.845 971.054 990.657 970.161L993.377 972.475C992.565 973.45 991.753 974.383 990.86 975.317L984.364 981.651L978.964 986.847L973.889 991.8ZM1000.04 964.68L997.274 962.366L1004.58 953.759C1006.53 951.648 1008.44 949.374 1010.39 946.816L1013.27 949.009C1011.24 951.688 1009.21 954.003 1007.26 956.154L1000.04 964.68ZM1021.15 937.763L1018.18 935.692L1021.71 930.699L1022.12 930.13L1025.04 932.201L1024.64 932.81C1023.22 934.637 1022.08 936.22 1020.9 937.925L1021.15 937.763ZM1032.8 920.874L1029.75 918.925C1031.16 916.777 1032.45 914.554 1033.61 912.266L1043.07 895.255L1046.24 897.001L1036.57 914.337C1035.36 916.644 1034.02 918.88 1032.55 921.036L1032.8 920.874Z",
    fill: "url(#paint159_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.16 1074.75L645.891 1071.21L659.938 1074.14L659.207 1077.67L645.16 1074.75Z",
    fill: "url(#paint160_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.994 1074.7L631.312 1070.36L632.409 1066.95L646.091 1071.25L644.994 1074.7Z",
    fill: "url(#paint161_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.445 1066.3L611.909 1064.23L613.005 1060.78L619.501 1062.85L618.445 1066.3ZM599.201 1058.83L582.596 1051.68L580.363 1050.75L581.865 1047.46L583.977 1048.36L600.622 1055.54L599.201 1058.83Z",
    fill: "url(#paint162_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.54 1046.08L554.61 1036.62C552.223 1035.4 549.905 1034.04 547.668 1032.56L549.616 1029.52C551.765 1030.98 553.988 1032.34 556.275 1033.58L573.286 1043.04L571.54 1046.08ZM536.381 1024.89L535.772 1024.48L530.819 1020.99L532.849 1018.03C534.595 1019.21 536.259 1020.34 537.843 1021.52L538.452 1021.93L536.381 1024.89ZM519.573 1013.12C516.894 1011.05 514.539 1009.06 512.387 1007.11L503.861 999.84L506.216 997.079L514.782 1004.39C517.007 1006.46 519.337 1008.41 521.766 1010.23L519.573 1013.12ZM496.107 993.222C495.133 992.41 494.158 991.598 493.224 990.705L486.932 984.209C485.226 982.382 483.44 980.596 481.694 978.809C479.949 977.023 478.406 975.439 476.782 973.694L479.38 971.217C481.004 972.922 482.669 974.587 484.293 976.251L489.53 981.692L495.742 988.147L498.421 990.461L496.107 993.222ZM467.688 963.544C466.172 961.839 464.71 960.052 463.303 958.185L466.145 955.992C467.566 957.779 468.946 959.524 470.408 961.23L467.688 963.544ZM454.94 947.304L447.754 937.885L442.76 930.577L445.805 928.588L451.732 937.682L457.579 945.071L454.94 947.304ZM437.401 922.011C432.235 914.415 427.635 906.45 423.638 898.179L426.845 896.555C430.785 904.656 435.289 912.47 440.324 919.94L437.401 922.011ZM417.386 886.121L416.98 885.431C416.086 883.563 415.193 881.736 414.341 879.869L417.629 878.366L420.187 883.807L420.552 884.416L417.386 886.121ZM408.9 867.283C406.302 860.99 403.907 854.535 401.714 847.998L405.125 846.861C407.276 853.276 409.672 859.691 412.229 865.943L408.9 867.283ZM398.548 838.214C395.949 829.607 393.594 820.715 391.605 811.702L395.097 810.931C397.127 819.822 399.441 828.673 402.039 837.158L398.548 838.214ZM388.844 798.264C388.438 796.031 388.073 793.758 387.708 791.525L391.24 790.956C391.605 793.149 392.011 795.382 392.417 797.614L388.844 798.264ZM385.718 777.964C384.825 771.103 384.176 764.242 383.688 757.665L387.302 757.421C387.789 764.079 388.438 770.9 389.291 777.721L385.718 777.964ZM383.161 747.231C383.161 742.846 382.958 738.583 383.161 734.442C383.161 729.692 383.161 724.901 383.161 719.826H386.774C386.571 724.82 386.571 729.57 386.774 734.239C386.977 738.908 386.774 742.643 386.774 746.987L383.161 747.231ZM384.054 706.104C384.257 703.749 384.5 701.475 384.744 699.283L388.317 699.689C388.073 701.881 387.829 704.114 387.626 706.469L384.054 706.104ZM386.246 685.804C386.246 684.992 386.246 684.18 386.449 683.368C386.879 679.829 387.516 676.318 388.357 672.853C388.641 671.432 388.926 670.214 389.129 669.118L389.859 665.504L393.391 666.235L392.661 669.808C392.661 670.863 392.214 672.163 391.849 673.624C391.049 676.941 390.453 680.303 390.062 683.693C390.062 684.464 390.062 685.276 389.819 686.169L386.246 685.804Z",
    fill: "url(#paint163_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.919 645.203L390.996 659.233L394.533 659.97L397.457 645.94L393.919 645.203Z",
    fill: "url(#paint164_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.372 631.412L394.039 645.073L397.483 646.165L401.817 632.505L398.372 631.412Z",
    fill: "url(#paint165_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.9 619.586L402.449 618.49L404.52 611.994L407.93 613.09L405.9 619.586ZM413.208 600.707L409.879 599.246L417.024 582.681C417.349 581.91 417.674 581.138 417.999 580.448L421.287 581.91C421.003 582.559 420.678 583.29 420.394 584.062L413.208 600.707Z",
    fill: "url(#paint166_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.794 573.304L422.668 571.558L432.087 554.587C433.306 552.21 434.662 549.906 436.147 547.685L439.192 549.634C437.717 551.777 436.362 554 435.132 556.292L425.794 573.304ZM446.784 538.469L443.82 536.358L444.267 535.749C445.444 534.166 446.581 532.501 447.718 530.796L450.722 532.867L447.23 537.86L446.784 538.469ZM458.517 521.783L455.634 519.591C457.664 516.911 459.694 514.556 461.643 512.405L468.87 503.879L471.63 506.193L464.444 514.881C462.374 516.992 460.384 519.266 458.517 521.864V521.783ZM478.248 498.438L475.528 496.084C476.34 495.109 477.152 494.176 478.004 493.242L484.744 487.03L490.143 481.793C491.808 480.128 493.513 478.504 495.218 476.88L497.695 479.479L492.661 484.351L487.261 489.628L480.684 495.84C479.831 496.693 479.019 497.586 478.248 498.52V498.438ZM507.52 470.263L505.043 467.745C506.789 466.284 508.575 464.822 510.402 463.401L512.595 466.243C510.93 467.461 509.103 468.882 507.52 470.344V470.263ZM523.475 457.596L521.242 454.754L530.621 447.568L538.01 442.777L539.958 445.822L530.864 451.709L523.475 457.596ZM548.606 440.178L546.495 437.215C554.097 432.071 562.062 427.485 570.327 423.492L571.991 426.7C563.879 430.65 556.064 435.182 548.606 440.26V440.178ZM584.13 420.366L582.384 417.199L583.075 416.834L588.637 414.195L590.179 417.483C588.352 418.295 586.526 419.189 584.739 420.041L584.13 420.366ZM602.603 412.246L601.222 408.917C607.515 406.359 614.011 403.923 620.507 401.731L621.644 405.182C615.229 407.212 608.814 409.607 602.481 412.124L602.603 412.246ZM631.347 402.056L630.291 398.605C638.898 395.966 647.83 393.652 656.802 391.622L657.614 395.154C648.683 397.021 639.873 399.336 631.347 401.934V402.056ZM670.89 392.474L670.241 388.902L676.98 387.724L677.589 391.297C675.559 391.541 673.123 391.906 670.89 392.353V392.474ZM691.19 389.348L690.703 385.735C697.564 384.882 704.466 384.233 711.205 383.745V387.359C704.628 387.684 697.807 388.374 691.027 389.226L691.19 389.348ZM721.436 386.547V382.933C725.861 382.933 730.124 382.73 734.265 382.73C738.406 382.73 743.765 382.73 748.881 382.73V386.344C743.887 386.141 739.178 386.1 734.468 386.344C729.759 386.587 725.78 386.547 721.436 386.547ZM762.035 387.399L762.36 383.786L769.18 384.517L768.774 388.09L762.035 387.399ZM782.335 389.592L782.659 386.019H785.095C788.647 386.439 792.171 387.062 795.651 387.887C797.031 388.211 798.29 388.496 799.386 388.658L803 389.429L802.269 392.962L798.696 392.231L794.636 391.419C791.318 390.616 787.956 390.006 784.568 389.592H782.335Z",
    fill: "url(#paint167_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.727 394.666L809.457 391.134L823.464 394.057L822.733 397.589L808.727 394.666Z",
    fill: "url(#paint168_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.216 401.893L822.574 397.549L823.67 394.098L837.352 398.442L836.216 401.893Z",
    fill: "url(#paint169_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.678 421.381L884.567 420.447L867.921 413.261L869.342 409.972L885.947 417.118L888.18 418.051L886.678 421.381ZM855.539 408.023L849.043 405.953L850.098 402.542L856.594 404.572L855.539 408.023Z",
    fill: "url(#paint170_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.43 802.405L1076.16 798.873C1076.16 797.777 1076.6 796.478 1076.97 795.016C1077.77 791.7 1078.37 788.337 1078.76 784.948C1078.76 784.176 1078.76 783.364 1078.96 782.471L1082.57 782.837C1082.57 783.649 1082.57 784.461 1082.37 785.273C1081.95 788.824 1081.32 792.348 1080.5 795.828C1080.18 797.209 1079.89 798.467 1079.69 799.523L1078.96 803.136L1075.43 802.405ZM1080.5 768.911C1080.7 766.719 1080.95 764.486 1081.19 762.131L1084.81 762.496C1084.56 764.851 1084.32 767.125 1084.07 769.317L1080.5 768.911ZM1082.13 748.611C1082.37 743.618 1082.37 738.908 1082.13 734.199C1081.88 729.489 1082.13 725.795 1082.13 721.491H1085.7C1085.7 725.876 1085.94 730.179 1085.9 734.28C1085.9 739.03 1085.9 743.821 1085.9 748.936L1082.13 748.611ZM1081.56 711.341C1081.11 704.683 1080.46 697.862 1079.61 691.042L1083.18 690.595C1084.03 697.456 1084.72 704.318 1085.17 710.895L1081.56 711.341ZM1077.5 677.644C1077.13 675.451 1076.73 673.219 1076.32 670.986L1079.85 670.336C1080.3 672.569 1080.66 674.842 1081.07 677.075L1077.5 677.644ZM1073.44 657.669C1071.49 648.778 1069.13 639.927 1066.54 631.442L1069.99 630.386C1072.63 638.993 1074.98 647.885 1076.97 656.898L1073.44 657.669ZM1063.45 621.739C1061.3 615.324 1058.9 608.909 1056.35 602.657L1059.72 601.317C1062.27 607.61 1064.71 614.106 1066.86 620.602L1063.45 621.739ZM1050.95 590.234C1050.09 588.407 1049.24 586.62 1048.35 584.793L1048.02 584.184L1051.19 582.479L1051.55 583.169C1052.49 585.037 1053.38 586.864 1054.23 588.731L1050.95 590.234ZM1041.73 572.045C1037.78 563.94 1033.27 556.125 1028.21 548.66L1031.17 546.589C1036.33 554.19 1040.93 562.155 1044.94 570.421L1041.73 572.045ZM1022.61 540.053L1016.68 530.959L1010.83 523.57L1013.64 521.337L1020.82 530.715L1025.61 538.104L1022.61 540.053ZM1002.31 512.811C1000.93 511.024 999.507 509.279 998.248 507.573L1000.97 505.259C1002.47 507.005 1003.93 508.751 1005.35 510.618L1002.31 512.811ZM988.951 497.586C987.327 495.881 985.663 494.216 984.039 492.552L978.801 487.111L972.549 480.656C971.737 479.925 970.844 479.113 969.91 478.342L972.265 475.581L975.107 478.098L981.4 484.635L986.637 490.034C988.261 491.699 989.925 493.364 991.549 495.109L988.951 497.586ZM962.44 471.805L953.873 464.498C951.722 462.508 949.448 460.438 946.89 458.651L949.083 455.809C951.762 457.839 954.117 459.869 956.269 461.777L964.795 469.045L962.44 471.805ZM935.807 450.897C934.061 449.679 932.397 448.542 930.813 447.365L930.204 446.959L932.275 443.995L932.884 444.441L937.837 447.892L935.807 450.897ZM919.161 439.326C917.031 437.853 914.822 436.497 912.544 435.266L895.492 425.806L897.278 422.64L914.208 432.099C916.587 433.316 918.891 434.672 921.11 436.159L919.161 439.326Z",
    fill: "url(#paint171_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.14 808.812L1071.21 822.84L1074.74 823.58L1077.68 809.553L1074.14 808.812Z",
    fill: "url(#paint172_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.48 1146.24L638.292 1142.18L653.801 1145.43L652.989 1149.49L637.48 1146.24ZM668.579 1152.7L669.351 1148.64L670.325 1148.88L684.941 1150.38L684.535 1154.44L668.579 1152.7ZM700.328 1156.15L700.734 1152.09L707.676 1152.82C710.572 1153.17 713.487 1153.35 716.405 1153.35V1157.41C713.351 1157.44 710.299 1157.27 707.27 1156.88L700.328 1156.15ZM732.239 1157.45V1153.39H748.153V1157.45H732.239ZM764.149 1156.55L763.784 1152.49L779.496 1150.99L779.902 1155.05L764.149 1156.55ZM795.898 1153.43L795.248 1149.37C797.319 1149.04 799.308 1148.6 801.46 1148.19L806.372 1147.26L810.798 1146.36L811.528 1150.42L807.103 1151.32L802.272 1152.25L795.898 1153.43ZM827.118 1147.34L826.347 1143.28L834.467 1141.73L841.734 1139.74L842.83 1143.56L835.319 1145.59L827.118 1147.34ZM858.014 1139.22L856.837 1135.44C861.831 1133.86 866.824 1132.15 871.818 1130.41L873.117 1134.14C868.083 1135.85 863.049 1137.63 858.014 1139.14V1139.22ZM888.098 1128.58L886.637 1124.89C891.508 1122.98 896.421 1120.83 901.252 1118.88L902.836 1122.53C897.923 1124.52 893.011 1126.55 888.098 1128.5V1128.58ZM917.37 1115.95L915.665 1112.38C920.456 1110.11 925.165 1107.79 929.875 1105.4L931.701 1108.93C926.951 1111.28 922.161 1113.6 917.37 1115.87V1115.95ZM945.789 1101.34L943.759 1097.93L945.992 1096.67C949.727 1094.4 953.503 1092.08 957.198 1089.69L959.349 1093.02C955.614 1095.45 951.798 1097.77 947.982 1100.08L945.789 1101.34ZM972.625 1084.16L970.352 1080.92C974.655 1077.87 978.959 1074.79 983.181 1071.66L985.536 1074.83C981.354 1077.91 977.01 1081.04 972.666 1084.08L972.625 1084.16ZM998.162 1065.08L995.686 1062C999.745 1058.71 1003.81 1055.34 1007.87 1051.93L1010.46 1054.93C1006.48 1058.3 1002.38 1061.67 998.203 1065L998.162 1065.08ZM1022.52 1044.42L1019.8 1041.45C1023.86 1037.88 1027.56 1034.27 1031.33 1030.61L1034.09 1033.46C1030.28 1037.07 1026.38 1040.72 1022.48 1044.26L1022.52 1044.42ZM1045.26 1021.93L1042.25 1019.37L1052.56 1007.19L1055.57 1009.75L1045.26 1021.93ZM1065.84 997.769L1062.84 995.171C1064.5 993.263 1066.12 991.354 1067.63 989.365L1072.26 982.666L1075.54 984.94L1070.79 991.476C1069.37 993.709 1067.55 995.536 1065.8 997.688L1065.84 997.769ZM1084.6 971.907L1081.35 969.634L1090.24 956.723L1093.73 958.631L1092.27 960.864L1084.6 971.907ZM1101.45 944.787L1097.79 942.757L1101.57 935.977C1102.83 933.582 1104.21 931.186 1105.63 928.872L1109.08 930.821C1107.74 933.135 1106.4 935.449 1105.02 937.885L1101.45 944.787ZM1116.47 916.611L1112.85 915.028L1119.15 900.453L1122.76 902.036L1116.47 916.611ZM1129.05 887.461L1125.44 885.878L1127.1 882.021L1130.56 871.059L1134.37 872.277L1130.8 883.401L1129.05 887.461ZM1139.16 857.133L1135.39 855.956L1140.18 840.812L1143.95 841.99L1139.16 857.133Z",
    fill: "url(#paint173_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.849 1144.01L611.705 1139.22L612.923 1135.4L628.067 1140.23L626.849 1144.01ZM596.562 1134.39L585.478 1130.85L581.418 1129.11L583.002 1125.45L587.062 1127.16L597.983 1130.61L596.562 1134.39ZM566.843 1122.81L552.228 1116.52L553.811 1112.87L568.386 1119.16L566.843 1122.81ZM537.856 1109.21C535.582 1107.91 533.227 1106.57 530.832 1105.15L524.011 1101.34L525.96 1097.89L532.7 1101.66C535.136 1102.92 537.49 1104.3 539.845 1105.72L537.856 1109.21ZM510.167 1093.75L507.934 1092.28L496.932 1084.85L499.165 1081.57L512.075 1090.46L510.167 1093.75ZM483.9 1075.56L477.16 1070.89C475.008 1069.3 473.1 1067.6 471.07 1065.89L473.628 1062.89C475.577 1064.55 477.688 1066.18 479.474 1067.68L486.133 1072.31L483.9 1075.56ZM458.972 1055.58L446.792 1045.31L449.35 1042.27L461.53 1052.58L458.972 1055.58ZM435.343 1034.15C431.689 1030.37 428.035 1026.47 424.422 1022.53L427.345 1019.85C430.918 1023.91 434.572 1027.61 438.185 1031.34L435.343 1034.15ZM413.866 1010.56C410.456 1006.5 407.046 1002.44 403.717 998.378L406.843 995.901C410.131 999.961 413.501 1004.02 416.871 1008.08L413.866 1010.56ZM393.973 985.67C390.806 981.61 387.68 977.104 384.676 972.719L387.924 970.445C390.928 974.789 394.013 979.052 397.18 983.275L393.973 985.67ZM375.825 959.443C373.389 955.708 371.034 951.932 368.72 948.116L367.462 945.883L370.913 943.853L372.171 946.126C374.404 949.861 376.759 953.597 379.154 957.291L375.825 959.443ZM359.91 931.754C357.474 927.004 355.12 922.254 352.846 917.463L356.459 915.758C358.692 920.508 361.006 925.258 363.442 929.927L359.91 931.754ZM346.31 902.888C344.198 898.016 342.25 893.104 340.26 888.15L343.955 886.689C345.863 891.601 348.015 896.473 349.963 901.345L346.31 902.888ZM334.536 873.21C332.79 868.176 331.085 863.101 329.502 858.107L333.277 856.889C334.861 861.883 336.525 866.876 338.312 871.87L334.536 873.21ZM324.914 842.801C324.224 840.324 323.493 837.807 322.884 835.331L321.26 827.211L325.32 826.44L326.903 834.559C327.512 836.914 328.202 839.391 328.893 841.867L324.914 842.801ZM318.296 811.621L317.444 807.155C317.159 805.531 316.835 803.948 316.51 802.324C316.185 800.7 315.657 798.264 315.292 795.949L319.352 795.3C319.677 797.37 320.083 799.36 320.529 801.552C320.976 803.745 321.179 804.8 321.463 806.424L322.316 810.849L318.296 811.621ZM313.627 779.953L312.125 764.241L316.185 763.835L317.647 779.547L313.627 779.953ZM311.191 748.205V732.29H315.251V748.164L311.191 748.205ZM311.191 716.415C311.193 713.363 311.369 710.313 311.719 707.281L312.45 700.419L316.51 700.825L315.779 707.727C315.466 710.626 315.303 713.54 315.292 716.456L311.191 716.415ZM314.115 684.626L315.901 668.671L319.961 669.442L319.758 670.416L318.215 685.032L314.115 684.626ZM319.108 653.081L322.356 637.531L326.416 638.343L323.168 653.893L319.108 653.081Z",
    fill: "url(#paint174_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.526 628.071L324.75 626.894L329.541 611.75L333.316 612.928L328.526 628.071ZM338.107 597.784L334.331 596.607L337.864 585.483L339.609 581.423L343.263 583.006L341.599 587.066L338.107 597.784ZM349.556 568.431L345.943 566.848L352.236 552.272L355.889 553.856L349.556 568.431ZM362.954 540.011L359.503 538.063C360.843 535.748 362.182 533.434 363.563 530.998L367.338 524.218L370.83 526.126L367.014 532.703C365.674 535.18 364.293 537.575 362.954 539.89V540.011ZM378.463 512.282L374.971 510.374L376.433 508.141L384.106 497.098L387.354 499.371L378.463 512.282ZM396.448 486.339L393.159 484.066L397.869 477.326C399.452 475.215 401.117 473.266 402.822 471.236L405.826 473.835C404.202 475.743 402.578 477.651 401.076 479.64L396.448 486.339ZM416.179 461.736L413.134 459.178L423.446 446.998L426.451 449.556L416.179 461.736ZM437.372 438.391L434.611 435.549C438.387 431.855 442.244 428.201 446.222 424.628L448.861 427.551C444.964 431.205 441.107 434.616 437.372 438.27V438.391ZM460.716 417.077L458.158 414.072C462.218 410.621 466.278 407.252 470.338 403.923L472.815 407.008C468.795 410.175 464.735 413.545 460.716 416.955V417.077ZM485.441 397.345L483.086 394.179C487.146 391.012 491.653 387.886 495.997 384.841L498.27 388.129C493.926 391.012 489.663 394.097 485.441 397.224V397.345ZM511.424 379.319L509.272 375.99C513.008 373.595 516.783 371.24 520.64 368.926L522.873 367.667L524.863 371.078L522.63 372.377C518.894 374.366 515.119 376.802 511.424 379.198V379.319ZM538.788 363.648L537.002 360.075C541.711 357.68 546.502 355.325 551.292 353.052L552.998 356.665C548.207 358.776 543.497 361.09 538.788 363.526V363.648ZM567.207 350.128L565.664 346.515C570.591 344.404 575.503 342.374 580.402 340.425L581.864 344.12C577.154 345.947 572.242 347.936 567.37 350.007L567.207 350.128ZM596.682 338.598L595.383 334.863C600.417 333.077 605.452 331.372 610.486 329.788L611.704 333.605C606.832 335.026 601.838 336.731 596.845 338.476L596.682 338.598ZM626.847 328.936L625.751 325.119L633.221 323.049L641.341 321.465L642.112 325.525L633.993 327.068C631.963 327.555 629.486 328.205 626.847 328.936ZM657.703 322.318L656.972 318.258L661.397 317.405L666.228 316.431C668.38 316.025 670.288 315.578 672.602 315.254L673.252 319.314L667.04 320.491L662.128 321.465L657.703 322.318ZM689.207 317.527L688.761 313.467L704.513 311.965L704.879 316.025L689.207 317.527ZM720.55 315.132V311.072H736.465V315.132H720.55ZM752.258 315.132V311.072C755.324 311.053 758.389 311.229 761.433 311.6L768.294 312.331L767.888 316.39L760.824 315.863C757.981 315.519 755.121 315.343 752.258 315.335V315.132ZM783.681 318.055L784.128 313.995L800.083 315.781L799.312 319.841H798.337L783.681 318.055ZM814.821 323.008L815.633 318.948L831.182 322.196L830.37 326.256L814.821 323.008Z",
    fill: "url(#paint175_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.45 830.459L1145.7 814.909L1149.55 815.721L1146.31 831.271L1142.45 830.459ZM1148.91 799.36L1149.11 798.385L1150.65 783.769L1154.71 784.175L1152.92 800.172L1148.91 799.36ZM1152.32 767.976L1153.05 761.074C1153.36 758.175 1153.52 755.262 1153.53 752.346H1157.59C1157.59 755.398 1157.42 758.448 1157.07 761.48L1156.33 768.342L1152.32 767.976ZM1153.57 736.471V720.597H1157.63V736.512L1153.57 736.471ZM1152.68 704.966L1151.22 689.254L1155.28 688.848L1156.74 704.601L1152.68 704.966ZM1149.6 673.502C1149.23 671.431 1148.78 669.442 1148.38 667.249C1147.97 665.057 1147.73 664.002 1147.44 662.378L1146.59 657.952L1150.65 657.181L1151.5 661.647C1151.79 663.271 1152.11 664.895 1152.44 666.478C1152.76 668.061 1153.29 670.741 1153.66 672.852L1149.6 673.502ZM1143.38 642.322L1141.8 634.202C1141.19 631.847 1140.5 629.37 1139.81 626.894L1143.63 625.838C1144.36 628.315 1145.01 630.832 1145.7 633.308L1147.28 641.428L1143.38 642.322ZM1135.26 611.872C1133.68 606.878 1132.02 601.885 1130.23 596.891L1133.96 595.551C1135.75 600.585 1137.46 605.66 1139.04 610.654L1135.26 611.872ZM1124.71 582.072C1122.8 577.16 1120.65 572.288 1118.7 567.416L1122.35 565.873C1124.46 570.745 1126.41 575.698 1128.4 580.611L1124.71 582.072ZM1112.2 553.003C1109.97 548.253 1107.66 543.503 1105.22 538.834L1108.75 537.007C1111.19 541.757 1113.54 546.507 1115.78 551.298L1112.2 553.003ZM1097.79 524.949L1096.53 522.675C1094.26 518.94 1091.94 515.205 1089.55 511.511L1092.92 509.359C1095.31 513.094 1097.67 516.87 1099.94 520.686L1101.24 522.919L1097.79 524.949ZM1080.78 498.356C1077.78 494.012 1074.69 489.749 1071.56 485.527L1074.73 483.132C1077.9 487.192 1080.98 491.698 1084.07 496.083L1080.78 498.356ZM1061.86 472.982C1058.57 468.922 1055.2 464.862 1051.83 460.802L1054.84 458.244C1058.25 462.304 1061.66 466.364 1064.99 470.424L1061.86 472.982ZM1041.36 448.947C1037.75 444.887 1034.13 441.193 1030.52 437.457L1033.32 434.656C1037.01 438.472 1040.67 442.329 1044.28 446.268L1041.36 448.947ZM1019.23 426.536L1007.05 416.224L1009.61 413.22L1021.79 423.491L1019.23 426.536ZM994.872 405.912C992.964 404.288 991.056 402.623 989.067 401.121L982.409 396.493L984.642 393.245L991.381 397.914C993.533 399.497 995.441 401.202 997.471 402.907L994.872 405.912ZM969.336 387.439L956.588 378.426L958.496 374.935L960.729 376.396L971.934 384.191L969.336 387.439ZM942.581 370.793L935.801 366.977C933.406 365.719 931.01 364.379 928.696 362.917L930.685 359.466C932.959 360.765 935.314 362.105 937.709 363.526L944.53 367.342L942.581 370.793ZM915.095 355.934L900.48 349.641L902.063 345.987L916.638 352.28L915.095 355.934ZM885.945 343.348L881.886 341.684L870.964 338.192L872.182 334.416L883.266 337.949L887.326 339.694L885.945 343.348ZM855.983 333.401L840.84 328.57L842.058 324.794L856.998 329.707L855.983 333.401Z",
    fill: "url(#paint176_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.983 1106.53C988.245 1106.37 987.595 1105.93 987.156 1105.32C986.757 1104.63 986.613 1103.82 986.75 1103.04C986.963 1102.24 987.47 1101.54 988.171 1101.09L990.931 1099.35L992.433 1098.33L995.275 1096.47C995.92 1096.06 996.696 1095.9 997.448 1096.04C998.2 1096.17 998.874 1096.59 999.335 1097.2C999.765 1097.84 999.928 1098.62 999.792 1099.37C999.656 1100.13 999.23 1100.81 998.605 1101.26L995.438 1103.37C994.951 1103.65 994.545 1103.98 994.139 1104.26L991.297 1106.05C990.97 1106.29 990.593 1106.46 990.194 1106.55C989.794 1106.63 989.381 1106.63 988.983 1106.53ZM1043.75 1061.87C1043.19 1061.75 1042.69 1061.47 1042.29 1061.06C1041.77 1060.48 1041.46 1059.73 1041.44 1058.95C1041.49 1058.15 1041.83 1057.4 1042.41 1056.84C1042.96 1056.32 1043.69 1056.04 1044.44 1056.04C1045.2 1056.04 1045.92 1056.32 1046.47 1056.84C1047 1057.39 1047.29 1058.11 1047.29 1058.87C1047.29 1059.63 1047 1060.36 1046.47 1060.9C1046.12 1061.24 1045.68 1061.5 1045.21 1061.64C1044.74 1061.78 1044.24 1061.8 1043.75 1061.71V1061.87ZM1094.22 1005.04C1093.89 1004.93 1093.58 1004.8 1093.28 1004.63C1092.65 1004.15 1092.22 1003.46 1092.06 1002.68C1091.92 1001.93 1092.07 1001.14 1092.47 1000.49L1093.97 998.256L1109.97 975.236C1112.46 971.774 1114.7 968.137 1116.67 964.355L1116.87 963.909C1118.9 960.214 1120.93 956.56 1123 952.987L1123.37 952.257L1128.03 943.934C1130.67 939.224 1133.23 934.718 1135.34 930.374C1137.49 925.339 1139.6 920.467 1141.59 915.92L1144.84 908.369C1147.44 902.401 1149.8 896.879 1151.91 892.129C1153.08 888.841 1154.1 885.674 1154.91 882.913L1156.33 878.366C1158.89 870.571 1160.39 866.186 1160.39 866.186C1160.49 865.826 1160.67 865.489 1160.9 865.195C1161.13 864.902 1161.42 864.658 1161.75 864.476C1162.08 864.295 1162.44 864.181 1162.81 864.14C1163.19 864.099 1163.56 864.132 1163.92 864.237C1164.3 864.347 1164.64 864.532 1164.94 864.78C1165.24 865.028 1165.48 865.335 1165.66 865.681C1165.83 866.027 1165.93 866.405 1165.96 866.793C1165.98 867.18 1165.92 867.567 1165.79 867.932C1165.79 867.932 1164.33 872.641 1161.93 880.112C1161.49 881.452 1161.04 882.913 1160.55 884.415C1159.7 887.298 1158.69 890.668 1157.39 894.281C1155.89 897.894 1154.22 901.711 1152.39 905.852L1140.82 932.769C1138.51 937.56 1135.79 942.229 1133.03 947.141C1131.61 949.74 1130.1 952.378 1128.64 955.261C1127.47 957.332 1126.33 959.321 1125.11 961.473L1121.86 967.36C1119.8 971.341 1117.46 975.168 1114.84 978.809L1103.35 995.333L1099.01 1001.67C1098.48 1002.36 1098.03 1003.13 1097.5 1003.9C1097.14 1004.41 1096.63 1004.79 1096.04 1004.99C1095.45 1005.18 1094.81 1005.19 1094.22 1005V1005.04Z",
    fill: "url(#paint177_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.782 1171.41C580.897 1161.23 543.542 1145.91 508.703 1125.86C508.365 1125.69 508.071 1125.44 507.839 1125.14C507.608 1124.83 507.445 1124.49 507.363 1124.11C507.247 1123.73 507.212 1123.33 507.261 1122.93C507.31 1122.53 507.441 1122.15 507.647 1121.8C508.053 1121.13 508.704 1120.64 509.463 1120.45C510.221 1120.25 511.027 1120.36 511.707 1120.74C546.11 1140.41 582.971 1155.43 621.325 1165.4H621.934C630.987 1167.8 640.284 1169.91 649.663 1171.7H650.231L653.032 1172.27C653.423 1172.33 653.797 1172.47 654.132 1172.68C654.466 1172.89 654.754 1173.17 654.978 1173.5C655.202 1173.82 655.358 1174.19 655.435 1174.58C655.512 1174.97 655.51 1175.37 655.428 1175.76C655.356 1176.14 655.208 1176.5 654.991 1176.82C654.775 1177.14 654.495 1177.42 654.169 1177.62C653.502 1178.07 652.688 1178.25 651.896 1178.11L648.729 1177.42C639.026 1176.12 629.323 1173.93 619.782 1171.41ZM665.253 1180.87C664.528 1180.69 663.898 1180.24 663.485 1179.62C663.072 1179 662.906 1178.24 663.02 1177.5C663.159 1176.72 663.598 1176.03 664.242 1175.56C664.887 1175.1 665.686 1174.91 666.471 1175.03C667.227 1175.16 667.902 1175.58 668.35 1176.2C668.798 1176.82 668.984 1177.6 668.866 1178.36C668.728 1179.11 668.315 1179.78 667.707 1180.25C667.099 1180.71 666.34 1180.94 665.577 1180.87C665.471 1180.9 665.359 1180.9 665.253 1180.87ZM727.207 1186.03C726.571 1185.86 726.008 1185.49 725.61 1184.97C725.213 1184.44 725.003 1183.8 725.014 1183.15C725.009 1182.35 725.314 1181.57 725.867 1180.99C726.451 1180.48 727.2 1180.19 727.978 1180.18C728.779 1180.19 729.543 1180.52 730.105 1181.09C730.667 1181.66 730.983 1182.43 730.982 1183.23C730.951 1184.02 730.611 1184.77 730.034 1185.32C729.458 1185.86 728.691 1186.16 727.897 1186.15C727.66 1186.19 727.416 1186.15 727.207 1186.03ZM803.005 1180.79C802.451 1180.64 801.953 1180.33 801.577 1179.9C801.201 1179.46 800.963 1178.93 800.894 1178.36C800.822 1177.98 800.828 1177.59 800.912 1177.21C800.996 1176.83 801.155 1176.48 801.381 1176.16C801.854 1175.53 802.553 1175.11 803.33 1174.99L810.354 1173.85C854.363 1167.11 889.278 1152.78 914.734 1142.3L919.524 1140.35C927.644 1136.29 934.587 1132.72 940.189 1129.8C942.219 1128.66 944.249 1127.69 945.792 1126.83C946.516 1126.49 947.343 1126.45 948.101 1126.7C948.858 1126.96 949.486 1127.5 949.852 1128.21C950.034 1128.57 950.146 1128.95 950.179 1129.35C950.213 1129.74 950.168 1130.14 950.047 1130.52C949.926 1130.89 949.732 1131.24 949.476 1131.54C949.219 1131.85 948.905 1132.09 948.553 1132.27L943.031 1135.16C937.347 1138.16 930.283 1141.9 921.92 1145.96L916.764 1148.07C891.146 1158.58 855.865 1173 811.45 1179.78C809.014 1180.22 806.7 1180.59 804.304 1180.95C803.865 1180.99 803.422 1180.94 803.005 1180.79ZM446.992 1082.82C446.583 1082.68 446.2 1082.48 445.856 1082.22C445.559 1081.97 445.316 1081.67 445.141 1081.33C444.967 1080.98 444.864 1080.61 444.841 1080.23C444.774 1079.43 445.006 1078.63 445.49 1077.99C446.011 1077.46 446.708 1077.13 447.452 1077.06C448.197 1076.99 448.942 1077.19 449.55 1077.63C450.108 1078.13 450.459 1078.83 450.534 1079.58C450.609 1080.33 450.403 1081.08 449.956 1081.69C449.618 1082.14 449.16 1082.48 448.637 1082.68C448.113 1082.88 447.543 1082.93 446.992 1082.82ZM402.049 1039.87C401.479 1039.74 400.966 1039.43 400.588 1038.98C400.088 1038.42 399.812 1037.7 399.812 1036.95C399.812 1036.2 400.088 1035.48 400.588 1034.92C401.178 1034.46 401.911 1034.23 402.655 1034.27C403.4 1034.31 404.106 1034.61 404.648 1035.12C405.147 1035.68 405.423 1036.4 405.423 1037.15C405.423 1037.9 405.147 1038.62 404.648 1039.18C404.301 1039.5 403.885 1039.72 403.433 1039.84C402.98 1039.96 402.506 1039.97 402.049 1039.87ZM392.874 1029.48C392.279 1029.32 391.735 1029.01 391.291 1028.58C375.477 1010.16 361.18 990.486 348.54 969.756C334.513 946.911 322.609 922.83 312.975 897.814C312.797 897.441 312.7 897.035 312.688 896.622C312.677 896.209 312.752 895.798 312.909 895.416C313.066 895.033 313.3 894.688 313.599 894.402C313.897 894.116 314.251 893.895 314.64 893.754C315.399 893.443 316.251 893.443 317.011 893.754C317.77 894.066 318.377 894.664 318.7 895.419C336.917 942.543 363.076 986.197 396.041 1024.48C396.286 1024.78 396.469 1025.13 396.581 1025.49C396.692 1025.86 396.729 1026.25 396.69 1026.64C396.675 1027.03 396.576 1027.41 396.401 1027.76C396.226 1028.11 395.979 1028.42 395.675 1028.67C395.318 1029.03 394.872 1029.3 394.381 1029.44C393.891 1029.58 393.371 1029.6 392.874 1029.48ZM958.784 1125.94C958.374 1125.85 957.991 1125.66 957.661 1125.4C957.331 1125.14 957.063 1124.82 956.875 1124.44C956.686 1124.09 956.568 1123.71 956.529 1123.31C956.489 1122.92 956.53 1122.52 956.647 1122.14C956.764 1121.76 956.956 1121.41 957.212 1121.11C957.467 1120.81 957.781 1120.56 958.134 1120.38C958.827 1120.07 959.614 1120.03 960.335 1120.27C961.056 1120.51 961.657 1121.02 962.018 1121.69C962.379 1122.36 962.472 1123.14 962.278 1123.88C962.085 1124.62 961.619 1125.25 960.976 1125.66C960.305 1126.02 959.524 1126.12 958.784 1125.94ZM293.65 826.643C293.111 826.52 292.621 826.237 292.245 825.831C291.868 825.426 291.622 824.917 291.539 824.37C291.409 823.601 291.587 822.811 292.036 822.173C292.484 821.534 293.166 821.098 293.934 820.959C294.315 820.88 294.709 820.875 295.091 820.947C295.474 821.019 295.839 821.166 296.165 821.379C296.491 821.592 296.772 821.867 296.992 822.189C297.212 822.51 297.366 822.872 297.446 823.253C297.526 823.635 297.53 824.028 297.458 824.411C297.386 824.793 297.239 825.158 297.026 825.484C296.813 825.81 296.538 826.091 296.217 826.311C295.895 826.531 295.533 826.685 295.152 826.765C294.65 826.871 294.128 826.829 293.65 826.643ZM285.327 765.054C284.73 764.902 284.197 764.564 283.803 764.09C283.409 763.616 283.175 763.03 283.135 762.415C283.088 762.022 283.126 761.623 283.245 761.245C283.364 760.867 283.561 760.519 283.825 760.223C284.056 759.909 284.355 759.651 284.699 759.468C285.044 759.286 285.425 759.183 285.814 759.167C286.599 759.111 287.374 759.364 287.973 759.873C288.573 760.381 288.949 761.105 289.022 761.888C289.049 762.626 288.803 763.349 288.331 763.917C287.784 764.505 287.055 764.891 286.261 765.014C285.953 765.066 285.639 765.079 285.327 765.054ZM284.678 751.251C284.038 751.064 283.478 750.673 283.082 750.138C282.686 749.603 282.476 748.953 282.485 748.287C282.485 743.618 282.485 739.111 282.485 734.767V725.308C282.485 724.09 282.485 722.872 282.485 721.654C282.324 715.092 282.609 708.527 283.338 702.004L286.748 669.971C286.959 667.019 287.393 664.087 288.047 661.201L288.291 659.943C288.535 659.049 288.575 658.562 288.656 658.319C288.843 657.557 289.306 656.891 289.955 656.451C290.28 656.234 290.645 656.085 291.03 656.016C291.414 655.946 291.808 655.956 292.188 656.045C292.953 656.211 293.622 656.669 294.054 657.321C294.486 657.973 294.647 658.768 294.503 659.537L293.934 662.622C293.249 665.278 292.854 668.001 292.757 670.742C292.107 676.832 291.214 685.195 290.118 695.751L289.346 703.019C288.549 709.455 288.251 715.943 288.453 722.425V730.545C288.453 736.269 288.453 742.319 288.453 748.733C288.453 749.119 288.376 749.5 288.226 749.856C288.076 750.211 287.857 750.532 287.581 750.801C287.304 751.07 286.977 751.28 286.618 751.42C286.258 751.56 285.875 751.627 285.49 751.616L284.678 751.251Z",
    fill: "url(#paint178_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.842 604.848C304.471 604.728 304.128 604.536 303.831 604.284C303.535 604.031 303.291 603.723 303.114 603.376C302.936 603.029 302.829 602.651 302.798 602.262C302.768 601.874 302.814 601.483 302.934 601.113L303.259 599.976L306.831 588.852C307.237 587.471 307.724 586.05 308.212 584.548C309.064 581.544 310.079 578.296 311.378 574.683C313.652 569.445 316.21 563.558 318.97 557.062C320.432 553.571 322.056 549.958 323.72 546.222L327.983 536.194C330.298 531.363 333.018 526.654 335.778 521.741L340.163 513.621L346.659 501.969L346.943 501.482C349.003 497.5 351.351 493.674 353.967 490.033L369.8 467.257C370.247 466.445 370.775 465.755 371.303 464.983C371.758 464.368 372.429 463.946 373.182 463.803C373.934 463.66 374.713 463.806 375.362 464.212C375.977 464.668 376.4 465.335 376.55 466.085C376.701 466.836 376.566 467.615 376.174 468.272C375.647 468.962 375.241 469.612 374.713 470.342L373.901 471.601C368.867 478.909 363.751 486.176 358.717 493.484C356.15 496.998 353.856 500.703 351.856 504.568V504.811L348.364 511.023L345.319 516.463L340.691 524.583C338.011 529.414 335.454 533.799 333.302 538.265L323.883 560.148C321.325 566.157 318.889 571.678 316.778 576.591C315.601 579.92 314.586 583.087 313.774 585.929C313.246 587.512 312.799 588.933 312.353 590.395C309.836 598.108 308.496 602.574 308.496 602.574C308.294 603.349 307.802 604.017 307.122 604.44C306.443 604.863 305.626 605.009 304.842 604.848ZM423.391 412.813C422.884 412.679 422.422 412.413 422.051 412.042C421.765 411.772 421.541 411.444 421.393 411.08C421.246 410.715 421.18 410.323 421.199 409.931C421.195 409.53 421.271 409.133 421.425 408.763C421.578 408.393 421.805 408.059 422.092 407.779C422.528 407.389 423.067 407.133 423.644 407.041C424.221 406.949 424.813 407.026 425.348 407.261C425.884 407.497 426.34 407.881 426.662 408.369C426.985 408.857 427.16 409.427 427.167 410.012C427.167 410.403 427.084 410.791 426.923 411.148C426.762 411.505 426.527 411.823 426.233 412.082C425.871 412.451 425.414 412.714 424.914 412.843C424.413 412.972 423.886 412.961 423.391 412.813ZM471.014 372.782C470.307 372.593 469.689 372.162 469.268 371.564C468.862 370.915 468.716 370.136 468.859 369.383C469.002 368.631 469.424 367.96 470.039 367.504L473.044 365.474L474.505 364.581L477.347 362.754C478.009 362.366 478.791 362.239 479.542 362.396C480.292 362.554 480.957 362.986 481.407 363.607C481.806 364.273 481.932 365.068 481.758 365.825C481.584 366.582 481.124 367.242 480.473 367.667L477.713 369.494C477.193 369.804 476.692 370.143 476.21 370.509C475.213 371.073 474.25 371.696 473.328 372.376C472.991 372.6 472.612 372.752 472.213 372.822C471.815 372.892 471.407 372.878 471.014 372.782Z",
    fill: "url(#paint179_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.27 812.839C1175.52 812.673 1174.87 812.218 1174.45 811.572C1174.03 810.926 1173.88 810.141 1174.04 809.388C1174.04 809.388 1174.24 808.292 1174.69 806.343C1175.32 803.677 1175.72 800.959 1175.87 798.223C1176.64 790.794 1177.78 779.913 1179.2 765.987C1179.98 759.699 1180.31 753.363 1180.17 747.027C1180.17 745.891 1180.17 744.673 1180.17 743.414C1180.17 736.187 1180.17 728.514 1180.17 720.394C1180.15 720.004 1180.23 719.616 1180.38 719.257C1180.54 718.899 1180.77 718.58 1181.06 718.324C1181.47 717.891 1182 717.592 1182.59 717.466C1183.17 717.339 1183.78 717.391 1184.33 717.614C1184.88 717.838 1185.35 718.223 1185.68 718.719C1186.01 719.215 1186.19 719.799 1186.18 720.394V722.099C1186.18 729.651 1186.18 736.796 1186.18 743.414C1186.18 744.754 1186.18 746.053 1186.18 747.474C1186.37 753.956 1186.07 760.443 1185.29 766.881L1181.92 798.873C1181.74 801.831 1181.29 804.766 1180.58 807.642L1180.33 808.982C1180.13 809.835 1180.05 810.322 1180.01 810.484C1179.92 810.866 1179.76 811.228 1179.53 811.547C1179.31 811.867 1179.02 812.138 1178.69 812.346C1178.36 812.554 1177.99 812.693 1177.6 812.757C1177.21 812.821 1176.82 812.807 1176.44 812.717L1176.27 812.839ZM1181.84 709.636C1181.35 709.498 1180.91 709.243 1180.55 708.894C1180.19 708.545 1179.92 708.112 1179.77 707.633C1179.62 707.155 1179.58 706.647 1179.68 706.153C1179.77 705.659 1179.98 705.196 1180.29 704.804C1180.55 704.507 1180.87 704.264 1181.23 704.09C1181.58 703.916 1181.97 703.814 1182.36 703.789C1182.75 703.762 1183.13 703.81 1183.5 703.932C1183.86 704.054 1184.2 704.247 1184.49 704.5C1184.78 704.752 1185.02 705.06 1185.19 705.405C1185.36 705.75 1185.46 706.125 1185.49 706.509C1185.56 707.288 1185.32 708.062 1184.83 708.668C1184.34 709.275 1183.63 709.665 1182.85 709.757C1182.5 709.733 1182.16 709.665 1181.84 709.554V709.636ZM1173.43 648.006C1172.9 647.859 1172.43 647.569 1172.05 647.167C1171.68 646.766 1171.43 646.269 1171.32 645.732C1171.23 645.343 1171.22 644.939 1171.3 644.547C1171.37 644.155 1171.53 643.784 1171.77 643.459C1171.97 643.13 1172.24 642.85 1172.56 642.639C1172.89 642.429 1173.25 642.292 1173.63 642.241C1174.02 642.158 1174.41 642.153 1174.79 642.225C1175.18 642.297 1175.54 642.445 1175.87 642.661C1176.19 642.877 1176.47 643.155 1176.69 643.481C1176.9 643.806 1177.05 644.171 1177.13 644.555C1177.22 644.937 1177.23 645.335 1177.17 645.723C1177.1 646.111 1176.95 646.481 1176.74 646.809C1176.52 647.138 1176.24 647.417 1175.9 647.63C1175.57 647.843 1175.2 647.985 1174.81 648.046C1174.35 648.085 1173.88 648.044 1173.43 647.925V648.006ZM1152.2 574.927C1151.74 574.808 1151.32 574.579 1150.98 574.261C1150.63 573.943 1150.37 573.544 1150.21 573.1C1140.65 548.433 1128.88 524.68 1115.05 502.132C1102.6 481.651 1088.47 462.244 1072.79 444.116C1072.33 443.52 1072.11 442.78 1072.16 442.033C1072.22 441.286 1072.54 440.583 1073.07 440.056C1073.67 439.599 1074.41 439.38 1075.16 439.44C1075.91 439.5 1076.61 439.835 1077.13 440.381C1110.48 479.211 1136.97 523.432 1155.49 571.151C1155.77 571.879 1155.75 572.687 1155.44 573.401C1155.13 574.115 1154.55 574.678 1153.82 574.968C1153.29 575.126 1152.73 575.126 1152.2 574.968V574.927ZM508.379 348.586C507.976 348.478 507.599 348.289 507.271 348.03C506.943 347.772 506.671 347.45 506.471 347.084C506.223 346.346 506.223 345.548 506.471 344.81C506.603 344.439 506.808 344.097 507.073 343.804C507.337 343.512 507.657 343.274 508.014 343.105C508.732 342.761 509.556 342.708 510.313 342.958C511.07 343.208 511.701 343.74 512.073 344.445C512.262 344.795 512.377 345.18 512.414 345.576C512.45 345.972 512.406 346.372 512.285 346.75C512.164 347.129 511.968 347.48 511.708 347.781C511.449 348.083 511.131 348.329 510.774 348.505C510.4 348.675 509.996 348.77 509.585 348.784C509.174 348.798 508.764 348.731 508.379 348.586ZM520.559 342.212C520.157 342.099 519.782 341.909 519.455 341.651C519.127 341.393 518.854 341.073 518.651 340.71C518.462 340.359 518.347 339.974 518.31 339.578C518.274 339.182 518.318 338.783 518.439 338.404C518.56 338.025 518.756 337.675 519.016 337.373C519.275 337.072 519.593 336.826 519.95 336.65L525.877 333.524C531.48 330.56 538.463 326.906 546.623 322.968C548.247 322.237 549.912 321.587 551.657 320.897C577.316 310.301 612.556 295.888 657.215 289.067C659.529 288.661 661.924 288.296 664.32 287.971C665.092 287.863 665.876 288.056 666.511 288.509C667.145 288.962 667.582 289.642 667.73 290.407C667.847 291.182 667.652 291.972 667.187 292.603C666.723 293.235 666.028 293.657 665.254 293.777C662.858 294.142 660.544 294.508 658.23 294.954C614.18 301.734 579.346 315.985 553.931 326.5L549.14 328.408C541.021 332.468 533.916 336.081 528.313 339.045L522.71 341.928C522.072 342.254 521.342 342.354 520.64 342.212H520.559ZM1065.32 434.656C1064.77 434.52 1064.27 434.223 1063.9 433.804C1063.37 433.259 1063.08 432.531 1063.08 431.774C1063.08 431.017 1063.37 430.289 1063.9 429.744C1064.48 429.213 1065.24 428.919 1066.03 428.919C1066.81 428.919 1067.58 429.213 1068.16 429.744C1068.6 430.219 1068.88 430.827 1068.95 431.476C1069.01 432.124 1068.87 432.776 1068.52 433.331C1068.18 433.886 1067.67 434.313 1067.06 434.545C1066.45 434.777 1065.78 434.802 1065.15 434.616L1065.32 434.656ZM1020.13 391.743C1019.7 391.637 1019.3 391.444 1018.95 391.175C1018.36 390.633 1017.97 389.901 1017.86 389.104C1017.82 388.721 1017.87 388.335 1018 387.971C1018.12 387.608 1018.32 387.274 1018.59 386.993C1019.09 386.433 1019.79 386.084 1020.55 386.016C1021.3 385.949 1022.05 386.167 1022.65 386.627C1022.93 386.877 1023.17 387.182 1023.34 387.523C1023.5 387.865 1023.6 388.237 1023.62 388.617C1023.67 389.376 1023.44 390.127 1022.97 390.728C1022.64 391.143 1022.2 391.458 1021.69 391.637C1021.19 391.816 1020.65 391.853 1020.13 391.743ZM957.688 348.383C957.454 348.265 957.21 348.17 956.957 348.099C914.189 323.44 867.604 306.096 819.124 296.781L815.795 296.132C815.082 295.928 814.471 295.468 814.077 294.841C813.683 294.213 813.534 293.463 813.66 292.733C813.786 292.003 814.177 291.345 814.759 290.886C815.34 290.426 816.07 290.198 816.81 290.245L818.555 290.61C819.164 290.61 819.692 290.854 820.261 290.894C869.383 300.385 916.591 317.959 959.962 342.902C960.571 343.276 961.026 343.856 961.246 344.536C961.466 345.216 961.437 345.952 961.163 346.612C960.889 347.273 960.389 347.814 959.752 348.138C959.115 348.463 958.383 348.549 957.688 348.383ZM739.956 288.499C739.186 288.397 738.488 287.993 738.016 287.376C737.544 286.759 737.336 285.98 737.439 285.21C737.541 284.441 737.945 283.743 738.562 283.271C739.178 282.799 739.957 282.591 740.727 282.693C741.116 282.688 741.502 282.761 741.862 282.908C742.222 283.056 742.548 283.274 742.821 283.551C743.094 283.828 743.308 284.158 743.451 284.519C743.593 284.881 743.661 285.268 743.65 285.657C743.65 286.044 743.573 286.428 743.424 286.785C743.274 287.142 743.056 287.466 742.78 287.738C742.504 288.01 742.177 288.225 741.818 288.369C741.458 288.514 741.074 288.586 740.687 288.58C740.44 288.594 740.193 288.566 739.956 288.499ZM801.95 293.736C801.248 293.506 800.655 293.025 800.284 292.386C799.914 291.746 799.793 290.992 799.943 290.268C800.094 289.544 800.507 288.902 801.102 288.463C801.697 288.024 802.432 287.82 803.168 287.89C803.949 288.019 804.646 288.453 805.107 289.097C805.568 289.74 805.754 290.54 805.625 291.321C805.495 292.101 805.061 292.799 804.418 293.259C803.775 293.72 802.975 293.906 802.194 293.777L801.95 293.736Z",
    fill: "url(#paint180_radial_147_3552)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.88
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.216 196.176H557.457V225.935H587.216V196.176Z",
    fill: "#757575"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627.654 196.176H597.895V225.935H627.654V196.176Z",
    fill: "#757575"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.099 196.176H638.34V225.935H668.099V196.176Z",
    fill: "#757575"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M708.525 196.176H678.766V225.935H708.525V196.176Z",
    fill: "#757575"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.911 196.176H719.152V225.935H748.911V196.176Z",
    fill: "#757575"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.357 196.176H759.598V225.935H789.357V196.176Z",
    fill: "#757575"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.794 196.176H800.035V225.935H829.794V196.176Z",
    fill: "#757575"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.216 233.812H557.457V263.572H587.216V233.812Z",
    fill: "#757575"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627.654 233.812H597.895V263.571H627.654V233.812Z",
    fill: "#757575"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.099 233.812H638.34V263.571H668.099V233.812Z",
    fill: "#757575"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M708.525 233.812H678.766V263.571H708.525V233.812Z",
    fill: "#757575"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.911 233.812H719.152V263.571H748.911V233.812Z",
    fill: "#757575"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.357 233.812H759.598V263.571H789.357V233.812Z",
    fill: "#757575"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M829.794 233.812H800.035V263.571H829.794V233.812Z",
    fill: "#757575"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870.24 233.812H840.48V263.571H870.24V233.812Z",
    fill: "#757575"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M910.626 233.812H880.867V263.571H910.626V233.812Z",
    fill: "#757575"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.216 271.448H557.457V301.207H587.216V271.448Z",
    fill: "#757575"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627.654 271.448H597.895V301.207H627.654V271.448Z",
    fill: "#757575"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M668.099 271.448H638.34V301.207H668.099V271.448Z",
    fill: "#757575"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M708.525 271.448H678.766V301.207H708.525V271.448Z",
    fill: "#757575"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.911 271.448H719.152V301.207H748.911V271.448Z",
    fill: "#757575"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.357 271.448H759.598V301.207H789.357V271.448Z",
    fill: "#757575"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.794 271.448H800.035V301.207H829.794V271.448Z",
    fill: "#757575"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870.24 271.448H840.48V301.207H870.24V271.448Z",
    fill: "#757575"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M910.626 271.448H880.867V301.207H910.626V271.448Z",
    fill: "#757575"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M951.072 271.448H921.312V301.207H951.072V271.448Z",
    fill: "#757575"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    d: "M991.494 271.448H961.734V301.207H991.494V271.448Z",
    fill: "#757575"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1031.93 271.448H1002.18V301.207H1031.93V271.448Z",
    fill: "#757575"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1072.33 271.448H1042.57V301.207H1072.33V271.448Z",
    fill: "#757575"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112.76 271.448H1083V301.207H1112.76V271.448Z",
    fill: "#757575"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1153.21 271.448H1123.45V301.207H1153.21V271.448Z",
    fill: "#757575"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1193.66 271.448H1163.9V301.207H1193.66V271.448Z",
    fill: "#757575"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1234.04 271.448H1204.28V301.207H1234.04V271.448Z",
    fill: "#757575"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.216 309.083H557.457V338.843H587.216V309.083Z",
    fill: "#757575"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.357 309.083H759.598V338.843H789.357V309.083Z",
    fill: "#757575"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.794 309.083H800.035V338.843H829.794V309.083Z",
    fill: "#757575"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870.24 309.083H840.48V338.843H870.24V309.083Z",
    fill: "#757575"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("path", {
    d: "M910.626 309.083H880.867V338.843H910.626V309.083Z",
    fill: "#757575"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M951.072 309.083H921.312V338.843H951.072V309.083Z",
    fill: "#757575"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    d: "M991.494 309.083H961.734V338.843H991.494V309.083Z",
    fill: "#757575"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1031.93 309.083H1002.18V338.843H1031.93V309.083Z",
    fill: "#757575"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1072.33 309.083H1042.57V338.843H1072.33V309.083Z",
    fill: "#757575"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112.76 309.083H1083V338.843H1112.76V309.083Z",
    fill: "#757575"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1153.21 309.083H1123.45V338.843H1153.21V309.083Z",
    fill: "#757575"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1193.66 309.083H1163.9V338.843H1193.66V309.083Z",
    fill: "#757575"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M587.216 346.719H557.457V376.479H587.216V346.719Z",
    fill: "#757575"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    d: "M910.626 346.719H880.867V376.478H910.626V346.719Z",
    fill: "#757575"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M951.072 346.719H921.312V376.478H951.072V346.719Z",
    fill: "#757575"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M991.494 346.719H961.734V376.478H991.494V346.719Z",
    fill: "#757575"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1031.93 346.719H1002.18V376.478H1031.93V346.719Z",
    fill: "#757575"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1072.33 346.719H1042.57V376.478H1072.33V346.719Z",
    fill: "#757575"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112.76 346.719H1083V376.478H1112.76V346.719Z",
    fill: "#757575"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1153.21 346.719H1123.45V376.478H1153.21V346.719Z",
    fill: "#757575"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1193.66 346.719H1163.9V376.478H1193.66V346.719Z",
    fill: "#757575"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.02
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.216 384.354H557.457V414.113H587.216V384.354Z",
    fill: "#757575"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.97
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1072.33 384.354H1042.57V414.113H1072.33V384.354Z",
    fill: "#757575"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.88
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721.087 1211.56H691.328V1241.32H721.087V1211.56Z",
    fill: "#757575"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M680.65 1211.56H650.891V1241.32H680.65V1211.56Z",
    fill: "#757575"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.204 1211.56H610.445V1241.32H640.204V1211.56Z",
    fill: "#757575"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.763 1211.56H570.004V1241.32H599.763V1211.56Z",
    fill: "#757575"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.372 1211.56H529.613V1241.32H559.372V1211.56Z",
    fill: "#757575"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.935 1211.56H489.176V1241.32H518.935V1211.56Z",
    fill: "#757575"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.501 1211.56H448.742V1241.32H478.501V1211.56Z",
    fill: "#757575"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721.087 1173.93H691.328V1203.69H721.087V1173.93Z",
    fill: "#757575"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M680.65 1173.93H650.891V1203.69H680.65V1173.93Z",
    fill: "#757575"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.204 1173.93H610.445V1203.69H640.204V1173.93Z",
    fill: "#757575"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.763 1173.93H570.004V1203.69H599.763V1173.93Z",
    fill: "#757575"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.372 1173.93H529.613V1203.69H559.372V1173.93Z",
    fill: "#757575"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.935 1173.93H489.176V1203.69H518.935V1173.93Z",
    fill: "#757575"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M478.501 1173.93H448.742V1203.69H478.501V1173.93Z",
    fill: "#757575"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.072 1173.93H408.312V1203.69H438.072V1173.93Z",
    fill: "#757575"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.673 1173.93H367.914V1203.69H397.673V1173.93Z",
    fill: "#757575"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721.087 1136.29H691.328V1166.05H721.087V1136.29Z",
    fill: "#757575"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M680.65 1136.29H650.891V1166.05H680.65V1136.29Z",
    fill: "#757575"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M640.204 1136.29H610.445V1166.05H640.204V1136.29Z",
    fill: "#757575"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.763 1136.29H570.004V1166.05H599.763V1136.29Z",
    fill: "#757575"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.372 1136.29H529.613V1166.05H559.372V1136.29Z",
    fill: "#757575"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.935 1136.29H489.176V1166.05H518.935V1136.29Z",
    fill: "#757575"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.501 1136.29H448.742V1166.05H478.501V1136.29Z",
    fill: "#757575"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.072 1136.29H408.312V1166.05H438.072V1136.29Z",
    fill: "#757575"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.673 1136.29H367.914V1166.05H397.673V1136.29Z",
    fill: "#757575"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.228 1136.29H327.469V1166.05H357.228V1136.29Z",
    fill: "#757575"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.79 1136.29H287.031V1166.05H316.79V1136.29Z",
    fill: "#757575"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.353 1136.29H246.594V1166.05H276.353V1136.29Z",
    fill: "#757575"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.958 1136.29H206.199V1166.05H235.958V1136.29Z",
    fill: "#757575"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.517 1136.29H165.758V1166.05H195.517V1136.29Z",
    fill: "#757575"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721.087 1098.66H691.328V1128.42H721.087V1098.66Z",
    fill: "#757575"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.935 1098.66H489.176V1128.42H518.935V1098.66Z",
    fill: "#757575"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.501 1098.66H448.742V1128.42H478.501V1098.66Z",
    fill: "#757575"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.072 1098.66H408.312V1128.42H438.072V1098.66Z",
    fill: "#757575"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.673 1098.66H367.914V1128.42H397.673V1098.66Z",
    fill: "#757575"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.228 1098.66H327.469V1128.42H357.228V1098.66Z",
    fill: "#757575"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.79 1098.66H287.031V1128.42H316.79V1098.66Z",
    fill: "#757575"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.353 1098.66H246.594V1128.42H276.353V1098.66Z",
    fill: "#757575"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.958 1098.66H206.199V1128.42H235.958V1098.66Z",
    fill: "#757575"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.517 1098.66H165.758V1128.42H195.517V1098.66Z",
    fill: "#757575"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M721.087 1060.98H691.328V1090.74H721.087V1060.98Z",
    fill: "#757575"
  })), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.673 1060.98H367.914V1090.74H397.673V1060.98Z",
    fill: "#757575"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.228 1060.98H327.469V1090.74H357.228V1060.98Z",
    fill: "#757575"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.79 1060.98H287.031V1090.74H316.79V1060.98Z",
    fill: "#757575"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.353 1060.98H246.594V1090.74H276.353V1060.98Z",
    fill: "#757575"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.958 1060.98H206.199V1090.74H235.958V1060.98Z",
    fill: "#757575"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.517 1060.98H165.758V1090.74H195.517V1060.98Z",
    fill: "#757575"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.079 1060.98H125.32V1090.74H155.079V1060.98Z",
    fill: "#757575"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.02
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721.087 1023.35H691.328V1053.1H721.087V1023.35Z",
    fill: "#757575"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.97
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.958 1023.35H206.199V1053.1H235.958V1023.35Z",
    fill: "#757575"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1536.6 -1558.57 1558.55 -1536.61 176.199 1064.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1536.6 -1558.57 1558.56 -1536.61 176.191 1064.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1542.72 -1561.7 1561.69 -1542.74 214.675 1100.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1536.66 -1558.62 1558.61 -1536.67 176.24 1064.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1261.65 -1279.68 1279.67 -1261.66 90.0705 821.347)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1536.66 -1558.62 1558.61 -1536.67 176.186 1064.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1536.75 -1558.71 1558.7 -1536.76 176.122 1064.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-373.373 -378.709 378.707 -373.376 206.643 1132.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1536.6 -1558.56 1558.55 -1536.61 176.18 1064.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1536.63 -1558.6 1558.59 -1536.64 176.198 1064.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1536.63 -1558.59 1558.58 -1536.64 176.183 1064.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1536.6 -1558.57 1558.56 -1536.61 176.173 1064.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1542.36 -1561.88 1561.87 -1542.37 213.098 1101.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.894 1962.88 -1962.87 -505.898 1300.28 910.842)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.894 1962.88 -1962.87 -505.898 1300.28 910.842)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.904 1962.92 -1962.91 -505.908 1300.26 910.842)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.894 1962.88 -1962.87 -505.898 1300.26 910.842)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.864 1962.77 -1962.75 -505.868 1300.22 910.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.894 1962.88 -1962.87 -505.898 1300.27 910.842)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.935 1963.04 -1963.03 -505.938 1300.34 910.861)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.822 1962.61 -1962.59 -505.827 1300.11 910.802)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.823 1962.61 -1962.59 -505.826 1300.11 910.801)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.874 1962.8 -1962.79 -505.877 1300.18 910.861)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-511.832 1960.42 -1960.43 -511.84 1289.73 959.695)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-515.398 1959.35 -1959.33 -515.398 1287.8 987.488)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-184.238 714.85 -714.843 -184.24 972.021 418.406)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-281.544 1092.4 -1092.39 -281.546 1289.34 461.004)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.892 1962.88 -1962.86 -505.898 1300.23 910.832)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.875 1962.81 -1962.79 -505.878 1300.25 910.832)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.863 1962.76 -1962.75 -505.867 1300.22 910.833)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.884 1962.84 -1962.83 -505.887 1300.23 910.832)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-354.338 1374.84 -1374.83 -354.341 836.71 785.528)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-505.874 1962.8 -1962.79 -505.877 1300.19 910.861)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.322 662.662) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.301 662.662) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.31 662.662) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.311 662.662) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.301 662.662) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.319 662.662) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.318 662.662) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.322 662.662) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.303 662.662) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.306 662.663) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.312 662.662) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.312 662.662) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.31 662.662) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(304.244 662.735) rotate(-90) scale(1507.2 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.309 662.662) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.322 662.661) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.329 662.663) rotate(-90) scale(1507.17 1507.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.329 662.663) rotate(-90) scale(1507.17 1507.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.321 662.662) rotate(-90) scale(1507.17 1507.14)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.304 662.663) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.416 662.657) rotate(-90) scale(1507.2 1507.19)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(304.269 662.783) rotate(-90) scale(1507.2 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.311 662.663) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.303 662.662) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.316 662.663) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.316 662.663) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.313 662.662) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.312 662.661) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(302.875 662.558) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(316.76 554.668) rotate(-90) scale(1408.51 1408.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.307 662.663) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.3 662.662) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.307 662.662) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.319 662.662) rotate(-90) scale(1507.17 1507.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(346.338 662.661) rotate(-90) scale(1385.9 1385.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.305 662.663) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.314 662.662) rotate(-90) scale(1507.21 1507.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.85 885.211 -885.205 -897.857 902.591 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.886 902.593 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.885 902.595 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.886 902.619 1030.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.908 885.268 -885.261 -897.915 902.626 1030.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.886 902.592 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.885 902.584 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.85 885.211 -885.204 -897.857 902.57 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.85 885.211 -885.205 -897.857 902.597 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.886 902.562 1030.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.885 902.578 1030.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.885 902.582 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.24 -885.233 -897.886 902.585 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-899.856 888.625 -888.613 -899.857 945.456 1034.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.909 885.268 -885.262 -897.914 902.613 1030.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.851 885.211 -885.205 -897.857 902.583 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.818 885.183 -885.173 -897.828 902.565 1030.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.966 885.323 -885.318 -897.971 902.651 1030.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.965 885.324 -885.318 -897.972 902.649 1030.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.885 902.614 1030.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-899.727 888.497 -888.497 -899.739 945.535 1034.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-899.842 888.612 -888.611 -899.856 945.657 1033.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.937 885.297 -885.29 -897.944 902.583 1030.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.85 885.211 -885.204 -897.857 902.587 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(902.584 1030.9) rotate(135.406) scale(1260.89 1260.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.885 902.588 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.91 885.268 -885.263 -897.914 902.597 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.885 902.598 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-899.798 888.569 -888.556 -899.8 945.211 1034.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.85 885.211 -885.205 -897.857 902.582 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.908 885.268 -885.261 -897.914 902.614 1030.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.851 885.211 -885.205 -897.857 902.598 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.886 902.592 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.886 902.586 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.886 902.617 1030.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.908 885.268 -885.261 -897.914 902.584 1030.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-897.879 885.239 -885.233 -897.885 902.592 1030.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.079 314.039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.084 313.998)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.07 314.039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.82 244.16 -244.158 1510.83 876.082 313.999)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.82 244.16 -244.158 1510.83 876.075 314)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.082 313.999)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.085 314.038)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.09 314.039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.74 244.147 -244.145 1510.75 876.071 314.039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.096 313.998)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.82 244.16 -244.158 1510.83 876.119 314.005)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.083 314.039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.086 314.038)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.84 244.163 -244.158 1510.83 876.009 313.959)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.82 244.16 -244.159 1510.83 876.04 314.033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.74 244.147 -244.145 1510.75 876.07 314.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.74 244.149 -244.145 1510.76 876.074 314.033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.82 244.162 -244.158 1510.84 876.078 313.993)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.94 244.179 -244.177 1510.95 876.103 313.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.042 313.992)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.66 244.134 -244.132 1510.67 876.009 313.801)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.076 314.054)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.86 244.166 -244.164 1510.87 876.131 314.005)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.74 244.147 -244.145 1510.75 876.069 313.998)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.079 313.999)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.074 314.038)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.82 244.16 -244.158 1510.83 876.071 314.038)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.077 314.038)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.73 244.417 -244.414 1510.74 876.319 313.898)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.069 314.038)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.82 244.16 -244.158 1510.83 876.047 313.992)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.74 244.147 -244.145 1510.75 876.081 313.998)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.78 244.153 -244.152 1510.79 876.082 314.038)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1136.88 183.729 -183.727 1136.89 1048.97 437.474)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1474.43 238.279 -238.277 1474.44 698.329 285.273)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1510.82 244.16 -244.158 1510.83 876.119 314.005)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1154.68 186.605 -186.603 1154.68 836.655 222.824)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#326177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A5265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1B3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0F1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#070D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.175 425.718)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.155 425.756)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.75 291.432 -291.43 1130.76 865.121 425.746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.132 425.708)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.83 291.452 -291.45 1130.83 865.156 425.718)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.104 425.746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.104 425.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.171 425.717)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.83 291.452 -291.45 1130.83 865.168 425.718)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.158 425.757)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.16 425.758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.75 291.432 -291.43 1130.76 865.121 425.746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.122 425.746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1127.56 295.813 -295.81 1127.57 872.697 425.909)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.75 291.432 -291.431 1130.76 865.162 425.718)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.169 425.717)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.83 291.452 -291.45 1130.83 865.17 425.719)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.67 291.412 -291.409 1130.68 865.147 425.795)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.63 291.401 -291.399 1130.64 865.139 425.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.75 291.432 -291.43 1130.76 865.146 425.757)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1127.73 295.647 -295.644 1127.74 872.532 425.964)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1127.49 295.795 -295.789 1127.49 872.567 426.061)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.71 291.422 -291.42 1130.72 865.071 425.736)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.111 425.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.75 291.433 -291.43 1130.76 865.114 425.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.75 291.432 -291.431 1130.75 865.117 425.746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.71 291.422 -291.419 1130.72 865.115 425.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.119 425.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1127.6 295.823 -295.821 1127.61 872.687 425.959)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.8 865.164 425.718)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.75 291.432 -291.43 1130.76 865.159 425.757)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.79 865.118 425.746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.79 291.442 -291.44 1130.79 865.113 425.746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.75 291.432 -291.43 1130.76 865.16 425.717)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.75 291.432 -291.43 1130.76 865.156 425.757)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.75 291.432 -291.43 1130.76 865.103 425.746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_147_3552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1130.75 291.432 -291.43 1130.76 865.117 425.746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0077B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#004266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#002A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#001824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologbg);
export default __webpack_public_path__ + "static/media/technologbg.e0e446a9c1c02197898f3854a7096d1d.svg";
export { ForwardRef as ReactComponent };